// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./fontawesome-all.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./flaticon.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./elegent-icon.css";
import ___CSS_LOADER_AT_RULE_IMPORT_3___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./animate.css";
import ___CSS_LOADER_AT_RULE_IMPORT_4___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./swiper.css";
import ___CSS_LOADER_AT_RULE_IMPORT_5___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./owl.css";
import ___CSS_LOADER_AT_RULE_IMPORT_6___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./jquery.fancybox.min.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/sideflowers.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../images/headingPattern.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../images/grass.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../images/weddingPartner.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Poppins:200,300,400,500,600,700,800,900|Orbitron:500,700|Ubuntu:400,500,700&display=swap);"]);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_3___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_4___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_5___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
	margin: 0px;
	padding: 0px;
	border: none;
	outline: none;
}

body {
	overflow-x:hidden;
	font-size: 14px;
	color: #777777;
	line-height: 1.7em;
	font-weight: 400;
	background: #ffffff;
	-webkit-font-smoothing: antialiased;
	-moz-font-smoothing: antialiased;
	font-family: 'Poppins', sans-serif;
}

a {
	text-decoration: none;
	cursor: pointer;
	color: #890025;
}

button,
a:hover,
a:focus,
a:visited {
	text-decoration: none;
	outline: none !important;
}

h1,
h2,
h3,
h4,
h5,
h6 {
	position: relative;
	font-weight: normal;
	margin: 0px;
	background: none;
	line-height: 1.6em;
	font-family: 'Ubuntu', sans-serif;
}

input,
button,
select,
textarea {}

textarea {
	overflow: hidden;
}

p,
.text {
	position: relative;
	font-size: 16px;
	line-height: 26px;
	color: #888888;
	font-weight: 400;
}

.set-logo-images {
	position: relative;
}

img.set-images {
	height: 50px;
	width: 50px !important;
	border-radius: 50px;
	border: 3px solid #890023;
}

.inner-column {
	width: 522px;
	margin: auto;
	/* box-shadow: 2px 4px 12px 5px #d5d3d3; */
	padding: 20px;
	/* border-radius: 28px;
	border: 0.3px solid #cc003726; */
}

.btn.btn-primary {
	background-color: #890025;
	border: none;
	border-radius: 50px;
	font-size: 15px;
	font-weight: 400;
	padding: 6px 18px;
}

.btn.btn-secondary {
	border: none;
	border-radius: 50px;
	font-size: 15px;
	font-weight: 400;
	padding: 6px 18px;
}

i.fa.fa-times.time-set {
	position: absolute;
	padding: 0px 8px;
	border-radius: 50px;
	top: -4px;
	right: -11px;
	font-size: 13px;
	font-weight: 700;
	color: #890025;
}

.auto-container {
	position: static;
	/* max-width: 1140px; */
	padding: 0px 15px;
	margin: 0 auto;
}

.large-container {
	position: static;
	max-width: 1550px;
	padding: 0px 15px;
	margin: 0 auto;
}

.medium-container {
	max-width: 850px;
}

.page-wrapper {
	position: relative;
	margin: 0 auto;
	width: 100%;
	min-width: 300px;
	overflow: hidden;
}

ul,
li {
	list-style: none;
	padding: 0px;
	margin: 0px;
}

img {
	display: inline-block;
	max-width: 100%;
	height: auto;
}

.theme-btn {
	display: inline-block;
	transition: all 0.3s ease;
}

.centered {
	text-align: center;
}

.theme-btn .flaticon-arrow {
	display: inherit;
	font-size: inherit;
	margin-left: 3px;
	font-size: 14px;
	transform: scaleX(-1) translateY(-1px);
}

::-webkit-input-placeholder {
	color: inherit;
}

::-moz-input-placeholder {
	color: inherit;
}

::-ms-input-placeholder {
	color: inherit;
}


::selection {
	background: #ec167f;
	color: #ffffff;
}

::-moz-selection {
	background: #ec167f;
	color: #ffffff;
}

::-webkit-selection {
	background: #ec167f;
	color: #ffffff;
}

.theme-btn {
	position: relative;
	transition: all 300ms ease;
}

.btn-style-one {
	position: relative;
	padding: 10px 30px;
	font-size: 16px;
	line-height: 30px;
	color: #ffffff;
	font-weight: 400;
	text-align: center;
	background-color: #890025;
	overflow: hidden;
	border-radius: 10px;
}

.btn-style-one .btn-title {
	position: relative;
}

.btn-style-one:hover {
	-ms-box-shadow: 0 10px 30px rgba(0, 0, 0, 0.10);
	-o-box-shadow: 0 10px 30px rgba(0, 0, 0, 0.10);
	box-shadow: 0 10px 30px rgba(0, 0, 0, 0.10);
}

.btn-style-one:before {
	position: absolute;
	left: 0;
	top: 0;
	height: 100%;
	width: 100%;
	content: "";
	background-color: #ffffff;
	transform: scale(0, 1);
	transform-origin: top right;
	transition: transform 500ms cubic-bezier(0.860, 0.000, 0.070, 1.000);
	/* easeInOutQuint */
	transition-timing-function: cubic-bezier(0.860, 0.000, 0.070, 1.000);
	/* easeInOutQuint */
}

.btn-style-one:hover:before {
	transform: scale(1, 1);
	transform-origin: bottom left;
}

.btn-style-two {
	position: relative;
	padding: 10px 30px;
	font-size: 16px;
	line-height: 30px;
	color: #ffffff;
	font-weight: 400;
	text-align: center;
	background-color: #eb2869;
	overflow: hidden;
	border-radius: 10px;
}

.btn-style-two .btn-title {
	position: relative;
}

.btn-style-two:hover {
	color: #faaC1D;
	-ms-box-shadow: 0 10px 30px rgba(0, 0, 0, 0.10);
	-o-box-shadow: 0 10px 30px rgba(0, 0, 0, 0.10);
	box-shadow: 0 10px 30px rgba(0, 0, 0, 0.10);
}

.btn-style-two:before {
	position: absolute;
	left: 0;
	top: 0;
	height: 100%;
	width: 100%;
	content: "";
	background-color: #ffffff;
	transform: scale(0, 1);
	transform-origin: top right;
	transition: transform 500ms cubic-bezier(0.860, 0.000, 0.070, 1.000);
	/* easeInOutQuint */
	transition-timing-function: cubic-bezier(0.860, 0.000, 0.070, 1.000);
	/* easeInOutQuint */
}

.btn-style-two:hover:before {
	transform: scale(1, 1);
	transform-origin: bottom left;
}


/* Button style three*/

.btn-style-three {
	position: relative;
	padding: 10px 30px;
	font-size: 16px;
	line-height: 30px;
	color: #ffffff;
	font-weight: 400;
	text-align: center;
	background-color: #FFA886;
	overflow: hidden;
	border-radius: 10px;
}

.btn-style-three .btn-title {
	position: relative;
}

.btn-style-three:hover {
	color: #1c94d2;
	-ms-box-shadow: 0 10px 30px rgba(0, 0, 0, 0.10);
	-o-box-shadow: 0 10px 30px rgba(0, 0, 0, 0.10);
	box-shadow: 0 10px 30px rgba(0, 0, 0, 0.10);
}

.btn-style-three:before {
	position: absolute;
	left: 0;
	top: 0;
	height: 100%;
	width: 100%;
	content: "";
	background-color: #ffffff;
	transform: scale(0, 1);
	transform-origin: top right;
	transition: transform 500ms cubic-bezier(0.860, 0.000, 0.070, 1.000);
	/* easeInOutQuint */
	transition-timing-function: cubic-bezier(0.860, 0.000, 0.070, 1.000);
	/* easeInOutQuint */
}

.btn-style-three:hover:before {
	transform: scale(1, 1);
	transform-origin: bottom left;
}



/* Button style four*/

.btn-style-four {
	position: relative;
	padding: 10px 30px;
	font-size: 16px;
	line-height: 30px;
	color: #ffffff;
	font-weight: 400;
	text-align: center;
	background-color: #24293d;
	overflow: hidden;
	border-radius: 10px;
}

.btn-style-four .btn-title {
	position: relative;
}

.btn-style-four:hover {
	color: #24293d;
	-ms-box-shadow: 0 10px 30px rgba(0, 0, 0, 0.10);
	-o-box-shadow: 0 10px 30px rgba(0, 0, 0, 0.10);
	box-shadow: 0 10px 30px rgba(0, 0, 0, 0.10);
}

.btn-style-four:before {
	position: absolute;
	left: 0;
	top: 0;
	height: 100%;
	width: 100%;
	content: "";
	background-color: #ffffff;
	transform: scale(0, 1);
	transform-origin: top right;
	transition: transform 500ms cubic-bezier(0.860, 0.000, 0.070, 1.000);
	transition-timing-function: cubic-bezier(0.860, 0.000, 0.070, 1.000);
}

.btn-style-four:hover:before {
	transform: scale(1, 1);
	transform-origin: bottom left;
}

/* List Style One */

.list-style-one {
	position: relative;
}

.list-style-one li {
	position: relative;
	font-size: 16px;
	line-height: 26px;
	color: #444444;
	font-weight: 400;
	padding-left: 35px;
	margin-bottom: 10px;
}

.list-style-one li:before {
	position: absolute;
	left: 0;
	top: 0;
	font-size: 16px;
	content: "\\52";
	font-family: 'ElegantIcons';
	color: #e1137b;
}

/* List Style Two */

.list-style-two {
	position: relative;
}

.list-style-two li {
	position: relative;
	font-size: 16px;
	line-height: 30px;
	color: #888888;
	font-weight: 400;
	padding-left: 25px;
	margin-bottom: 10px;
}

.list-style-two li:before {
	position: absolute;
	left: 0;
	top: 12px;
	height: 6px;
	width: 6px;
	background-color: #e1137b;
	content: "";
}

/* csign up field */
.candidate-field {
	width: 100%;
}

/* sign up field */
/***

====================================================================
	Social Icons
====================================================================

 ***/

/*Social Icon One*/

.social-icon-one {
	position: relative;
}

.social-icon-one li {
	position: relative;
	display: inline-block;
	margin-right: 8px;
	margin-bottom: 10px;
}

.social-icon-one li:last-child {
	margin-right: 0;
}

.social-icon-one li a .fab {
	position: relative;
	display: block;
	height: 40px;
	width: 40px;
	line-height: 40px;
	text-align: center;
	font-size: 16px;
	color: #ffffff;
	border-radius: 5px;
	background-color: #373851;
	transition: all 900ms ease;
	-moz-transition: all 900ms ease;
	-webkit-transition: all 900ms ease;
	-ms-transition: all 900ms ease;
	-o-transition: all 900ms ease;
}

.social-icon-one li a:hover .fab {
	transform: rotate(360deg);
}

.social-icon-one li a:hover .fab {
	background-color: #890025;
	border-color: #890025;
	color: #ffffff;
}

/*Social Icon Two*/

.social-icon-two {
	position: relative;
	display: block;
}

.social-icon-two li {
	position: relative;
	display: inline-block;
	margin-right: 8px;
	margin-bottom: 10px;
}

.social-icon-two li a .fab {
	position: relative;
	display: block;
	height: 40px;
	width: 40px;
	line-height: 40px;
	text-align: center;
	font-size: 16px;
	border: 1px solid #dddddd;
	background-color: #ffffff;
	transition: all 300ms ease;
}

.social-icon-two li a:hover .fab {
	color: #ffffff;
	background-color: #d24c59;
}

/*Social Icon Three*/

.social-icon-three {
	position: relative;
	display: block;
}

.social-icon-three li {
	position: relative;
	display: inline-block;
	margin-left: 30px;
	margin-bottom: 10px;
}

.social-icon-three li a {
	position: relative;
	display: block;
	line-height: 30px;
	text-align: center;
	font-size: 16px;
	transition: all 300ms ease;
}

.social-icon-three li a:hover {
	color: #222222;
}

.theme_color {
	color: #d24c59;
}

.pull-left {
	float: left;
}

.pull-right {
	float: right;
}

.scroll-to-top {
	position: fixed;
	bottom: 15px;
	right: 90px;
	width: 40px;
	height: 40px;
	color: #ffffff;
	border-radius: 5px;
	font-size: 18px;
	text-transform: uppercase;
	line-height: 40px;
	text-align: center;
	z-index: 100;
	cursor: pointer;
	background: #890025;
	display: none;
	transition: all 300ms ease;
}

.tabs-box {
	position: relative;
}

.tabs-box .tab {
	display: none;
}

.tabs-box .tab.active-tab {
	display: block;
}

.page-title {
	position: relative;
	text-align: center;
	overflow: hidden;
	z-index: 1;
	padding: 120px 0;
	background-repeat: no-repeat;
	background-position: center bottom;
	background-size: cover;
}

.page-title h1 {
	position: relative;
	display: block;
	font-size: 60px;
	color: #ffffff;
	line-height: 1em;
	font-weight: 700;
	margin-bottom: 10px;
}

.page-title .bread-crumb {
	position: relative;
}

.page-title .bread-crumb li {
	position: relative;
	display: inline-block;
	font-size: 18px;
	line-height: 30px;
	color: #ffffff;
	font-weight: 500;
	cursor: default;
	padding-right: 15px;
	margin-right: 15px;
}

.page-title .bread-crumb li:before {
	position: absolute;
	right: -3px;
	font-size: 18px;
	line-height: 30px;
	color: #ffffff;
	font-weight: 400;
	content: "|";
}

.page-title .bread-crumb li:last-child {
	padding-right: 0;
	margin-right: 0;
}

.page-title .bread-crumb li:last-child:before {
	display: none;
}

.page-title .bread-crumb li a {
	color: #ffffff;
	transition: all 300ms ease;
}

.page-title .bread-crumb li a:hover {
	color: #f0c52e;
}

.sec-title {
	position: relative;
	margin-bottom: 30px;
}

.sec-title .title {
	position: relative;
	display: block;
	font-size: 16px;
	line-height: 1em;
	color: #ff8a01;
	font-weight: 500;
	background: #ff8a01;
	background: -moz-linear-gradient(to left, #ff8a01, #890025 25%, #ff8a01 75%, #890025 100%);

	filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#F70068', endColorstr='#441066', GradientType=1);
	color: transparent;
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;
	text-transform: uppercase;
	letter-spacing: 5px;
	margin-bottom: 15px;
}

.sec-title h2 {
	position: relative;
	display: inline-block;
	font-size: 48px;
	line-height: 1.2em;
	color: #1e1f36;
	font-weight: 700;
}

.sec-title .text {
	position: relative;
	font-size: 16px;
	line-height: 28px;
	color: #888888;
	margin-top: 15px;
}

.sec-title.light h2,
.sec-title.light .title {
	color: #ffffff;
	-webkit-text-fill-color: inherit;
}



.anim-icons {
	position: absolute;
	left: 0;
	top: 0;
	right: 0;
	height: 100%;
	width: 100%;
	max-width: 1170px;
	margin: 0 auto;
}

/* .anim-icons.full-width {
	max-width: 100%;
} */

.avatar-edit.kils {
    bottom: inherit;
    padding: 6px 6px;
    width: 40px;
    height: 40px;
}
label.pensil:hover {
    background: #ff000000 !important;
}
.anim-icons .icon {
	position: absolute;
	background-position: center;
	background-repeat: no-repeat;
}

.logo h6 {
	animation: Color 4s linear infinite;
	-webkit-animation: Color 4s ease-in-out infinite;
	font-size: 32px;
}

@keyframes Color {
	0% {
		color: #890025;
	}

	20% {
		color: #ea7207;
	}

	40% {
		color: #FFCE54;
	}

	60% {
		color: #FC6E51;
	}

	80% {
		color: #ED5565;
	}

	100% {
		color: #AC92EC;
	}
}

.main-header {
	/* position: fixed; */
	top: 0;
	left: 0;
	z-index: 999;
	width: 100%;
	transition: all 300ms ease;
}

.main-header .main-box {
	position: relative;
	padding: 10px 0;
	transition: all 300ms ease;
	background-color: #d79c80;
}

.main-header .logo-box {
	position: relative;
	float: left;
	transition: all 300ms ease;
}

.main-header .logo-box .logo img {
	display: inline-block;
	max-width: 100%;
	transition: all 300ms ease;
	width: 60px;
	height: 60px;
	object-fit: cover;
}

.search-box-btn {
	display: flex;
	align-items: center;
}

.main-header .nav-outer {
	position: relative;
	float: right;
	transition: all 600ms ease;
	padding: 6px 10px;
}

.main-header .nav-outer .main-menu {
	position: static;
	float: left;
}

.main-menu .navigation {
	position: static;
	margin: 0px;
}

.main-menu .navigation>li {
	position: relative;
	float: left;
	margin-left: 24px;
	transition: all 300ms ease;
}

.main-menu .navigation>li>a {
	position: relative;
	display: block;
	font-size: 16px;
	line-height: 30px;
	font-weight: 500;
	padding: 10px 0;
	color: #fff !important;
	opacity: 1;
	text-align: center;
	transition: all 300ms ease;
}

.main-menu .navigation>li>a:before {
	position: absolute;
	left: 50%;
	bottom: 10px;
	height: 2px;
	width: 0%;
	content: "";
	transform: scale(-1);
	background: #ffa8B6;
	transition: all 300ms ease;
}

.main-menu .navigation>li.current>a:before,
.main-menu .navigation>li:hover>a:before {
	left: 0;
	width: 100%;
}

.main-menu .navigation>li>ul>li.dropdown>a:before {
	font-family: 'Font Awesome 5 Free';
	content: "\\f105";
	position: absolute;
	right: 25px;
	top: 8px;
	width: 10px;
	height: 20px;
	display: block;
	line-height: 20px;
	font-size: 16px;
	font-weight: 900;
	text-align: center;
	z-index: 5;
}

.main-menu .navigation>li>ul>li>ul>li.dropdown:hover>a:after {
	color: #ffffff;
}

.main-menu .navigation>li>ul {
	position: absolute;
	left: 0px;
	top: 100%;
	width: 250px;
	z-index: 100;
	display: none;
	opacity: 0;
	visibility: hidden;
	padding: 20px 0px;
	background: #ffffff;
	border-radius: 3px;
	transform-origin: top;
	transform: rotateX(90deg);
	border-bottom: 3px solid #f20487;
	border-radius: 0 0 6px 6px;
	-ms-box-shadow: 2px 2px 5px 1px rgba(0, 0, 0, 0.05), -2px 0px 5px 1px rgba(0, 0, 0, 0.05);
	-o-box-shadow: 2px 2px 5px 1px rgba(0, 0, 0, 0.05), -2px 0px 5px 1px rgba(0, 0, 0, 0.05);
	box-shadow: 2px 2px 5px 1px rgba(0, 0, 0, 0.05), -2px 0px 5px 1px rgba(0, 0, 0, 0.05);
}

.main-menu .navigation>li>ul:before {
	position: absolute;
	content: '';
	left: 0px;
	top: -30px;
	width: 100%;
	height: 30px;
	display: block;
}

.main-menu .navigation>li>ul.from-right {
	left: auto;
	right: 0px;
}

.main-menu .navigation>li>ul>li {
	position: relative;
	width: 115%;
	margin-bottom: 0px;
}

.main-menu .navigation>li>ul>li:last-child {
	margin-bottom: 0px;
}

.main-menu .navigation>li>ul>li>a {
	position: relative;
	display: block;
	padding: 5px 25px;
	line-height: 24px;
	font-weight: 400;
	font-size: 16px;
	text-transform: capitalize;
	color: #222222;
	transition: all 500ms ease;
	-moz-transition: all 500ms ease;
	-webkit-transition: all 500ms ease;
	-ms-transition: all 500ms ease;
	-o-transition: all 500ms ease;
}

.main-menu .navigation>li>ul>li:hover>a {
	color: #FFA886;
}

.main-menu .navigation>li>ul>li>ul {
	position: absolute;
	left: 100%;
	top: 100%;
	width: 220px;
	z-index: 100;
	display: none;
	opacity: 0;
	visibility: hidden;
	margin-top: -50px;
	padding: 20px 0px;
	background: #ffffff;
	transform-origin: top;
	transform: rotateX(90deg);
	border-bottom: 3px solid #f20487;
	border-radius: 0 0 6px 6px;
	-ms-box-shadow: 2px 2px 5px 1px rgba(0, 0, 0, 0.05), -2px 0px 5px 1px rgba(0, 0, 0, 0.05);
	-o-box-shadow: 2px 2px 5px 1px rgba(0, 0, 0, 0.05), -2px 0px 5px 1px rgba(0, 0, 0, 0.05);
	box-shadow: 2px 2px 5px 1px rgba(0, 0, 0, 0.05), -2px 0px 5px 1px rgba(0, 0, 0, 0.05);
}

.main-menu .navigation>li>ul>li>ul.from-right {
	left: auto;
	right: 0px;
}

.main-menu .navigation>li>ul>li>ul>li {
	position: relative;
	width: 100%;
	margin-bottom: 0px;
}

.main-menu .navigation>li>ul>li>ul>li:last-child {
	margin-bottom: 0px;
}

.main-menu .navigation>li>ul>li>ul>li>a {
	position: relative;
	display: block;
	padding: 5px 25px;
	line-height: 24px;
	font-weight: 400;
	font-size: 16px;
	text-transform: capitalize;
	color: #222222;
	transition: all 500ms ease;
	-moz-transition: all 500ms ease;
	-webkit-transition: all 500ms ease;
	-ms-transition: all 500ms ease;
	-o-transition: all 500ms ease;
}

.main-menu .navigation>li>ul>li>ul>li:hover>a {
	color: #e1137b;
}

.main-menu .navigation>li.dropdown:hover>ul {
	visibility: visible;
	opacity: 1;
	transform: rotateX(0deg);
	transition: all 500ms ease;
}

.main-menu .navigation li>ul>li.dropdown:hover>ul {
	visibility: visible;
	opacity: 1;
	transform: rotateX(0deg);
	transition: all 500ms ease;
}

.main-menu .navbar-collapse>ul li.dropdown .dropdown-btn {
	position: absolute;
	right: 10px;
	top: 6px;
	width: 30px;
	height: 30px;
	text-align: center;
	color: #ffffff;
	line-height: 28px;
	border: 1px solid #ffffff;
	background-size: 20px;
	cursor: pointer;
	z-index: 5;
	display: none;
}

/* Outer box */
.main-header .outer-box {
	position: relative;
	float: right;
	margin-left: 20px;
}

.main-header .search-box-outer {
	position: relative;
	float: left;
	transition: all 300ms ease;
}

.main-header .search-box-outer2 {
	position: relative;
	float: left;
	transition: all 300ms ease;
}
.nav-outer.clearfix {
    display: flex;
    align-items: center;
}
.main-header .search-box-btn {
	position: relative;
	float: left;
	font-size: 19px;
	line-height: 30px;
	cursor: pointer;
	background: none;
	color: #ffffff;
	font-weight: 600;
	cursor: pointer;
	margin-top: 8px;
	transition: all 300ms ease;
}

.main-header .search-box-btn2 {
	position: relative;
	float: left;
	font-size: 24px;
	line-height: 30px;
	cursor: pointer;
	background: none;
	color: #ffffff;
	font-weight: 400;
	cursor: pointer;
	margin-top: 10px;
	transition: all 300ms ease;
}

.main-header .search-box-btn3 {
	position: relative;
	float: left;
	font-size: 24px;
	line-height: 30px;
	cursor: pointer;
	background: none;
	color: #ffffff;
	font-weight: 400;
	cursor: pointer;
	margin-top: 10px;
	transition: all 300ms ease;
}

.main-header .search-box-btn4 {
	position: relative;
	float: left;
	font-size: 24px;
	line-height: 30px;
	cursor: pointer;
	background: none;
	color: #ffffff;
	font-weight: 400;
	cursor: pointer;
	margin-top: 10px;
	transition: all 300ms ease;
}

.main-header .search-box-btn5 {
	position: relative;
	float: left;
	font-size: 24px;
	line-height: 30px;
	cursor: pointer;
	background: none;
	color: #ffffff;
	font-weight: 400;
	cursor: pointer;
	margin-top: 10px;
	transition: all 300ms ease;
}

.main-header .search-box-btn6 {
	position: relative;
	float: left;
	font-size: 24px;
	line-height: 30px;
	cursor: pointer;
	background: none;
	color: #ffffff;
	font-weight: 400;
	cursor: pointer;
	margin-top: 10px;
	transition: all 300ms ease;
}

.dropdown-toggle::after {
	display: none;
}

.main-header .search-box-outer .dropdown-menu {
	top: 44px !important;
	left: auto !important;
	right: 0;
	padding: 0px;
	width: 280px;
	border-radius: 0px;
	transform: none !important;
	border-top: 3px solid #df6512;
}

.main-header .search-box-outer2 .dropdown-menu {
	top: 44px !important;
	left: auto !important;
	right: 0;
	padding: 0px;
	width: 280px;
	border-radius: 0px;
	transform: none !important;
	border-top: 3px solid #df6512;
}

.main-header .search-panel .form-container {
	padding: 25px 20px;
}

.main-header .search-panel .form-group {
	position: relative;
	margin: 0px;
}

.main-header .search-panel input[type="text"],
.main-header .search-panel input[type="number"],
.main-header .search-panel input[type="search"],
.main-header .search-panel input[type="password"],
.main-header .search-panel select {
	display: block;
	width: 100%;
	line-height: 24px;
	padding: 7px 40px 7px 15px;
	height: 40px;
	font-size: 14px;
	border: 1px solid #e0e0e0;
	background: #ffffff;
}

.main-header .search-panel input:focus,
.main-header .search-panel select:focus {
	border-color: #25262c;
}

.main-header .search-panel .search-btn {
	position: absolute;
	right: 0px;
	top: 0px;
	width: 40px;
	height: 40px;
	text-align: center;
	color: #555555;
	font-size: 12px;
	background: none;
	cursor: pointer;
}

.main-header .outer-box .btn-box {
	position: relative;
	float: right;
	padding: 5px 0;
	margin-left: 20px;
}

.main-header .outer-box .btn-box a {
	position: relative;
	float: right;
	border-radius: 50px;
	line-height: 20px;
	padding: 6px 18px;
	font-size: 14px;
}

.nav-outer .mobile-nav-toggler {
	position: relative;
	float: right;
	font-size: 40px;
	line-height: 50px;
	cursor: pointer;
	color: #e1137b;
	margin: 7px 0px 2px;
	display: none;
}

.nav-outer .mobileapp_Icon {
	display: none;
}

.nav-outer .mobileapp_Icon1 {
	display: none;
}

/***

====================================================================
	Header Style Two
====================================================================

***/

.header-span {
	height: 90px;
	display: block;
}


.header-style-two .main-box {
	padding: 0;
	box-shadow: 0 0 30px rgba(0, 0, 0, 0.10);
}

.header-style-two .outer-box,
.header-style-two .logo-box,
.header-style-two .main-menu .navigation>li {
	padding: 10px 0;
	transition: all 300ms ease;
}

.header-style-two .search-box-btn,
.header-style-two .main-menu .navigation>li>a {
	color: #3f4161;
}

.header-style-two .search-box-btn2,
.header-style-two .main-menu .navigation>li>a {
	color: #3f4161;
}

.header-style-two .search-box-btn3,
.header-style-two .main-menu .navigation>li>a {
	color: #3f4161;
}

.header-style-two .search-box-btn4,
.header-style-two .main-menu .navigation>li>a {
	color: #3f4161;
}

.header-style-two .search-box-btn5,
.header-style-two .main-menu .navigation>li>a {
	color: #3f4161;
}

.header-style-two .search-box-btn6,
.header-style-two .main-menu .navigation>li>a {
	color: #3f4161;
}

.header-style-two.fixed-header {
	box-shadow: 0 0 30px rgba(0, 0, 0, 0.10);
}

.main-header.header-style-two.fixed-header .main-box {
	background-color: #ffffff;
	padding: 0;
}

.header-style-two.fixed-header .outer-box,
.header-style-two.fixed-header .logo-box,
.header-style-two.fixed-header .main-menu .navigation>li {
	padding: 10px 0;
}

/***

====================================================================
	Header Style Three
====================================================================

***/

.header-style-three .main-menu .navigation>li {
	margin-left: 35px;
}

.header-style-three .nav-outer {
	float: left;
}

.header-style-three .nav-outer .main-menu {
	margin-left: 45px;
}

.header-style-three .outer-box {
	position: relative;
	float: right;
}

.header-style-three .outer-box .btn-box a {
	border-radius: 3px;
}

/***

====================================================================
		Fixed Header
====================================================================

***/

.main-header.fixed-header .main-box {
	padding: 10px 0;
	background-color: #d79c80;
}

/***

====================================================================
			Mobile Menu
====================================================================

***/

.mobile-menu {
	position: fixed;
	right: 0;
	top: 0;
	width: 100%;
	padding-right: 30px;
	max-width: 100%;
	height: 100%;
	opacity: 0;
	visibility: hidden;
	z-index: 999999;
}

.mobile-menu .nav-logo {
	position: relative;
	padding: 20px 20px;
	text-align: left;
}

.mobile-menu .nav-logo img {
	max-width: 200px;
}

.mobile-menu-visible {
	overflow: hidden;
}

.mobile-menu-visible .mobile-menu {
	opacity: 1;
	visibility: visible;
}

.mobile-menu .menu-backdrop {
	position: fixed;
	right: 0;
	top: 0;
	width: 100%;
	height: 100%;
	z-index: 1;
	opacity: 0;
}

.mobile-menu-visible .mobile-menu .menu-backdrop {
	opacity: 1;
	visibility: visible;
}

.mobile-menu .menu-box {
	position: absolute;
	left: 0px;
	top: 0px;
	width: 100%;
	height: 100%;
	max-height: 100%;
	overflow-y: auto;
	background: #ffffff;
	padding: 0px 0px;
	z-index: 5;
	opacity: 0;
	border-radius: 0px;
	visibility: hidden;
	transform: scale(0);
	transform-origin: top right;
	transition: all 400ms ease;
}

.mobile-menu-visible .mobile-menu .menu-box {
	opacity: 1;
	visibility: visible;
	transform: scale(1);
}

.btn-primary:not(:disabled):not(.disabled).active:focus,
.btn-primary:not(:disabled):not(.disabled):active:focus,
.show>.btn-primary.dropdown-toggle:focus {
	box-shadow: 0 0 0 0.2rem rgb(0 123 255 / 0%);
}

.btn-primary:not(:disabled):not(.disabled).active,
.btn-primary:not(:disabled):not(.disabled):active,
.show>.btn-primary.dropdown-toggle {
	color: #fff;
	background-color: #890025;
	border-color: #890025;
}

.clikcxs {
	opacity: 0;
	position: absolute;
	width: 109px;
	top: 3px;
}


.btn:focus-visible {


	box-shadow: 0px 0px 0px 0px;
}

.mobile-menu .close-btn {
	position: absolute;
	right: 15px;
	top: 25px;
	line-height: 30px;
	width: 30px;
	text-align: center;
	font-size: 14px;
	color: #ffffff;
	background-color: #e1137b;
	cursor: pointer;
	z-index: 10;
	transition: all 0.5s ease;
	transform: translateY(-50px);
}

.mobile-menu-visible .mobile-menu .close-btn {
	transform: translateY(0px);
}

.mobile-menu .close-btn:hover {
	opacity: 0.50;
}

.mobile-menu .navigation {
	position: relative;
	display: block;
	border-top: 1px solid rgba(0, 0, 0, 0.10);
}

.mobile-menu .navigation li {
	position: relative;
	display: block;
	border-bottom: 1px solid rgba(0, 0, 0, 0.10);
}

.mobile-menu .navigation li>ul>li:last-child {
	border-bottom: none;
}

.mobile-menu .navigation li>ul>li:first-child {
	border-top: 1px solid rgba(0, 0, 0, 0.10);
}

.mobile-menu .navigation li>a {
	position: relative;
	display: block;
	line-height: 24px;
	padding: 10px 20px;
	font-size: 16px;
	color: #404040;
	font-weight: 600;
	text-transform: capitalize;
}

.mobile-menu .navigation li:hover>a,
.mobile-menu .navigation li.current>a {
	color: #e1137b;
}

.mobile-menu .navigation li.dropdown .dropdown-btn {
	position: absolute;
	right: 0px;
	top: 0px;
	width: 44px;
	height: 44px;
	text-align: center;
	font-size: 16px;
	line-height: 44px;
	color: #404040;
	cursor: pointer;
	z-index: 5;
}

.mobile-menu .navigation li.dropdown .dropdown-btn:after {
	content: '';
	position: absolute;
	left: 0px;
	top: 10px;
	width: 1px;
	height: 24px;
	border-left: 1px solid rgba(0, 0, 0, 0.10);
}

.mobile-menu .navigation li>ul,
.mobile-menu .navigation li>ul>li>ul {
	display: none;
}

/***

====================================================================
		Banner Section
====================================================================

***/

.banner-section {
	position: relative;
}

.banner-carousel {
	position: relative;
}

.banner-carousel .slide-item {
	position: relative;
	background-repeat: no-repeat;
	background-position: center;
	background-size: cover;
	padding: 220px 0 100px;
	text-align: center;
}

.banner-carousel .slide-item:before {
	position: absolute;
	left: 0;
	top: 0;
	height: 100%;
	width: 100%;
	/*  */

	content: "";
}

.banner-carousel .content-box {
	position: relative;
}

.banner-carousel .content-box .title {
	display: block;
	font-size: 28px;
	color: #faaC1D;
	font-weight: 500;
	margin-bottom: 25px;
	opacity: 0;
	transform: translateY(100px);
	transition: all 500ms ease;
}

.banner-carousel .active .content-box .title {
	opacity: 1;
	transform: translateY(0);
}

.banner-carousel .content-box h2 {
	display: block;
	font-size: 54px;
	line-height: 1.2em;
	color: #ffffff;
	font-weight: 700;
	margin-bottom: 30px;
	opacity: 0;
	transform: translateY(100px);
	transition: all 500ms ease;
}

.banner-carousel .active .content-box h2 {
	opacity: 1;
	transform: translateY(0);
	transition-delay: 300ms;
}

.banner-carousel .content-box .info-list {
	position: relative;
	margin-bottom: 45px;
	opacity: 0;
	transform: translateY(100px);
	transition: all 500ms ease;
}

.banner-carousel .active .content-box .info-list {
	opacity: 1;
	transform: translateY(0);
	transition-delay: 600ms;
}

.banner-carousel .content-box .info-list li {
	position: relative;
	display: inline-block;
	font-size: 18px;
	line-height: 26px;
	color: #ffffff;
	font-weight: 400;
	margin: 0 10px;
	text-transform: uppercase;
}

.banner-carousel .content-box .info-list li .icon {
	/* color: #faaC1D; */
	margin-right: 10px;
	float: left;
	font-size: 18px;
	line-height: 26px;
}

.banner-carousel .content-box .btn-box {
	opacity: 0;
	transform: translateY(100px);
	transition: all 500ms ease;
}

.banner-carousel .active .content-box .btn-box {
	opacity: 1;
	transform: translateY(0);
	transition-delay: 900ms;
}

.banner-carousel .owl-nav {
	position: absolute;
	left: 0;
	top: 50%;
	width: 100%;
}

.banner-carousel .owl-next,
.banner-carousel .owl-prev {
	position: absolute;
	left: 0;
	top: 0;
	height: 100px;
	width: 30px;
	color: #ffffff;
	background-color: rgba(255, 255, 255, 0.10);
	font-size: 20px;
	line-height: 100px;
	text-align: center;
	transition: all 500ms ease;
}

.banner-carousel .owl-next {
	left: auto;
	right: 0;
}

.banner-carousel .owl-next:hover,
.banner-carousel .owl-prev:hover {
	background-color: rgba(255, 255, 255, .90);
	color: #222222;
}

/***

====================================================================
		Banner Conference
====================================================================

***/

.banner-conference {
	position: relative;
	padding: 200px 0;
	overflow: hidden;
}






.banner-conference .icons {
	position: absolute;
	left: 0px;
	top: 0px;
	right: 0px;
	bottom: 0px;
}

.banner-conference .icons .icon-one {
	position: absolute;
	left: 10% !important;
	top: 17% !important;
	width: 12px;
	height: 12px;
	display: inline-block;
	background-repeat: no-repeat;
}

.banner-conference .icons .icon-two {
	position: absolute;
	left: 35% !important;
	top: 25% !important;
	width: 16px;
	height: 16px;
	display: inline-block;
	background-repeat: no-repeat;
}

.banner-conference .icons .icon-three {
	position: absolute;
	left: 6% !important;
	top: 58% !important;
	width: 34px;
	height: 10px;
	display: inline-block;
	background-repeat: no-repeat;
}

.banner-conference .icons .icon-four {
	position: absolute;
	left: 56% !important;
	top: 60% !important;
	width: 34px;
	height: 20px;
	display: inline-block;
	background-repeat: no-repeat;
}

.banner-conference .icons .icon-five {
	position: absolute;
	left: 79% !important;
	top: 25% !important;
	width: 35px;
	height: 16px;
	display: inline-block;
	background-repeat: no-repeat;
}

.banner-conference .icons .icon-six {
	position: absolute;
	left: 90% !important;
	top: 88% !important;
	width: 20px;
	height: 20px;
	display: inline-block;
	background-repeat: no-repeat;
}

.banner-conference .icons .icon-seven {
	position: absolute;
	left: 80% !important;
	top: 60% !important;
	width: 20px;
	height: 20px;
	display: inline-block;
	background-repeat: no-repeat;
}

.banner-conference .icons .icon-eight {
	position: absolute;
	left: 52% !important;
	top: 40% !important;
	width: 12px;
	height: 12px;
	display: inline-block;
	background-repeat: no-repeat;
}

.banner-conference .icons .icon-nine {
	position: absolute;
	left: 52% !important;
	top: 12% !important;
	width: 16px;
	height: 16px;
	display: inline-block;
	background-repeat: no-repeat;
}

.banner-conference .icons .icon-ten {
	position: absolute;
	left: 34% !important;
	top: 68% !important;
	width: 34px;
	height: 10px;
	display: inline-block;
	background-repeat: no-repeat;
}

.banner-conference .icons .icon-eleven {
	position: absolute;
	left: 89% !important;
	top: 80% !important;
	width: 34px;
	height: 20px;
	display: inline-block;
	background-repeat: no-repeat;
}

.banner-conference .icons .icon-twelve {
	position: absolute;
	left: 69% !important;
	top: 70% !important;
	width: 35px;
	height: 16px;
	display: inline-block;
	background-repeat: no-repeat;
}

.banner-conference .icons .icon-thirteen {
	position: absolute;
	left: 200% !important;
	top: 88% !important;
	width: 20px;
	height: 20px;
	display: inline-block;
	background-repeat: no-repeat;
}

.banner-conference .icons .icon-fourteen {
	position: absolute;
	left: 95% !important;
	top: 95% !important;
	width: 20px;
	height: 20px;
	display: inline-block;
	background-repeat: no-repeat;
}

.banner-conference-two .icon-dots {
	left: 40%;
	bottom: 180px;
}

.banner-conference-two .layer-outer {
	position: absolute;
	right: 0;
	top: 0;
	height: 100%;
	width: 50%;
}

.banner-conference-two .images-outer {
	position: absolute;
	right: 0;
	top: 0;
	height: 100%;
	width: 50%;
}

.banner-conference-two .images-outer .speaker-img {
	position: absolute;
	right: 150px;
	top: 52%;
	transform: translateY(-50%);
}

.banner-conference-two .content-box {
	position: relative;
	z-index: 99;
}

.banner-conference-two .content-box .title {
	display: block;
	font-size: 16px;
	color: #ffffff;
	font-weight: 400;
	margin-bottom: 20px;
}

.banner-conference-two .content-box h2 {
	display: block;
	font-size: 50px;
	line-height: 1.2em;
	color: #ffffff;
	font-weight: 700;
	margin-bottom: 50px;
}

.banner-conference-two .time-counter {
	position: relative;
	margin-bottom: 30px;
}

.banner-conference-two .time-countdown {
	position: relative;
}

.banner-conference-two .time-countdown .counter-column {
	position: relative;
	display: inline-block;
	margin-right: 30px;
	width: 90px;
	text-align: center;
	font-size: 14px;
	color: #ffffff;
	font-weight: 500;
}

.banner-conference-two .time-countdown .counter-column:last-child {
	margin-right: 0;
}

.banner-conference-two .time-countdown .counter-column:before {
	position: absolute;
	content: ':';
	top: 10px;
	right: -20px;
	font-size: 30px;
	line-height: 1em;
	color: #ffffff;
}

.banner-conference-two .time-countdown .counter-column:after {
	position: absolute;
	left: 0;
	top: -20px;
	height: 100px;
	width: 90px;
	z-index: -1;
	border-radius: 5px 30px 5px 30px;
	background-color: #ec167f;
	/* border-top: 3px solid #ec167f;
	border-bottom: 3px solid #ec167f; */
	content: "";
}

.banner-conference-two .time-countdown .counter-column:last-child:before {
	display: none;
}

.banner-conference-two .time-countdown .counter-column .count {
	position: relative;
	display: block;
	font-size: 40px;
	line-height: 1em;
	color: #ffffff;
	font-weight: 700;
}

.banner-conference-two .content-box .btn-box {
	position: relative;
	margin-top: 60px;
}







.banner-conference .icon-circle-3 {
	left: -150px;
	top: -150px;
}

.banner-conference .icon-dots {
	left: 40%;
	bottom: 180px;
}


.banner-conference .layer-outer {
	position: absolute;
	right: 0;
	top: 0;
	height: 100%;
	width: 50%;
}

.banner-conference .gradient-layer {
	position: absolute;
	left: 120px;
	width: 140%;
	height: 140%;
	top: -20%;
	border-radius: 50%;
	transform: skew(-200deg);
	background: rgb(247, 0, 104);
	background: linear-gradient(to left, rgba(247, 0, 104) 0%, rgba(68, 16, 102, 1) 100%);
	filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#F70068', endColorstr='#441066', GradientType=1);
	opacity: 2;
}

.banner-conference .images-outer {
	position: absolute;
	right: 0;
	top: 0;
	height: 100%;
	width: 50%;
}

.banner-conference .images-outer .speaker-img {
	position: absolute;
	left: -100px;
	top: 50%;
	transform: translateY(-50%);
}

.banner-conference .content-box {
	position: relative;
	z-index: 99;
}

.banner-conference .content-box .title {
	display: block;
	font-size: 24px;
	color: #222222;
	font-weight: 500;
	margin-bottom: 20px;
}

.banner-conference .content-box h2 {
	display: block;
	font-size: 54px;
	line-height: 1.2em;
	color: #e78f45;
	background: rgb(247, 0, 104);
	background: linear-gradient(to left, rgba(247, 0, 104) 0%, rgba(68, 16, 102, 1) 100%);
	filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#F70068', endColorstr='#441066', GradientType=1);
	color: transparent;
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;
	font-weight: 700;
	margin-bottom: 50px;
}

.banner-conference .time-counter {
	position: relative;
	margin-bottom: 30px;
}

.banner-conference .time-countdown {
	position: relative;
}

.banner-conference .time-countdown .counter-column {
	position: relative;
	display: inline-block;
	margin-right: 30px;
	width: 80px;
	text-align: center;
	font-size: 14px;
	color: #4a763c;
	font-weight: 500;
}

.banner-conference .time-countdown .counter-column:last-child {
	margin-right: 0;
}


.banner-conference .time-countdown .counter-column:before {
	position: absolute;
	content: ':';
	top: 10px;
	right: -20px;
	font-size: 30px;
	line-height: 1em;
	color: #d84343;
}

.banner-conference .time-countdown .counter-column:after {
	position: absolute;
	left: 0;
	top: -20px;
	height: 80px;
	width: 80px;
	border-radius: 50px;
	border-top: 5px solid #d84343;
	content: "";
}


.banner-conference .time-countdown .counter-column:last-child:before {
	display: none;
}

.banner-conference .time-countdown .counter-column .count {
	position: relative;
	display: block;
	font-size: 40px;
	line-height: 1em;
	color: #d84343;
	font-weight: 700;
}

.banner-conference .content-box .btn-box {
	position: relative;
}

/***

====================================================================
		Banner MeetUp
====================================================================

***/

.banner-meetup {
	position: relative;
	padding: 140px 0;
	z-index: 1;
}

.banner-meetup .bg-pattern {
	position: absolute;
	right: 0;
	top: 0;
	width: 100%;
	height: 100%;
	background-repeat: no-repeat;
	background-position: center;
	background-size: cover;
}

.banner-meetup .content-box {
	position: relative;
	text-align: center;
}

.banner-meetup h2 {
	display: block;
	font-size: 80px;
	line-height: 1.2em;
	color: #ffffff;
	font-weight: 700;
	margin-bottom: 40px;
	text-shadow: 0 20px 40px rgba(0, 0, 0, .80);
}

.banner-meetup .address {
	position: relative;
	display: block;
	font-size: 20px;
	line-height: 26px;
	color: #ffffff;
	font-weight: 700;
	text-align: center;
	margin-bottom: 20px;
	text-shadow: 0 10px 20px rgba(0, 0, 0, 0.80);
}

.banner-meetup .address .icon {
	position: relative;
	display: inline-block;
	margin-right: 10px;
	font-size: 18px;
	line-height: 26px;
	color: #ec167f;
}

.banner-meetup .btn-box {
	position: relative;
	text-align: center;
	margin-top: 30px;
}

.banner-meetup .btn-box .theme-btn {
	padding: 15px 34px;
	line-height: 20px;
	border-radius: 5px;
	font-weight: 700;
}

.banner-meetup .countdown {
	position: relative;
	text-align: center;
	font-family: 'Orbitron', sans-serif;
}

.banner-meetup .countdown .time-counter {
	position: relative;
	display: inline-block;
}

.banner-meetup .countdown .counter-column:before {
	position: absolute;
	content: '';
	left: -10px;
	top: -15px;
	width: 120px;
	height: 120px;
	opacity: 0.5;
	border: 2px solid #ffffff;
	transform: rotate(45deg);
}

.banner-meetup .countdown .counter-column {
	position: relative;
	display: inline-block;
	line-height: 30px;
	font-size: 16px;
	font-weight: 700;
	text-transform: uppercase;
	background-color: transparent;
	border-radius: 50%;
	color: #fafafa;
	width: 100px;
	margin: 0 20px 30px;
	text-shadow: 0 10px 20px rgba(0, 0, 0, 0.60);

}

.banner-meetup .countdown .counter-column .count {
	position: relative;
	display: block;
	font-size: 45px;
	line-height: 1.2em;
	color: #fafafa;
	width: auto;
	font-weight: 600;
	letter-spacing: 0;
	text-shadow: 0 15px 20px rgba(0, 0, 0, 0.60);
}

.banner-meetup .btn-box .theme-btn {
	position: relative;
	box-shadow: 0 20px 30px rgba(0, 0, 0, 0.30);
}


/***

====================================================================
		About Section
====================================================================

***/

.about-section {
	position: relative;
	padding: 50px 0 30px;
}

.about-section .content-column {
	position: relative;
	margin-bottom: 50px;
}

.about-section .content-column .inner-column {
	position: relative;
	padding-right: 80px;
}

.about-section .content-column .sec-title {
	position: relative;
	margin-bottom: 20px;
}

.about-section .content-column .sec-title .text {
	margin-top: 20px;
}

.about-section .content-column .sec-title h2 {
	font-size: 40px;
}

.about-section .content-column .list-style-one {
	margin-bottom: 30px;
}

.about-section .content-column .btn-box {
	position: relative;
}

.about-section .content-column .btn-box a {
	padding: 15px 30px;
	line-height: 20px;
	font-weight: 600;
	font-size: 15px;
}

.about-section .image-column {
	position: relative;
	margin-bottom: 50px;
}

.about-section .image-column .image-box {
	position: relative;
	padding-left: 80px;
}

.about-section .image-column .image-box img {
	position: relative;
	z-index: 1;
	border-radius: 50%;
	border: 15px solid #ffffff;
	box-shadow: 0 0 20px rgba(0, 0, 0, 0.10);
}

.about-section .image-column .image {
	position: relative;
	margin-bottom: 0;
}

.about-section .image-column .image:before {
	position: absolute;
	right: -10%;
	top: -10%;
	height: 120%;
	width: 120%;
	/* background-image: url(../images/icons/shape-2.png); */
	background-repeat: no-repeat;
	background-position: center;
	background-size: 100%;
	animation: dizzling 10s infinite;
	transition: all 300ms ease;
	content: "";
}

@keyframes dizzling {
	0% {
		transform: rotate(0);
	}

	50% {
		transform: rotate(5deg);
	}

	100% {
		transform: rotate(0);
	}
}

.icon-shape-1 {
	width: 484px;
	height: 225px;
	/* background-image: url(../images/icons/shape-1.png); */
}

.icon-shape-2 {
	width: 325px;
	height: 280px;
	/* background-image: url(../images/icons/shape-2.png); */
}

.icon-line-1 {
	width: 128px;
	height: 128px;
	/* background-image: url(../images/icons/icon-line-1.png); */
}

.icon-dots {
	width: 72px;
	height: 60px;
	/* background-image: url(../images/icons/icon-dots.png); */
}

.icon-dots-3 {
	width: 204px;
	height: 114px;
	/* background-image: url(../images/icons/icon-dots-3.png); */
}

.icon-circle-1 {
	width: 500px;
	height: 500px;
	/* background-image: url(../images/icons/icon-circle-1.png); */
	background-size: 100%;
}

.icon-circle-blue {
	width: 300px;
	height: 300px;
	/* background-image: url(../images/icons/circle-blue.png); */
}

.about-section .icon-circle-blue {
	right: -150px;
	bottom: -150px;
	opacity: .70;
	animation: fa-spin 30s infinite;
}

.about-section .icon-dots {
	left: 50%;
	top: 30%;
}

.about-section .icon-circle-1 {
	left: -200px;
	top: -200px;
	opacity: .05;
}

/***

====================================================================
		About Section Two
====================================================================

***/

.about-section-two {
	position: relative;
	padding: 50px 0 70px;
}

.about-section-two .content-column {
	position: relative;
	margin-bottom: 50px;
}

.about-section-two .content-column .inner-column {
	position: relative;
	padding-top: 50px;
}

.about-section-two .content-column .sec-title {
	position: relative;
	margin-bottom: 20px;
}

.about-section-two .content-column .sec-title .text {
	margin-top: 20px;
}

.about-section-two .content-column .sec-title h2 {
	font-size: 40px;
}

.about-section-two .content-column .list-style-one {
	margin-bottom: 30px;
}

.about-section-two .content-column .btn-box {
	position: relative;
}

.about-section-two .content-column .btn-box a {
	padding: 15px 30px;
	line-height: 20px;
	font-weight: 600;
	font-size: 15px;
}

.about-section-two .about-block {
	position: relative;
	margin-bottom: 30px;
}

.about-section-two .about-block .inner-box {
	position: relative;
}

.about-section-two .about-block h4 {
	position: relative;
	padding-left: 35px;
	font-size: 24px;
	line-height: 50px;
	color: #24293d;
}

.about-section-two .about-block .icon {
	position: absolute;
	left: 0;
	top: 0;
	font-size: 24px;
	line-height: 50px;
	color: #e6275a;
}

.about-section-two .about-block .text {
	font-size: 16px;
	color: #888888;
	line-height: 1.2em;
	font-weight: 500;
}

.about-section-two .image-column {
	position: relative;
	margin-bottom: 50px;
}

.about-section-two .image-column .image-box {
	position: relative;
	padding-right: 50px;
}

.about-section-two .image-column .image-box img {
	display: block;
	width: 100%;
	z-index: 1;
}

.about-section-two .image-column .image {
	position: relative;
	margin-bottom: 0;
}

.about-section-two .image-column .image:before {
	position: absolute;
	left: -1px;
	top: -1px;
	right: -1px;
	bottom: -1px;
	/* background-image: url(../images/icons/icon-shape.png); */
	background-repeat: no-repeat;
	background-position: center;
	background-size: cover;
	content: "";
	z-index: 8;
}


.about-section-two .icon-circle-blue {
	left: -150px;
	bottom: -150px;
	opacity: .70;
	animation: fa-spin 30s infinite;
}

.about-section-two .icon-dots {
	left: 5%;
	top: 20%;
}

.about-section-two .icon-circle-1 {
	right: -200px;
	top: -200px;
	opacity: .05;
}

/***

====================================================================
		Coming Soon
====================================================================

***/

.coming-soon-section {
	position: relative;
	z-index: 2;
}

.coming-soon-section .outer-box {
	position: relative;
	display: block;
	padding: 30px 80px;
	background-color: #ffffff;
	text-align: center;
	margin-top: -72px;
	background: #FFA886;
	background: linear-gradient(to left, #A28089, #C63800);
	filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#F70068', endColorstr='#441066', GradientType=1);
	box-shadow: 0 0 30px rgba(0, 0, 0, 0.30);
	border-radius: 10px;
}

.coming-soon-section .timer-column {
	position: relative;
}

.coming-soon-section .time-counter {
	position: relative;
}

.coming-soon-section .time-countdown {
	position: relative;
}

.coming-soon-section .time-countdown .counter-column {
	position: relative;
	display: inline-block;
	margin: 0px 40px;
	width: 100px;
	text-align: center;
	font-size: 18px;
	color: #ffffff;
	font-weight: 500;
}

.coming-soon-section .time-countdown .counter-column:before {
	position: absolute;
	content: ':';
	top: 10px;
	right: -50px;
	font-size: 56px;
	line-height: 1em;
	color: #ffffff;
}

.coming-soon-section .time-countdown .counter-column:last-child:before {
	display: none;
}

.coming-soon-section .time-countdown .counter-column .count {
	position: relative;
	display: block;
	font-size: 60px;
	line-height: 1em;
	color: #ffffff;
	font-weight: 700;
}

/***

====================================================================
		Features Section
====================================================================

***/

.features-section {
	position: relative;
	padding: 120px 0 80px;
}

.feature-block {
	position: relative;
	margin-bottom: 40px;
}

.feature-block .inner-box {
	position: relative;
	padding: 40px 30px;
	background-color: #ffffff;
	border: 1px solid #eeeeee;
	box-shadow: 0 30px 40px rgba(0, 0, 0, 0.10);
	transition: all 500ms ease;
	text-align: center;
	overflow: hidden;
}

.feature-block .inner-box:hover {
	box-shadow: none;
}

.feature-block .icon-box {
	position: relative;
	display: block;
	margin-bottom: 30px;
}

.feature-block .icon-box .icon {
	position: relative;
	display: inline-block;
	font-size: 70px;
	line-height: 1em;
	color: #40cbb4;
	transition: all 400ms ease;
}

.feature-block:nth-child(3n + 2) h4 a:hover,
.feature-block:nth-child(3n + 2) .icon-box .icon {
	color: #4c35a9;
}

.feature-block:nth-child(3n + 3) h4 a:hover,
.feature-block:nth-child(3n + 3) .icon-box .icon {
	color: #e6275a;
}

.feature-block .inner-box:hover .icon-box .icon {
	transform: scale(-1) rotate(180deg);
}

.feature-block h4 {
	position: relative;
	display: block;
	font-size: 22px;
	line-height: 1.2em;
	color: #12114a;
	font-weight: 700;
	margin-bottom: 20px;
}

.feature-block h4 a {
	color: #12114a;
	display: inline-block;
	transition: all 300ms ease;
}

.feature-block h4 a:hover {
	color: #40cbb4;
}

.feature-block .text {
	position: relative;
	display: block;
	font-size: 15px;
	line-height: 24px;
	color: #888888;
	font-weight: 400;
	margin-bottom: 25px;
	cursor: default;
}

.feature-block .link-box {
	position: relative;
	display: block;
}

.feature-block .link-box a {
	position: relative;
	display: inline-block;
	padding: 10px 20px;
	line-height: 20px;
	font-size: 14px;
	color: #ffffff;
	background-color: #40cbb4;
	border-radius: 10px;
	border-top: 2px solid transparent;
	border-bottom: 2px solid transparent;
	transition: all 400ms ease;
}

.feature-block .inner-box:hover .link-box a {
	border-radius: 0px;
	color: #40cbb4;
	background: none;
	border-color: #40cbb4;
}

.feature-block:nth-child(3n + 2) .link-box a {
	background-color: #4c35a9;
}

.feature-block:nth-child(3n + 2) .inner-box:hover .link-box a {
	background: none;
	color: #4c35a9;
	border-color: #4c35a9;
}

.feature-block:nth-child(3n + 3) .link-box a {
	background-color: #e6275a;
}

.feature-block:nth-child(3n + 3) .inner-box:hover .link-box a {
	background: none;
	color: #e6275a;
	border-color: #e6275a;
}

.features-section .anim-icons {
	max-width: 100%;
}

.icon-shape-3 {
	height: 490px;
	width: 290px;
	/* background-image: url(../images/icons/shape-3.png); */
	background-size: 100%;
}

.features-section .icon-shape-3 {
	top: 0px;
	left: -110px;
	opacity: .70;
	transform: scaleX(-1);
}

.features-section .icon-line-1 {
	right: 10%;
	top: 35%;
	animation: fa-spin 30s infinite alternate;
}

.features-section .icon-dots {
	right: 10%;
	top: 35%;
}

/***

====================================================================
	Features Section Two
====================================================================

***/

.features-section-two {
	position: relative;
	padding: 120px 0 15px;
}

.features-section-two .title-block {
	position: relative;
	margin-bottom: 40px;
}

.features-section-two .title-block .inner-box {
	padding: 50px 30px 0;
	background-color: #ffffff;
}

.features-section-two .title-block .sec-title {
	margin-bottom: 0;
}

.features-section-two .title-block .sec-title .title {
	margin-bottom: 5px;
}

.feature-block-two {
	position: relative;
	margin-bottom: 40px;
}

.feature-block-two .inner-box {
	position: relative;
	padding: 40px 30px;
	padding-left: 100px;
	background-color: #ffffff;
	border: 1px solid #eeeeee;
	box-shadow: 0 30px 40px rgba(0, 0, 0, 0.10);
	transition: all 500ms ease;
	overflow: hidden;
}

.feature-block-two .inner-box:hover {
	box-shadow: none;
}

.feature-block-two .icon-box {
	position: absolute;
	left: 30px;
	top: 50px;
	display: block;
	margin-bottom: 30px;
}

.feature-block-two .icon-box .icon {
	position: relative;
	display: inline-block;
	font-size: 50px;
	line-height: 1em;
	background: rgb(247, 0, 104);
	background: linear-gradient(to left, rgba(247, 0, 104) 0%, rgba(68, 16, 102, 1) 100%);
	filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#F70068', endColorstr='#441066', GradientType=1);
	background: none;
	color: #f14b59;
	transition: all 400ms ease;
}

.feature-block-two .inner-box:hover .icon-box .icon {
	transform: scale(-1) rotate(180deg);
}

.feature-block-two h4 {
	position: relative;
	display: block;
	font-size: 22px;
	line-height: 1.2em;
	color: #12114a;
	font-weight: 700;
	margin-bottom: 10px;
}

.feature-block-two h4 a {
	color: #12114a;
	display: inline-block;
	transition: all 300ms ease;
}

.feature-block-two h4 a:hover {
	color: #f14b59;
}

.feature-block-two .text {
	position: relative;
	display: block;
	font-size: 15px;
	line-height: 24px;
	color: #888888;
	font-weight: 400;
	cursor: default;
}

.feature-block-two .link-box {
	position: relative;
	display: block;
}

.feature-block-two .link-box a {
	padding: 10px 20px;
	line-height: 20px;
	font-size: 14px;
}

.features-section-two .twist-line-1 {
	left: -110px;
	top: 290px;
}

.features-section-two .twist-line-2 {
	left: -10%;
	top: 80px;
}

.features-section-two .twist-line-3 {
	left: 90px;
	top: 50px;
}

.twist-line-1 {
	height: 70px;
	width: 80px;
}

.twist-line-2 {
	height: 73px;
	width: 70px;
	/* background-image: url(../images/icons/twist-line-2.png); */
}

.twist-line-3 {
	height: 73px;
	width: 70px;
	/* background-image: url(../images/icons/twist-line-3.png); */
}

/***

====================================================================
	Features Section Three
====================================================================

***/

.features-section-three {
	position: relative;
	padding: 120px 0 80px;
}

.features-section-three.no-pd-top {
	padding-top: 0;
}

.feature-block-three {
	position: relative;
	margin-bottom: 40px;
}

.feature-block-three .inner-box {
	position: relative;
	padding: 20px 30px;
	padding-left: 170px;
	padding-right: 100px;
	background-color: #ffffff;
	border: 1px solid #eeeeee;
	box-shadow: 0 30px 40px rgba(0, 0, 0, 0.10);
	transition: all 500ms ease;
	overflow: hidden;
}

.feature-block-three .inner-box:hover {
	box-shadow: none;
}

.feature-block-three .icon-box {
	position: absolute;
	left: 50px;
	top: 0;
	height: 100%;
	width: 70px;
	padding: 0 20px;
}

.feature-block-three .icon-box:before {
	position: absolute;
	left: 0;
	top: 0;
	height: 100%;
	width: 100%;
	background-color: #40cbb4;
	content: "";
	transform: skew(-15deg);
	transition: all 600ms ease;
}

.feature-block-three .inner-box:hover .icon-box:before {
	transform: skew(15deg);
}

.feature-block-three .icon-box .icon {
	position: absolute;
	left: 50%;
	top: 50%;
	width: 40px;
	font-size: 40px;
	line-height: 1em;
	margin-top: -20px;
	margin-left: -20px;
	color: #ffffff;
	transition: all 400ms ease;
}

.feature-block-three .inner-box:hover .icon-box .icon {
	transform: scale(-1) rotate(180deg);
}

.feature-block-three h4 {
	position: relative;
	display: block;
	font-size: 20px;
	line-height: 1.2em;
	color: #12114a;
	font-weight: 700;
	margin-bottom: 10px;
}

.feature-block-three h4 a {
	color: #12114a;
	display: inline-block;
	transition: all 300ms ease;
}

.feature-block-three h4 a:hover {
	color: #40cbb4;
}

.feature-block-three .text {
	position: relative;
	display: block;
	font-size: 14px;
	line-height: 24px;
	color: #888888;
	font-weight: 400;
	cursor: default;
}

.feature-block-three .link-box {
	position: absolute;
	right: 30px;
	top: 50%;
	margin-top: -20px;
	font-size: 20px;
	border-radius: 50%;
}

.feature-block-three .link-box a {
	position: relative;
	display: inline-block;
	padding: 10px 20px;
	line-height: 20px;
	font-size: 14px;
	color: #ffffff;
	background-color: #40cbb4;
	border-radius: 10px;
	transition: all 600ms ease;
}

.feature-block-three .inner-box:hover .link-box a {
	transform: rotate(360deg);
	border-radius: 0px;
}

.feature-block-three .inner-box:hover .link-box a {
	color: #ffffff;
	box-shadow: 0 10px 20px rgba(0, 0, 0, 0.10);
}

.feature-block-three:nth-child(3n + 2) .icon-box:before,
.feature-block-three:nth-child(3n + 2) .link-box a {
	background-color: #4c35a9;
}

.feature-block-three:nth-child(3n + 3) .icon-box:before,
.feature-block-three:nth-child(3n + 3) .link-box a {
	background-color: #e6275a;
}

.feature-block-three:nth-child(3n + 4) .icon-box:before,
.feature-block-three:nth-child(3n + 4) .link-box a {
	background-color: #1c94d2;
}


/***

====================================================================
			Fluid Section One
====================================================================

***/

.fluid-section-one {
	position: relative;
	background-color: #41cbb4;
}

.fluid-section-one .outer-box {
	position: relative;
}

.fluid-section-one .content-column {
	position: relative;
	float: right;
	width: 50%;
	padding: 0 15px;
}

.fluid-section-one .content-column .inner-column {
	position: relative;
	max-width: 600px;
	padding: 80px 20px;
	margin: 0 auto;
}

.fluid-section-one .content-column h3 {
	position: relative;
	font-size: 40px;
	line-height: 1.2em;
	color: #ffffff;
	font-weight: 700;
	margin-bottom: 28px;
}

.fluid-section-one .content-column .text {
	font-size: 16px;
	line-height: 30px;
	color: #ffffff;
	margin-bottom: 30px;
}

.fluid-section-one .content-column .theme-btn {
	border-radius: 5px;
	box-shadow: 0 10px 30px rgba(80, 4, 42, .15);
}

.fluid-section-one .image-column {
	position: absolute;
	left: 0;
	top: 0;
	height: 100%;
	width: 50%;
	background-repeat: no-repeat;
	background-position: center left;
	background-size: cover;
}

.fluid-section-one .image-column .image-box {
	display: none;
}

.fluid-section-one .image-column .image {
	position: relative;
	margin-bottom: 0;
}

.fluid-section-one .image-column .image img {
	display: block;
	width: 100%;
	height: auto;
}


/***

====================================================================
		Speakers Section
====================================================================

***/

.speakers-section {
	position: relative;
	padding: 60px 0 90px;
}

.speakers-section:before {
	position: absolute;
	left: 0;
	top: 0;
	height: 100%;
	width: 100%;
	background-color: rgba(28, 139, 210, .50);
	content: "";
}

.speaker-block {
	position: relative;
	margin-bottom: 40px;
}

.speaker-block .inner-box {
	position: relative;
	overflow: hidden;
	border-radius: 50%;
	border: 6px solid #ffffff;
	box-shadow: 0 30px 30px rgba(0, 0, 0, 0.40);
	width: 257px;
	height: 251px;
	margin: 0 auto;
	transition: all 500ms ease;

}

.speaker-block .inner-box:hover {
	box-shadow: none;
}

.speaker-block .image-box {
	position: relative;
}

.speaker-block .image-box .image {
	position: relative;
	margin-bottom: 0;
}

.speaker-block .image-box .image img {
	display: block;
	width: 100%;
	transition: all 300ms ease;
}

.speaker-block .inner-box:hover .image img {
	opacity: .80;
	transform: scale(1.1);
}

.speaker-block .info-box {
	position: absolute;
	left: 0px;
	top: 0px;
	right: 0px;
	bottom: 0px;
	text-align: center;
	background-color: rgba(28, 139, 210, .70);
	background-color: rgba(237, 23, 127, .90);
	transition: transform 0.4s ease;
	transform: scale(0, 1);
	transform-origin: right center;
}

.speaker-block .inner-box:hover .info-box {
	transform: scale(1, 1);
	transform-origin: left center;
	opacity: 1;
}


.speaker-block .info-box .inner {
	position: absolute;
	left: 0;
	width: 100%;
	top: 50%;
	transform: translateY(-50%);
	padding: 0 40px;
}

.speaker-block .info-box .name {
	position: relative;
	display: block;
	font-size: 22px;
	line-height: 1.2em;
	color: #ffffff;
	font-weight: 700;
	opacity: 0;
	margin-bottom: 5px;
	transform: translateY(20px);
	transition: all 300ms ease;
}

.speaker-block .inner-box:hover .info-box .name {
	opacity: 1;
	transform: translateY(0px);
	transition-delay: 300ms;
}


.speaker-block .info-box .name a {
	color: #ffffff;
	transition: all 300ms ease;
}

.speaker-block .info-box .name a:hover {}

.speaker-block .info-box .designation {
	position: relative;
	display: block;
	font-size: 13px;
	line-height: 30px;
	color: #ffffff;
	font-weight: 400;
	margin-bottom: 15px;
	opacity: 0;
	transform: translateY(20px);
	transition: all 300ms ease;
}

.speaker-block .inner-box:hover .info-box .designation {
	opacity: 1;
	transform: translateY(0px);
	transition-delay: 500ms;
}

.speaker-block .social-links {
	position: relative;
	opacity: 0;
	transform: translateY(20px);
	transition: all 300ms ease;
}

.speaker-block .inner-box:hover .social-links {
	opacity: 1;
	transform: translateY(0px);
	transition-delay: 700ms;
}

.speaker-block .social-links li {
	position: relative;
	display: inline-block;
	margin-bottom: 10px;
}

.speaker-block .social-links li a i {
	position: relative;
	display: block;
	width: 32px;
	height: 32px;
	font-size: 16px;
	line-height: 30px;
	background-color: #ffffff;
	text-align: center;
	transition: all 300ms ease;
}

.speaker-block .social-links li a:hover i {
	color: #ffffff;
}

/***

====================================================================
	Speakers Section Two
====================================================================

***/

.speakers-section-two {
	position: relative;
	padding: 120px 0 70px;
	overflow: hidden;
}

.speaker-block-two {
	position: relative;
	margin-bottom: 50px;
}

.speaker-block-two .inner-box {
	position: relative;
	background-color: #ffffff;
	overflow: hidden;
	padding: 50px 0 40px;
	box-shadow: 0 20px 30px rgba(0, 0, 0, 0.10);
	border: 1px solid #dddddd;
	border-bottom: 5px solid #1c94d2;
	max-width: 300px;
	margin: 0 auto;
	transition: all 600ms ease;
}

.speaker-block-two .inner-box:hover {
	box-shadow: none;
}

.speaker-block-two .inner-box:before {
	position: absolute;
	left: 0;
	top: 0;
	height: 100%;
	width: 100%;
	/* background-image: url(../images/icons/speaker-bg.png); */
	background-repeat: no-repeat;
	background-position: center;
	background-size: 100%;
	content: "";
	opacity: .30;
}

.speaker-block-two .info-box {
	position: relative;
	display: inline-block;
	padding: 10px 30px;
	border-radius: 0 30px 30px 0;
	background-color: #1c94d2;
	margin-bottom: 50px;
}

.speaker-block-two .info-box .name {
	position: relative;
	font-size: 18px;
	line-height: 1.2em;
	color: #ffffff;
	font-weight: 500;
}

.speaker-block-two .info-box .name a {
	color: #ffffff;
	transition: all 300ms ease;
}

.speaker-block-two .info-box .name a:hover {
	color: #ffffff;
}

.speaker-block-two .info-box .designation {
	position: relative;
	display: block;
	font-size: 14px;
	line-height: 20px;
	color: #ffffff;
	font-weight: 400;
}

.speaker-block-two .image-box {
	position: relative;
	display: block;
	margin-bottom: 30px;
	text-align: center;
}

.speaker-block-two .image-box .image {
	position: relative;
	display: inline-block;
	height: 150px;
	width: 150px;
	overflow: hidden;
	border: 4px solid #1c94d2;
	box-shadow: 0 0 20px rgba(0, 0, 0, 0.10);
	border-radius: 50%;
	z-index: 9;
	margin-bottom: 0;
}

.speaker-block-two .image-box .image img {
	display: block;
	width: 100%;
	transition: all 300ms ease;
}

.speaker-block-two .inner-box:hover .image img {
	transform: scale(1.1);
}

.speaker-block-two .social-box {
	position: relative;
	display: block;
	text-align: center;
}

.speaker-block-two .social-links li {
	position: relative;
	display: inline-block;
	margin-bottom: 10px;
}

.speaker-block-two .social-links li a i {
	position: relative;
	display: block;
	width: 32px;
	height: 32px;
	border: 1px solid #eeeeee;
	font-size: 16px;
	line-height: 30px;
	background-color: #ffffff;
	text-align: center;
	transition: all 300ms ease;
}

.speaker-block-two .social-links li a:hover i {
	color: #ffffff;
}

.speakers-section-two .anim-icons {
	max-width: 100%;
}

.speakers-section-two .icon-shape-1 {
	transform: scale(-1);
	left: 0;
	top: 0;
}

.speakers-section-two .icon-circle-3 {
	left: -90px;
	bottom: -90px;
	opacity: .70;
}

.speakers-section-two .icon-circle-4 {
	right: -75px;
	top: 30%;
}

.icon-circle-4 {
	height: 156px;
	width: 156px;
	/* background-image: url(../images/icons/icon-circle-4.png); */
}

.icon-circle-3 {
	height: 360px;
	width: 360px;
	/* background-image: url(../images/icons/icon-circle-3.png); */
	background-size: 100%;
}

/***

====================================================================
	Speakers Section Three
====================================================================

***/

.speakers-section-three {
	position: relative;
	padding: 120px 0 90px;
	background-repeat: no-repeat;
	background-position: center;
	background-size: cover;
	overflow: hidden;
}

.speaker-block-three {
	position: relative;
	margin-bottom: 50px;
}

.speaker-block-three .inner-box {
	position: relative;
	background-color: #ffffff;
	overflow: hidden;
	padding-bottom: 30px;
	max-width: 300px;
	margin: 0 auto;
	overflow: hidden;
	box-shadow: 0 20px 30px rgba(0, 0, 0, 0.10);
	transition: all 600ms ease;
}

.speaker-block-three .inner-box:hover {
	box-shadow: 0 0px 5px rgba(0, 0, 0, 0.10);
}

.speaker-block-three .image-box {
	position: relative;
	display: block;
	text-align: center;
	padding: 25px 0;
}

.speaker-block-three .image-box:before {
	position: absolute;
	left: -10px;
	right: -10px;
	top: -4px;
	height: 100%;
	/* background-image: url(../images/icons/shape-5.png); */
	transform: scale(-1);
	background-repeat: no-repeat;
	background-position: right top;
	background-size: cover;
	content: "";
}

.speaker-block-three .image-box .image {
	position: relative;
	display: inline-block;
	height: 200px;
	width: 200px;
	overflow: hidden;
	border: 4px solid #682372;
	box-shadow: 0 0 20px rgba(0, 0, 0, 0.30);
	border-radius: 50%;
	z-index: 9;
	margin-bottom: 0;
	transition: all 600ms ease;
}

.speaker-block-three .inner-box:hover .image-box .image {
	border-radius: 0px;
}

.speaker-block-three .image-box .image img {
	display: block;
	width: 100%;
	transition: all 300ms ease;
}

.speaker-block-three .inner-box:hover .image img {
	transform: scale(1.1);
}

.speaker-block-three .info-box {
	position: relative;
	display: inline-block;
	padding: 10px 30px;
	padding-right: 10px;
	background-color: #f20487;
}

.speaker-block-three .info-box:before {
	position: absolute;
	left: 0;
	right: -30px;
	background-color: #f20487;
	content: "";
	top: 0;
	height: 100%;
	transform: skew(-30deg);
	border-radius: 0 14px 14px 0;
}

.speaker-block-three .info-box .name {
	position: relative;
	font-size: 18px;
	line-height: 1.2em;
	color: #ffffff;
	font-weight: 500;
}

.speaker-block-three .info-box .name a {
	color: #ffffff;
	transition: all 300ms ease;
}

.speaker-block-three .info-box .name a:hover {
	color: #ffffff;
}

.speaker-block-three .info-box .designation {
	position: relative;
	display: block;
	font-size: 14px;
	line-height: 20px;
	color: #ffffff;
	font-weight: 400;
}

.speaker-block-three .social-box {
	position: absolute;
	top: 90px;
	left: -8px;
	transform: translateX(-50px);
	transition: all 600ms ease;
}

.speaker-block-three .social-box .social-links li {
	margin-bottom: 2px;
}

.speaker-block-three .inner-box:hover .social-box {
	transform: translateX(10px);
}

.speaker-block-two .social-links li {
	position: relative;
	display: inline-block;
	margin-bottom: 10px;
}

.speaker-block-three .social-links li a i {
	position: relative;
	display: block;
	width: 32px;
	height: 32px;
	border: 1px solid #eeeeee;
	font-size: 16px;
	line-height: 30px;
	background-color: #ffffff;
	text-align: center;
	transition: all 300ms ease;
}

.speaker-block-three .social-links li a:hover i {
	color: #ffffff;
}

/***

====================================================================
	Speker Detail
====================================================================

***/

.speaker-detail {
	position: relative;
	padding: 120px 0 70px;
}

.speaker-detail .image-column {
	position: relative;
	margin-bottom: 50px;
}

.speaker-detail .image-column .image-box {
	position: relative;
	padding-right: 20px;
}

.speaker-detail .image-column .image {
	position: relative;
	margin-bottom: 30px;
	overflow: hidden;
	border: 10px solid #ffffff;
	box-shadow: 0 0 30px rgba(0, 0, 0, 0.10);
}

.speaker-detail .image-column .image img {
	display: block;
	width: 100%;
}

.speaker-detail .info-column {
	position: relative;
}

.speaker-detail .info-column .inner-column {
	position: relative;
}

.speaker-detail .info-column h1 {
	position: relative;
	font-size: 50px;
	line-height: 1em;
	font-weight: 700;
	margin-bottom: 20px;
}

.speaker-detail .info-column h3 {
	position: relative;
	display: block;
	font-size: 40px;
	line-height: 1em;
	font-weight: 600;
	margin-bottom: 20px;
	color: #101130;
}

.speaker-detail .info-column h4 {
	position: relative;
	display: block;
	font-size: 24px;
	line-height: 1em;
	font-weight: 500;
	margin-bottom: 20px;
	color: #222222;
}

.speaker-detail .info-column h5 {
	position: relative;
	display: block;
	font-size: 18px;
	line-height: 1em;
	font-weight: 500;
	margin-bottom: 10px;
	color: rgba(68, 16, 102, 1);
}

.speaker-detail .info-column .text-box {
	position: relative;
}

.speaker-detail .info-column p {
	position: relative;
	font-size: 16px;
	line-height: 1.6em;
	color: #888888;
	margin-bottom: 30px;
}

.speaker-detail .speaker-session-info {
	position: relative;
	margin-bottom: 30px;
}

.speaker-detail .speaker-session-info p {
	margin-bottom: 0;
	color: rgb(247, 0, 104);
}


.speaker-detail .bottom-box {
	position: relative;
	padding-left: 80px;
	min-height: 50px;
	margin-bottom: 30px;
}


/***

====================================================================
	schedule Section
====================================================================

***/

.schedule-section {
	position: relative;
	padding: 120px 0 100px;
	background-repeat: no-repeat;
	background-position: center;
	background-size: cover;
	background-color: #fafafa;
	overflow: hidden;
}

.schedule-section .icon-circle-4 {
	right: -200px;
	bottom: 160px;
}

.schedule-section .icon-circle-3 {
	left: -375px;
	top: 340px;
	opacity: .30;
}

.tabs-box {
	position: relative;
}

.tabs-box .tab {
	display: none;
}

.tabs-box .tab.active-tab {
	display: block;
}

.schedule-tabs {
	position: relative;
	margin-top: 30px;
}

.schedule-tabs .btns-box {
	position: relative;
	display: block;
	margin-bottom: 40px;
}

/* .schedule-tabs .tab-buttons{
	position: relative;
	text-align: center;
} */

.schedule-tabs .tab-buttons li {
	position: relative;
	display: inline-block;
	height: 135px;
	width: 160px;
	border-radius: 20px;
	background-color: #ffffff;
	font-size: 16px;
	line-height: 20px;
	color: #222222;
	font-weight: 600;
	text-align: left;
	padding: 15px 15px;
	padding-top: 60px;
	padding-left: 90px;
	cursor: pointer;
	margin: 0 15px 20px;
	border: 1px solid #dddddd;
	transition: all 300ms ease;
}

.schedule-tabs .tab-buttons li .day {
	position: absolute;
	left: 0px;
	top: 20px;
	padding: 5px 20px;
	background-color: #222222;
	font-size: 14px;
	line-height: 20px;
	font-weight: 600;
	color: #ffffff;
	border-radius: 0 15px 15px 0;
}

.schedule-tabs .tab-buttons li .date {
	position: absolute;
	left: -0;
	top: 80px;
	width: 150px;
	text-align: center;
	font-size: 38px;
	line-height: 20px;
	font-weight: 600;
	color: #222222;
}

.schedule-tabs .tab-buttons li .month {
	display: block;
	font-size: 20px;
	line-height: 1em;
	font-weight: 600;
	color: #222222;
	text-transform: uppercase;
}

.schedule-tabs .tab-buttons li .year {
	font-size: 30px;
}

.schedule-tabs .tab-buttons li.active-btn {
	box-shadow: 0 20px 30px rgba(0, 0, 0, .10);
}

.schedule-tabs .tab-buttons li:nth-child(4n + 1) .day {
	background-color: #ffc20b;
}

.schedule-tabs .tab-buttons li:nth-child(4n + 2) .day {
	background-color: #40cbb4;
}

.schedule-tabs .tab-buttons li:nth-child(4n + 3) .day {
	background-color: #4c35a9;
}

.schedule-tabs .tab-buttons li:nth-child(4n + 4) .day {
	background-color: #e6275a;
}

/* new tab-5 css */
.schedule-tabs .tab-buttons li:nth-child(4n + 5) .day {
	background-color: #05a7dc;
}

/* end  new tab-5 css */

.schedule-tabs .tab-buttons li:nth-child(4n + 1) .month,
.schedule-tabs .tab-buttons li:nth-child(4n + 1) .date {
	color: #ffc20b;
}

.schedule-tabs .tab-buttons li:nth-child(4n + 2) .month,
.schedule-tabs .tab-buttons li:nth-child(4n + 2) .date {
	color: #40cbb4;
}

.schedule-tabs .tab-buttons li:nth-child(4n + 3) .month,
.schedule-tabs .tab-buttons li:nth-child(4n + 3) .date {
	color: #4c35a9;
}

.schedule-tabs .tab-buttons li:nth-child(4n + 4) .month,
.schedule-tabs .tab-buttons li:nth-child(4n + 4) .date {
	color: #e6275a;
}

/* new tab-5 css */
.schedule-tabs .tab-buttons li:nth-child(4n + 5) .month,
.schedule-tabs .tab-buttons li:nth-child(4n + 5) .date {
	color: #e6275a;
}

/* end  new tab-5 css */
.schedule-tabs .tab-buttons li:nth-child(4n + 1).active-btn {
	box-shadow: 0 0px 30px rgba(255, 194, 11, .30);
	border: 1px solid #ffc20b;
}

.schedule-tabs .tab-buttons li:nth-child(4n + 2).active-btn {
	box-shadow: 0 0px 30px rgba(64, 203, 180, .30);
	border: 1px solid #40cbb4;
}

.schedule-tabs .tab-buttons li:nth-child(4n + 3).active-btn {
	box-shadow: 0 0px 30px rgba(76, 53, 169, .30);
	border: 1px solid #4c35a9;
}

.schedule-tabs .tab-buttons li:nth-child(4n + 4).active-btn {
	box-shadow: 0 0px 30px rgba(230, 39, 90, .30);
	border: 1px solid #e6275a;
}

/* new tab-5 css */
.schedule-tabs .tab-buttons li:nth-child(4n + 5).active-btn {
	box-shadow: 0 0px 30px rgba(43, 199, 234, .30);
	border: 1px solid #05a7dc;
}

/* end  new tab-5 css */
.schedule-timeline {
	position: relative;
}

/*=== Schedule Block ===*/

.schedule-block {
	position: relative;
	margin-bottom: -120px;
}

.schedule-block:after {
	display: table;
	clear: both;
	content: "";
}

.schedule-block .inner-box {
	position: relative;
	float: right;
	width: 50%;
	text-align: left;
}

.schedule-block .inner-box .inner {
	position: relative;
	padding: 20px 30px 20px;
	background-color: #ffffff;
	border: 1px solid #dddddd;
	box-shadow: 0 0 30px rgba(0, 0, 0, 0.05);
	margin-left: 80px;
	border-radius: 20px;
}

.schedule-block .inner:before {
	position: absolute;
	top: 0;
	bottom: 240px;
	right: 100%;
	border-left: 2px dashed #dddddd;
	content: "";
	margin-right: 80px;
}

.schedule-block .inner:after {
	position: absolute;
	right: 100%;
	top: 35px;
	border-top: 15px solid transparent;
	border-right: 20px solid #cccccc;
	border-bottom: 15px solid transparent;
	content: "";
}

.schedule-block .date {
	position: absolute;
	left: -132px;
	width: 100px;
	top: 0px;
	height: 100px;
	background-color: #ffffff;
	text-align: center;
	font-size: 14px;
	line-height: 18px;
	color: #212639;
	font-weight: 500;
	padding: 20px 15px 0;
	border-radius: 50%;
	border: 2px dashed #dddddd;
	box-shadow: 0 0 30px rgba(0, 0, 0, 0.05);
}

.schedule-block .speaker-info {
	position: relative;
	padding-left: 80px;
	padding-top: 10px;
	min-height: 60px;
}

.schedule-block .speaker-info .thumb {
	position: absolute;
	left: 0;
	top: 0;
	width: 60px;
	border-radius: 50%;
	overflow: hidden;
}

.schedule-block .speaker-info .name {
	font-size: 16px;
	color: #212639;
	font-weight: 500;
	line-height: 1.2em;
}

.schedule-block .speaker-info .designation {
	font-size: 13px;
}

.schedule-block h4 {
	position: relative;
	font-size: 22px;
	line-height: 1.2em;
	color: #0f1925;
	font-weight: 600;
	margin-bottom: 15px;
	padding-top: 15px;
}

.schedule-block h4 a {
	color: #212639;
	display: inline-block;
	transition: all 300ms ease;
}

.schedule-block h4 a:hover {
	color: #f14b59;
}

.schedule-block .text {
	position: relative;
	font-size: 16px;
	line-height: 26px;
	color: #888888;
	margin-bottom: 15px;
}

.schedule-block .btn-box {
	position: relative;
	padding: 6px 0;
}

.schedule-block .btn-box a {
	padding: 10px 20px;
	line-height: 20px;
	font-size: 14px;
	background-color: #444444;
	color: #ffffff;
	border-top: 2px solid transparent;
	border-bottom: 2px solid transparent;
	border-radius: 5px;
}

.schedule-block .btn-box a:hover {
	color: #ffffff;
	/* box-shadow: 0 10px 20px rgba(0,0,0,0.10); */
}

.schedule-block.even .inner-box {
	float: left;
	text-align: right;
}

.schedule-block.even .inner-box .inner {
	margin-left: 0;
	margin-right: 80px;
}

.schedule-block.even .inner:before {
	right: auto;
	left: 100%;
	margin-left: 80px;
	margin-right: 0;
	bottom: -40px;
}

.schedule-block.even .inner:after {
	right: auto;
	left: 100%;
	border-right: 0;
	border-left: 20px solid #cccccc;
}

.schedule-block:last-child .inner:before {
	display: none;
}

.schedule-block.even .date {
	left: auto;
	right: -132px;
}

.schedule-block.even .speaker-info {
	padding-left: 0;
	padding-right: 80px;
}

.schedule-block.even .speaker-info .thumb {
	left: auto;
	right: 0;
}

.schedule-block:nth-child(4n + 1) .date,
.schedule-block:nth-child(4n + 1) .inner:before {
	border-color: #ffc20b;
	bottom: 188px;
}

.schedule-block:nth-child(4n + 2) .date,
.schedule-block:nth-child(4n + 2) .inner:before {
	border-color: #05a7dc;
}

.schedule-block:nth-child(4n + 3) .date,
.schedule-block:nth-child(4n + 3) .inner:before {
	border-color: #40cbb4;
}

.schedule-block:nth-child(4n + 4) .date,
.schedule-block:nth-child(4n + 4) .inner:before {
	border-color: #4c35a9;
}

.schedule-block:nth-child(4n + 5) .date,
.schedule-block:nth-child(4n + 5) .inner:before {
	border-color: #e6275a;
}


/* Backgroud */

.schedule-block:nth-child(4n + 1) .btn-box a {
	background-color: #ffc20b;
}

.schedule-block:nth-child(4n + 1) .btn-box a:hover {
	color: #ffc20b;
	border-radius: 0px;
	background: none;
	border-color: #ffc20b;
}

.schedule-block:nth-child(4n + 2) .btn-box a {
	background-color: #40cbb4;
}

.schedule-block:nth-child(4n + 2) .btn-box a:hover {
	border-radius: 0px;
	color: #40cbb4;
	background: none;
	border-color: #40cbb4;
}





.schedule-block:nth-child(4n + 3) .btn-box a {
	background-color: #4c35a9;
}

.schedule-block:nth-child(4n + 3) .btn-box a:hover {
	border-radius: 0px;
	color: #4c35a9;
	background: none;
	border-color: #4c35a9;
}



.schedule-block:nth-child(4n + 4) .btn-box a {
	background-color: #e6275a;
}

.schedule-block:nth-child(4n + 4) .btn-box a:hover {
	border-radius: 0px;
	color: #e6275a;
	background: none;
	border-color: #e6275a;
}

.schedule-block:nth-child(4n + 5) .btn-box a {
	background-color: #05a7dc;
}

.schedule-block:nth-child(4n + 5) .btn-box a:hover {
	border-radius: 0px;
	color: #05a7dc;
	background: none;
	border-color: #05a7dc;
}


/* color */

.schedule-section.style-three .schedule-block:nth-child(4n + 1) .date,
.schedule-section.style-two .schedule-block:nth-child(4n + 1) .date,
.schedule-block:nth-child(4n + 1) h4 a:hover {
	color: #ffc20b;
}

.schedule-section.style-three .schedule-block:nth-child(4n + 2) .date,
.schedule-section.style-two .schedule-block:nth-child(4n + 2) .date,
.schedule-block:nth-child(4n + 2) h4 a:hover {
	color: #40cbb4;
}

.schedule-section.style-three .schedule-block:nth-child(4n + 3) .date,
.schedule-section.style-two .schedule-block:nth-child(4n + 3) .date,
.schedule-block:nth-child(4n + 3) h4 a:hover {
	color: #4c35a9;
}

.schedule-section.style-three .schedule-block:nth-child(4n + 4) .date,
.schedule-section.style-two .schedule-block:nth-child(4n + 4) .date,
.schedule-block:nth-child(4n + 4) h4 a:hover {
	color: #e6275a;
}

.schedule-section.style-three .schedule-block:nth-child(4n + 5) .date,
.schedule-section.style-two .schedule-block:nth-child(4n + 5) .date,
.schedule-block:nth-child(4n + 5) h4 a:hover {
	color: #05a7dc;
}

/***

====================================================================
	schedule Section Style two
====================================================================

***/

.schedule-section.style-two {
	position: relative;
}

.schedule-section.style-two .schedule-block .date {
	position: relative;
	left: 0;
	top: 0;
	margin: 0;
	padding: 0;
	border: 0;
	box-shadow: none;
	height: auto;
	width: auto;
	margin-bottom: 20px;
	text-align: left;
	font-size: 16px;
}

.schedule-section.style-two .schedule-block .inner-box {
	width: 100%;
}

.schedule-section.style-two .schedule-block .inner-box .inner {
	margin: 0;
	padding: 50px 50px 40px;
	box-shadow: 0 0 30px rgba(0, 0, 0, 0.10);
}

.schedule-section.style-two .schedule-block .inner:before,
.schedule-section.style-two .schedule-block .inner:after {
	display: none;
}

.schedule-section.style-two .schedule-timeline {
	position: relative;
	max-width: 900px;
	margin: 0 auto;
}

/***

====================================================================
	schedule Section Style Three
====================================================================

***/

.schedule-section.style-three {
	position: relative;
}

.schedule-tabs.style-three .tab-buttons li {
	float: left;
	width: 25%;
	margin: 0;
	box-shadow: none;
	border-radius: 0;
	border-color: transparent;
}

.schedule-tabs.style-three .tab-buttons li.active-btn {
	z-index: 2;
}

.schedule-section.style-three .schedule-block .date {
	position: relative;
	left: 0;
	top: 0;
	margin: 0;
	padding: 0;
	border: 0;
	box-shadow: none;
	height: auto;
	width: auto;
	margin-bottom: 20px;
	text-align: left;
	font-size: 16px;
}

.schedule-section.style-three .schedule-block .inner-box {
	width: 100%;
}

.schedule-section.style-three .schedule-block .inner-box .inner {
	margin: 0;
	padding: 50px 50px 40px;
	box-shadow: 0 0 30px rgba(0, 0, 0, 0.10);
}

.schedule-section.style-three .schedule-block .inner:before,
.schedule-section.style-three .schedule-block .inner:after {
	display: none;
}

.schedule-section.style-three .schedule-timeline {
	position: relative;
}

/***

====================================================================
		Event Detail
====================================================================

***/

.event-detail {
	position: relative;
	padding: 120px 0 90px;
}

.event-detail .auto-container {
	max-width: 1000px;
}

.event-detail .image-box {
	position: relative;
	margin-bottom: 30px;
}

.event-detail .image-box .image {
	position: relative;
	margin-bottom: 0;
}

.event-detail .image-box .image img {
	display: block;
	width: 100%;
	height: auto;
}

.event-detail .content-box {
	position: relative;
}

.event-detail .upper-info {
	position: relative;
	margin-bottom: 20px;
}

.event-detail .upper-info li {
	position: relative;
	display: inline-block;
	font-size: 14px;
	line-height: 24px;
	color: #222222;
	font-weight: 500;
	text-transform: uppercase;
	padding-left: 25px;
	margin-right: 20px;
}

.event-detail .upper-info .icon {
	position: absolute;
	left: 0;
	top: 0;
	font-size: 16px;
	line-height: 24px;
	color: #e1137b;
}

.event-detail .content-box h2 {
	display: block;
	font-size: 32px;
	line-height: 1.2em;
	color: #222222;
	font-weight: 700;
	margin-bottom: 25px;
}

.event-detail .speaker-info {
	position: relative;
	padding-left: 75px;
	min-height: 60px;
	margin-bottom: 25px;
}

.event-detail .speaker-info .thumb {
	position: absolute;
	left: 0;
	top: 0;
	width: 60px;
	border-radius: 50%;
	overflow: hidden;
}

.event-detail .speaker-info .name {
	font-size: 16px;
	line-height: 30px;
	font-weight: 500;
	color: #222222;
}

.event-detail .speaker-info .designation {
	font-size: 14px;
	line-height: 20px;
}

.event-detail .content-box p {
	position: relative;
	display: block;
	font-size: 16px;
	line-height: 30px;
	color: #888888;
	font-weight: 400;
	margin-bottom: 30px;
}

.event-detail .two-column {
	position: relative;
}

.event-detail .two-column .column {
	margin-bottom: 30px;
}

.event-detail .two-column .image {
	position: relative;
	margin-bottom: 0;
}

.event-detail .two-column .image img {
	display: block;
	width: 100%;
}

.event-detail .two-column h4 {
	font-size: 20px;
	line-height: 1.2em;
	color: #222222;
	font-weight: 500;
	margin-bottom: 20px;
	margin-top: 20px;
}

/***

====================================================================
		Pricing Section
====================================================================

***/

.pricing-section {
	position: relative;
	padding: 120px 0 80px;
	overflow: hidden;
}

.pricing-section .outer-box {
	max-width: 1100px;
	margin: 0 auto;
}


.pricing-section .row {
	margin: 0 -30px;
}

.pricing-block {
	position: relative;
	padding: 0 30px;
	margin-bottom: 40px;
}

.pricing-block .inner-box {
	position: relative;
	background-color: #ffffff;
	box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);
	padding: 0 0 30px;
	max-width: 370px;
	margin: 0 auto;
	border-bottom: 20px solid #40cbb4;
	border-radius: 5px
}

.pricing-block .icon-box {
	position: relative;
	padding: 50px 30px 0;
	background-color: #40cbb4;
	text-align: center;
	border-radius: 5px
}

.pricing-block .icon-box:before {
	position: absolute;
	left: 0;
	bottom: 0;
	height: 75px;
	width: 100%;
	border-radius: 50% 50% 0 0;
	background-color: #ffffff;
	content: "";
}


.pricing-block .icon-box .icon-outer {
	position: relative;
	height: 150px;
	width: 150px;
	background-color: #ffffff;
	border-radius: 50%;
	margin: 0 auto;
	padding: 10px;
}

.pricing-block .icon-box .icon {
	position: relative;
	display: block;
	height: 130px;
	width: 130px;
	line-height: 120px;
	border: 5px solid #40cbb4;
	border-radius: 50%;
	font-size: 70px;
	color: #40cbb4;
	transition: all 600ms ease;
}

.pricing-block .inner-box:hover .icon-box .icon {
	transform: rotate(360deg);
}

.pricing-block .price-box {
	position: relative;
	text-align: center;
	padding: 10px 20px;
}

.pricing-block .title {
	position: relative;
	display: block;
	font-size: 24px;
	line-height: 1.2em;
	color: #222222;
	font-weight: 600;
}

.pricing-block .price {
	display: block;
	font-size: 30px;
	color: #222222;
	font-weight: 700;
	color: #40cbb4;
}


.pricing-block .features {
	position: relative;
	max-width: 200px;
	margin: 0 auto 20px;
}

.pricing-block .features li {
	position: relative;
	display: block;
	font-size: 14px;
	line-height: 30px;
	color: #848484;
	font-weight: 500;
	padding: 5px 0;
	padding-left: 30px;
	border-bottom: 1px dashed #dddddd;
}

.pricing-block .features li:before {
	position: absolute;
	left: 0;
	top: 5px;
	font-size: 16px;
	line-height: 30px;
	content: "\\52";
	font-family: 'ElegantIcons';
	color: #2bd40f;
}

.pricing-block .features li.false:before {
	color: #e1137b;
	content: "\\51";
}

.pricing-block .features li a {
	color: #848484;
}

.pricing-block .features li:last-child {
	border-bottom: 0;
}

.pricing-block .btn-box {
	position: relative;
	text-align: center;
}

.pricing-block .btn-box a {
	position: relative;
	display: inline-block;
	font-size: 14px;
	line-height: 25px;
	color: #ffffff;
	font-weight: 500;
	padding: 8px 30px;
	background-color: #40cbb4;
	border-radius: 10px;
	border-top: 2px solid transparent;
	border-bottom: 2px solid transparent;
	transition: all 300ms ease;
}

.pricing-block .btn-box a:hover {
	color: #ffffff;
}

.pricing-block .inner-box:hover .btn-box a {
	color: #40cbb4;
	background: none;
	border-radius: 0px;
	border-color: #40cbb4;
}

.pricing-block:nth-child(2) .icon-box .icon,
.pricing-block:nth-child(2) .inner-box {
	border-color: #1d95d2;
}

.pricing-block:nth-child(2) .btn-box a,
.pricing-block:nth-child(2) .icon-box {
	background-color: #1d95d2;
}

.pricing-block:nth-child(2) .inner-box:hover .btn-box a {
	color: #1d95d2;
	background: none;
	border-radius: 0px;
	border-color: #1d95d2;
}

.pricing-block:nth-child(2) .icon-box .icon,
.pricing-block:nth-child(2) .price {
	color: #1d95d2;
}

.pricing-block:nth-child(3) .icon-box .icon,
.pricing-block:nth-child(3) .inner-box {
	border-color: #ffc20b;
}

.pricing-block:nth-child(3) .btn-box a,
.pricing-block:nth-child(3) .icon-box {
	background-color: #ffc20b;
}

.pricing-block:nth-child(3) .icon-box .icon,
.pricing-block:nth-child(3) .price {
	color: #ffc20b;
}

.pricing-block:nth-child(3) .inner-box:hover .btn-box a {
	color: #ffc20b;
	background: none;
	border-radius: 0px;
	border-color: #ffc20b;
}



.icon-circle-green {
	width: 300px;
	height: 300px;
	/* background-image: url(../images/icons/circle-green.png); */
}

.icon-circle-orange {
	width: 300px;
	height: 300px;
	/* background-image: url(../images/icons/circle-orange.png); */
}

.icon-circle-pink {
	width: 300px;
	height: 300px;
	/* background-image: url(../images/icons/circle-pink.png); */
}

.pricing-section .icon-circle-green {
	left: -375px;
	top: -50px;
	opacity: .50;
}

.pricing-section .icon-circle-blue {
	right: -375px;
	top: 50%;
	opacity: .50;
}

.pricing-section .icon-circle-pink {
	left: -375px;
	bottom: -100px;
	opacity: .50;
}

.pricing-section .icon-circle-green,
.pricing-section .icon-circle-blue,
.pricing-section .icon-circle-pink {
	animation: fa-spin 30s infinite;
}

/***

====================================================================
		Pricing Section Two
====================================================================

***/

.pricing-section-two {
	position: relative;
	padding: 120px 0 70px;
	overflow: hidden;
}

.pricing-section-two.alternate {
	position: relative;
	background-color: #fafafa;
}


.pricing-section-two .outer-box {
	position: relative;
	max-width: 1000px;
	margin: 0 auto;
}

.pricing-block-two {
	position: relative;
	display: block;
	margin-bottom: 50px;
}

.pricing-block-two .inner-box {
	position: relative;
	background-color: #ffffff;
	padding: 30px 30px 25px;
	max-width: 300px;
	margin: 0 auto;
	border: 1px solid #dddddd;
	box-shadow: 0 20px 40px rgba(0, 0, 0, 0.07);
	transition: all 500ms ease;
}

.pricing-block-two .inner-box:hover {
	box-shadow: 0 0 0px rgba(0, 0, 0, 0.07);
}

.pricing-block-two .inner-box:hover .theme-btn {
	border-radius: 0px;
}

.pricing-block-two .title {
	position: relative;
	display: block;
	font-size: 20px;
	line-height: 1.2em;
	color: #212639;
	font-weight: 500;
	text-transform: uppercase;
	margin-bottom: 25px;
}

.pricing-block-two .title .icon {
	font-size: 22px;
	margin-right: 5px;
	display: inline-block;
}

.pricing-block-two .price-box {
	position: relative;
	margin-left: -30px;
}

.pricing-block-two .price {
	position: relative;
	display: inline-block;
	font-size: 38px;
	line-height: .9em;
	color: #ffffff;
	font-weight: 600;
	margin-bottom: 20px;
	padding: 20px 30px;
	padding-right: 30px;
	border-radius: 0 50px 50px 0;
	background: rgb(247, 0, 104);
	transition: all 500ms ease;
	background: linear-gradient(to left, rgba(247, 0, 104) 0%, rgba(68, 16, 102, 1) 25%, rgba(247, 0, 104, 1) 75%, rgba(68, 16, 102, 1) 100%);
	filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#F70068', endColorstr='#441066', GradientType=1);
	background-size: 600% 100%;
}

.pricing-block-two .inner-box:hover .price {
	padding-right: 80px;
}

.pricing-block-two .features {
	position: relative;
	max-width: 300px;
	margin: 0 auto 20px;
}

.pricing-block-two .features li {
	position: relative;
	display: block;
	font-size: 14px;
	line-height: 30px;
	color: #848484;
	font-weight: 500;
	padding: 5px 0;
	padding-left: 30px;
	border-bottom: 1px dashed #dddddd;
}

.pricing-block-two .features li:before {
	position: absolute;
	left: 0;
	top: 5px;
	font-size: 16px;
	line-height: 30px;
	content: "\\52";
	font-family: 'ElegantIcons';
	color: #2bd40f;
}

.pricing-block-two .features li.false:before {
	color: #e1137b;
	content: "\\51";
}

.pricing-block-two .features li a {
	color: #848484;
}

.pricing-block-two .features li:last-child {
	border-bottom: 0;
}

.pricing-block-two .btn-box {
	position: relative;
	text-align: center;
}

.pricing-block-two .btn-box a {
	position: relative;
	font-size: 14px;
	line-height: 25px;
	font-weight: 500;
	padding: 8px 30px;
	border-radius: 30px;
}

.pricing-section-two .icon-line-1 {
	right: 0%;
	top: 15%;
}

.pricing-section-two .icon-dots {
	right: 0%;
	bottom: 15%;
}

.pricing-section-two .icon-circle-1 {
	left: -400px;
	bottom: -200px;
	opacity: .30;
}

.icon-shape-5 {
	width: 540px;
	height: 330px;
	/* background-image: url(../images/icons/shape-5.png); */
	background-size: 100%;
}

/***

====================================================================
		Pricing Section Three
====================================================================

***/

.pricing-section-three {
	position: relative;
	padding: 120px 0 70px;
	overflow: hidden;
}

.pricing-section-three .outer-box {
	position: relative;
	max-width: 1000px;
	margin: 0 auto;
}

.pricing-block-three {
	position: relative;
	margin-bottom: 50px;
}

.pricing-block-three .inner-box {
	position: relative;
	background-color: #ffffff;
	border-radius: 30px;
	padding: 70px 20px 60px;
	text-align: center;
	max-width: 400px;
	margin: 0 auto;
	box-shadow: 0 0 30px rgba(0, 0, 0, 0.10);
	transition: all 500ms ease;
}

.pricing-block-three .inner-box:hover {}

.pricing-block-three .title {
	position: relative;
	display: block;
	font-size: 38px;
	line-height: 1em;
	color: #848484;
	font-weight: 200;
	text-transform: uppercase;
	padding-bottom: 30px;
	margin-bottom: 25px;
}

.pricing-block-three .title:before {
	position: absolute;
	bottom: 0;
	left: 50%;
	margin-left: -40px;
	width: 80px;
	background-color: #848484;
	height: 2px;
	content: "";
}

.pricing-block-three .price {
	position: relative;
	display: block;
	font-size: 100px;
	line-height: .9em;
	color: #ec167f;
	font-weight: 200;
	font-family: 'Poppins', sans-serif;
	margin-bottom: 20px;
}

.pricing-block-three .features {
	position: relative;
	max-width: 300px;
	margin: 0 auto 20px;
}

.pricing-block-three .features li {
	position: relative;
	display: block;
	font-size: 14px;
	line-height: 30px;
	color: #848484;
	font-weight: 500;
	padding: 5px 0;
	border-bottom: 1px dashed #dddddd;
}

.pricing-block-three .features li a {
	color: #848484;
}

.pricing-block-three .features li:last-child {
	border-bottom: 0;
}

.pricing-block-three .btn-box {
	position: relative;
	text-align: center;
}

.pricing-block-three .btn-box a {
	position: relative;
	font-size: 14px;
	line-height: 25px;
	font-weight: 500;
	padding: 8px 30px;
	border-radius: 30px;
}

.pricing-section-three .icon-line-1 {
	right: 0%;
	top: 15%;
}

.pricing-section-three .icon-dots {
	right: 0%;
	bottom: 15%;
}

.pricing-section-three .icon-circle-1 {
	left: -400px;
	bottom: -200px;
	opacity: .30;
}

/***

====================================================================
		Fun Fact Section
====================================================================

***/

.fun-fact-section {
	position: relative;
	padding: 100px 0 50px;
}

.fun-fact-section:before {
	position: absolute;
	left: 0;
	top: 0;
	height: 100%;
	width: 100%;
	background-repeat: no-repeat;
	background-position: center;
	background-size: cover;
	/* background-image: url(../images/icons/pattern-1.jpg); */
	content: "";
	opacity: .10;
}

.fun-fact-section .fact-counter {
	position: relative;
}

.fun-fact-section .counter-column {
	position: relative;
	text-align: center;
	margin-bottom: 50px;
}

.fun-fact-section .count-box {
	position: relative;
	font-size: 80px;
	line-height: 1em;
	color: #222222;
	font-weight: 700;
}

.fun-fact-section .count-box .icon {
	position: relative;
	display: inline-block;
	font-size: 60px;
	color: #ffffff;
	margin-bottom: 20px;
	height: 120px;
	width: 120px;
	line-height: 120px;
	border-radius: 50%;
	font-weight: 400;
	transition: all 600ms ease;
	background-color: #222222;
	box-shadow: 5px 10px 30px rgba(0, 0, 0, 0.10);
}

.fun-fact-section .count-box:hover .icon {
	transform: rotateY(360deg);
}

.fun-fact-section .count-box .count-text {
	position: relative;
	display: block;
	font-size: 60px;
	line-height: 1em;
	color: #15212f;
	text-shadow: 10px 10px 10px rgba(0, 0, 0, 0.10);
	font-weight: 600;
	margin-bottom: 10px;
}

.fun-fact-section .count-box .counter-title {
	position: relative;
	display: block;
	font-size: 18px;
	line-height: 22px;
	font-weight: 700;
	color: #222222;
}

.fun-fact-section .counter-column:nth-child(4n + 1) .count-box .icon {
	background-color: #ffc20b;
}

.fun-fact-section .counter-column:nth-child(4n + 2) .count-box .icon {
	background-color: #40cbb4;
}

.fun-fact-section .counter-column:nth-child(4n + 3) .count-box .icon {
	background-color: #4c35a9;
}

.fun-fact-section .counter-column:nth-child(4n + 4) .count-box .icon {
	background-color: #e6275a;
}

.fun-fact-section .counter-column:nth-child(4n + 1) .counter-title {
	color: #ffc20b;
}

.fun-fact-section .counter-column:nth-child(4n + 2) .counter-title {
	color: #40cbb4;
}

.fun-fact-section .counter-column:nth-child(4n + 3) .counter-title {
	color: #4c35a9;
}

.fun-fact-section .counter-column:nth-child(4n + 4) .counter-title {
	color: #e6275a;
}

.fun-fact-section.style-two {
	background-repeat: no-repeat;
	background-position: center;
	background-size: cover;
}

.fun-fact-section.style-two:before {
	background: #1c94d2;
	opacity: 0;
}

.fun-fact-section.style-two .count-box .count-text {
	color: #ffffff;
}



/*====================================================
		FAQ's Section
====================================================*/

.faq-section {
	position: relative;
	padding: 120px 0 90px;
}

.faq-section .content-column {
	position: relative;
	margin-bottom: 30px;
}

/* Accordian Box */

.accordion-box {
	position: relative;
}

.accordion-box .block {
	position: relative;
	margin-bottom: 30px;
	box-shadow: 0 0 20px rgba(0, 0, 0, 0.10);
}

.accordion-box .block:last-child {
	margin-bottom: 0px;
}

.accordion-box .block .acc-btn {
	position: relative;
	font-size: 18px;
	cursor: pointer;
	line-height: 28px;
	color: #ffffff;
	font-weight: 400;
	border-radius: 4px;
	padding: 15px 25px 15px 25px;
	padding-right: 50px;
	border: 1px solid #dddddd;
	background-color: #40cbb4;
	transition: all 300ms ease;
}

.accordion-box .block .icon-outer {
	position: absolute;
	right: 25px;
	top: 10px;
	font-size: 18px;
	line-height: 35px;
	color: #ffffff;
	text-align: center;
	transform: rotate(-90deg);
	transition: all 300ms ease;
}

.accordion-box .block .acc-btn .icon-outer .icon {
	position: relative;
}

.accordion-box .block.active-block {
	box-shadow: 0 0 20px rgba(0, 0, 0, 0.10);
}

.accordion-box .block .acc-btn.active .icon-outer {
	transform: rotate(0deg);
}

.accordion-box .block .acc-content {
	position: relative;
	display: none;
	background-color: #ffffff;
	border: 1px solid #dddddd;
	border-top: 0;
}

.accordion-box .block .acc-content.current {
	display: block;
}

.accordion-box .block .content {
	position: relative;
	font-size: 16px;
	padding: 30px 35px;
}

.accordion-box .block .content .text {
	position: relative;
	font-size: 16px;
	line-height: 26px;
	color: #888888;
}

.accordion-box .block .content p:last-child {
	margin-bottom: 0px;
}


/***

====================================================================
		FAQ Form Section
====================================================================

***/

.faq-form-section {
	position: relative;
	padding: 120px 0 120px;
	background-color: #fafafa;
}

.faq-form-section .faq-form {
	position: relative;
}

.faq-form .form-group {
	position: relative;
	margin-bottom: 20px;
}

.faq-form .form-group input[type="text"],
.faq-form .form-group input[type="number"],
.faq-form .form-group input[type="email"],
.faq-form .form-group input[type="url"],
.faq-form .form-group textarea,
.faq-form .form-group select {
	position: relative;
	display: block;
	width: 100%;
	font-size: 15px;
	color: #222222;
	line-height: 28px;
	padding: 10px 25px;
	background-color: #ffffff;
	font-weight: 400;
	height: 50px;
	border: 1px solid #dddddd;
	transition: all 300ms ease;
}

.faq-form .form-group input:focus,
.faq-form .form-group select:focus,
.faq-form .form-group textarea:focus {
	box-shadow: 0 0 20px rgba(0, 0, 0, 0.10);
}

.faq-form .form-group textarea {
	height: 200px;
	resize: none;
	padding-top: 15px;
}

.faq-form .form-group button {
	border: 0;
	font-size: 14px;
	font-weight: 400;
	margin-top: 10px;
}

.faq-form-section .image-column {
	position: relative;
}

.faq-form-section .image-column .image-box {
	position: relative;
}

.faq-form-section .image-column .image {
	position: relative;
	margin-bottom: 0;
}

.faq-form-section .image-column .image img {
	display: block;
}


/***

====================================================================
			Why Choose Us
====================================================================

***/

.why-choose-us {
	position: relative;
	background-color: #fafafa;
	padding: 120px 0 70px;
}

.why-choose-us .image-column {
	position: relative;
	margin-bottom: 50px
}

.why-choose-us .image-column .image-box {
	position: relative;
}

.why-choose-us .image-column .image-box .image {
	position: relative;
	margin-bottom: 0;
}

.why-choose-us .image-column .image-box img {
	display: block;
	width: 100%;
}

.why-choose-us .content-column {
	position: relative;
	margin-bottom: 50px;
}

.why-choose-us .content-column .inner-column {
	position: relative;
	padding-top: 20px;
}

.why-choose-us .content-column .sec-title {
	position: relative;
	margin-bottom: 30px;
}

.why-choose-us .content-column .list-style-one {
	margin-bottom: 30px;
}


/***

====================================================================
		App Section
====================================================================

***/

.app-section {
	position: relative;
	background-color: #fafafa;
	padding: 90px 0;
	z-index: 9;
}

.app-section .image-column {
	position: relative;
}

.app-section .image-column .inner-column {
	position: relative;
	text-align: right;
}

.app-section .image-column .image-box {
	position: relative;
}

.app-section .image {
	position: relative;
	margin-bottom: 0;
}

.app-section .image img {
	display: inline-block;
	max-width: 100%;
	height: auto;
}

.app-section .content-column {
	position: relative;
	margin-bottom: 50px;
}

.app-section .content-column .inner-column {
	position: relative;
	padding-top: 80px;
}

.app-section .content-column .sec-title {
	margin-bottom: 30px;
}

.app-section .content-column .text-box {
	font-size: 16px;
	margin-bottom: 30px;
}

.app-section .link-box {
	position: relative;
}

.app-section .link-box a {
	position: relative;
	display: inline-block;
	margin-right: 25px;
	margin-bottom: 10px;
	transition: all 300ms ease;
}

.app-section .link-box a:hover {
	-ms-box-shadow: 0 10px 25px rgba(0, 0, 0, 0.30);
	-o-box-shadow: 0 10px 25px rgba(0, 0, 0, 0.30);
	box-shadow: 0 10px 25px rgba(0, 0, 0, 0.30);
}


/***

====================================================================
		Gallery Section
====================================================================

***/

.gallery-section {
	position: relative;
	padding: 120px 0 90px;
}

.gallery-item {
	position: relative;
	margin-bottom: 90px;
	margin-top: -5px;
}

.gallery-item .image-box {
	position: relative;
	box-shadow: 0 0px 30px rgba(8, 13, 62, .10);
	overflow: hidden;
}

.gallery-item .image-box .image {
	position: relative;
	margin-bottom: 0;
}

.gallery-item .image-box .image img {
	display: block;
	width: 100%;
	height: auto;
}

.gallery-item .overlay-box {
	position: absolute;
	left: 0;
	top: 0;
	height: 100%;
	width: 100%;
	text-align: center;
	content: "";
	opacity: 0;
	background-color: #1d95d2;
	transform: scale(.5);
	border-radius: 500px;
	transition: all 300ms ease;
}

.gallery-item .image-box:hover .overlay-box {
	transform: scale(1);
	opacity: .9;
	border-radius: 0px;
}

.gallery-item .overlay-box a {
	position: absolute;
	left: 56%;
	top: 67px;
	margin-top: -20px;
	margin-left: 86px;
}

.gallery-item .overlay-box a span {
	display: block;
	height: 58px;
	width: 58px;
	background-color: #ec167f;
	color: #ffffff;
	border-radius: 50%;
	font-weight: 700;
	font-size: 18px;
	line-height: 58px;
}

.gallery-section .owl-nav {
	display: none;
}

.gallery-section.style-two {
	padding: 0;
}

.gallery-section.style-two .gallery-item {
	margin-bottom: 0;
}



/***

====================================================================
		Event Info Section
====================================================================

***/

.event-info-section {
	position: relative;
	padding: 120px 0 120px;
}

.event-info-section .info-column {
	position: relative;
}

.event-info-section .info-column .inner-column {
	position: relative;
	padding-left: 30px;
}

.event-info-section .info-column .sec-title {
	margin-bottom: 50px;
}

.event-info-section .info-column .sec-title h2 {
	font-size: 40px;
}

.event-info-tabs {
	position: relative;
}

.event-info-tabs .tab-buttons {
	position: relative;
}

.event-info-tabs .tab-btn {
	position: relative;
	float: left;
	padding: 10px 25px;
	font-size: 14px;
	line-height: 20px;
	color: #ffffff;
	background-color: #1d95d2;
	font-weight: 600;
	cursor: pointer;
	margin-right: 5px;
	border: 1px solid #dddddd;
	border-bottom: 0;
	margin-bottom: -2px;
	z-index: 3;
	transition: all 300ms ease;
}

.event-info-tabs .tab-btn:hover,
.event-info-tabs .tab-btn.active-btn {
	color: #1d95d2;
	background-color: #ffffff;
}

.event-info-tabs .tabs-content {
	position: relative;
	background-color: #ffffff;
	border: 1px solid #dddddd;
	padding: 30px 30px;
	box-shadow: 0 30px 20px rgba(0, 0, 0, .05);
}

.event-info-tabs .tabs-content .tab {
	min-height: 155px;
}

.event-info-tabs .tabs-content h4 {
	position: relative;
	display: block;
	font-size: 24px;
	line-height: 1.2em;
	color: #3f4161;
	font-weight: 500;
	margin-bottom: 10px;
}

.event-info-tabs .tabs-content h4 .icon {
	color: #40cbb4;
	font-size: 20px;
	margin-right: 10px;
}


.event-info-tabs .tabs-content h5 {
	position: relative;
	display: block;
	font-size: 20px;
	line-height: 1.2em;
	color: #3f4161;
	font-weight: 500;
	margin-bottom: 20px;
}

.event-info-tabs .tabs-content .text {
	font-size: 16px;
	line-height: 28px;
	color: #888888;
	max-width: 470px;
}

.event-info-tabs .tabs-content .info-list {
	position: relative;
	margin-top: 10px;
}

.event-info-tabs .tabs-content .info-list li {
	position: relative;
	padding-left: 30px;
	font-size: 16px;
	line-height: 26px;
	color: #616977;
	font-weight: 400;
}

.event-info-tabs .tabs-content .info-list li .icon {
	position: absolute;
	left: 0;
	top: 0;
	font-size: 14px;
	line-height: 26px;
	color: #ec167f;
}

.event-info-tabs .tabs-content .info-list li a {
	color: #616977;
	display: inline-block;
	transition: all 300ms ease;
}

.event-info-tabs .tabs-content .info-list li a:hover {
	color: #f0228c;
	text-decoration: underline;
}

.event-info-section .image-column {
	position: relative;
}

.event-info-section .image-column .image {
	position: relative;
	background-color: #ffffff;
	padding-top: 60px;
	margin-bottom: 0;
}

.event-info-section .image-column .image img {
	display: block;
	width: 100%;
	height: auto;
}

.event-info-section .map-column {}

.event-info-section .map-outer .map-canvas,
.event-info-section .map-outer {
	position: absolute;
	left: 0;
	top: 0;
	height: 100%;
	width: 100%;
}

.event-info-section .map-outer .map-canvas {
	right: 15px;
	left: 15px;
	width: auto;
}




/***

====================================================================
		Testimonial Section
====================================================================

***/

.testimonial-section {
	position: relative;
	padding: 120px 0;
	background-color: #fdfdfd;
}

.testimonial-section .bg-layer {
	position: absolute;
	left: 0;
	top: 0;
	height: 100%;
	width: 100%;
	background-repeat: no-repeat;
	background-position: center bottom;
	background-size: 100%;
	opacity: .02;
}

.testimonial-section .sec-title {
	margin-bottom: 50px;
}

.testimonial-section .carousel-outer {
	position: relative;
	max-width: 800px;
	margin: 0 auto;
}

.testimonial-block {
	position: relative;
	text-align: center;
}

.testimonial-block .inner {
	position: relative;
}

.testimonial-block .icon {
	position: relative;
	display: inline-block;
	font-size: 40px;
	line-height: 80px;
	width: 80px;
	height: 80px;
	background-color: #40cbb4;
	color: #ffffff;
	border-radius: 50%;
	margin-bottom: 30px;
	text-shadow: 10px 10px 0 rgba(0, 0, 0, 0.2);
}

.testimonial-block .text {
	position: relative;
	display: block;
	font-size: 20px;
	line-height: 36px;
	color: #888888;
	font-weight: 400;
	max-width: 700px;
	margin: 0 auto 25px;
}

.testimonial-block .name {
	position: relative;
	display: block;
	font-size: 20px;
	line-height: 1.2em;
	color: #222222;
	font-weight: 500;
	margin-bottom: 5px;
}

.testimonial-block .rating {
	position: relative;
	font-size: 15px;
	line-height: 25px;
	color: #ffc20b;
}

.testimonial-section .owl-nav {
	position: absolute;
	top: 50%;
	width: 100%;
}

.testimonial-section .owl-next,
.testimonial-section .owl-prev {
	position: absolute;
	left: -80px;
	top: 0;
	height: 40px;
	width: 40px;
	font-size: 22px;
	color: #ffffff;
	line-height: 40px;
	margin-left: 15px;
	border-radius: 50%;
	text-align: center;
	background-color: #1c94d2;
	transition: all 300ms ease;
}

.testimonial-section .owl-next {
	left: auto;
	right: -80px;
}

.testimonial-section .owl-next:hover,
.testimonial-section .owl-prev:hover {
	box-shadow: 0 0 20px rgba(0, 0, 0, 0.20);
}


/***

====================================================================
		News Section
====================================================================

***/

.news-section {
	position: relative;
	padding: 110px 0 80px;
	overflow: hidden;
}

.news-section.alternate {
	padding: 120px 0;
}

.news-section .styled-pagination {
	margin-top: 30px;
}

.news-block {
	position: relative;
	margin-bottom: 40px;
}

.news-block .inner-box {
	position: relative;
	background-color: #ffffff;
	box-shadow: 0 0 20px rgba(0, 0, 0, 0.10);
}

.news-block .image-box {
	position: relative;
}

.news-block .image {
	position: relative;
	overflow: hidden;
	margin-bottom: 0;
}

.news-block .image-box .image a:after {
	content: "";
	position: absolute;
	top: -110%;
	left: -210%;
	width: 200%;
	height: 200%;
	opacity: 0;
	background: rgba(255, 255, 255, 0.13);
	background: linear-gradient(to right,
			rgba(255, 255, 255, 0.13) 0%,
			rgba(255, 255, 255, 0.13) 77%,
			rgba(255, 255, 255, 0.5) 92%,
			rgba(255, 255, 255, 0.0) 100%);
}

.news-block .inner-box:hover .image-box .image a:after {
	opacity: 1;
	top: -20%;
	left: -30%;
	transition-property: left, top, opacity;
	transition-duration: 0.7s, 0.7s, 0.15s;
	transition-timing-function: linear;
}

.news-block .image img {
	display: block;
	width: 100%;
}

.news-block .lower-content {
	position: relative;
	padding: 20px 30px 30px;
}

.news-block .post-info {
	position: relative;
	margin-bottom: 10px;
}

.news-block .post-info li {
	position: relative;
	display: inline-block;
	font-size: 14px;
	line-height: 24px;
	color: #777777;
	font-weight: 400;
	margin-right: 25px;
}

.news-block .post-info li span {
	margin-right: 5px;
	color: #1d95d2;
}

.news-block h4 {
	position: relative;
	display: block;
	font-size: 22px;
	line-height: 1.4em;
	color: #222222;
	font-weight: 500;
	margin-bottom: 20px;
}

.news-block h4 a {
	color: #222222;
	display: inline-block;
	transition: all 300ms ease;
}

.news-block h4 a:hover {
	color: #e1137b;
}

.news-block .text {
	position: relative;
	font-size: 14px;
	line-height: 27px;
	color: #888888;
	font-weight: 400;
	margin-bottom: 20px;
}

.news-block .btn-box {
	position: relative;
}

.news-block .btn-box a {
	position: relative;
	display: inline-block;
	font-size: 12px;
	line-height: 20px;
	color: #ffffff;
	padding: 4px 15px;
	background-color: #1d95d2;
	border-radius: 2px;
	border: 1px solid #1d95d2;
	transition: all 300ms ease;
}

.news-block .btn-box a:hover {
	background: none;
	color: #1d95d2;
	border-color: #1d95d2;
}

.news-section .icon-circle-blue {
	right: -305px;
	bottom: -120px;
	opacity: .70;
	animation: fa-spin 10s infinite;
}


.news-section .twist-line-1 {
	left: -110px;
	top: 290px;
}

.news-section .twist-line-2 {
	left: -10%;
	top: 80px;
}

.news-section .twist-line-3 {
	left: 90px;
	top: 50px;
}


/***

====================================================================
		Blog Sidebar
====================================================================

***/

.blog-sidebar {
	position: relative;
}

.blog-sidebar .news-block {
	margin-bottom: 50px;
}

.blog-sidebar .news-block .lower-content {
	padding: 30px 30px;
}

.blog-sidebar .news-block h4 {
	font-size: 26px;
}


/***

====================================================================
		Blog Detail
====================================================================

***/

.blog-single {
	position: relative;
}

.blog-single .news-block {
	margin-bottom: 0;
}

.blog-single .news-block .inner-box {
	box-shadow: none;
}

.blog-single .lower-content {
	padding: 20px 0 0;
}

.blog-single h2 {
	font-size: 28px;
	line-height: 1.2em;
	font-weight: 600;
	color: #222222;
	margin-bottom: 15px;
}

.blog-single .lower-content p {
	font-size: 16px;
	line-height: 30px;
	margin-bottom: 30px;
	color: #888888;
}

.blog-single .lower-content blockquote {
	position: relative;
	padding: 35px 40px;
	padding-left: 95px;
	background-color: #fafafa;
	margin: 45px 0;
}

.blog-single .lower-content blockquote .icon {
	position: absolute;
	left: 40px;
	top: 40px;
	font-size: 30px;
	line-height: 1em;
	color: #f20487;
}

.blog-single .lower-content blockquote p {
	font-size: 20px;
	line-height: 32px;
	color: #7f8897;
	font-weight: 400;
	margin-bottom: 15px;
}

.blog-single .lower-content blockquote cite {
	position: relative;
	display: block;
	font-size: 15px;
	line-height: 30px;
	color: #f20487;
	font-weight: 400;
	font-style: normal;
	padding-left: 30px;
}

.blog-single .lower-content blockquote cite:before {
	position: absolute;
	left: 0;
	top: 14px;
	height: 1px;
	width: 20px;
	background-color: #f20487;
	content: "";
}

/*post share options*/

.blog-single .post-share-options {
	position: relative;
	margin-bottom: 65px;
	border-top: 2px solid #eeeeee;
	padding-top: 30px;
}

.blog-single .post-share-options .tags {
	position: relative;
	display: inline-block;
}

.blog-single .post-share-options .tags li {
	position: relative;
	display: inline-block;
	margin-right: 5px;
}

.blog-single .post-share-options .tags a {
	position: relative;
	display: inline-block;
	font-size: 14px;
	line-height: 20px;
	border: 1px solid #dddddd;
	color: #7f8897;
	padding: 5px 20px;
	font-weight: 500;
	transition: all 300ms ease;
}

.blog-single .post-share-options .tags a:hover {
	color: #e1137b;
}

/*=== Author Box ===*/

.blog-single .author-box {
	position: relative;
	padding: 40px 50px;
	background-color: #f7f7fa;
	margin-bottom: 90px;
}

.blog-single .author-box .inner-box {
	position: relative;
}

.blog-single .author-box .info-box {
	position: relative;
	padding-left: 110px;
	min-height: 80px;
	margin-bottom: 20px;
	padding-top: 15px;
}

.blog-single .author-box .thumb {
	position: absolute;
	left: 0;
	top: 0;
	height: 80px;
	width: 80px;
	border-radius: 50%;
	overflow: hidden;
	margin-bottom: 10px;
}

.blog-single .author-box .thumb img {
	display: block;
	width: 100%;
}

.blog-single .author-box .name {
	position: relative;
	display: block;
	font-size: 20px;
	line-height: 1.2em;
	color: #3f4161;
	font-weight: 700;
}

.blog-single .author-box .designation {
	display: block;
	font-size: 18px;
	line-height: 25px;
	color: #7f8897;
	font-weight: 400;
	margin-top: 5px;
}

.blog-single .author-box .text {
	display: block;
	font-size: 16px;
	line-height: 30px;
	color: #888888;
	font-weight: 400;
	margin-bottom: 25px;
}

.blog-single .author-box .read-more {
	position: relative;
	display: inline-block;
	font-size: 16px;
	line-height: 24px;
	color: #7f8897;
	font-weight: 500;
	transition: all 300ms ease;
}

.blog-single .author-box .read-more .icon {
	margin-left: 7px;
	float: right;
	font-size: 20px;
	line-height: 24px;
}

.blog-single .author-box .read-more:hover {
	color: #e1137b;
}


/***

====================================================================
		Styled Pagination
====================================================================

***/

.styled-pagination {
	position: relative;
}

.styled-pagination li {
	position: relative;
	display: inline-block;
	margin: 0 8px 0 0;
}

.styled-pagination li:last-child {
	margin-right: 0;
}

.styled-pagination li a {
	position: relative;
	display: block;
	line-height: 50px;
	font-size: 18px;
	height: 50px;
	width: 50px;
	color: #222222;
	font-weight: 500;
	text-align: center;
	background: #ffffff;
	border: 1px solid #dddddd;
	border-bottom: 2px solid #ec167f;
	transition: all 500ms ease;
}

.styled-pagination li a:hover,
.styled-pagination li a.active {
	background-color: #ec167f;
	color: #ffffff;
	box-shadow: 0 5px 10px rgba(0, 0, 0, 0.10);
}

/***

====================================================================
			Coming Soon
====================================================================

***/

.coming-soon {
	position: relative;
	padding: 100px 0;
}

.coming-soon:before {
	position: absolute;
	left: 0;
	top: 0;
	height: 100%;
	width: 100%;
	/* background-image: url(../images/icons/pattern-1.jpg); */
	background-repeat: no-repeat;
	background-position: center;
	background-size: cover;
	content: "";
	opacity: .05;
}

.coming-soon .content {
	position: relative;
	text-align: center;
}

.coming-soon .content .logo {
	position: relative;
	margin-bottom: 30px;
}

.coming-soon .timer {
	position: relative;
	display: inline-block;
	margin-bottom: 50px;
}

.coming-soon .cs-countdown {
	position: relative;
	text-align: center;
	font-family: 'Orbitron', sans-serif;
}

.coming-soon .cs-countdown div {
	position: relative;
	display: inline-block;
	font-size: 45px;
	line-height: 1.2em;
	color: #e6275a;
	width: auto;
	font-weight: 600;
	letter-spacing: 0;
	text-shadow: 0 15px 20px rgba(0, 0, 0, 0.20);
	border-radius: 50%;
}

.coming-soon .cs-countdown h6 {
	position: relative;
	display: block;
	line-height: 30px;
	font-size: 16px;
	font-weight: 700;
	text-transform: uppercase;
	background-color: transparent;
	border-radius: 50%;
	color: #e6275a;
	width: 100px;
	margin: 0 20px 30px;
	text-shadow: 0 10px 20px rgba(0, 0, 0, 0.20);
}

.coming-soon .cs-countdown div:nth-child(2) h6,
.coming-soon .cs-countdown div:nth-child(2) {
	color: #40cbb4;
}

.coming-soon .cs-countdown div:nth-child(3) h6,
.coming-soon .cs-countdown div:nth-child(3) {
	color: #4c35a9;
}

.coming-soon .cs-countdown div:nth-child(4) h6,
.coming-soon .cs-countdown div:nth-child(4) {
	color: #1c94d2;
}

.coming-soon .cs-countdown div:nth-child(5) h6,
.coming-soon .cs-countdown div:nth-child(5) {
	color: #333333;
}

.coming-soon h1 {
	position: relative;
	color: #222222;
	font-size: 75px;
	font-weight: 700;
	line-height: 1em;
	margin-bottom: 30px;
	text-shadow: 0 10px 20px rgba(0, 0, 0, 0.20);
}

.coming-soon .content .text {
	position: relative;
	font-size: 16px;
	font-weight: 400;
	line-height: 26px;
	color: #888888;
	margin-bottom: 50px;
}

.coming-soon .emailed-form .form-group {
	position: relative;
	display: block;
	max-width: 460px;
	margin: 0 auto;
	width: 100%;
	margin-bottom: 35px;
	box-shadow: 0 8px 30px rgba(72, 69, 224, .20);
	border-radius: 50px;
}

.coming-soon .emailed-form .form-group input[type="text"],
.coming-soon .emailed-form .form-group input[type="tel"],
.coming-soon .emailed-form .form-group input[type="email"],
.coming-soon .emailed-form .form-group input[type="number"],
.coming-soon .emailed-form .form-group textarea {
	position: relative;
	display: block;
	width: 100%;
	line-height: 20px;
	height: 50px;
	font-size: 15px;
	color: #222222;
	overflow: hidden;
	padding: 15px 70px 15px;
	background: #ffffff;
	border-radius: 50px;
	transition: all 300ms ease;
}

.coming-soon .emailed-form .form-group input[type="submit"],
.coming-soon .emailed-form button {
	position: absolute;
	right: 35px;
	top: 10px;
	line-height: 30px;
	font-size: 18px;
	color: #000000;
	font-weight: 400;
	background-color: transparent;
	cursor: pointer;
}

.coming-soon .emailed-form .form-group input[type="submit"]:hover,
.coming-soon .emailed-form button:hover {
	color: #f20487;
}

.coming-soon .icon-circle-blue {
	left: -80px;
	bottom: -80px;
	opacity: .70;
	animation: fa-spin 30s infinite;
}

.coming-soon .icon-dots {
	left: 15%;
	top: 20%;
}

.coming-soon .icon-line-1 {
	right: 15%;
	bottom: 20%;
	opacity: .70;
	animation: fa-spin 30s infinite;
}

.coming-soon .icon-circle-1 {
	right: -200px;
	top: -200px;
	opacity: .20;
}

/***

====================================================================
		Video Section
====================================================================

***/

.video-section {
	position: relative;
	background-repeat: no-repeat;
	background-size: cover;
	padding: 120px 0 140px;
	background-attachment: fixed;
}

.video-section:before {
	position: absolute;
	left: 0;
	top: 0;
	height: 100%;
	width: 100%;
	background: rgb(247, 0, 104);
	background: linear-gradient(to left, rgba(247, 0, 104) 0%, rgba(68, 16, 102, 1) 100%);
	filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#F70068', endColorstr='#441066', GradientType=1);
	opacity: .70;
	content: "";
}

.video-section .content-box {
	position: relative;
	text-align: center;
}

.video-section .content-box .text {
	position: relative;
	display: block;
	font-size: 18px;
	line-height: 26px;
	color: #ffbc00;
	font-weight: 500;
	text-transform: uppercase;
	margin-bottom: 15px;
}

.video-section .content-box h2 {
	display: block;
	font-size: 48px;
	line-height: 1.2em;
	color: #ffffff;
	font-weight: 700;
}

.video-section .play-now {
	position: relative;
	display: inline-block;
	margin-top: 50px;
}

.video-section .play-now .icon {
	height: 100px;
	width: 100px;
	line-height: 100px;
	background-color: #ffbc00;
	padding-left: 0;
	font-size: 50px;
}

.play-now {
	position: relative;
	display: block;
	z-index: 9;
	transition: all 300ms ease;
}

.play-now .icon {
	position: relative;
	display: inline-block;
	height: 80px;
	width: 80px;
	text-align: center;
	line-height: 80px;
	background-color: #000000;
	color: #ffffff;
	z-index: 1;
	padding-left: 5px;
	font-size: 24px;
	display: block;
	border-radius: 50%;
	-ms-box-shadow: 0 0px 10px 0 rgba(255, 255, 255, .3);
	-o-box-shadow: 0 0px 10px 0 rgba(255, 255, 255, .3);
	box-shadow: 0 0px 10px 0 rgba(255, 255, 255, .3);
	transform-origin: center;
}

.play-now .ripple,
.play-now .ripple:before,
.play-now .ripple:after {
	position: absolute;
	top: 50%;
	left: 50%;
	height: 70px;
	width: 70px;
	transform: translate(-50%, -50%);
	border-radius: 50%;
	-ms-box-shadow: 0 0 0 0 rgba(255, 255, 255, .6);
	-o-box-shadow: 0 0 0 0 rgba(255, 255, 255, .6);
	box-shadow: 0 0 0 0 rgba(255, 255, 255, .6);
	animation: ripple 3s infinite;
}

.play-now .ripple:before {
	animation-delay: .9s;
	content: "";
	position: absolute;
}

.play-now .ripple:after {
	animation-delay: .6s;
	content: "";
	position: absolute;
}

@keyframes ripple {
	70% {
		box-shadow: 0 0 0 70px rgba(255, 255, 255, 0);
	}

	100% {
		box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);
	}
}

/***

====================================================================
		Call to Action
====================================================================

***/

.call-to-action {
	position: relative;
	background-position: center;
	background-repeat: no-repeat;
	background-size: cover;
	padding: 100px 0;
}

.call-to-action:before {
	position: absolute;
	left: 0;
	top: 0;
	height: 100%;
	width: 100%;
	background-color: #000000;
	opacity: .50;
	content: "";
}

.call-to-action .content-box {
	position: relative;
	text-align: center;
}

.call-to-action .content-box .text {
	position: relative;
	display: block;
	font-size: 18px;
	line-height: 26px;
	color: #ffbc00;
	font-weight: 500;
	text-transform: uppercase;
	margin-bottom: 15px;
}

.call-to-action .content-box h2 {
	display: block;
	font-size: 42px;
	line-height: 1.2em;
	color: #ffffff;
	font-weight: 700;
	margin-bottom: 30px;
}

.call-to-action .content-box .btn-box {
	position: relative;
}


/***

====================================================================
		Register Section
====================================================================

***/

.register-section {
	position: relative;
	padding: 120px 0;
	background-color: #fafafa;
	overflow: hidden;
}

.register-section .outer-box {
	position: relative;
	box-shadow: 0 30px 50px rgba(0, 0, 0, 0.10);
	background-color: #ffffff;
}

.register-section .title-column {
	position: relative;
	float: left;
	width: 20%;
	/* background-image: url(../images/icons/form-bg.png); */
	background-repeat: no-repeat;
	background-position: center;
	background-size: cover;
}

.register-section .title-column .inner {
	position: relative;
	text-align: center;
	padding: 80px 50px 20px;
}

.register-section .title-column .icon-box {
	position: relative;
	display: inline-block;
	margin-bottom: 30px;
	background-color: #ffffff;
	height: 150px;
	width: 150px;
	line-height: 150px;
	border-radius: 50%;
}

.register-section .title-column .icon {
	position: relative;
	display: inline-block;
	font-size: 80px;
	color: #222222;
}

.register-section .title-column .text {
	margin-top: 20px;
}

.register-section .title-column h2 {
	position: relative;
	font-size: 34px;
	display: block;
}

.register-section .title-column .text {
	font-size: 16px;
	line-height: 26px;
	color: #ffffff;
}

.register-form {
	position: relative;
}

.register-form .form-inner {
	position: relative;
	padding: 50px 30px 30px;
	background-color: #ffffff;
}

.register-form h2 {
	position: relative;
	display: block;
	font-size: 34px;
	line-height: 1.2em;
	color: #181e44;
	font-weight: 600;
	margin-bottom: 25px;
}

.register-form .form-group {
	position: relative;
	margin-bottom: 20px;
}

.register-form .form-group .icon {
	position: absolute;
	left: 20px;
	top: 10px;
	line-height: 33px;
	color: #aaaaaa;
	font-size: 16px;
	z-index: 9;
}

.register-form .form-group input[type="text"],
.register-form .form-group input[type="email"],
.register-form .form-group input[type="url"],
.register-form .form-group input[type="number"],
.register-form .form-group input[type="date"],
.register-form .form-group input[type="email"],
.register-form .form-group textarea,
.register-form .form-group select {
	position: relative;
	display: block;
	width: 100%;
	line-height: 33px;
	padding: 10px 20px;
	height: 52px;
	color: #777777;
	font-size: 15px;
	background-color: #ffffff;
	border: 1px solid #aaaaaa;
	padding-left: 50px;
	transition: all 300ms ease;
}

.register-form .form-group input[type="text"]:focus,
.register-form .form-group input[type="email"]:focus,
.register-form .form-group input[type="number"]:focus,
.register-form .form-group textarea:focus {
	border-color: #f70068;
}

.register-form .form-group textarea {
	position: relative;
	display: block;
	width: 100%;
	line-height: 33px;
	padding: 10px 20px;
	height: 200px;
	padding-left: 50px;
}

.register-form button {
	cursor: pointer;
	line-height: 25px;
	font-size: 14px;
	padding: 10px 30px;
}

.register-section .icon-circle-3 {
	right: -100px;
	top: -120px;
	opacity: .20;
}

.register-section .icon-shape-3 {
	right: 5%;
	top: 0%;
}



/***

====================================================================
		Contact Page Section
====================================================================

***/

.contact-page-section {
	position: relative;
	padding: 110px 0 70px;
}

.contact-page-section .form-column {
	position: relative;
	margin-bottom: 40px;
}

.contact-page-section .form-column .inner-column {
	position: relative;
}

.contact-page-section .sec-title {
	margin-bottom: 30px;
}

.contact-page-section .sec-title h2 {
	font-size: 32px;
}

.contact-form .form-group {
	position: relative;
	margin-bottom: 30px;
}

.contact-form .form-group:last-child {
	margin-bottom: 0;
}

.contact-form .form-group input[type="text"],
.contact-form .form-group input[type="email"],
.contact-form .form-group input[type="url"],
.contact-form .form-group input[type="password"],
.contact-form .form-group input[type="number"],
.contact-form .form-group textarea,
.contact-form .form-group select {
	position: relative;
	display: block;
	width: 100%;
	font-size: 14px;
	color: #312d2dba;
	line-height: 32px;
	padding: 0px 13px;
	border: 1px solid #a1a7a1;
	background-color: ffffff;
	font-weight: 400;
	height: 50px;
	transition: all 300ms ease;
	border-radius: 3px;
}

.contact-form .form-group input:focus,
.contact-form .form-group select:focus,
.contact-form .form-group textarea:focus {
	border-color: #f20487;
}

.contact-form .form-group textarea {
	height: 75px;
	resize: none;
}

.contact-form .form-group button {
	text-transform: capitalize;
}

.contact-form input.error:focus,
.contact-form select.error:focus,
.contact-form textarea.error:focus {
	border-color: #ff0000;
}

.contact-form label.error {
	display: block;
	font-weight: 500;
	font-size: 13px;
	text-transform: capitalize;
	line-height: 24px;
	color: #ff0000;
	padding-top: 7px;
	margin-bottom: 0;
}

.contact-page-section .contact-column {
	position: relative;
	margin-bottom: 30px;
}

.contact-page-section .contact-info {
	position: relative;
	margin-bottom: 37px;
}

.contact-page-section .contact-info li {
	position: relative;
	padding-left: 55px;
	margin-bottom: 30px;
}

.contact-page-section .contact-info li p {
	display: block;
	font-size: 14px;
	line-height: 24px;
	color: #777777;
	font-weight: 400;
	margin: 0;
}

.contact-page-section .contact-info li strong {
	display: block;
	font-size: 16px;
	line-height: 20px;
	color: #222222;
	font-weight: 600;
}

.contact-page-section .contact-info li .icon {
	position: absolute;
	left: 0;
	top: 0;
	height: 40px;
	width: 40px;
	text-align: center;
	border-radius: 5px;
	font-size: 18px;
	line-height: 40px;
	background-color: #8e0026;
	color: #ffffff;
}

.contact-page-section .contact-info li a {
	color: #777777;
	transition: all 300ms ease;
}

.contact-page-section .contact-info li a:hover {
	color: #f20487;
}


/***

====================================================================
		Map Section
====================================================================

***/

.map-section {
	position: relative;
	display: block;
	padding-bottom: 120px;
}

.map-area {
	position: relative;
}

.map-data {
	text-align: center;
	font-size: 14px;
	font-weight: 400;
	line-height: 1.8em;
}

.map-data a {
	display: block;
}

.map-data h6 {
	font-size: 16px;
	font-weight: 700;
	text-align: center;
	margin-bottom: 5px;
	color: #121212;
}

.map-section .map-canvas {
	height: 540px;
	background-color: #f9f9f9;
}


/***

====================================================================
		Subscribe Section
====================================================================

***/

.subscribe-section {
	position: relative;
	background-color: #ffffff;
}

.subscribe-section .title-column {
	position: relative;
	margin-bottom: 40px;
}

.subscribe-section:before {
	position: absolute;
	left: 0;
	bottom: 0;
	height: 50%;
	width: 100%;
	background-color: #101130;
	content: "";
}

.subscribe-section .content-box {
	position: relative;
	z-index: 9;
	padding: 40px 20px 0;
	border-radius: 20px;
	overflow: hidden;
	background-color: #40cbb4;
	text-align: center;
	box-shadow: 0 0 30px rgba(0, 0, 0, 0.30);
}

.subscribe-section .content-box:before {
	position: absolute;
	left: 0;
	bottom: 0;
	height: 100%;
	width: 100%;
	/* background-image: url(../images/icons/pattern-2.png); */
	background-repeat: no-repeat;
	background-position: center;
	background-size: cover;
	content: "";
	transform: scaleY(-1);
}

.subscribe-section .content-box .sec-title {
	margin-bottom: 0px;
	padding-left: 90px;
	text-align: left;
}

.subscribe-section .content-box .sec-title h2 {
	position: relative;
	display: block;
	color: #ffffff;
	font-size: 30px;
	line-height: 35px;
}

.subscribe-section .content-box .sec-title .icon {
	position: absolute;
	left: 0;
	top: 0px;
	height: 70px;
	width: 70px;
	background-color: #ffffff;
	border-radius: 50%;
	color: #ec167f;
	line-height: 70px;
	font-size: 28px;
	text-align: center;
	box-shadow: 0 0 20px rgba(0, 0, 0, 0.10);
	color: #1d95d2;
}

.subscribe-section .form-column {
	position: relative;
	margin-bottom: 40px;
}

.subscribe-section .newsletter-form {
	position: relative;
	max-width: 870px;
	margin: 0 auto;
}

.subscribe-section .newsletter-form .form-group {
	position: relative;
	padding-right: 140px;
	overflow: hidden;
	border-radius: 10px;
	margin-bottom: 0;
}

.subscribe-section .newsletter-form .form-group input[type="number"],
.subscribe-section .newsletter-form .form-group input[type="text"],
.subscribe-section .newsletter-form .form-group input[type="email"] {
	display: block;
	height: 70px;
	width: 100%;
	font-size: 16px;
	line-height: 30px;
	color: #616977;
	font-weight: 400;
	padding: 20px 40px;
	background-color: #ffffff;
	transition: all 300ms ease;
}

.subscribe-section .newsletter-form .form-group .theme-btn {
	position: absolute;
	right: 0px;
	top: 0px;
	min-width: 140px;
	line-height: 30px;
	padding: 20px 30px;
	text-transform: capitalize;
	font-weight: 500;
	border-radius: 0;
	cursor: pointer;
}

/***

====================================================================
	Newsletter Section
====================================================================

***/

.newsletter-section {
	position: relative;
	padding: 10px 0;
	z-index: 1;
}


.newsletter-section .icon-shape-3 {
	transform: scaleX(-1);
	top: 0px;
	left: -110px;
	opacity: .70;
}

.newsletter-section .icon-line-1 {
	right: -70px;
	top: 50%;
	animation: fa-spin 30s infinite alternate;
}

.subscribe-form {
	position: relative;
}

.subscribe-form .form-inner {
	position: relative;
	max-width: 60%;
	width: 100%;
	margin: 0 auto;
}

.subscribe-form .upper-box {
	position: relative;
	text-align: center;
}

.subscribe-form .sec-title {
	margin-bottom: 40px;
}

.subscribe-form .sec-title .text {
	margin-top: 20px;
}

.subscribe-form .upper-box .icon-box {
	position: relative;
	display: inline-block;
	height: 150px;
	width: 150px;
	border-radius: 50%;
	background: rgb(247, 0, 104);
	background: linear-gradient(to left, rgba(247, 0, 104) 0%, rgba(68, 16, 102, 1) 100%);
	filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#F70068', endColorstr='#441066', GradientType=1);
	z-index: 1;
	font-size: 70px;
	line-height: 150px;
	color: #ffffff;
	margin-bottom: 30px;
}

.subscribe-form .form-group {
	position: relative;
	display: block;
	margin: 0px;
	width: 100%;
	padding-right: 70px;
	background: #ffffff;
	z-index: 2;
	/*box-shadow: 0 0 30px rgba(0,0,0,0.10);*/
	margin-bottom: 10px;
}

.subscribe-form .form-group input[type="text"],
.subscribe-form .form-group input[type="tel"],
.subscribe-form .form-group input[type="password"],
.subscribe-form .form-group input[type="email"],
.subscribe-form .form-group input[type="number"],
.subscribe-form .form-group textarea {
	position: relative;
	display: block;
	width: 100%;
	line-height: 30px;
	height: 60px;
	font-size: 15px;
	color: #222222;
	background: #ffffff;
	padding: 0px 15px;
	border: 1px solid transparent;
	transition: all 300ms ease;
}

.subscribe-form .form-group input[type="submit"],
.subscribe-form .form-group button {
	position: absolute;
	right: 0px;
	top: 0px;
	height: 60px;
	width: 60px;
	text-align: center;
	line-height: 30px;
	font-size: 18px;
	line-height: 60px;
	background-color: #ffffff;
	color: #222222;
	cursor: pointer;
}

.subscribe-form .form-group input[type="submit"]:hover,
.subscribe-form .form-group button:hover {}

/***

====================================================================
		Clients Section
====================================================================

***/

.clients-section {
	position: relative;
	padding: 120px 0 90px;
}

.clients-section:before {
	position: absolute;
	left: 0;
	top: 0;
	height: 100%;
	width: 100%;
	/* background-image: url(../images/icons/icon-dots-2.png); */
	content: "";
	opacity: .02;
	background-repeat: no-repeat;
	background-position: center;
	background-size: cover;
	transform: scale(-1);
}


.clients-section .sponsors-outer {
	position: relative;
	margin-bottom: 50px;
}

.clients-section .sponsors-outer .owl-dots,
.clients-section .sponsors-outer .owl-nav {
	display: none;
}

.clients-section .sponsors-outer .client-block {
	position: relative;
	margin-bottom: 30px;
}

.clients-section .sponsors-outer .image-box {
	position: relative;
	text-align: center;
	margin-bottom: 0;
	border: 1px solid #dddddd;
	box-shadow: 0 0 30px rgba(0, 0, 0, 0.10);
	background-color: #ffffff;
	transition: all 500ms ease;
}

.clients-section .sponsors-outer .image-box:hover {
	box-shadow: none;
}


.clients-section .sponsors-outer .image-box img {
	max-width: 50%;
	width: auto;
	display: inline-block;
	opacity: 1;
	transition: all 300ms ease;
}

.clients-section .sponsors-outer .image-box:hover img {
	opacity: .70;
}

.clients-section .sponsors-outer h3 {
	display: inline-block;
	font-size: 20px;
	line-height: 1.2em;
	background-color: #ec167f;
	color: #ffffff;
	padding: 10px 30px;
	font-weight: 700;
	margin-bottom: 20px;
	border-radius: 10px;
}

.clients-section .sponsors-outer:nth-child(3) h3 {
	background-color: #1d95d2;
}

.clients-section .sponsors-outer:nth-child(2) h3 {
	background-color: #40cbb4;
}


.clients-section .icon-dots-3 {
	left: -60px;
	top: 230px;
}

.clients-section .icon-circle-blue {
	left: -370px;
	top: 500px;
	opacity: .50;
	animation: fa-spin 30s infinite alternate;
}

/***

====================================================================
		Clients Section Two
====================================================================

***/

.clients-section-two {
	position: relative;
	padding: 60px 0;
}

.clients-section-two:before {
	position: absolute;
	left: 0;
	top: 0;
	height: 100%;
	width: 100%;
	/* background-image: url(../images/icons/icon-dots-2.png); */
	content: "";
	opacity: .02;
	background-repeat: no-repeat;
	background-position: center;
	background-size: cover;
	transform: scale(-1);
}


.clients-section-two .sponsors-outer {
	position: relative;
}

.clients-section-two .sponsors-outer .owl-dots,
.clients-section-two .sponsors-outer .owl-nav {
	display: none;
}

.clients-section-two .sponsors-outer .client-block {
	position: relative;
}

.clients-section-two .sponsors-outer .image-box {
	position: relative;
	text-align: center;
	margin-bottom: 0;
	transition: all 500ms ease;
}

.clients-section-two .sponsors-outer .image-box:hover {
	box-shadow: none;
}

.clients-section-two .sponsors-outer .image-box img {
	opacity: .80;
	transition: all 300ms ease;
}

.clients-section-two .sponsors-outer .image-box:hover img {
	opacity: 1;
}

/***

====================================================================
		Clients Section Three
====================================================================

***/

.clients-section-three {
	position: relative;
	padding: 60px 0;
}

.clients-section-three:before {
	position: absolute;
	left: 0;
	top: 0;
	height: 100%;
	width: 100%;
	/* background-image: url(../images/icons/icon-dots-2.png); */
	content: "";
	opacity: .02;
	background-repeat: no-repeat;
	background-position: center;
	background-size: cover;
	transform: scale(-1);
}


.clients-section-three .sponsors-outer {
	position: relative;
}

.clients-section-three .sponsors-outer .owl-dots,
.clients-section-three .sponsors-outer .owl-nav {
	display: none;
}

.clients-section-three .sponsors-outer .client-block {
	position: relative;
}

.clients-section-three .sponsors-outer .image-box {
	position: relative;
	text-align: center;
	margin-bottom: 0;
	transition: all 500ms ease;
}

.clients-section-three .sponsors-outer .image-box:hover {
	box-shadow: none;
}

.clients-section-three .sponsors-outer .image-box img {
	max-width: 70%;
	opacity: .80;
	display: inline-block;
	transition: all 300ms ease;
}

.clients-section-three .sponsors-outer .image-box:hover img {
	opacity: 1;
}

/***

==================================================================
		Main Footer
==================================================================

***/

.main-footer {
	position: relative;
	background-color: #101130;
	/* background-image: url(../images/background/9.jpg); */
}

.main-footer .widgets-section {
	position: relative;
	background-repeat: no-repeat;
	background-position: center;
	background-size: cover;
	padding: 120px 0 50px;
}

.main-footer .footer-column {
	position: relative;
	margin-bottom: 40px;
}

.main-footer .footer-widget {
	position: relative;
}

.main-footer .footer-column .widget-title {
	position: relative;
	font-size: 24px;
	font-weight: 500;
	color: #ffffff;
	line-height: 30px;
	padding-bottom: 10px;
	margin-bottom: 30px;
}

.main-footer .footer-column .widget-title:before {
	position: absolute;
	left: 0;
	bottom: 0;
	height: 1px;
	width: 40px;
	background-color: #f70068;
	content: '';
}

.main-footer .about-widget {
	position: relative;
}

.main-footer .logo {
	position: relative;
	margin-bottom: 5px;
	top: -20px;
}

.main-footer .footer-logo figure {
	margin: 0;
}

.main-footer .footer-logo img {
	display: block;
	max-width: 100%;
	width: 200px;
}

.main-footer .about-widget .text {
	position: relative;
	margin-bottom: 30px;
}

.main-footer .about-widget .text p {
	font-size: 14px;
	line-height: 24px;
	color: #aaaaaa;
	font-weight: 400;
	margin-bottom: 30px;
}

/*Recent Posts*/

.recent-posts {
	position: relative;
	padding-left: 40px;
}

.recent-posts .post {
	position: relative;
	min-height: 90px;
	margin-bottom: 30px;
}

.recent-posts .post:last-child {
	margin-bottom: 0;
}

.recent-posts .post .thumb {
	position: absolute;
	left: 0;
	top: 0;
	height: 90px;
	width: 90px;
	overflow: hidden;
}

.recent-posts .post .thumb a {
	display: block;
}

.recent-posts .post .thumb img {
	display: block;
	width: 100%;
	height: auto;
}

.recent-posts .post h4 {
	position: relative;
	font-size: 18px;
	color: #ffffff;
	line-height: 30px;
	font-weight: 500;
	margin-bottom: 5px;
}

.recent-posts .post h4 a {
	color: #ffffff;
	transition: all 300ms ease;
}

.recent-posts .post h4 a:hover {
	color: #f70068;
}

.recent-posts .post .date {
	position: relative;
	display: block;
	font-size: 14px;
	line-height: 30px;
	color: #bbbbbb;
}

.recent-posts .post .date span {
	color: #f70068;
	margin-right: 4px;
	opacity: .70;
}

/*=== User LInks ===*/

.useful-links {
	position: relative;
	padding-left: 50px;
}

.user-links li {
	position: relative;
	display: block;
	margin-bottom: 5px;
}

.user-links li a {
	position: relative;
	display: block;
	font-size: 14px;
	line-height: 30px;
	color: #ffffff;
	font-weight: 400;
	padding: 0 15px;
	border-left: 1px solid #f70068;
	transition: all 300ms ease;
}

.user-links li a:hover {
	color: #f70068;
}

.main-footer .contact-list {
	position: relative;
}

.main-footer .contact-list li {
	position: relative;
	padding-left: 40px;
	margin-bottom: 25px;
}

.main-footer .contact-list li:last-child {
	margin-bottom: 0;
}

.main-footer .contact-list li .icon {
	position: absolute;
	left: 0;
	top: 0;
	font-size: 23px;
	line-height: 25px;
	color: #ffffff;
}

.main-footer .contact-list li .text {
	display: block;
	font-size: 14px;
	line-height: 24px;
	color: #ffffff;
	font-weight: 400;
}

.main-footer .contact-list li .text a {
	color: #ffffff;
	transition: all 300ms ease;
}

.main-footer .contact-list li .text a:hover {
	color: #f70068;
}


/* Instagram Widget */

.instagram-widget {
	position: relative;
}

.instagram-widget .link-box {
	position: absolute;
	right: 30px;
	top: 27px;
}

.instagram-widget .link-box a {
	display: inline-block;
	height: 30px;
	width: 30px;
	border-radius: 50%;
	background-color: #f70068;
	color: #ffffff;
	font-size: 18px;
	text-align: center;
	transition: all 300ms ease;
}

.instagram-widget .link-box a:hover {
	box-shadow: 0 0 10px rgba(0, 0, 0, 0.10);
	background-color: #ffffff;
	color: #f70068;
}

.instagram-widget .outer {
	position: relative;
	margin: 0px -5px 0;
}

.instagram-widget .outer .image {
	position: relative;
	float: left;
	width: 33.3333%;
	padding: 0px 4px;
	margin-bottom: 10px;
}

.instagram-widget .image img {
	display: block;
	width: 100%;
}

.instagram-widget .image a {
	position: relative;
	display: block;
}

.instagram-widget .image a:before {
	position: absolute;
	left: 0;
	top: 0;
	height: 100%;
	width: 100%;
	background: #ffffff;
	padding: 5px;
	opacity: .70;
	content: "";
	transform: scale(0);
	transition: all 300ms ease;
}

.instagram-widget .image a:hover:before {
	transform: scale(1);
}

.instagram-widget .image a:after {
	position: absolute;
	height: 20px;
	width: 20px;
	left: 50%;
	top: 50%;
	margin-left: -10px;
	margin-top: -10px;
	text-align: center;
	line-height: 20px;
	font-size: 18px;
	color: #f70068;
	font-weight: 900;
	content: "\\f0c1";
	font-family: "Font Awesome 5 Free";
	transform: scale(0);
	transition: all 300ms ease;
}

.instagram-widget .image a:hover:after {
	transform: scale(1);
}

/*=== Footer Bottom ===*/

.main-footer .footer-bottom {
	position: relative;
	width: 100%;
	background-color: rgba(255, 255, 255, .10);
	text-align: center;
}

.main-footer .footer-bottom .inner-container {
	position: relative;
}

.main-footer .footer-bottom .copyright-text {
	position: relative;
	padding: 20px 0;
}

.main-footer .footer-bottom .copyright-text p {
	position: relative;
	line-height: 20px;
	font-size: 16px;
	color: #ffffff;
	font-weight: 400;
	margin-bottom: 0;
}

.main-footer .footer-bottom .copyright-text a {
	color: #ffffff;
	font-weight: 600;
	text-decoration: underline;
	transition: all 300ms ease;
}

.main-footer .footer-bottom .copyright-text a:hover {
	color: #f70068;
}

.main-footer .footer-bottom .footer-nav {
	position: relative;
	float: right;
}

.main-footer .footer-bottom .footer-nav ul {
	position: relative;
	padding: 15px 0;
}

.main-footer .footer-bottom .footer-nav ul li {
	position: relative;
	float: left;
	margin-left: 10px;
	font-family: "Oswald", sans-serif;
}

.main-footer .footer-bottom .footer-nav ul li a {
	position: relative;
	display: block;
	font-size: 14px;
	line-height: 20px;
	color: #ffffff;
	font-weight: 400;
	padding: 5px 10px;
	text-transform: uppercase;
	background-color: #333333;
	transition: all 300ms ease;
}

.main-footer .footer-bottom .footer-nav ul li a:hover {
	color: #f70068;
	box-shadow: 0 0 10px rgba(0, 0, 0, 0.20);
}

/***

==================================================================
		Main Footer Style Two
==================================================================

***/

.main-footer.style-two {
	position: relative;
	background-repeat: no-repeat;
	background-position: center;
	background-size: cover;
	text-align: center;
	/* position: absolute; */
    bottom: 0;
	width:100%;

}
.footer-container {
    position: relative;
}

.main-footer.style-two .footer-content {
	position: relative;
	padding: 70px 0 70px;
}

.main-footer.style-two .footer-logo {
	position: relative;
	text-align: center;
	margin-bottom: 20px;
}

.main-footer.style-two .footer-logo img {
	display: inline-block;
}

.main-footer.style-two .text {
	position: relative;
	max-width: 700px;
	margin: 0 auto;
	font-size: 16px;
	color: #ffffff;
	line-height: 28px;
	margin-bottom: 30px;
}

.main-footer .footer-nav {
	position: relative;
	margin-bottom: 30px;
}

.main-footer .footer-nav li {
	position: relative;
	display: inline-block;
	margin: 0 5px;
}

.main-footer .footer-nav li a {
	position: relative;
	display: block;
	font-size: 16px;
	line-height: 30px;
	color: #ffffff;
	font-weight: 500;
	transition: all 300ms ease;
}

.main-footer .footer-nav li a:hover {
	color: #890025
}

.main-footer.style-two .copyright-text {
	color: #ffffff;
	margin-bottom: 30px;
}

.main-footer.style-two .copyright-text a {
	color: #ffffff;
}

.main-footer.style-two .copyright-text a:hover {
	color: #e1137b;
}

.main-footer.style-two .copyright-text {
	border-top: 0;
}


/***

==================================================================
		Main Footer Style three
==================================================================

***/

.main-footer.style-three {
	position: relative;
	background: #ffffff;
	text-align: center;
	overflow: hidden;
}

.main-footer.style-three .footer-content {
	position: relative;
	padding: 70px 0 70px;
}

.main-footer.style-three .footer-logo {
	position: relative;
	text-align: center;
	margin-bottom: 20px;
}

.main-footer.style-three .footer-logo img {
	display: inline-block;
}

.main-footer.style-three .text {
	position: relative;
	max-width: 700px;
	margin: 0 auto;
	font-size: 16px;
	color: #101130;
	line-height: 28px;
	margin-bottom: 30px;
}

.main-footer.style-three .footer-nav li a {
	position: relative;
	display: block;
	font-size: 16px;
	line-height: 30px;
	color: #101130;
	font-weight: 500;
	transition: all 300ms ease;
}

.main-footer.style-three .footer-nav li a:hover {
	color: #f20487;
}

.main-footer.style-three .copyright-text {
	color: #101130;
	margin-bottom: 30px;
}

.main-footer.style-three .copyright-text a {
	color: #101130;
}

.main-footer.style-three .copyright-text a:hover {
	color: #e1137b;
}

.main-footer.style-three .copyright-text {
	border-top: 0;
}


.main-footer.style-three .icon-circle-blue {
	left: -150px;
	bottom: -100px;
	opacity: .70;
	animation: fa-spin 30s infinite alternate;
}

.main-footer.style-three .icon-dots {
	left: 15%;
	top: 20%;
}

.main-footer.style-three .icon-circle-1 {
	right: -200px;
	top: -200px;
	opacity: .05;
}

/***

====================================================================
	Error Section
====================================================================

***/
.error-section2 {
	position: relative;
	text-align: center;
	padding: 50px 0px;
}

.error-section2:before {
	position: absolute;
	left: 0;
	top: 0;
	height: 100%;
	width: 100%;
	/* background-image: url(../images/icons/pattern-1.jpg); */
	background-repeat: no-repeat;
	background-position: center;
	background-size: cover;
	content: "";
	opacity: .05;
}

.error-section2 .error-title {
	position: relative;
	color: #ec167f;
	font-size: 53px;
	font-weight: 700;
	line-height: 1em;
	text-shadow: 0 20px 30px rgba(0, 0, 0, 0.20);
}


.error-section2 h4 {
	color: #394963;
	font-size: 40px;
	font-weight: 700;
	margin-bottom: 20px;
}

.error-section2 .text {
	color: #777777;
	font-size: 22px;
	line-height: 1.4em;
	margin-bottom: 30px;
}

.error-section2 .theme-btn {
	border-radius: 5px;
	font-weight: 500;
	margin: 0 10px 10px;
	box-shadow: 0 10px 30px rgba(0, 0, 0, 0.20);
}

.error-section2 .icon-circle-blue {
	left: -80px;
	bottom: -80px;
	opacity: .70;
	animation: fa-spin 30s infinite alternate;
}

.error-section2 .icon-dots {
	left: 15%;
	top: 20%;
}

.error-section2 .icon-line-1 {
	right: 15%;
	bottom: 20%;
	opacity: .70;
	animation: fa-spin 30s infinite alternate;
}

.error-section2 .icon-circle-1 {
	right: -200px;
	top: -200px;
	opacity: .20;
}

.error-section {
	position: relative;
	text-align: center;
	padding: 150px 0px;
}

.error-section:before {
	position: absolute;
	left: 0;
	top: 0;
	height: 100%;
	width: 100%;
	/* background-image: url(../images/icons/pattern-1.jpg); */
	background-repeat: no-repeat;
	background-position: center;
	background-size: cover;
	content: "";
	opacity: .05;
}

.error-section .error-title {
	position: relative;
	color: #ec167f;
	font-size: 53px;
	font-weight: 700;
	line-height: 1em;
	text-shadow: 0 20px 30px rgba(0, 0, 0, 0.20);
}


.error-section h4 {
	color: #394963;
	font-size: 40px;
	font-weight: 700;
	margin-bottom: 20px;
}

.error-section .text {
	color: #888888;
	font-size: 22px;
	line-height: 1.4em;
	margin-bottom: 30px;
}

.error-section .theme-btn {
	border-radius: 5px;
	font-weight: 500;
	margin: 0 10px 10px;
	box-shadow: 0 10px 30px rgba(0, 0, 0, 0.20);
}

.error-section .icon-circle-blue {
	left: -80px;
	bottom: -80px;
	opacity: .70;
	animation: fa-spin 30s infinite alternate;
}

.error-section .icon-dots {
	left: 15%;
	top: 20%;
}

.error-section .icon-line-1 {
	right: 15%;
	bottom: 20%;
	opacity: .70;
	animation: fa-spin 30s infinite alternate;
}

.error-section .icon-circle-1 {
	right: -200px;
	top: -200px;
	opacity: .20;
}

/***

====================================================================
	Sidebar Page Container
====================================================================

***/

.sidebar-page-container {
	position: relative;
	padding: 120px 0px 70px;
}

.sidebar-page-container .content-side,
.sidebar-page-container .sidebar-side {
	margin-bottom: 50px;
}

.sidebar-page-container .sidebar.padding-left {
	padding-left: 40px;
}

.sidebar-widget {
	position: relative;
	margin-bottom: 50px;
}

.sidebar-widget:last-child {
	margin-bottom: 0;
}

/* Sidebar Title */

.sidebar-title {
	position: relative;
	display: block;
	font-size: 24px;
	line-height: 1.2em;
	color: #333333;
	font-weight: 700;
	margin-bottom: 20px;
	padding-bottom: 20px;
	border-bottom: 2px solid #eeeeee;
}

/*Search Box Widget*/

.sidebar .search-box {
	margin-bottom: 60px;
}

.sidebar .search-box .form-group {
	position: relative;
	margin: 0px;
}

.sidebar .search-box .form-group input[type="text"],
.sidebar .search-box .form-group input[type="search"] {
	position: relative;
	padding: 20px 50px 20px 30px;
	border: 2px solid #eeeeee;
	background: #ffffff;
	display: block;
	font-size: 15px;
	line-height: 18px;
	width: 100%;
	height: 60px;
	color: #333333;
	transition: all 500ms ease;
}

.sidebar .search-box .form-group input[type="text"]:focus,
.sidebar .search-box .form-group input[type="search"]:focus {
	color: #666666;
}

.sidebar .search-box .form-group button {
	position: absolute;
	right: 0;
	top: 0;
	height: 60px;
	width: 60px;
	display: block;
	font-size: 18px;
	color: #888888;
	line-height: 60px;
	font-weight: normal;
	background: #eeeeee;
	z-index: 9;
	cursor: pointer;
}

.sidebar .search-box .form-group button:hover {
	color: #e1137b;
}

/*Post Widget*/

.sidebar .popular-posts .post {
	position: relative;
	margin-bottom: 20px;
}

.sidebar .popular-posts .post .post-inner {
	position: relative;
	padding-left: 110px;
	min-height: 90px;
}

.sidebar .popular-posts .post .post-thumb {
	position: absolute;
	left: 0px;
	top: 0px;
	width: 90px;
}

.sidebar .popular-posts .post .post-thumb img {
	display: block;
	width: 100%;
	transition: all 0.3s ease;
}

.sidebar .popular-posts .post .text {
	position: relative;
	font-size: 18px;
	line-height: 26px;
	font-weight: 600;
	color: #888888;
	margin: 0px;
}

.sidebar .popular-posts .post .text a {
	color: #3f4161;
	transition: all 0.3s ease;
}

.sidebar .popular-posts .post a:hover {
	color: #e1137b;
}

.sidebar .popular-posts .post-info {
	position: relative;
	font-size: 16px;
	color: #7f8897;
	font-weight: 400;
	line-height: 30px;
	margin-bottom: 5px;
}

/* Blog Categories */

.blog-categories {
	position: relative;
}

.blog-categories li {
	position: relative;
}

.blog-categories li a {
	position: relative;
	display: block;
	color: #333333;
	font-size: 18px;
	line-height: 30px;
	font-weight: 400;
	margin-bottom: 10px;
	transition: all 500ms ease;
}

.blog-categories li a span {
	float: right;
}


.blog-categories li a:hover {
	color: #e1137b;
}

/*Popular Tags*/

.sidebar .popular-tags .widget-content {
	position: relative;
}

.sidebar .popular-tags a {
	position: relative;
	float: left;
	padding: 5px;
	margin: 0 20px 10px 0;
	color: #333333;
	text-align: center;
	font-size: 16px;
	line-height: 20px;
	background: none;
	font-weight: 400;
	border-bottom: 2px solid #dddddd;
	background-color: #ffffff;
	transition: all 300ms ease;
}

.sidebar .popular-tags a:hover {
	border-color: #e1137b;
	color: #e1137b;
}

/***

====================================================================
		Comment Area
====================================================================

 ***/

.group-title {
	position: relative;
	margin-bottom: 40px;
}

.group-title h3 {
	position: relative;
	display: inline-block;
	font-size: 28px;
	line-height: 1.2em;
	color: #222222;
	font-weight: 500;
}

.comments-area {
	position: relative;
	margin-bottom: 70px;
}

.comments-area .comment-box {
	position: relative;
	margin-bottom: 50px;
}

.comments-area .comment-box.reply-comment {
	margin-left: 70px;
}

.comments-area .comment-box:last-child {
	margin-bottom: 0;
}

.comments-area .comment {
	position: relative;
	min-height: 50px;
	padding-left: 70px;
}

.comments-area .comment-box .author-thumb {
	position: absolute;
	left: 0px;
	top: 0px;
	height: 50px;
	width: 50px;
	margin-bottom: 20px;
	border-radius: 50%;
	overflow: hidden;
	background-color: #7d7d7d;
}

.comments-area .comment-box .author-thumb img {
	width: 100%;
	display: block;
}

.comments-area .comment-info {
	position: relative;
	display: block;
	margin-bottom: 5px;
	font-size: 16px;
	line-height: 25px;
	font-weight: 700;
	color: #12114a;
}

.comments-area .comment-box .name {
	position: relative;
	display: inline-block;
	font-size: 16px;
	line-height: 25px;
	font-weight: 700;
	color: #12114a;
	margin-right: 10px;
}

.comments-area .comment-box .date {
	position: relative;
	display: inline-block;
	font-size: 14px;
	line-height: 24px;
	color: #777777;
	font-weight: 400;
	margin-left: 10px;
}

.comments-area .comment-box .text {
	font-size: 15px;
	line-height: 26px;
	color: #888888;
	font-weight: 400;
}

.comments-area .comment-box .reply-btn {
	position: relative;
	margin-top: 20px;
	font-size: 14px;
	line-height: 20px;
	padding: 5px 20px;
}

/***

====================================================================
		Comment Form
====================================================================

 ***/

.comment-form {
	position: relative;
}

.comment-form .form-group {
	position: relative;
	margin-bottom: 20px;
}

.comment-form .form-group:last-child {
	margin-bottom: 0;
}

.comment-form .form-group input[type="text"],
.comment-form .form-group input[type="email"],
.comment-form .form-group textarea,
.comment-form .form-group select {
	position: relative;
	display: block;
	height: 50px;
	width: 100%;
	font-size: 14px;
	color: #878787;
	line-height: 28px;
	font-weight: 400;
	padding: 10px 20px;
	background-color: #ffffff;
	border: 1px solid #999999;
	transition: all 300ms ease;
}

.comment-form .form-group input:focus,
.comment-form .form-group select:focus,
.comment-form .form-group textarea:focus {
	border-color: #12114a;
}

.comment-form .form-group textarea {
	height: 190px;
	resize: none;
}

.comment-form .form-group input[type="submit"],
.comment-form .form-group button {
	font-size: 15px;
	padding: 10px 30px;
	font-weight: 500;
	cursor: pointer;
}

/*=========================================================
			Buy Tickets
=========================================================*/

.buy-ticket {
	position: relative;
	padding: 120px 0 100px;
}

.buy-ticket .form-column {
	position: relative;
	margin-bottom: 30px;
}

.buy-ticket .form-column .inner-column {
	position: relative;
	padding-right: 30px;
}

.buy-ticket .content-column {
	position: relative;
	margin-bottom: 20px;
}

.buy-ticket p {
	position: relative;
	margin-bottom: 30px;
}

.buy-ticket h2 {
	position: relative;
	display: block;
	font-size: 32px;
	line-height: 1.2em;
	color: #3f4161;
	font-weight: 600;
	margin-bottom: 15px;
}

.buy-ticket h2 span {
	color: #ec167f;
}

.buy-ticket h3 {
	position: relative;
	display: block;
	font-size: 24px;
	line-height: 1.2em;
	color: #3f4161;
	font-weight: 600;
	margin-bottom: 15px;
}

.buy-ticket ul {
	margin-bottom: 30px;
}

.buy-ticket .ticket-form {
	position: relative;
	padding: 40px 30px;
	background-color: #f7f7f7;
	z-index: 1;
	margin-bottom: 40px;
}

.ticket-form .form-group {
	position: relative;
	display: block;
	width: 100%;
	margin-bottom: 20px;
}

.ticket-form .form-group:last-child {
	margin-bottom: 0;
}

.ticket-form .form-group input[type="text"],
.ticket-form .form-group input[type="email"],
.ticket-form .form-group input[type="phone"],
.ticket-form .form-group input[type="number"],
.ticket-form .form-group input[type="tel"],
.ticket-form .form-group input[type="url"] .ticket-form .form-group textarea,
.ticket-form .form-group select {
	position: relative;
	display: block;
	width: 100%;
	font-size: 16px;
	line-height: 20px;
	color: #9da6b4;
	font-weight: 400;
	height: 60px;
	padding: 20px 30px;
	background-color: #ffffff;
	border: 1px solid #dddddd;
	transition: all 300ms ease;
}

.ticket-form .form-group input:focus,
.ticket-form .form-group select:focus,
.ticket-form .form-group textarea:focus {
	background-color: #ffffff;
	border-color: #faeff5;
	color: #9da6b4;
	box-shadow: 0 30px 30px rgba(14, 16, 48, .08);
}

.ticket-form .form-group textarea {
	height: 150px;
	resize: none;
}

.ticket-form .form-group input[type=submit],
.ticket-form .form-group button {
	cursor: pointer;
	display: block;
	width: 100%;
}

.ticket-form .form-group label {
	position: relative;
	font-size: 14px;
	line-height: 24px;
	color: #888888;
}

.ticket-form .form-group label:hover {
	cursor: pointer;
}

.ticket-form .form-group label span {
	color: #ec167f;
	text-decoration: underline;
}

.ticket-form .form-group input[type=checkbox] {
	position: relative;
	top: 3px;
}

.buy-ticket .follow-us {
	position: relative;
	margin-bottom: 30px;
}

.buy-ticket .support-box {
	position: relative;
}

.buy-ticket .support-box p {
	margin-bottom: 10px;
}

.buy-ticket .support-box .number {
	position: relative;
	font-size: 20px;
	line-height: 1.2em;
	color: #1c94d2;
	font-weight: 500;
}

.buy-ticket .support-box .number a {
	color: #1c94d2;
}

.buy-ticket .support-box .number span {
	color: #3f4161;
	font-size: 18px;
	margin-right: 5px;
}

.buy-ticket .support-box .number a:hover {
	text-decoration: underline;
}

.buy-ticket .icon-circle-blue {
	left: -150px;
	bottom: -150px;
	opacity: .70;
	animation: fa-spin 30s infinite;
}

.buy-ticket .icon-circle-1 {
	right: -250px;
	top: -250px;
	opacity: .05;
}


/*=========================================================
			Social icon Colored
=========================================================*/

.social-icon-colored .fa-adn {
	color: #504e54;
}

.social-icon-colored .fa-apple {
	color: #aeb5c5;
}

.social-icon-colored .fa-android {
	color: #A5C63B;
}

.social-icon-colored .fa-bitbucket,
.social-icon-colored .fa-bitbucket-square {
	color: #F46899;
}

.social-icon-colored .fa-bitcoin,
.social-icon-colored .fa-btc {
	color: #F7931A;
}

.social-icon-colored .fa-css3 {
	color: #1572B7;
}

.social-icon-colored .fa-dribbble {
	color: #F46899;
}

.social-icon-colored .fa-dropbox {
	color: #018BD3;
}

.social-icon-colored .fa-facebook,
.social-icon-colored .fa-facebook-f,
.social-icon-colored .fa-facebook-square {
	color: #3C599F;
}

.social-icon-colored .fa-flickr {
	color: #FF0084;
}

.social-icon-colored .fa-foursquare {
	color: #0086BE;
}

.social-icon-colored .fa-github,
.social-icon-colored .fa-github-alt,
.social-icon-colored .fa-github-square {
	color: #070709;
}

.social-icon-colored .fa-google-plus,
.social-icon-colored .fa-google-plus-g,
.social-icon-colored .fa-google-plus-square {
	color: #CF3D2E;
}

.social-icon-colored .fa-html5 {
	color: #E54D26;
}

.social-icon-colored .fa-instagram {
	color: #A1755C;
}

.social-icon-colored .fa-linkedin,
.social-icon-colored .fa-linkedin-in,
.social-icon-colored .fa-linkedin-square {
	color: #0085AE;
}

.social-icon-colored .fa-linux {
	color: #FBC002;
	color: #333;
}

.social-icon-colored .fa-maxcdn {
	color: #F6AE1C;
}

.social-icon-colored .fa-pagelines {
	color: #241E20;
	color: #3984EA;
}

.social-icon-colored .fa-pinterest,
.social-icon-colored .fa-pinterest-square {
	color: #CC2127;
}

.social-icon-colored .fa-renren {
	color: #025DAC;
}

.social-icon-colored .fa-skype {
	color: #01AEF2;
}

.social-icon-colored .fa-stack-exchange {
	color: #245590;
}

.social-icon-colored .fa-stack-overflow {
	color: #FF7300;
}

.social-icon-colored .fa-trello {
	color: #265A7F;
}

.social-icon-colored .fa-tumblr,
.social-icon-colored .fa-tumblr-square {
	color: #314E6C;
}

.social-icon-colored .fa-twitter,
.social-icon-colored .fa-twitter-square {
	color: #32CCFE;
}

.social-icon-colored .fa-vimeo-square {
	color: #229ACC;
}

.social-icon-colored .fa-vk {
	color: #375474;
}

.social-icon-colored .fa-weibo {
	color: #D72B2B;
}

.social-icon-colored .fa-windows {
	color: #12B6F3;
}

.social-icon-colored .fa-xing,
.social-icon-colored .fa-xing-square {
	color: #00555C;
}

.social-icon-colored .fa-youtube,
.social-icon-colored .fa-youtube-play,
.social-icon-colored .fa-youtube-square {
	color: #C52F30;
}

/*Social icon Colored*/
.social-icon-colored li a:hover .fa-adn {
	background-color: #504e54;
}

.social-icon-colored li a:hover .fa-apple {
	background-color: #aeb5c5;
}

.social-icon-colored li a:hover .fa-android {
	background-color: #A5C63B;
}

.social-icon-colored li a:hover .fa-bitbucket,
.social-icon-colored li a:hover .fa-bitbucket-square {
	background-color: #F46899;
}

.social-icon-colored li a:hover .fa-bitcoin,
.social-icon-colored li a:hover .fa-btc {
	background-color: #F7931A;
}

.social-icon-colored li a:hover .fa-css3 {
	background-color: #1572B7;
}

.social-icon-colored li a:hover .fa-dribbble {
	background-color: #F46899;
}

.social-icon-colored li a:hover .fa-dropbox {
	background-color: #018BD3;
}

.social-icon-colored li a:hover .fa-facebook,
.social-icon-colored li a:hover .fa-facebook-f,
.social-icon-colored li a:hover .fa-facebook-square {
	background-color: #3C599F;
}

.social-icon-colored li a:hover .fa-flickr {
	background-color: #FF0084;
}

.social-icon-colored li a:hover .fa-foursquare {
	background-color: #0086BE;
}

.social-icon-colored li a:hover .fa-github,
.social-icon-colored li a:hover .fa-github-alt,
.social-icon-colored li a:hover .fa-github-square {
	background-color: #070709;
}

.social-icon-colored li a:hover .fa-google-plus,
.social-icon-colored li a:hover .fa-google-plus-g,
.social-icon-colored li a:hover .fa-google-plus-square {
	background-color: #CF3D2E;
}

.social-icon-colored li a:hover .fa-html5 {
	background-color: #E54D26;
}

.social-icon-colored li a:hover .fa-instagram {
	background-color: #A1755C;
}

.social-icon-colored li a:hover .fa-linkedin,
.social-icon-colored li a:hover .fa-linkedin-in,
.social-icon-colored li a:hover .fa-linkedin-square {
	background-color: #0085AE;
}

.social-icon-colored li a:hover .fa-linux {
	background-color: #FBC002;
	color: #333;
}

.social-icon-colored li a:hover .fa-maxcdn {
	background-color: #F6AE1C;
}

.social-icon-colored li a:hover .fa-pagelines {
	background-color: #241E20;
	color: #3984EA;
}

.social-icon-colored li a:hover .fa-pinterest,
.social-icon-colored li a:hover .fa-pinterest-square {
	background-color: #CC2127;
}

.social-icon-colored li a:hover .fa-renren {
	background-color: #025DAC;
}

.social-icon-colored li a:hover .fa-skype {
	background-color: #01AEF2;
}

.social-icon-colored li a:hover .fa-stack-exchange {
	background-color: #245590;
}

.social-icon-colored li a:hover .fa-stack-overflow {
	background-color: #FF7300;
}

.social-icon-colored li a:hover .fa-trello {
	background-color: #265A7F;
}

.social-icon-colored li a:hover .fa-tumblr,
.social-icon-colored li a:hover .fa-tumblr-square {
	background-color: #314E6C;
}

.social-icon-colored li a:hover .fa-twitter,
.social-icon-colored li a:hover .fa-twitter-square {
	background-color: #32CCFE;
}

.social-icon-colored li a:hover .fa-vimeo-square {
	background-color: #229ACC;
}

.social-icon-colored li a:hover .fa-vk {
	background-color: #375474;
}

.social-icon-colored li a:hover .fa-weibo {
	background-color: #D72B2B;
}

.social-icon-colored li a:hover .fa-windows {
	background-color: #12B6F3;
}

.social-icon-colored li a:hover .fa-xing,
.social-icon-colored li a:hover .fa-xing-square {
	background-color: #00555C;
}

.social-icon-colored li a:hover .fa-youtube,
.social-icon-colored li a:hover .fa-youtube-play,
.social-icon-colored li a:hover .fa-youtube-square {
	background-color: #C52F30;
}

.social-icon-colored li a:hover .fab {
	color: #ffffff;
}

/***

==================================================================
		Right To Left Style
==================================================================

***/

.rtl {
	direction: rtl;
	text-align: right;
}

.rtl .social-icon-three li,
.rtl .social-icon-one,
.rtl .banner-conference .time-countdown,
.rtl .styled-pagination,
.rtl .owl-carousel {
	direction: ltr !important;
}

.rtl .banner-conference .layer-outer,
.rtl .anim-icons {
	transform: scaleX(-1);
}

.rtl .main-header .search-box-outer,
.rtl .schedule-tabs.style-three .tab-buttons li,
.rtl .main-header .nav-outer .main-menu,
.rtl .main-header .logo-box {
	float: right;
}

.rtl .main-header .search-box-outer2,
.rtl .schedule-tabs.style-three .tab-buttons li,
.rtl .main-header .nav-outer .main-menu,
.rtl .main-header .logo-box {
	float: right;
}

.rtl .blog-categories li a span,
.rtl .fluid-section-one .content-column,
.rtl .main-header .nav-outer {
	float: left;
}

.rtl .list-style-one li:before,
.rtl .list-style-two li:before,
.rtl .fluid-section-one .image-column,
.rtl .schedule-block.style-two .speaker-info .thumb,
.rtl .pricing-block-two .features li:before,
.rtl .event-detail .speaker-info .thumb,
.rtl .event-info-tabs .tabs-content .info-list li .icon,
.rtl .comments-area .comment-box .author-thumb,
.rtl .blog-single .lower-content blockquote cite:before,
.rtl .about-section-two .about-block .icon,
.rtl .contact-page-section .contact-info li .icon,
.rtl .subscribe-section .content-box .sec-title .icon,
.rtl .sidebar .popular-posts .post .post-thumb,
.rtl .main-footer .footer-column .widget-title:before,
.rtl .pricing-block .features li:before,
.rtl .main-menu .navigation>li>ul {
	left: auto;
	right: 0;
}

.rtl .main-menu .navigation>li>ul>li>ul {
	right: 100%;
	left: auto;
}

.rtl .sidebar .search-box .form-group button,
.rtl .subscribe-form .form-group input[type="submit"],
.rtl .subscribe-form .form-group button,
.rtl .banner-conference .images-outer,
.rtl .banner-conference .layer-outer {
	right: auto;
	left: 0;
}

.rtl .main-header .outer-box {
	float: left;
	margin-right: 50px;
	margin-left: 0;
}

.rtl .main-header .outer-box .btn-box {
	float: right;
	margin-left: 0;
	margin-right: 20px;
}

.rtl .main-header .search-box-outer .dropdown-menu {
	right: auto !important;
	left: 0 !important;
}

.rtl .main-header .search-box-outer2 .dropdown-menu {
	right: auto !important;
	left: 0 !important;
}

.rtl .main-menu .navigation>li {
	float: right;
	margin-right: 45px;
	margin-left: 0;
}

.rtl .banner-carousel .content-box .info-list li .icon {
	float: right;
	margin-left: 10px;
}

.rtl .coming-soon-section .time-countdown .counter-column:before {
	right: auto;
	left: -50px;
}

.rtl .list-style-one li {
	padding-left: 0;
	padding-right: 35px;
}

.rtl .about-section .image-column .image-box {
	padding-left: 0;
	padding-right: 80px;
}

.rtl .about-section .content-column .inner-column {
	padding-right: 0;
	padding-left: 80px;
}

.rtl .feature-block-two .inner-box {
	padding: 40px 30px;
	padding-right: 100px;
}

.rtl .feature-block-two .icon-box {
	left: auto;
	right: 30px;
}

.rtl .pricing-block .features li {
	padding: 5px 0;
	padding-right: 30px;
}

.rtl .register-form .form-group input[type="text"],
.rtl .register-form .form-group input[type="email"],
.rtl .register-form .form-group input[type="url"],
.rtl .register-form .form-group input[type="number"],
.rtl .register-form .form-group input[type="date"],
.rtl .register-form .form-group input[type="email"],
.rtl .register-form .form-group textarea,
.register-form .form-group select {
	padding: 10px 20px;
	padding-right: 50px;
}

.rtl .register-form .form-group .icon {
	left: auto;
	right: 20px;
}

.rtl .user-links li a {
	border-left: 0;
	border-right: 1px solid #f70068;
}

.rtl .main-footer .contact-list li {
	padding-left: 0;
	padding-right: 40px;
}

.rtl .main-footer .contact-list li .icon {
	left: auto;
	right: 0px;
}

.rtl .speaker-block-two .info-box {
	border-radius: 30px 0 0 30px;
}

.rtl .schedule-section.style-two .schedule-block .date,
.rtl .schedule-section.style-two .schedule-block .inner-box {
	text-align: right;
}

.rtl .schedule-block.style-two .speaker-info {
	padding-left: 0;
	padding-right: 80px;
}

.rtl .pricing-block-two .title .icon {
	margin-right: 0;
	margin-left: 5px;
}

.rtl .pricing-block-two .price-box {
	margin-left: 0;
	margin-right: -30px;
}

.rtl .pricing-block-two .price {
	border-radius: 50px 0 0 50px;
}

.rtl .pricing-block-two .features li {
	padding-right: 30px;
	padding-left: 0;
}

.rtl .banner-meetup .address .icon,
.rtl .event-info-tabs .tabs-content h4 .icon {
	margin-right: 0;
	margin-left: 10px;
}

.rtl .event-info-tabs .tabs-content .info-list li {
	padding-left: 0;
	padding-right: 30px;
}

.rtl .subscribe-section .content-box .sec-title {
	text-align: right;
}

.rtl .subscribe-section .content-box .sec-title {
	padding-right: 90px;
	padding-left: 0;
}

.rtl .about-section-two .image-column .image-box {
	padding-right: 0;
	padding-left: 50px;
}

.rtl .about-section-two .about-block h4 {
	padding-left: 0;
	padding-right: 35px;
}

.rtl .feature-block-three .inner-box {
	padding-right: 170px;
	padding-left: 100px;
}

.rtl .feature-block-three .icon-box {
	left: auto;
	right: 50px;
}

.rtl .feature-block-three .link-box {
	right: auto;
	left: 30px;
}

.rtl .speaker-block-three .info-box {
	padding: 10px 30px;
	padding-left: 10px;
}

.rtl .speaker-block-three .info-box:before {
	right: 0;
	left: -30px;
	border-radius: 14px 0 0 14px;
}

.rtl .schedule-section.style-three .schedule-block .date,
.rtl .schedule-section.style-three .schedule-block .inner-box {
	text-align: right;
}

.rtl .accordion-box .block .acc-btn {
	padding: 15px 25px 15px 25px;
	padding-left: 50px;
}

.rtl .accordion-box .block .icon-outer {
	right: auto;
	left: 25px;
}

.rtl .app-section .link-box a {
	margin-right: 0;
	margin-left: 25px;
}

.rtl .app-section .image-column .inner-column {
	text-align: left;
}

.rtl .event-info-section .info-column .inner-column {
	left: 0;
	padding-right: 30px;
}

.rtl .event-info-tabs .tab-btn {
	float: right;
	margin-left: 5px;
	margin-right: 0;
}

.rtl .subscribe-form .form-group {
	padding-right: 0;
	padding-left: 70px;
}

.rtl .about-section .icon-dots {
	left: auto;
	right: 50%;
}

.rtl .coming-soon .emailed-form .form-group input[type="submit"],
.rtl .coming-soon .emailed-form button {
	right: auto;
	left: 35px;
	transform: scaleX(-1);
}

.rtl .event-detail .speaker-info {
	padding-left: 0;
	padding-right: 75px;
}

.rtl .list-style-two li {
	padding-left: 0;
	padding-right: 25px;
}

.rtl .buy-ticket .support-box .number span {
	margin-left: 5px;
	margin-right: 0;
}

.rtl .buy-ticket .form-column .inner-column {
	padding-right: 0;
	padding-left: 30px;
}

.rtl .news-block .post-info li {
	margin-left: 25px;
	margin-right: 0;
}

.rtl .news-block .post-info li span {
	margin-right: 0;
	margin-left: 5px;
}

.rtl .sidebar-page-container .sidebar.padding-left {
	padding-left: 0;
	padding-right: 40px;
}

.rtl .sidebar .search-box .form-group input[type="text"],
.rtl .sidebar .search-box .form-group input[type="search"] {
	padding: 20px 30px 20px 50px;
}

.rtl .sidebar .popular-posts .post .post-inner {
	padding-left: 0;
	padding-right: 110px;
}

.rtl .sidebar .popular-tags a {
	float: right;
	margin: 0 0px 10px 20px;
}

.rtl .blog-single .lower-content blockquote {
	padding: 35px 40px;
	padding-right: 95px;
}

.rtl .blog-single .lower-content blockquote .icon {
	left: auto;
	right: 40px;
}

.rtl .blog-single .lower-content blockquote cite {
	padding-left: 0;
	padding-right: 30px;
}

.rtl .comments-area .comment {
	padding-left: 0;
	padding-right: 70px;
}

.rtl .comments-area .comment-box .name {
	margin-right: 0;
	margin-left: 10px;
}

.rtl .contact-page-section .contact-info li {
	padding-left: 0;
	padding-right: 55px;
}


.rtl .schedule-section.style-three .schedule-block .speaker-info,
.rtl .schedule-section.style-two .schedule-block .speaker-info {
	padding-left: 0;
	padding-right: 80px;
}

.rtl .schedule-section.style-three .schedule-block .speaker-info .thumb,
.rtl .schedule-section.style-two .schedule-block .speaker-info .thumb {
	left: auto;
	right: 0;
}

.rtl .banner-conference-two .time-countdown .counter-column {
	margin-right: 0px;
	margin-left: 30px;
}

.rtl .banner-conference-two .time-countdown .counter-column:before {
	right: auto;
	left: -20px;
}

.rtl .banner-conference-two .images-outer {
	left: 0px;
	right: auto;
}

.rtl .header-top .top-left {
	order: 2;
}

.rtl .header-top .top-right {
	order: 1;
}

.rtl .header-top-two .top-left .links li a {
	padding-left: 0px;
	padding-right: 24px;
}

.rtl .header-top-two .top-left .links li a .icon {
	right: 0px;
	left: auto;
}

.rtl .header-top-two .top-right .cart-box {
	margin-left: 30px;
}

/***

====================================================================
	Box Layout
====================================================================

***/

.box-layout .page-wrapper {
	max-width: 1280px;
	margin: 0 auto;
	background-color: #ffffff;
	overflow: hidden;
	box-shadow: 0 0 50px rgba(0, 0, 0, 0.10);
}

.box-layout .main-header {
	max-width: 1280px;
	left: 0;
	right: 0;
	margin: 0 auto;
}

.box-layout {
	background-repeat: repeat;
	background-position: center;
	background-attachment: fixed;
	/* background-image: url(../images/icons/boxed-bg.png); */
}

.box-layout .coming-soon {
	position: relative;
}

/* Header Top */

.header-top {
	position: relative;
	background-color: #ec167f;
	transition: all 600ms ease;
}

.header-top .top-left {
	position: relative;
	padding: 15px 0px;
}

.header-top .text {
	position: relative;
	color: #ffffff;
	font-size: 16px;
}

.header-top .top-right {
	position: relative;
}

.header-span.style-two {
	height: 145px;
}

.header-top .social-links {
	position: relative;
	padding: 16px 0px;
	float: left;
}

.header-top .social-links li {
	position: relative;
	margin-left: 18px;
	display: inline-block;
}

.header-top .social-links li a {
	position: relative;
	color: #ffffff;
	font-size: 14px;
	transition: all 0.3s ease;
}

.header-top .social-links li a:hover {
	color: #4c35a9;
}

.header-top .register-btn {
	position: relative;
	color: #ffffff;
	float: left;
	font-size: 16px;
	padding: 16.5px 30px;
	margin-left: 25px;
	background-color: #1c94d2;
}

.main-header.header-style-two.alternate-two {
	position: absolute;
	left: 0px;
	top: 0px;
	right: 0px;
}

.main-header.header-style-two.alternate-two .outer-box .search-box-btn,
.main-header.header-style-two.alternate-two .main-menu .navigation>li>a {
	color: #ffffff;
}

.main-header.header-style-two.alternate-two .outer-box .search-box-btn2,
.main-header.header-style-two.alternate-two .main-menu .navigation>li>a {
	color: #ffffff;
}

.main-header.header-style-two.alternate-two .outer-box .search-box-btn3,
.main-header.header-style-two.alternate-two .main-menu .navigation>li>a {
	color: #ffffff;
}

.main-header.header-style-two.alternate-two .outer-box .search-box-btn4,
.main-header.header-style-two.alternate-two .main-menu .navigation>li>a {
	color: #ffffff;
}

.main-header.header-style-two.alternate-two .outer-box .search-box-btn5,
.main-header.header-style-two.alternate-two .main-menu .navigation>li>a {
	color: #ffffff;
}

.main-header.header-style-two.alternate-two .outer-box .search-box-btn6,
.main-header.header-style-two.alternate-two .main-menu .navigation>li>a {
	color: #ffffff;
}

.main-header.header-style-two.alternate-two.fixed-header .outer-box .search-box-btn,
.main-header.header-style-two.alternate-two.fixed-header .main-menu .navigation>li>a {
	color: #000000;
}

.main-header.header-style-two.alternate-two.fixed-header .outer-box .search-box-btn2,
.main-header.header-style-two.alternate-two.fixed-header .main-menu .navigation>li>a {
	color: #000000;
}

.main-header.header-style-two.alternate-two.fixed-header .outer-box .search-box-btn3,
.main-header.header-style-two.alternate-two.fixed-header .main-menu .navigation>li>a {
	color: #000000;
}

.main-header.header-style-two.alternate-two.fixed-header .outer-box .search-box-btn4,
.main-header.header-style-two.alternate-two.fixed-header .main-menu .navigation>li>a {
	color: #000000;
}

.main-header.header-style-two.alternate-two.fixed-header .outer-box .search-box-btn5,
.main-header.header-style-two.alternate-two.fixed-header .main-menu .navigation>li>a {
	color: #000000;
}

.main-header.header-style-two.alternate-two.fixed-header .outer-box .search-box-btn6,
.main-header.header-style-two.alternate-two.fixed-header .main-menu .navigation>li>a {
	color: #000000;
}

.main-header.header-style-two.alternate.fixed-header .header-top,
.main-header.header-style-two.alternate-two.fixed-header .header-top-two {
	display: none;
}

.main-header.header-style-two.alternate-two .main-box {
	position: fixed;
	width: 100%;
}

/* Banner Section Two */

.banner-section-two {
	position: relative;
	padding: 150px 0px 350px;
	background-size: cover;
	background-repeat: no-repeat;
	transition: all 600ms ease;
}

.banner-section-two .outer-container {
	position: relative;
}

.banner-section-two .outer-container .content {
	position: relative;
	width: 100%;
	max-width: 800px;
	text-align: center;
	display: inline-block;
	background-color: #ec167f;
}

.banner-section-two .outer-container .content .upper-content {
	position: relative;
	padding: 10px 30px;
	display: inline-block;
	background-color: #ec167f;
}

.banner-section-two .outer-container .title {
	position: relative;
	color: #ffffff;
	font-size: 20px;
}

.banner-section-two .outer-container .content h1 {
	position: relative;
	font-weight: 800;
	color: #ffffff;
	font-size: 80px;
	line-height: 1em;
	margin-top: 12px;
}

.banner-section-two .outer-container .content h1 span {
	position: relative;
	font-weight: 300;
}

.banner-section-two .outer-container .content h2 {
	position: relative;
	font-weight: 400;
	color: #ffffff;
	font-size: 35px;
	line-height: 1.1em;
	margin-top: 18px;
	text-transform: uppercase;
}

.banner-section-two .outer-container .content h2 span {
	font-weight: 300;
	display: block;
	font-size: 28px;
}

.banner-section-two .outer-container .content .lower-content {
	position: relative;
	padding: 10px 50px;
	background-color: #363636;
}

.banner-section-two .outer-container .content .lower-content .lower-title {
	position: relative;
	color: #ffffff;
	font-weight: 300;
	font-size: 18px;
	font-style: italic;
}

.banner-section-two .outer-container .content .lower-content .date {
	position: relative;
	color: #ffffff;
	font-weight: 600;
	font-size: 16px;
	font-style: italic;
	margin-top: 8px;
}

/***

====================================================================
	Coming Soon Section Two
====================================================================

***/

.coming-soon-section-two {
	position: relative;
	z-index: 2;
}

.coming-soon-section-two .outer-box:before {
	position: absolute;
	content: '';
	left: 0px;
	bottom: 0px;
	width: 100%;
	height: 42px;
	background-color: #363941;
}

.coming-soon-section-two .outer-box {
	position: relative;
	display: block;
	padding: 0px 80px 40px;
	background-color: #ec167f;
	text-align: center;
	margin-top: -142px;
	/* background: -moz-linear-gradient(to left, rgba(247,0,104,1) 0%, rgba(68,16,102,1) 100%);
	background: -webkit-linear-gradient(to left, rgba(247,0,104,1) 0%, rgba(68,16,102,1) 100%);
	background: linear-gradient(to left, rgba(247,0,104) 0%,rgba(68,16,102,1) 100%);
	filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#F70068', endColorstr='#441066',GradientType=1 ); */
	box-shadow: 0 0 30px rgba(0, 0, 0, 0.30);
}

.coming-soon-section-two .timer-column {
	position: relative;
}

.coming-soon-section-two .time-counter {
	position: relative;

}

.coming-soon-section-two .time-countdown {
	position: relative;
}

.coming-soon-section-two .time-countdown .counter-column {
	position: relative;
	display: inline-block;
	margin: 0px 40px;
	width: 100px;
	text-align: center;
	font-size: 14px;
	color: #ffffff;
	top: 30px;
	font-weight: 300;
	font-style: italic;
	text-transform: uppercase;
}

.coming-soon-section-two .time-countdown .counter-column:before {
	position: absolute;
	content: ':';
	top: 5px;
	right: -50px;
	font-size: 80px;
	line-height: 1em;
	color: #ffffff;
	font-style: normal;
}

.coming-soon-section-two .time-countdown .counter-column:last-child:before {
	display: none;
}

.coming-soon-section-two .time-countdown .counter-column .count {
	position: relative;
	display: block;
	font-size: 90px;
	line-height: 1em;
	color: #ffffff;
	font-weight: 700;
	padding-bottom: 30px;
	font-style: normal;
}






.header-top-two {
	position: relative;
	border-bottom: 1px solid rgba(245, 245, 245, 0.50);
}

.header-top-two .top-left {
	position: relative;
	float: left;
}

.header-top-two .top-left .links {
	position: relative;
}

.header-top-two .top-left .links li {
	position: relative;
	margin-right: 18px;
	padding: 13px 0px;
	padding-right: 22px;
	display: inline-block;
	border-right: 1px solid rgba(245, 245, 245, 0.50);
}

.header-top-two .top-left .links li:last-child {
	border-right: none;
}

.header-top-two .top-left .links li a {
	position: relative;
	font-size: 15px;
	font-weight: 400;
	color: #ffffff;
	padding-left: 24px;
}

.header-top-two .top-left .links li a .icon {
	position: absolute;
	left: 0px;
	color: #ec167f;
}

.header-top-two .top-right {
	position: relative;
	float: right;
}

.header-top-two .top-right .social-icons {
	position: relative;
	float: left;
}

.header-top-two .top-right .social-icons li {
	position: relative;
	margin-left: 15px;
	padding: 13px 0px;
	display: inline-block;
}

.header-top-two .top-right .social-icons li a {
	position: relative;
	color: #ffffff;
	font-size: 16px;
}

/***

====================================================================
	Banner Conference Two
====================================================================

***/

.banner-conference-two {
	position: relative;
	padding: 320px 0px 200px;
	overflow: hidden;
}




.banner-conference-two .icons {
	position: absolute;
	left: 0px;
	top: 0px;
	right: 0px;
	bottom: 0px;
}

.banner-conference-two .icons .icon-one {
	position: absolute;
	left: 10% !important;
	top: 17% !important;
	width: 12px;
	height: 12px;
	display: inline-block;
	background-repeat: no-repeat;
}

.banner-conference-two .icons .icon-two {
	position: absolute;
	left: 35% !important;
	top: 25% !important;
	width: 16px;
	height: 16px;
	display: inline-block;
	background-repeat: no-repeat;
}

.banner-conference-two .icons .icon-three {
	position: absolute;
	left: 6% !important;
	top: 58% !important;
	width: 34px;
	height: 10px;
	display: inline-block;
	background-repeat: no-repeat;
}

.banner-conference-two .icons .icon-four {
	position: absolute;
	left: 56% !important;
	top: 60% !important;
	width: 34px;
	height: 20px;
	display: inline-block;
	background-repeat: no-repeat;
}

.banner-conference-two .icons .icon-five {
	position: absolute;
	left: 79% !important;
	top: 25% !important;
	width: 35px;
	height: 16px;
	display: inline-block;
	background-repeat: no-repeat;
}

.banner-conference-two .icons .icon-six {
	position: absolute;
	left: 90% !important;
	top: 88% !important;
	width: 20px;
	height: 20px;
	display: inline-block;
	background-repeat: no-repeat;
}

.banner-conference-two .icons .icon-seven {
	position: absolute;
	left: 80% !important;
	top: 60% !important;
	width: 20px;
	height: 20px;
	display: inline-block;
	background-repeat: no-repeat;
}




.banner-conference-two .icons .icon-eight {
	position: absolute;
	left: 52% !important;
	top: 40% !important;
	width: 12px;
	height: 12px;
	display: inline-block;
	background-repeat: no-repeat;
}

.banner-conference-two .icons .icon-nine {
	position: absolute;
	left: 52% !important;
	top: 12% !important;
	width: 16px;
	height: 16px;
	display: inline-block;
	background-repeat: no-repeat;
}

.banner-conference-two .icons .icon-ten {
	position: absolute;
	left: 34% !important;
	top: 68% !important;
	width: 34px;
	height: 10px;
	display: inline-block;
	background-repeat: no-repeat;
}

.banner-conference-two .icons .icon-eleven {
	position: absolute;
	left: 89% !important;
	top: 80% !important;
	width: 34px;
	height: 20px;
	display: inline-block;
	background-repeat: no-repeat;
}

.banner-conference-two .icons .icon-twelve {
	position: absolute;
	left: 69% !important;
	top: 70% !important;
	width: 35px;
	height: 16px;
	display: inline-block;
	background-repeat: no-repeat;
}

.banner-conference-two .icons .icon-thirteen {
	position: absolute;
	left: 200% !important;
	top: 88% !important;
	width: 20px;
	height: 20px;
	display: inline-block;
	background-repeat: no-repeat;
}

.banner-conference-two .icons .icon-fourteen {
	position: absolute;
	left: 95% !important;
	top: 95% !important;
	width: 20px;
	height: 20px;
	display: inline-block;
	background-repeat: no-repeat;
}

.banner-conference-two:before {
	position: absolute;
	content: '';
	left: 0px;
	top: 0px;
	right: 0px;
	bottom: 0px;
	background-color: rgba(0, 0, 0, 0.85);
}

.banner-conference-two .icon-dots {
	left: 40%;
	bottom: 180px;
}

.banner-conference-two .layer-outer {
	position: absolute;
	right: 0;
	top: 0;
	height: 100%;
	width: 50%;
}

.banner-conference-two .images-outer {
	position: absolute;
	right: 0;
	top: 0;
	height: 100%;
	width: 50%;
}

.banner-conference-two .images-outer .speaker-img {
	position: absolute;
	right: 150px;
	top: 52%;
	transform: translateY(-50%);
}

.banner-conference-two .content-box {
	position: relative;
	z-index: 99;
}

.banner-conference-two .content-box .title {
	display: block;
	font-size: 16px;
	color: #ffffff;
	font-weight: 400;
	margin-bottom: 20px;
}

.banner-conference-two .content-box h2 {
	display: block;
	font-size: 50px;
	line-height: 1.2em;
	color: #ffffff;
	font-weight: 700;
	margin-bottom: 50px;
}

.banner-conference-two .time-counter {
	position: relative;
	margin-bottom: 30px;
}

.banner-conference-two .time-countdown {
	position: relative;
}

.banner-conference-two .time-countdown .counter-column {
	position: relative;
	display: inline-block;
	margin-right: 30px;
	width: 90px;
	text-align: center;
	font-size: 14px;
	color: #ffffff;
	font-weight: 500;
}

.banner-conference-two .time-countdown .counter-column:last-child {
	margin-right: 0;
}

.banner-conference-two .time-countdown .counter-column:before {
	position: absolute;
	content: ':';
	top: 10px;
	right: -20px;
	font-size: 30px;
	line-height: 1em;
	color: #ffffff;
}

.banner-conference-two .time-countdown .counter-column:after {
	position: absolute;
	left: 0;
	top: -20px;
	height: 100px;
	width: 90px;
	z-index: -1;
	border-radius: 5px 30px 5px 30px;
	background-color: #ec167f;
	/* border-top: 3px solid #ec167f;
	border-bottom: 3px solid #ec167f; */
	content: "";
}

.banner-conference-two .time-countdown .counter-column:nth-child(2):after {
	background-color: #1c94d2;
}

.banner-conference-two .time-countdown .counter-column:nth-child(3):after {
	background-color: #faaC1D;
}

.banner-conference-two .time-countdown .counter-column:nth-child(4):after {
	background-color: #4c35a9;
}

.banner-conference-two .time-countdown .counter-column:last-child:before {
	display: none;
}

.banner-conference-two .time-countdown .counter-column .count {
	position: relative;
	display: block;
	font-size: 40px;
	line-height: 1em;
	color: #ffffff;
	font-weight: 700;
}

.banner-conference-two .content-box .btn-box {
	position: relative;
	margin-top: 60px;
}




/***

====================================================================
	Search Popup
====================================================================

***/

.search-popup {
	position: fixed;
	left: 0px;
	bottom: -100%;
	width: 100%;
	height: 100%;
	z-index: 9999;
	visibility: hidden;
	opacity: 0;
	overflow: auto;
	background: rgba(0, 0, 0, 0.80);
	transition: all 700ms ease;
	-moz-transition: all 700ms ease;
	-webkit-transition: all 700ms ease;
	-ms-transition: all 700ms ease;
	-o-transition: all 700ms ease;
}

.search-popup .overlay-layer {
	position: absolute;
	left: 0px;
	top: 0px;
	right: 0px;
	bottom: 0px;
	display: block;
}

.search-popup.popup-visible {
	bottom: 0;
	visibility: visible;
	opacity: 1;
}

.search-popup .close-search {
	position: absolute;
	right: 25px;
	top: 25px;
	font-size: 22px;
	color: #ffffff;
	cursor: pointer;
	z-index: 5;
}

.search-popup .close-search:hover {
	opacity: 0.70;
}

.search-popup .search-form {
	position: relative;
	padding: 0px 15px 0px;
	max-width: 1024px;
	margin: 0 auto;
	margin-top: 200px;
}

.search-popup .search-form fieldset {
	position: relative;
	border: 7px solid rgba(255, 255, 255, 0.50);
	border-radius: 12px;
	-webkit-border-radius: 12px;
	-ms-border-radius: 12px;
	-o-border-radius: 12px;
	-moz-border-radius: 12px;
}

.search-popup .search-form fieldset input[type="search"] {
	position: relative;
	height: 70px;
	padding: 20px 220px 20px 30px;
	background: #ffffff;
	line-height: 30px;
	font-size: 24px;
	color: #233145;
	border-radius: 7px;
	-webkit-border-radius: 7px;
	-ms-border-radius: 7px;
	-o-border-radius: 7px;
	-moz-border-radius: 7px;
}

.search-popup .search-form fieldset input[type="submit"] {
	position: absolute;
	display: block;
	right: 0px;
	top: 0px;
	text-align: center;
	width: 220px;
	height: 70px;
	padding: 20px 10px 20px 10px;
	color: #ffffff !important;
	background-color: #ec167f;
	line-height: 30px;
	font-size: 20px;
	color: #233145;
	cursor: pointer;
	text-transform: uppercase;
	border-radius: 0px 7px 7px 0px;
	-moz-border-radius: 0px 7px 7px 0px;
	-ms-border-radius: 0px 7px 7px 0px;
	-o-border-radius: 0px 7px 7px 0px;
	-webkit-border-radius: 0px 7px 7px 0px;
}

.search-popup .search-form fieldset input[type="submit"]:hover {
	background: #ec167f;
}

.search-popup h3 {
	font-size: 24px;
	color: #ffffff;
	margin-bottom: 20px;
	text-align: center;
}

.search-popup .recent-searches {
	font-size: 16px;
	color: #ffffff;
	text-align: center;
}

.search-popup .recent-searches li {
	display: inline-block;
	margin: 0px 10px 10px 0px;
}

.search-popup .recent-searches li a {
	display: block;
	line-height: 24px;
	border: 1px solid #ffffff;
	padding: 7px 15px;
	color: #ffffff;
	border-radius: 3px;
}

.search-popup .recent-searches li a:hover {
	color: #ec167f;
	border-color: #ec167f;
}


/***
====================================================================
	Search Popup
====================================================================

***/

.search-popup1 {
	position: fixed;
	left: 0px;
	bottom: -100%;
	width: 100%;
	height: 100%;
	z-index: 9999;
	visibility: hidden;
	opacity: 0;
	overflow: auto;
	background: rgba(0, 0, 0, 0.80);
	transition: all 700ms ease;
	-moz-transition: all 700ms ease;
	-webkit-transition: all 700ms ease;
	-ms-transition: all 700ms ease;
	-o-transition: all 700ms ease;
}

.search-popup1 .overlay-layer {
	position: absolute;
	left: 0px;
	top: 0px;
	right: 0px;
	bottom: 0px;
	display: block;
}

.search-popup1.popup-visible {
	bottom: 0;
	visibility: visible;
	opacity: 1;
}

.search-popup1 .close-search {
	position: absolute;
	right: 25px;
	top: 25px;
	font-size: 22px;
	color: #ffffff;
	cursor: pointer;
	z-index: 5;
}

.search-popup1 .close-search:hover {
	opacity: 0.70;
}

.search-popup1 .search-form {
	position: relative;
	padding: 0px 15px 0px;
	max-width: 1024px;
	margin: 0 auto;
	margin-top: 146px;
}

.search-popup1 .search-form fieldset {
	position: relative;
	border: 7px solid rgba(255, 255, 255, 0.50);
	border-radius: 12px;
	-webkit-border-radius: 12px;
	-ms-border-radius: 12px;
	-o-border-radius: 12px;
	-moz-border-radius: 12px;
}

.search-popup1 .search-form fieldset input[type="search"] {
	position: relative;
	height: 70px;
	padding: 20px 220px 20px 30px;
	background: #ffffff;
	line-height: 30px;
	font-size: 24px;
	color: #233145;
	border-radius: 7px;
	-webkit-border-radius: 7px;
	-ms-border-radius: 7px;
	-o-border-radius: 7px;
	-moz-border-radius: 7px;
}

.search-popup1 .search-form fieldset input[type="submit"] {
	position: absolute;
	display: block;
	right: 0px;
	top: 0px;
	text-align: center;
	width: 220px;
	height: 70px;
	padding: 20px 10px 20px 10px;
	color: #ffffff !important;
	background-color: #ec167f;
	line-height: 30px;
	font-size: 20px;
	color: #233145;
	cursor: pointer;
	text-transform: uppercase;
	border-radius: 0px 7px 7px 0px;
	-moz-border-radius: 0px 7px 7px 0px;
	-ms-border-radius: 0px 7px 7px 0px;
	-o-border-radius: 0px 7px 7px 0px;
	-webkit-border-radius: 0px 7px 7px 0px;
}

.search-popup1 .search-form fieldset input[type="submit"]:hover {
	background: #ec167f;
}

.search-popup1 h3 {
	font-size: 24px;
	color: #ffffff;
	margin-bottom: 20px;
	text-align: center;
}

.search-popup1 .recent-searches {
	font-size: 16px;
	color: #ffffff;
	text-align: center;
}

.search-popup1 .recent-searches li {
	display: inline-block;
	margin: 0px 10px 10px 0px;
}

.search-popup1 .recent-searches li a {
	display: block;
	line-height: 24px;
	border: 1px solid #ffffff;
	padding: 7px 15px;
	color: #ffffff;
	border-radius: 3px;
}

.search-popup1 .recent-searches li a:hover {
	color: #ec167f;
	border-color: #ec167f;
}

/*search popup2*/





.search-popup2 {
	position: fixed;
	left: 0px;
	bottom: -100%;
	width: 100%;
	height: 100%;
	z-index: 9999;
	visibility: hidden;
	opacity: 0;
	overflow: auto;
	background: rgba(0, 0, 0, 0.80);
	transition: all 700ms ease;
	-moz-transition: all 700ms ease;
	-webkit-transition: all 700ms ease;
	-ms-transition: all 700ms ease;
	-o-transition: all 700ms ease;
}

.search-popup2 .overlay-layer {
	position: absolute;
	left: 0px;
	top: 0px;
	right: 0px;
	bottom: 0px;
	display: block;
}

.search-popup2.popup-visible {
	bottom: 0;
	visibility: visible;
	opacity: 1;
}

.search-popup2 .close-search {
	position: absolute;
	right: 25px;
	top: 25px;
	font-size: 22px;
	color: #ffffff;
	cursor: pointer;
	z-index: 5;
}

.search-popup2 .close-search:hover {
	opacity: 0.70;
}

.search-popup2 .search-form {
	position: relative;
	padding: 0px 15px 0px;
	max-width: 1024px;
	margin: 0 auto;
	margin-top: 169px;
}

.search-popup2 .search-form fieldset {
	position: relative;
	border: 7px solid rgba(255, 255, 255, 0.50);
	border-radius: 12px;
	-webkit-border-radius: 12px;
	-ms-border-radius: 12px;
	-o-border-radius: 12px;
	-moz-border-radius: 12px;
}

.search-popup2 .search-form fieldset input[type="search"] {
	position: relative;
	height: 70px;
	padding: 20px 220px 20px 30px;
	background: #ffffff;
	line-height: 30px;
	font-size: 24px;
	color: #233145;
	border-radius: 7px;
	-webkit-border-radius: 7px;
	-ms-border-radius: 7px;
	-o-border-radius: 7px;
	-moz-border-radius: 7px;
}

.search-popup2 .search-form fieldset input[type="submit"] {
	position: absolute;
	display: block;
	right: 0px;
	top: 0px;
	text-align: center;
	width: 220px;
	height: 70px;
	padding: 20px 10px 20px 10px;
	color: #ffffff !important;
	background-color: #ec167f;
	line-height: 30px;
	font-size: 20px;
	color: #233145;
	cursor: pointer;
	text-transform: uppercase;
	border-radius: 0px 7px 7px 0px;
	-moz-border-radius: 0px 7px 7px 0px;
	-ms-border-radius: 0px 7px 7px 0px;
	-o-border-radius: 0px 7px 7px 0px;
	-webkit-border-radius: 0px 7px 7px 0px;
}

.search-popup2 .search-form fieldset input[type="submit"]:hover {
	background: #ec167f;
}

.search-popup2 h3 {
	font-size: 24px;
	color: #ffffff;
	margin-bottom: 20px;
	text-align: center;
}

.search-popup2 .recent-searches {
	font-size: 16px;
	color: #ffffff;
	text-align: center;
}

.search-popup2 .recent-searches li {
	display: inline-block;
	margin: 0px 10px 10px 0px;
}

.search-popup2 .recent-searches li a {
	display: block;
	line-height: 24px;
	border: 1px solid #ffffff;
	padding: 7px 15px;
	color: #ffffff;
	border-radius: 3px;
}

.search-popup2 .recent-searches li a:hover {
	color: #ec167f;
	border-color: #ec167f;
}

/*search popup3*/
.search-popup3 {
	position: fixed;
	left: 0px;
	bottom: -100%;
	width: 100%;
	height: 100%;
	z-index: 9999;
	visibility: hidden;
	opacity: 0;
	overflow: auto;
	background: rgba(0, 0, 0, 0.80);
	transition: all 700ms ease;
	-moz-transition: all 700ms ease;
	-webkit-transition: all 700ms ease;
	-ms-transition: all 700ms ease;
	-o-transition: all 700ms ease;
}

.search-popup3 .overlay-layer {
	position: absolute;
	left: 0px;
	top: 0px;
	right: 0px;
	bottom: 0px;
	display: block;
}

.search-popup3.popup-visible {
	bottom: 0;
	visibility: visible;
	opacity: 1;
}

.search-popup3 .close-search {
	position: absolute;
	right: 25px;
	top: 25px;
	font-size: 22px;
	color: #ffffff;
	cursor: pointer;
	z-index: 5;
}

.search-popup3 .close-search:hover {
	opacity: 0.70;
}

.search-popup3 .search-form {
	position: relative;
	padding: 0px 15px 0px;
	max-width: 1024px;
	margin: 0 auto;
	margin-top: 125px;
}

.search-popup3 .search-form fieldset {
	position: relative;
	border: 7px solid rgba(255, 255, 255, 0.50);
	border-radius: 12px;
	-webkit-border-radius: 12px;
	-ms-border-radius: 12px;
	-o-border-radius: 12px;
	-moz-border-radius: 12px;
}

.search-popup3 .search-form fieldset input[type="search"] {
	position: relative;
	height: 70px;
	padding: 20px 220px 20px 30px;
	background: #ffffff;
	line-height: 30px;
	font-size: 24px;
	color: #233145;
	border-radius: 7px;
	-webkit-border-radius: 7px;
	-ms-border-radius: 7px;
	-o-border-radius: 7px;
	-moz-border-radius: 7px;
}

.search-popup3 .search-form fieldset input[type="submit"] {
	position: absolute;
	display: block;
	right: 0px;
	top: 0px;
	text-align: center;
	width: 220px;
	height: 70px;
	padding: 20px 10px 20px 10px;
	color: #ffffff !important;
	background-color: #ec167f;
	line-height: 30px;
	font-size: 20px;
	color: #233145;
	cursor: pointer;
	text-transform: uppercase;
	border-radius: 0px 7px 7px 0px;
	-moz-border-radius: 0px 7px 7px 0px;
	-ms-border-radius: 0px 7px 7px 0px;
	-o-border-radius: 0px 7px 7px 0px;
	-webkit-border-radius: 0px 7px 7px 0px;
}

.search-popup3 .search-form fieldset input[type="submit"]:hover {
	background: #ec167f;
}

.search-popup3 h3 {
	font-size: 24px;
	color: #ffffff;
	margin-bottom: 20px;
	text-align: center;
}

.search-popup3 .recent-searches {
	font-size: 16px;
	color: #ffffff;
	text-align: center;
}

.search-popup3 .recent-searches li {
	display: inline-block;
	margin: 0px 10px 10px 0px;
}

.search-popup3 .recent-searches li a {
	display: block;
	line-height: 24px;
	border: 1px solid #ffffff;
	padding: 7px 15px;
	color: #ffffff;
	border-radius: 3px;
}

.search-popup3 .recent-searches li a:hover {
	color: #ec167f;
	border-color: #ec167f;
}

/*search popup4*/
.search-popup4 {
	position: fixed;
	left: 0px;
	bottom: -100%;
	width: 100%;
	height: 100%;
	z-index: 9999;
	visibility: hidden;
	opacity: 0;
	overflow: auto;
	background: rgba(0, 0, 0, 0.80);
	transition: all 700ms ease;
	-moz-transition: all 700ms ease;
	-webkit-transition: all 700ms ease;
	-ms-transition: all 700ms ease;
	-o-transition: all 700ms ease;
}

.search-popup4 .overlay-layer {
	position: absolute;
	left: 0px;
	top: 0px;
	right: 0px;
	bottom: 0px;
	display: block;
}

.search-popup4.popup-visible {
	bottom: 0;
	visibility: visible;
	opacity: 1;
}

.search-popup4 .close-search {
	position: absolute;
	right: 25px;
	top: 25px;
	font-size: 22px;
	color: #ffffff;
	cursor: pointer;
	z-index: 5;
}

.search-popup4 .close-search:hover {
	opacity: 0.70;
}

.search-popup4 .search-form {
	position: relative;
	padding: 0px 15px 0px;
	max-width: 1024px;
	margin: 0 auto;
	margin-top: 84px;
}

.search-popup4 .search-form fieldset {
	position: relative;
	border: 7px solid rgba(255, 255, 255, 0.50);
	border-radius: 12px;
	-webkit-border-radius: 12px;
	-ms-border-radius: 12px;
	-o-border-radius: 12px;
	-moz-border-radius: 12px;
}

.search-popup4 .search-form fieldset input[type="search"] {
	position: relative;
	height: 70px;
	padding: 20px 220px 20px 30px;
	background: #ffffff;
	line-height: 30px;
	font-size: 24px;
	color: #233145;
	border-radius: 7px;
	-webkit-border-radius: 7px;
	-ms-border-radius: 7px;
	-o-border-radius: 7px;
	-moz-border-radius: 7px;
}

.search-popup4 .search-form fieldset input[type="submit"] {
	position: absolute;
	display: block;
	right: 0px;
	top: 0px;
	text-align: center;
	width: 220px;
	height: 70px;
	padding: 20px 10px 20px 10px;
	color: #ffffff !important;
	background-color: #ec167f;
	line-height: 30px;
	font-size: 20px;
	color: #233145;
	cursor: pointer;
	text-transform: uppercase;
	border-radius: 0px 7px 7px 0px;
	-moz-border-radius: 0px 7px 7px 0px;
	-ms-border-radius: 0px 7px 7px 0px;
	-o-border-radius: 0px 7px 7px 0px;
	-webkit-border-radius: 0px 7px 7px 0px;
}

.search-popup4.search-form fieldset input[type="submit"]:hover {
	background: #ec167f;
}

.search-popup4 h3 {
	font-size: 24px;
	color: #ffffff;
	margin-bottom: 20px;
	text-align: center;
}

.search-popup4 .recent-searches {
	font-size: 16px;
	color: #ffffff;
	text-align: center;
}

.search-popup4 .recent-searches li {
	display: inline-block;
	margin: 0px 10px 10px 0px;
}

.search-popup4 .recent-searches li a {
	display: block;
	line-height: 24px;
	border: 1px solid #ffffff;
	padding: 7px 15px;
	color: #ffffff;
	border-radius: 3px;
}

.search-popup4 .recent-searches li a:hover {
	color: #ec167f;
	border-color: #ec167f;
}

/*search popup5*/
.search-popup5 {
	position: fixed;
	left: 0px;
	bottom: -100%;
	width: 100%;
	height: 100%;
	z-index: 9999;
	visibility: hidden;
	opacity: 0;
	overflow: auto;
	background: rgba(0, 0, 0, 0.80);
	transition: all 700ms ease;
	-moz-transition: all 700ms ease;
	-webkit-transition: all 700ms ease;
	-ms-transition: all 700ms ease;
	-o-transition: all 700ms ease;
}

.search-popup5 .overlay-layer {
	position: absolute;
	left: 0px;
	top: 0px;
	right: 0px;
	bottom: 0px;
	display: block;
}

.search-popup5.popup-visible {
	bottom: 0;
	visibility: visible;
	opacity: 1;
}

.search-popup5 .close-search {
	position: absolute;
	right: 25px;
	top: 25px;
	font-size: 22px;
	color: #ffffff;
	cursor: pointer;
	z-index: 5;
}

.search-popup5 .close-search:hover {
	opacity: 0.70;
}

.search-popup5 .search-form {
	position: relative;
	padding: 0px 15px 0px;
	max-width: 1024px;
	margin: 0 auto;
	margin-top: 117px;
}

.search-popup5 .search-form fieldset {
	position: relative;
	border: 7px solid rgba(255, 255, 255, 0.50);
	border-radius: 12px;
	-webkit-border-radius: 12px;
	-ms-border-radius: 12px;
	-o-border-radius: 12px;
	-moz-border-radius: 12px;
}

.search-popup5 .search-form fieldset input[type="search"] {
	position: relative;
	height: 70px;
	padding: 20px 220px 20px 30px;
	background: #ffffff;
	line-height: 30px;
	font-size: 24px;
	color: #233145;
	border-radius: 7px;
	-webkit-border-radius: 7px;
	-ms-border-radius: 7px;
	-o-border-radius: 7px;
	-moz-border-radius: 7px;
}

.search-popup5 .search-form fieldset input[type="submit"] {
	position: absolute;
	display: block;
	right: 0px;
	top: 0px;
	text-align: center;
	width: 220px;
	height: 70px;
	padding: 20px 10px 20px 10px;
	color: #ffffff !important;
	background-color: #ec167f;
	line-height: 30px;
	font-size: 20px;
	color: #233145;
	cursor: pointer;
	text-transform: uppercase;
	border-radius: 0px 7px 7px 0px;
	-moz-border-radius: 0px 7px 7px 0px;
	-ms-border-radius: 0px 7px 7px 0px;
	-o-border-radius: 0px 7px 7px 0px;
	-webkit-border-radius: 0px 7px 7px 0px;
}

.search-popup5.search-form fieldset input[type="submit"]:hover {
	background: #ec167f;
}

.search-popup5 h3 {
	font-size: 24px;
	color: #ffffff;
	margin-bottom: 20px;
	text-align: center;
}

.search-popup5 .recent-searches {
	font-size: 16px;
	color: #ffffff;
	text-align: center;
}

.search-popup5 .recent-searches li {
	display: inline-block;
	margin: 0px 10px 10px 0px;
}

.search-popup5 .recent-searches li a {
	display: block;
	line-height: 24px;
	border: 1px solid #ffffff;
	padding: 7px 15px;
	color: #ffffff;
	border-radius: 3px;
}

.search-popup5 .recent-searches li a:hover {
	color: #ec167f;
	border-color: #ec167f;
}

.register-section {
	position: relative;
	padding: 130px 0px 130px;
}

.register-section .form-box {
	position: relative;
	max-width: 550px;
	padding: 40px 30px;
	margin: 0 auto;
	width: 100%;
	background-color: #f9f9f9;
	border: 3px solid #f70068;
}

.register-section .form-box h1 {
	position: relative;
	color: #222222;
	font-size: 30px;
	font-weight: 700;
	line-height: 1.3em;
	text-align: center;
	margin-bottom: 30px;
}

/* Styled Form */

.styled-form {
	position: relative;
}

.styled-form .submit-text {
	font-size: 15px;
	color: #9e9e9e;
	font-weight: 400;
	margin-top: 10px;
}

.styled-form .form-group {
	position: relative;
	margin-bottom: 15px;
	font-size: 14px;
	color: #222222;
}

.styled-form .form-group.social-icon-one {
	padding-top: 8px;
}

.checkout-section .styled-form .form-group {
	position: relative;
	margin-bottom: 20px;
}

.styled-form .form-group .check-box {
	line-height: 24px;
	font-size: 15px;
	font-weight: normal;
	padding-top: 5px;
	color: #272727;
}

.styled-form .form-group .check-box label {
	position: relative;
	top: -1px;
	font-weight: normal;
	padding: 0px;
	font-size: 15px;
	cursor: pointer;
}

.styled-form .pull-left label,
.styled-form .pull-right label {
	cursor: pointer;
}

.styled-form .form-group .adon-icon {
	position: absolute;
	top: 50%;
	margin-top: -10px;
	right: 10px;
	width: 20px;
	height: 20px;
	line-height: 20px;
	font-size: 15px;
	color: #999999;
	z-index: 2;
}

.styled-form .form-group .field-label {
	display: block;
	color: #272727;
	text-transform: capitalize;
	font-size: 16px;
	margin-bottom: 7px;
	font-weight: 400;
}

.styled-form input[type="text"],
.styled-form input[type="email"],
.styled-form input[type="password"],
.styled-form input[type="tel"],
.styled-form input[type="number"],
.styled-form input[type="url"],
.styled-form select,
.styled-form textarea {
	position: relative;
	display: block;
	width: 100%;
	background: #ffffff;
	line-height: 30px;
	padding: 8px 20px;
	height: 50px;
	border: 1px solid #f4f4f4;
	transition: all 300ms ease;
	-webkit-transition: all 300ms ease;
	-ms-transition: all 300ms ease;
	-o-transition: all 300ms ease;
	-moz-transition: all 300ms ease;
}

.color-palate {
	display: none;
}

label {
	margin-left: 5px;
	margin-bottom: 2px;
	color: #890025;
}

/* new style */
.image1 {
	margin-left: -47px;
}


.sidebar1 .popular-tags1 a {
	position: relative;
	color: #333333;
	text-align: center;
	font-size: 16px;
	line-height: 20px;
	background: none;
	font-weight: 400;
	border-bottom: 2px solid #dddddd;
	background-color: #ffffff;
	transition: all 300ms ease;
	color: #ff9900;
}

.sidebar1 .popular-tags1 a:hover {
	border-color: #e1137b;
	color: #e1137b;
}

.sidebar2 .popular-tags2 a {
	position: relative;
	color: #333333;
	text-align: center;
	font-size: 16px;
	line-height: 20px;
	background: none;
	font-weight: 400;
	border-bottom: 2px solid #dddddd;
	background-color: #ffffff;
	transition: all 300ms ease;
	color: #40cbb4;
}

.sidebar2 .popular-tags2 a:hover {
	border-color: #e1137b;
	color: #e1137b;
}

.sidebar3 .popular-tags3 a {
	position: relative;
	color: #333333;
	text-align: center;
	font-size: 16px;
	line-height: 20px;
	background: none;
	font-weight: 400;
	border-bottom: 2px solid #dddddd;
	background-color: #ffffff;
	transition: all 300ms ease;
	color: #4c35a9;
}

.sidebar3 .popular-tags3 a:hover {
	border-color: #e1137b;
	color: #e1137b;
}

.sidebar4 .popular-tags4 a {
	position: relative;
	color: #333333;
	text-align: center;
	font-size: 16px;
	line-height: 20px;
	background: none;
	font-weight: 400;
	border-bottom: 2px solid #dddddd;
	background-color: #ffffff;
	transition: all 300ms ease;
	color: #e6275a;
}

.sidebar4 .popular-tags4 a:hover {
	border-color: #e1137b;
	color: #e1137b;
}

.sidebar5 .popular-tags5 a {
	position: relative;
	color: #333333;
	text-align: center;
	font-size: 16px;
	line-height: 20px;
	background: none;
	font-weight: 400;
	border-bottom: 2px solid #dddddd;
	background-color: #ffffff;
	transition: all 300ms ease;
	color: #05a7dc;
}

.sidebar5 .popular-tags5 a:hover {
	border-color: #e1137b;
	color: #e1137b;
}

.page-title {
	padding: 20px 0;
}

.speaker-detail {
	position: relative;
	padding: 20px 0 70px;
}

.dropdowninfinity {
	color: #888888;
	font-size: 16px;
	line-height: 1.4em;
	margin-bottom: 30px;
}

.shadow {
	box-shadow: 0 0 30px rgb(0 0 0 / 10%);
}

.about-section-two-index {
	position: relative;
	padding: 20px 0 20px;
}

.about-section-two-index .icon-circle-1 {
	right: -200px;
	top: -200px;
	opacity: .05;
}



.schedule-block .speaker-info1 {
	position: relative;
	//padding-left: 80px;
	padding-top: 10px;
	min-height: 60px;
}

.schedule-block .speaker-info1 .thumb {
	position: absolute;
	left: 0;
	top: 0;
	width: 60px;
	border-radius: 50%;
	overflow: hidden;
}

.schedule-block .speaker-info1 .name {
	font-size: 16px;
	color: #212639;
	font-weight: 500;
	line-height: 1.2em;
	font-family: Poppins, sans-serif;
}

.schedule-block .speaker-info1 .designation {
	font-size: 13px;
}

.about-section-two-index .icon-circle-blue {
	left: -150px;
	bottom: -150px;
	opacity: .70;
	animation: fa-spin 30s infinite;
}


.fabs {
	font-family: 'Font Awesome 5 Free';
	font-weight: 900;
	font-size: 25px;
	margin-left: -100px;
	margin-top: 12px;
	background-color: #fff;
}




@media only screen and (min-width: 1200px) and (max-width: 1367px) {
	.info-box-two {
		display: none;
		margin-top: 0rem !important;
	}
}

@media only screen and (min-width: 1200px) and (max-width: 2600px) {
	.info-box-two {
		display: none;
		margin-top: 0rem !important;
	}

	.schedule-timeline-two {
		margin-top: 0rem;
	}

	.ftr-dsk-lg {
		display: block !important;
	}

	.ftr-dsk-mn {
		display: block !important;
	}

	.schedule-timeline-two {
		margin-top: 0rem !important;
	}

	.margin-mobile {
		margin-top: 0rem !important;
	}

	.schedule-tabs .tab-buttons {
		position: relative;
		text-align: center !important;
	}

}

.schedule-tabs .tab-buttons {
	position: relative;
	text-align: left;
}

.margin-mobile {
	margin-top: 7rem;
	;
}

.ftr-dsk-lg {
	display: none;
}

.ftr-dsk-mn {
	display: none;
}

.schedule-timeline-two {
	margin-top: 14rem;
}

.info-box-two {
	margin-top: 0.6rem;
}

.info-box-two h4 {
	font-size: 13px;
	font-weight: 300;
	text-align: center;
}

.info-box-two a {
	color: #101130 !important;
}

.banner-carousel-two .slide-item:before {
	background-color: #0000001c !important;
}

.bootstrap-select .dropdown-menu {
	min-width: auto !important;
}

.buy-script {
	background: #ec167f;
	height: 30px;
	padding-top: 2px;
}

.blinks {
	animation: blinks 1s linear infinite;
}

.animate-charcter {
	text-transform: uppercase;
	background-image: linear-gradient(-225deg,
			#231557 0%,
			#44107a 29%,
			#ff1361 67%,
			#fff800 100%);
	background-size: auto auto;
	background-clip: border-box;
	background-size: 200% auto;
	color: #fff;
	background-clip: text;
	text-fill-color: transparent;
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;
	animation: textclip 4s linear infinite;
	display: inline-block;
	font-size: 190px;
}

@keyframes textclip {
	to {
		background-position: 200% center;
	}
}

.btn-style-letsbegin {
	color: #000;
	font-weight: 400;
	text-align: center;
	background-color: #ffffff;
}

@media screen and (max-width:768px) {
	.sec-title .text {
		margin-top: 30px;
	}
}

.styled-pagination li a {
	line-height: 32px;
	font-size: 18px;
	height: 32px;
	width: 32px;
	font-weight: 500;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
	-webkit-appearance: none;
	margin: 0;
}

/* Firefox */
input[type=number] {
	-moz-appearance: textfield;
}

.react-loading {
	position: absolute;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
}

.input_eyes_icon {
	position: absolute;
	right: 30px;
	top: 23px;
	transform: translateY(-50%);
	cursor: pointer;
}

.bg-main {
    background-color: #fff;
    box-shadow: 2px 3px 6px 2px #cdcdcd;
    border-radius: 5px;
    padding: 30px;
}
section.about-section .inner-column {
    width: auto;
}
.inner-column.contact-width {
    width: auto;
}
button.sub-btn{
	background-color: #890025;
	border: none;
	border-radius: 50px;
	font-size: 15px;
	font-weight: 400;
	padding: 6px 18px;
	color:#ffff;
}
.contact-form {
    margin: auto;
    box-shadow: 2px 4px 12px 5px #d5d3d3;
    padding: 20px;
    border-radius: 28px;
    border: 0.3px solid #cc003726;
}
.cards-one {
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
	margin-top: 0;
}
p.desh {
	text-align: start;
    word-break: break-all;
}

textarea.about-me {
    width: 100%;
    border: 1px solid  #00000042;
    padding: 0px 7px;
	min-height: 215px;
    overflow-y: auto;
}
div.document-verified{
	padding: 13px;
}
.d-verify-tick{
	color: green;
}
.date-time label {
    align-items: center;
    display: flex;
}
.date-time {
    font-size: 14px;
    border: 1px solid #a1a7a1;
    border-radius: 5px;
    height: 50px;
    display: flex;
    justify-content: space-between;
	max-width: 367px;
    margin-left: 15px
}
.profile-modal li {
	border-radius: 50px;
	border: 1px solid #890025;
	border-radius: 50px;
	margin-right: 20px;
	padding: 5px 10px;
}
.profile-modal ul {
	display: flex;
}

/* 05/04/0/2024 */

.btn-custom {
    background: linear-gradient(to left, #A28089, #C63800);
    color: #fff;
    padding: 10px 40px;
    border-radius: 8px;
	border: none !important;
	transition: 0.4s ease-in-out;
}
.btn-custom:hover {
    background: linear-gradient(90deg, #A28089, #C63800);
	color: #fff;
}
.marriageRegister .card img {
    height: 400px;
    width: 100%;
    object-fit: cover;
    border-radius: 10px;
    margin-bottom: 20px;
}
.marriageRegister .card {
    padding: 0;
    border: none;
    box-shadow: none;
    text-align: center;
	background: transparent;
}
.marriageRegister .card h2 {
    line-height: 38px;
    margin-bottom: 10px;
    font-size: 24px;
}
.customSideToggler {
    flex-wrap: wrap;
}
.customSideToggler li a {
    width: 100%;
    text-align: left;
    border: none;
    box-shadow: none !important;
    border-right: 4px solid #a28089;
    border-radius: 0;
    margin: 20px 0;
    opacity: 0.7;
}
.customSideToggler li a p {
    width: 100%;
    text-wrap: wrap;
	font-size: 12px;
    line-height: normal;
    margin-top: 6px;
}
.customSideToggler li a b {
    font-size: 24px;
    text-wrap: pretty;
    font-weight: normal;
}
.customSideToggler li.active a {
    border-color: #c63800;
    opacity: 1;
}
.tab-content>.active {
    opacity: 1;
}
p.services-para {
    max-width: 800px;
    margin: 0 auto;
}

p.services-para {
    max-width: 800px;
    margin: 0 auto;
}

.servicesList ul {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 16px;
}
a.card-Custom {
	display: inline-block;
    padding: 20px;
    background: #000;
    color: #fff;
    border-radius: 12px;
    background-size: cover !important;
    background-position: center !important;
	position: relative;
	width: 100%;
}

a.card-Custom img {
    border: 2px solid rgb(0, 0, 0);
    padding: 20px;
    border-radius: 12px;
    filter: invert(1);
    transition: all 0.5s ease-in-out 0s;
    opacity: 1;
    max-width: 150px;
    margin: 0 auto 10px;
    min-height: auto;
	width: 100%;
}

a.card-Custom h3 {
    margin: 0;
    font-size: 18px;
}
a.card-Custom:before {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    inset: 0px;
    border-radius: 8px;
    transition: all 0.4s ease 0s;
    background: linear-gradient(to top, rgb(37, 24, 8), rgba(215, 154, 78, 0));
}

a.card-Custom:after {
    content: '';
    position: absolute;
    width: 100%;
    height: 200px;
    right: 0px;
    bottom: 0px;
    left: 0px;
    border-radius: 50px 50px 0px 0px;
    transition: all 0.4s ease-in-out 0s;
    background: rgb(229, 2, 107);
    transform: scale(0);
    transform-origin: right bottom;
    z-index: 0;
}

body {
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
	background-position: center right;
    background-size: 200px;
    background-repeat: no-repeat;
    background-attachment: fixed;
	background-color: #f3ffef;
}

.customHeading {
	position: relative;
    margin-bottom: 50px;
    padding-bottom: 10px;
}

.customHeading span {
    position: absolute;
    left: 50%;
    bottom: 10px;
    transform: translateX(-50%);
    width: 200px;
    height: auto;
}

.customHeading span:before {
    content: '';
    position: absolute;
    width: 100px;
    height: 40px;
    top: 0px;
    transition: all 0.4s ease-in-out 0s;
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
	background-size: contain;
    background-repeat: no-repeat;
	transform: scalex(-1);
	left: 0;
}

.customHeading span:after {
	content: '';
    position: absolute;
    width: 100px;
    height: 40px;
    top: 0px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    transition: all 0.4s ease-in-out 0s;
    background-size: contain;
    background-repeat: no-repeat;
	right: 0;
}

.frameImg {
    width: 100%;
    height: auto;
    background: transparent;
    border-radius: 24px;
    overflow: hidden;
    border: 1px solid #dbdbdb;
    padding: 10px;
}

.frameImg img {border-radius: 10px;}

.customFooter {
    padding: 70px 0  10px;
    background: #101130;
    position: relative;
    z-index: 1;
}

.servicesList:after {
    position: absolute;
    content: '';
    height: 34px;
    width: 100%;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    /* background-position: bottom center; */
    background-repeat: no-repeat;
    background-size: contain;
    transform: scaleY(-1);
    bottom: 0px;
	left: 0;
}

.servicesList {
    position: relative;
    padding: 60px 0;
}

.customFooter h5 {
    font-size: 18px;
    color: #fff;
    margin-bottom: 20px;
}

.customFooter  li {
    margin-bottom: 10px;
}

.customFooter li a {
    color: #898989;
    transition: 0.4s ease-in-out;
    position: relative;
    border-left: 1px solid transparent;
	word-break: break-all;
}

.customFooter li a:hover {
    color: #fff;
    padding-left: 15px;
    border-color: #fff;
}

ul.socialLinks a i {
    width: 30px;
    text-align: center;
}

.copyright {
    border-top: 1px dashed #525252;
}

.coming-soon-section .outer-box {
    max-width: 1400px;
    margin: -72px auto 0;
}

.bannerTitle {
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
    background-size: cover;
    background-position: center;
    min-height: 300px;
    position: relative;
}

.bannerTitle:after {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: #00000078;
}

.bannerTitle .container {
    z-index: 1;
    position: relative;
}

.customModal {
    max-width: 800px;
}

.customModal .modal-body {
    background: linear-gradient(to left, #A28089, #C63800);
    border: none;
	padding: 0;
	position: relative;
    border-radius: 18px;
	overflow: hidden;
}

.customModal .modal-content {
    border: none;
	padding: 0;
	background: transparent;
}

.photoprimary {
    background-size: cover;
    background-position: center;
	min-height: 500px;
}

.photoprimary {
    background-size: cover;
    background-position: center;
    min-height: 500px;
}

.customModal .modal-body h2 {
    font-size: 28px;
    margin-bottom: 10px;
    font-weight: 700;
}

ul.modalSocial {
    gap: 15px;
    font-size: 22px;
    color: #fff;
}

.customModal button.close {
    color: #fff;
    position: absolute;
    right: 10px;
    top: 10px;
	transition: 0.4s ease-in-out;
}

.customModal button.close:hover {
	color: #fff;
}

/* Media Query */

@media screen and (max-width: 1200px) {
	body {background-size: 100px;}
	.servicesList ul {grid-template-columns: repeat(3, 1fr);align-items: center;justify-content: center;}
	.customSideToggler {flex-wrap: nowrap;flex-direction: row !important;overflow:auto; margin-bottom: 30px;}
	.customSideToggler li a {border-right: 0;border-bottom: 4px solid #a28089;min-width: 300px;margin-bottom: 0;}
	.customSideToggler li a b {font-size: 18px;}
}

@media screen and (max-width: 767px) {
	.marriageRegister .card {margin-bottom: 30px;}
}

@media screen and (max-width: 567px) {
	.servicesList ul {grid-template-columns: repeat(2, 1fr);}
	.servicesList ul {grid-template-columns: repeat(2, 1fr);}
	.coming-soon-section .outer-box {padding: 30px;margin-top: 30px !important;}
	.banner-carousel .content-box h2 {font-size: 30px;}
	.matching-ai .tab-content.px-5 {padding:  0 !important;}
	.matching-ai {z-index: 1;position: relative;background: #f3ffef;}
	.matching-ai .tab-content.px-5 {padding:  0 !important;}
	.servicesList:after {background-size: cover;background-position: center;}
	body {background-size: 50px;}
	.banner-carousel .slide-item {padding: 100px 0 100px;}
	.banner-carousel .slide-item:before {border-top: 190px solid #800925;border-right: 70px solid transparent;border-left: 216px solid #800925;border-bottom: 322px solid #800925;}
}`, "",{"version":3,"sources":["webpack://./src/assets/css/style.css"],"names":[],"mappings":"AAUA;CACC,WAAW;CACX,YAAY;CACZ,YAAY;CACZ,aAAa;AACd;;AAEA;CACC,iBAAiB;CACjB,eAAe;CACf,cAAc;CACd,kBAAkB;CAClB,gBAAgB;CAChB,mBAAmB;CACnB,mCAAmC;CACnC,gCAAgC;CAChC,kCAAkC;AACnC;;AAEA;CACC,qBAAqB;CACrB,eAAe;CACf,cAAc;AACf;;AAEA;;;;CAIC,qBAAqB;CACrB,wBAAwB;AACzB;;AAEA;;;;;;CAMC,kBAAkB;CAClB,mBAAmB;CACnB,WAAW;CACX,gBAAgB;CAChB,kBAAkB;CAClB,iCAAiC;AAClC;;AAEA;;;UAGU;;AAEV;CACC,gBAAgB;AACjB;;AAEA;;CAEC,kBAAkB;CAClB,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,YAAY;CACZ,sBAAsB;CACtB,mBAAmB;CACnB,yBAAyB;AAC1B;;AAEA;CACC,YAAY;CACZ,YAAY;CACZ,0CAA0C;CAC1C,aAAa;CACb;iCACgC;AACjC;;AAEA;CACC,yBAAyB;CACzB,YAAY;CACZ,mBAAmB;CACnB,eAAe;CACf,gBAAgB;CAChB,iBAAiB;AAClB;;AAEA;CACC,YAAY;CACZ,mBAAmB;CACnB,eAAe;CACf,gBAAgB;CAChB,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,mBAAmB;CACnB,SAAS;CACT,YAAY;CACZ,eAAe;CACf,gBAAgB;CAChB,cAAc;AACf;;AAEA;CACC,gBAAgB;CAChB,uBAAuB;CACvB,iBAAiB;CACjB,cAAc;AACf;;AAEA;CACC,gBAAgB;CAChB,iBAAiB;CACjB,iBAAiB;CACjB,cAAc;AACf;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,WAAW;CACX,gBAAgB;CAChB,gBAAgB;AACjB;;AAEA;;CAEC,gBAAgB;CAChB,YAAY;CACZ,WAAW;AACZ;;AAEA;CACC,qBAAqB;CACrB,eAAe;CACf,YAAY;AACb;;AAEA;CACC,qBAAqB;CAKrB,yBAAyB;AAC1B;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;CAClB,gBAAgB;CAChB,eAAe;CAKf,sCAAsC;AACvC;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;;AAGA;CACC,mBAAmB;CACnB,cAAc;AACf;;AAEA;CACC,mBAAmB;CACnB,cAAc;AACf;;AAEA;CACC,mBAAmB;CACnB,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,0BAA0B;AAC3B;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,gBAAgB;CAChB,kBAAkB;CAClB,yBAAyB;CACzB,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CAGC,+CAA+C;CAC/C,8CAA8C;CAC9C,2CAA2C;AAC5C;;AAEA;CACC,kBAAkB;CAClB,OAAO;CACP,MAAM;CACN,YAAY;CACZ,WAAW;CACX,WAAW;CACX,yBAAyB;CAGzB,sBAAsB;CAGtB,2BAA2B;CAI3B,oEAAoE;CACpE,mBAAmB;CAInB,oEAAoE;CACpE,mBAAmB;AACpB;;AAEA;CAGC,sBAAsB;CAGtB,6BAA6B;AAC9B;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,gBAAgB;CAChB,kBAAkB;CAClB,yBAAyB;CACzB,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,cAAc;CAGd,+CAA+C;CAC/C,8CAA8C;CAC9C,2CAA2C;AAC5C;;AAEA;CACC,kBAAkB;CAClB,OAAO;CACP,MAAM;CACN,YAAY;CACZ,WAAW;CACX,WAAW;CACX,yBAAyB;CAGzB,sBAAsB;CAGtB,2BAA2B;CAI3B,oEAAoE;CACpE,mBAAmB;CAInB,oEAAoE;CACpE,mBAAmB;AACpB;;AAEA;CAGC,sBAAsB;CAGtB,6BAA6B;AAC9B;;;AAGA,sBAAsB;;AAEtB;CACC,kBAAkB;CAClB,kBAAkB;CAClB,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,gBAAgB;CAChB,kBAAkB;CAClB,yBAAyB;CACzB,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,cAAc;CAGd,+CAA+C;CAC/C,8CAA8C;CAC9C,2CAA2C;AAC5C;;AAEA;CACC,kBAAkB;CAClB,OAAO;CACP,MAAM;CACN,YAAY;CACZ,WAAW;CACX,WAAW;CACX,yBAAyB;CAGzB,sBAAsB;CAGtB,2BAA2B;CAI3B,oEAAoE;CACpE,mBAAmB;CAInB,oEAAoE;CACpE,mBAAmB;AACpB;;AAEA;CAGC,sBAAsB;CAGtB,6BAA6B;AAC9B;;;;AAIA,qBAAqB;;AAErB;CACC,kBAAkB;CAClB,kBAAkB;CAClB,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,gBAAgB;CAChB,kBAAkB;CAClB,yBAAyB;CACzB,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,cAAc;CAGd,+CAA+C;CAC/C,8CAA8C;CAC9C,2CAA2C;AAC5C;;AAEA;CACC,kBAAkB;CAClB,OAAO;CACP,MAAM;CACN,YAAY;CACZ,WAAW;CACX,WAAW;CACX,yBAAyB;CAGzB,sBAAsB;CAGtB,2BAA2B;CAI3B,oEAAoE;CAIpE,oEAAoE;AACrE;;AAEA;CAGC,sBAAsB;CAGtB,6BAA6B;AAC9B;;AAEA,mBAAmB;;AAEnB;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,gBAAgB;CAChB,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,OAAO;CACP,MAAM;CACN,eAAe;CACf,cAAc;CACd,2BAA2B;CAC3B,cAAc;AACf;;AAEA,mBAAmB;;AAEnB;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,gBAAgB;CAChB,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,OAAO;CACP,SAAS;CACT,WAAW;CACX,UAAU;CACV,yBAAyB;CACzB,WAAW;AACZ;;AAEA,mBAAmB;AACnB;CACC,WAAW;AACZ;;AAEA,kBAAkB;AAClB;;;;;;IAMI;;AAEJ,kBAAkB;;AAElB;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,YAAY;CACZ,WAAW;CACX,iBAAiB;CACjB,kBAAkB;CAClB,eAAe;CACf,cAAc;CACd,kBAAkB;CAClB,yBAAyB;CACzB,0BAA0B;CAC1B,+BAA+B;CAC/B,kCAAkC;CAClC,8BAA8B;CAC9B,6BAA6B;AAC9B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;CACzB,qBAAqB;CACrB,cAAc;AACf;;AAEA,kBAAkB;;AAElB;CACC,kBAAkB;CAClB,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,YAAY;CACZ,WAAW;CACX,iBAAiB;CACjB,kBAAkB;CAClB,eAAe;CACf,yBAAyB;CACzB,yBAAyB;CAKzB,0BAA0B;AAC3B;;AAEA;CACC,cAAc;CACd,yBAAyB;AAC1B;;AAEA,oBAAoB;;AAEpB;CACC,kBAAkB;CAClB,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,iBAAiB;CACjB,kBAAkB;CAClB,eAAe;CAKf,0BAA0B;AAC3B;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,eAAe;CACf,YAAY;CACZ,WAAW;CACX,WAAW;CACX,YAAY;CACZ,cAAc;CACd,kBAAkB;CAClB,eAAe;CACf,yBAAyB;CACzB,iBAAiB;CACjB,kBAAkB;CAClB,YAAY;CACZ,eAAe;CACf,mBAAmB;CACnB,aAAa;CAKb,0BAA0B;AAC3B;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,gBAAgB;CAChB,UAAU;CACV,gBAAgB;CAChB,4BAA4B;CAC5B,kCAAkC;CAClC,sBAAsB;AACvB;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,eAAe;CACf,cAAc;CACd,gBAAgB;CAChB,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,gBAAgB;CAChB,eAAe;CACf,mBAAmB;CACnB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,gBAAgB;CAChB,YAAY;AACb;;AAEA;CACC,gBAAgB;CAChB,eAAe;AAChB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,cAAc;CAKd,0BAA0B;AAC3B;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,eAAe;CACf,gBAAgB;CAChB,cAAc;CACd,gBAAgB;CAChB,mBAAmB;CACnB,0FAA0F;;CAE1F,kHAAkH;CAClH,kBAAkB;CAClB,6BAA6B;CAC7B,oCAAoC;CACpC,yBAAyB;CACzB,mBAAmB;CACnB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,eAAe;CACf,kBAAkB;CAClB,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,gBAAgB;AACjB;;AAEA;;CAEC,cAAc;CACd,gCAAgC;AACjC;;;;AAIA;CACC,kBAAkB;CAClB,OAAO;CACP,MAAM;CACN,QAAQ;CACR,YAAY;CACZ,WAAW;CACX,iBAAiB;CACjB,cAAc;AACf;;AAEA;;GAEG;;AAEH;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,YAAY;AAChB;AACA;IACI,gCAAgC;AACpC;AACA;CACC,kBAAkB;CAClB,2BAA2B;CAC3B,4BAA4B;AAC7B;;AAEA;CACC,mCAAmC;CACnC,gDAAgD;CAChD,eAAe;AAChB;;AAEA;CACC;EACC,cAAc;CACf;;CAEA;EACC,cAAc;CACf;;CAEA;EACC,cAAc;CACf;;CAEA;EACC,cAAc;CACf;;CAEA;EACC,cAAc;CACf;;CAEA;EACC,cAAc;CACf;AACD;;AAsDA;CACC,qBAAqB;CACrB,MAAM;CACN,OAAO;CACP,YAAY;CACZ,WAAW;CAKX,0BAA0B;AAC3B;;AAEA;CACC,kBAAkB;CAClB,eAAe;CAKf,0BAA0B;CAC1B,yBAAyB;AAC1B;;AAEA;CACC,kBAAkB;CAClB,WAAW;CAKX,0BAA0B;AAC3B;;AAEA;CACC,qBAAqB;CACrB,eAAe;CACf,0BAA0B;CAC1B,WAAW;CACX,YAAY;CACZ,iBAAiB;AAClB;;AAEA;CACC,aAAa;CACb,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,0BAA0B;CAC1B,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;CAChB,WAAW;AACZ;;AAEA;CACC,gBAAgB;CAChB,WAAW;AACZ;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,iBAAiB;CAKjB,0BAA0B;AAC3B;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,eAAe;CACf,sBAAsB;CACtB,UAAU;CACV,kBAAkB;CAKlB,0BAA0B;AAC3B;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,YAAY;CACZ,WAAW;CACX,SAAS;CACT,WAAW;CAKX,oBAAoB;CACpB,mBAAmB;CAKnB,0BAA0B;AAC3B;;AAEA;;CAEC,OAAO;CACP,WAAW;AACZ;;AAEA;CACC,kCAAkC;CAClC,gBAAgB;CAChB,kBAAkB;CAClB,WAAW;CACX,QAAQ;CACR,WAAW;CACX,YAAY;CACZ,cAAc;CACd,iBAAiB;CACjB,eAAe;CACf,gBAAgB;CAChB,kBAAkB;CAClB,UAAU;AACX;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,SAAS;CACT,YAAY;CACZ,YAAY;CACZ,aAAa;CACb,UAAU;CACV,kBAAkB;CAClB,iBAAiB;CACjB,mBAAmB;CACnB,kBAAkB;CAKlB,qBAAqB;CAKrB,yBAAyB;CACzB,gCAAgC;CAChC,0BAA0B;CAE1B,yFAAyF;CACzF,wFAAwF;CAExF,qFAAqF;AACtF;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,SAAS;CACT,UAAU;CACV,WAAW;CACX,YAAY;CACZ,cAAc;AACf;;AAEA;CACC,UAAU;CACV,UAAU;AACX;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,iBAAiB;CACjB,iBAAiB;CACjB,gBAAgB;CAChB,eAAe;CACf,0BAA0B;CAC1B,cAAc;CACd,0BAA0B;CAC1B,+BAA+B;CAC/B,kCAAkC;CAClC,8BAA8B;CAC9B,6BAA6B;AAC9B;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,SAAS;CACT,YAAY;CACZ,YAAY;CACZ,aAAa;CACb,UAAU;CACV,kBAAkB;CAClB,iBAAiB;CACjB,iBAAiB;CACjB,mBAAmB;CAKnB,qBAAqB;CAKrB,yBAAyB;CACzB,gCAAgC;CAChC,0BAA0B;CAE1B,yFAAyF;CACzF,wFAAwF;CAExF,qFAAqF;AACtF;;AAEA;CACC,UAAU;CACV,UAAU;AACX;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,iBAAiB;CACjB,iBAAiB;CACjB,gBAAgB;CAChB,eAAe;CACf,0BAA0B;CAC1B,cAAc;CACd,0BAA0B;CAC1B,+BAA+B;CAC/B,kCAAkC;CAClC,8BAA8B;CAC9B,6BAA6B;AAC9B;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,mBAAmB;CACnB,UAAU;CAKV,wBAAwB;CAKxB,0BAA0B;AAC3B;;AAEA;CACC,mBAAmB;CACnB,UAAU;CAKV,wBAAwB;CAKxB,0BAA0B;AAC3B;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,QAAQ;CACR,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,cAAc;CACd,iBAAiB;CACjB,yBAAyB;CACzB,qBAAqB;CACrB,eAAe;CACf,UAAU;CACV,aAAa;AACd;;AAEA,cAAc;AACd;CACC,kBAAkB;CAClB,YAAY;CACZ,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,WAAW;CAKX,0BAA0B;AAC3B;;AAEA;CACC,kBAAkB;CAClB,WAAW;CAKX,0BAA0B;AAC3B;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;CACC,kBAAkB;CAClB,WAAW;CACX,eAAe;CACf,iBAAiB;CACjB,eAAe;CACf,gBAAgB;CAChB,cAAc;CACd,gBAAgB;CAChB,eAAe;CACf,eAAe;CACf,0BAA0B;AAC3B;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,eAAe;CACf,iBAAiB;CACjB,eAAe;CACf,gBAAgB;CAChB,cAAc;CACd,gBAAgB;CAChB,eAAe;CACf,gBAAgB;CAKhB,0BAA0B;AAC3B;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,eAAe;CACf,iBAAiB;CACjB,eAAe;CACf,gBAAgB;CAChB,cAAc;CACd,gBAAgB;CAChB,eAAe;CACf,gBAAgB;CAKhB,0BAA0B;AAC3B;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,eAAe;CACf,iBAAiB;CACjB,eAAe;CACf,gBAAgB;CAChB,cAAc;CACd,gBAAgB;CAChB,eAAe;CACf,gBAAgB;CAKhB,0BAA0B;AAC3B;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,eAAe;CACf,iBAAiB;CACjB,eAAe;CACf,gBAAgB;CAChB,cAAc;CACd,gBAAgB;CAChB,eAAe;CACf,gBAAgB;CAKhB,0BAA0B;AAC3B;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,eAAe;CACf,iBAAiB;CACjB,eAAe;CACf,gBAAgB;CAChB,cAAc;CACd,gBAAgB;CAChB,eAAe;CACf,gBAAgB;CAKhB,0BAA0B;AAC3B;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,oBAAoB;CACpB,qBAAqB;CACrB,QAAQ;CACR,YAAY;CACZ,YAAY;CACZ,kBAAkB;CAGlB,0BAA0B;CAC1B,6BAA6B;AAC9B;;AAEA;CACC,oBAAoB;CACpB,qBAAqB;CACrB,QAAQ;CACR,YAAY;CACZ,YAAY;CACZ,kBAAkB;CAGlB,0BAA0B;CAC1B,6BAA6B;AAC9B;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,WAAW;AACZ;;AAEA;;;;;CAKC,cAAc;CACd,WAAW;CACX,iBAAiB;CACjB,0BAA0B;CAC1B,YAAY;CACZ,eAAe;CACf,yBAAyB;CACzB,mBAAmB;AACpB;;AAEA;;CAEC,qBAAqB;AACtB;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,QAAQ;CACR,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,cAAc;CACd,eAAe;CACf,gBAAgB;CAChB,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,cAAc;CACd,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,mBAAmB;CACnB,iBAAiB;CACjB,iBAAiB;CACjB,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,eAAe;CACf,iBAAiB;CACjB,eAAe;CACf,cAAc;CACd,mBAAmB;CACnB,aAAa;AACd;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,aAAa;AACd;;AAEA;;;;;;GAMG;;AAEH;CACC,YAAY;CACZ,cAAc;AACf;;;AAGA;CACC,UAAU;CACV,wCAAwC;AACzC;;AAEA;;;CAGC,eAAe;CAKf,0BAA0B;AAC3B;;AAEA;;CAEC,cAAc;AACf;;AAEA;;CAEC,cAAc;AACf;;AAEA;;CAEC,cAAc;AACf;;AAEA;;CAEC,cAAc;AACf;;AAEA;;CAEC,cAAc;AACf;;AAEA;;CAEC,cAAc;AACf;;AAEA;CACC,wCAAwC;AACzC;;AAEA;CACC,yBAAyB;CACzB,UAAU;AACX;;AAEA;;;CAGC,eAAe;AAChB;;AAEA;;;;;;GAMG;;AAEH;CACC,iBAAiB;AAClB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,YAAY;AACb;;AAEA;CACC,kBAAkB;AACnB;;AAEA;;;;;;GAMG;;AAEH;CACC,eAAe;CACf,yBAAyB;AAC1B;;AAEA;;;;;;GAMG;;AAEH;CACC,eAAe;CACf,QAAQ;CACR,MAAM;CACN,WAAW;CACX,mBAAmB;CACnB,eAAe;CACf,YAAY;CACZ,UAAU;CACV,kBAAkB;CAClB,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,UAAU;CACV,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,QAAQ;CACR,MAAM;CACN,WAAW;CACX,YAAY;CACZ,UAAU;CACV,UAAU;AACX;;AAEA;CACC,UAAU;CACV,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,QAAQ;CACR,WAAW;CACX,YAAY;CACZ,gBAAgB;CAChB,gBAAgB;CAChB,mBAAmB;CACnB,gBAAgB;CAChB,UAAU;CACV,UAAU;CACV,kBAAkB;CAClB,kBAAkB;CAKlB,mBAAmB;CAKnB,2BAA2B;CAK3B,0BAA0B;AAC3B;;AAEA;CACC,UAAU;CACV,mBAAmB;CAKnB,mBAAmB;AACpB;;AAEA;;;CAGC,4CAA4C;AAC7C;;AAEA;;;CAGC,WAAW;CACX,yBAAyB;CACzB,qBAAqB;AACtB;;AAEA;CACC,UAAU;CACV,kBAAkB;CAClB,YAAY;CACZ,QAAQ;AACT;;;AAGA;;;CAGC,2BAA2B;AAC5B;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,SAAS;CACT,iBAAiB;CACjB,WAAW;CACX,kBAAkB;CAClB,eAAe;CACf,cAAc;CACd,yBAAyB;CACzB,eAAe;CACf,WAAW;CAKX,yBAAyB;CAGzB,4BAA4B;AAC7B;;AAEA;CAGC,0BAA0B;AAC3B;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,yCAAyC;AAC1C;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,4CAA4C;AAC7C;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,iBAAiB;CACjB,kBAAkB;CAClB,eAAe;CACf,cAAc;CACd,gBAAgB;CAChB,0BAA0B;AAC3B;;AAEA;;CAEC,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,QAAQ;CACR,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,eAAe;CACf,UAAU;AACX;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,SAAS;CACT,SAAS;CACT,UAAU;CACV,YAAY;CACZ,0CAA0C;AAC3C;;AAEA;;CAEC,aAAa;AACd;;AAEA;;;;;;GAMG;;AAEH;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,4BAA4B;CAC5B,2BAA2B;CAC3B,sBAAsB;CACtB,sBAAsB;CACtB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,OAAO;CACP,MAAM;CACN,YAAY;CACZ,WAAW;CACX,KAAK;;CAEL,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,eAAe;CACf,cAAc;CACd,gBAAgB;CAChB,mBAAmB;CACnB,UAAU;CAKV,4BAA4B;CAK5B,0BAA0B;AAC3B;;AAEA;CACC,UAAU;CAKV,wBAAwB;AACzB;;AAEA;CACC,cAAc;CACd,eAAe;CACf,kBAAkB;CAClB,cAAc;CACd,gBAAgB;CAChB,mBAAmB;CACnB,UAAU;CAKV,4BAA4B;CAK5B,0BAA0B;AAC3B;;AAEA;CACC,UAAU;CAKV,wBAAwB;CAKxB,uBAAuB;AACxB;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;CACnB,UAAU;CAKV,4BAA4B;CAK5B,0BAA0B;AAC3B;;AAEA;CACC,UAAU;CAKV,wBAAwB;CAKxB,uBAAuB;AACxB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,gBAAgB;CAChB,cAAc;CACd,yBAAyB;AAC1B;;AAEA;CACC,oBAAoB;CACpB,kBAAkB;CAClB,WAAW;CACX,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC,UAAU;CAKV,4BAA4B;CAK5B,0BAA0B;AAC3B;;AAEA;CACC,UAAU;CAKV,wBAAwB;CAKxB,uBAAuB;AACxB;;AAEA;CACC,kBAAkB;CAClB,OAAO;CACP,QAAQ;CACR,WAAW;AACZ;;AAEA;;CAEC,kBAAkB;CAClB,OAAO;CACP,MAAM;CACN,aAAa;CACb,WAAW;CACX,cAAc;CACd,2CAA2C;CAC3C,eAAe;CACf,kBAAkB;CAClB,kBAAkB;CAKlB,0BAA0B;AAC3B;;AAEA;CACC,UAAU;CACV,QAAQ;AACT;;AAEA;;CAEC,0CAA0C;CAC1C,cAAc;AACf;;AAEA;;;;;;GAMG;;AAEH;CACC,kBAAkB;CAClB,gBAAgB;CAChB,gBAAgB;AACjB;;;;;;;AAOA;CACC,kBAAkB;CAClB,SAAS;CACT,QAAQ;CACR,UAAU;CACV,WAAW;AACZ;;AAEA;CACC,kBAAkB;CAClB,oBAAoB;CACpB,mBAAmB;CACnB,WAAW;CACX,YAAY;CACZ,qBAAqB;CACrB,4BAA4B;AAC7B;;AAEA;CACC,kBAAkB;CAClB,oBAAoB;CACpB,mBAAmB;CACnB,WAAW;CACX,YAAY;CACZ,qBAAqB;CACrB,4BAA4B;AAC7B;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;CACnB,mBAAmB;CACnB,WAAW;CACX,YAAY;CACZ,qBAAqB;CACrB,4BAA4B;AAC7B;;AAEA;CACC,kBAAkB;CAClB,oBAAoB;CACpB,mBAAmB;CACnB,WAAW;CACX,YAAY;CACZ,qBAAqB;CACrB,4BAA4B;AAC7B;;AAEA;CACC,kBAAkB;CAClB,oBAAoB;CACpB,mBAAmB;CACnB,WAAW;CACX,YAAY;CACZ,qBAAqB;CACrB,4BAA4B;AAC7B;;AAEA;CACC,kBAAkB;CAClB,oBAAoB;CACpB,mBAAmB;CACnB,WAAW;CACX,YAAY;CACZ,qBAAqB;CACrB,4BAA4B;AAC7B;;AAEA;CACC,kBAAkB;CAClB,oBAAoB;CACpB,mBAAmB;CACnB,WAAW;CACX,YAAY;CACZ,qBAAqB;CACrB,4BAA4B;AAC7B;;AAEA;CACC,kBAAkB;CAClB,oBAAoB;CACpB,mBAAmB;CACnB,WAAW;CACX,YAAY;CACZ,qBAAqB;CACrB,4BAA4B;AAC7B;;AAEA;CACC,kBAAkB;CAClB,oBAAoB;CACpB,mBAAmB;CACnB,WAAW;CACX,YAAY;CACZ,qBAAqB;CACrB,4BAA4B;AAC7B;;AAEA;CACC,kBAAkB;CAClB,oBAAoB;CACpB,mBAAmB;CACnB,WAAW;CACX,YAAY;CACZ,qBAAqB;CACrB,4BAA4B;AAC7B;;AAEA;CACC,kBAAkB;CAClB,oBAAoB;CACpB,mBAAmB;CACnB,WAAW;CACX,YAAY;CACZ,qBAAqB;CACrB,4BAA4B;AAC7B;;AAEA;CACC,kBAAkB;CAClB,oBAAoB;CACpB,mBAAmB;CACnB,WAAW;CACX,YAAY;CACZ,qBAAqB;CACrB,4BAA4B;AAC7B;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,mBAAmB;CACnB,WAAW;CACX,YAAY;CACZ,qBAAqB;CACrB,4BAA4B;AAC7B;;AAEA;CACC,kBAAkB;CAClB,oBAAoB;CACpB,mBAAmB;CACnB,WAAW;CACX,YAAY;CACZ,qBAAqB;CACrB,4BAA4B;AAC7B;;AAEA;CACC,SAAS;CACT,aAAa;AACd;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,MAAM;CACN,YAAY;CACZ,UAAU;AACX;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,MAAM;CACN,YAAY;CACZ,UAAU;AACX;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,QAAQ;CAKR,2BAA2B;AAC5B;;AAEA;CACC,kBAAkB;CAClB,WAAW;AACZ;;AAEA;CACC,cAAc;CACd,eAAe;CACf,cAAc;CACd,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,cAAc;CACd,eAAe;CACf,kBAAkB;CAClB,cAAc;CACd,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,kBAAkB;CAClB,WAAW;CACX,kBAAkB;CAClB,eAAe;CACf,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,SAAS;CACT,YAAY;CACZ,eAAe;CACf,gBAAgB;CAChB,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,OAAO;CACP,UAAU;CACV,aAAa;CACb,WAAW;CACX,WAAW;CACX,gCAAgC;CAChC,yBAAyB;CACzB;oCACmC;CACnC,WAAW;AACZ;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,eAAe;CACf,gBAAgB;CAChB,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;AACjB;;;;;;;;AAQA;CACC,YAAY;CACZ,WAAW;AACZ;;AAEA;CACC,SAAS;CACT,aAAa;AACd;;;AAGA;CACC,kBAAkB;CAClB,QAAQ;CACR,MAAM;CACN,YAAY;CACZ,UAAU;AACX;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,WAAW;CACX,YAAY;CACZ,SAAS;CACT,kBAAkB;CAKlB,wBAAwB;CACxB,4BAA4B;CAG5B,qFAAqF;CACrF,kHAAkH;CAClH,UAAU;AACX;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,MAAM;CACN,YAAY;CACZ,UAAU;AACX;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,QAAQ;CAKR,2BAA2B;AAC5B;;AAEA;CACC,kBAAkB;CAClB,WAAW;AACZ;;AAEA;CACC,cAAc;CACd,eAAe;CACf,cAAc;CACd,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,cAAc;CACd,eAAe;CACf,kBAAkB;CAClB,cAAc;CACd,4BAA4B;CAG5B,qFAAqF;CACrF,kHAAkH;CAClH,kBAAkB;CAClB,6BAA6B;CAC7B,oCAAoC;CACpC,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,kBAAkB;CAClB,WAAW;CACX,kBAAkB;CAClB,eAAe;CACf,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,eAAe;AAChB;;;AAGA;CACC,kBAAkB;CAClB,YAAY;CACZ,SAAS;CACT,YAAY;CACZ,eAAe;CACf,gBAAgB;CAChB,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,OAAO;CACP,UAAU;CACV,YAAY;CACZ,WAAW;CACX,mBAAmB;CACnB,6BAA6B;CAC7B,WAAW;AACZ;;;AAGA;CACC,aAAa;AACd;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,eAAe;CACf,gBAAgB;CAChB,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;;;;;;GAMG;;AAEH;CACC,kBAAkB;CAClB,gBAAgB;CAChB,UAAU;AACX;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,MAAM;CACN,WAAW;CACX,YAAY;CACZ,4BAA4B;CAC5B,2BAA2B;CAC3B,sBAAsB;AACvB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,eAAe;CACf,kBAAkB;CAClB,cAAc;CACd,gBAAgB;CAChB,mBAAmB;CACnB,2CAA2C;AAC5C;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,gBAAgB;CAChB,kBAAkB;CAClB,mBAAmB;CACnB,4CAA4C;AAC7C;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,kBAAkB;CAClB,eAAe;CACf,iBAAiB;CACjB,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,iBAAiB;CACjB,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,mCAAmC;AACpC;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;AACtB;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,WAAW;CACX,UAAU;CACV,YAAY;CACZ,aAAa;CACb,YAAY;CACZ,yBAAyB;CACzB,wBAAwB;AACzB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,iBAAiB;CACjB,eAAe;CACf,gBAAgB;CAChB,yBAAyB;CACzB,6BAA6B;CAC7B,kBAAkB;CAClB,cAAc;CACd,YAAY;CACZ,mBAAmB;CACnB,4CAA4C;;AAE7C;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,eAAe;CACf,kBAAkB;CAClB,cAAc;CACd,WAAW;CACX,gBAAgB;CAChB,iBAAiB;CACjB,4CAA4C;AAC7C;;AAEA;CACC,kBAAkB;CAClB,2CAA2C;AAC5C;;;AAGA;;;;;;GAMG;;AAEH;CACC,kBAAkB;CAClB,oBAAoB;AACrB;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,iBAAiB;CACjB,gBAAgB;CAChB,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,kBAAkB;CAClB,0BAA0B;CAC1B,wCAAwC;AACzC;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,SAAS;CACT,YAAY;CACZ,WAAW;CACX,wDAAwD;CACxD,4BAA4B;CAC5B,2BAA2B;CAC3B,qBAAqB;CAKrB,gCAAgC;CAKhC,0BAA0B;CAC1B,WAAW;AACZ;;AAEA;CACC;EAKC,oBAAoB;CACrB;;CAEA;EAKC,uBAAuB;CACxB;;CAEA;EAKC,oBAAoB;CACrB;AACD;;AAEA;CACC,YAAY;CACZ,aAAa;CACb,wDAAwD;AACzD;;AAEA;CACC,YAAY;CACZ,aAAa;CACb,wDAAwD;AACzD;;AAEA;CACC,YAAY;CACZ,aAAa;CACb,4DAA4D;AAC7D;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,0DAA0D;AAC3D;;AAEA;CACC,YAAY;CACZ,aAAa;CACb,4DAA4D;AAC7D;;AAEA;CACC,YAAY;CACZ,aAAa;CACb,8DAA8D;CAC9D,qBAAqB;AACtB;;AAEA;CACC,YAAY;CACZ,aAAa;CACb,4DAA4D;AAC7D;;AAEA;CACC,aAAa;CACb,cAAc;CACd,YAAY;CAKZ,+BAA+B;AAChC;;AAEA;CACC,SAAS;CACT,QAAQ;AACT;;AAEA;CACC,YAAY;CACZ,WAAW;CACX,YAAY;AACb;;AAEA;;;;;;GAMG;;AAEH;CACC,kBAAkB;CAClB,oBAAoB;AACrB;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,iBAAiB;CACjB,gBAAgB;CAChB,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,eAAe;CACf,iBAAiB;CACjB,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,OAAO;CACP,MAAM;CACN,eAAe;CACf,iBAAiB;CACjB,cAAc;AACf;;AAEA;CACC,eAAe;CACf,cAAc;CACd,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,cAAc;CACd,WAAW;CACX,UAAU;AACX;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,SAAS;CACT,WAAW;CACX,YAAY;CACZ,2DAA2D;CAC3D,4BAA4B;CAC5B,2BAA2B;CAC3B,sBAAsB;CACtB,WAAW;CACX,UAAU;AACX;;;AAGA;CACC,YAAY;CACZ,cAAc;CACd,YAAY;CAKZ,+BAA+B;AAChC;;AAEA;CACC,QAAQ;CACR,QAAQ;AACT;;AAEA;CACC,aAAa;CACb,WAAW;CACX,YAAY;AACb;;AAEA;;;;;;GAMG;;AAEH;CACC,kBAAkB;CAClB,UAAU;AACX;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,kBAAkB;CAClB,yBAAyB;CACzB,kBAAkB;CAClB,iBAAiB;CACjB,mBAAmB;CACnB,sDAAsD;CACtD,kHAAkH;CAClH,wCAAwC;CACxC,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,gBAAgB;CAChB,YAAY;CACZ,kBAAkB;CAClB,eAAe;CACf,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,SAAS;CACT,YAAY;CACZ,eAAe;CACf,gBAAgB;CAChB,cAAc;AACf;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,eAAe;CACf,gBAAgB;CAChB,cAAc;CACd,gBAAgB;AACjB;;AAEA;;;;;;GAMG;;AAEH;CACC,kBAAkB;CAClB,qBAAqB;AACtB;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,yBAAyB;CACzB,yBAAyB;CACzB,2CAA2C;CAK3C,0BAA0B;CAC1B,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,eAAe;CACf,gBAAgB;CAChB,cAAc;CAKd,0BAA0B;AAC3B;;AAEA;;CAEC,cAAc;AACf;;AAEA;;CAEC,cAAc;AACf;;AAEA;CAKC,mCAAmC;AACpC;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,eAAe;CACf,kBAAkB;CAClB,cAAc;CACd,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,cAAc;CACd,qBAAqB;CAKrB,0BAA0B;AAC3B;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,gBAAgB;CAChB,mBAAmB;CACnB,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,kBAAkB;CAClB,iBAAiB;CACjB,eAAe;CACf,cAAc;CACd,yBAAyB;CACzB,mBAAmB;CACnB,iCAAiC;CACjC,oCAAoC;CAKpC,0BAA0B;AAC3B;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,gBAAgB;CAChB,qBAAqB;AACtB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,gBAAgB;CAChB,cAAc;CACd,qBAAqB;AACtB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,gBAAgB;CAChB,cAAc;CACd,qBAAqB;AACtB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,aAAa;CACb,YAAY;CACZ,wDAAwD;CACxD,qBAAqB;AACtB;;AAEA;CACC,QAAQ;CACR,YAAY;CACZ,YAAY;CAKZ,qBAAqB;AACtB;;AAEA;CACC,UAAU;CACV,QAAQ;CAKR,yCAAyC;AAC1C;;AAEA;CACC,UAAU;CACV,QAAQ;AACT;;AAEA;;;;;;GAMG;;AAEH;CACC,kBAAkB;CAClB,qBAAqB;AACtB;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,oBAAoB;CACpB,yBAAyB;AAC1B;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,mBAAmB;CACnB,yBAAyB;CACzB,yBAAyB;CACzB,2CAA2C;CAK3C,0BAA0B;CAC1B,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,SAAS;CACT,cAAc;CACd,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,eAAe;CACf,gBAAgB;CAChB,4BAA4B;CAG5B,qFAAqF;CACrF,kHAAkH;CAClH,gBAAgB;CAChB,cAAc;CAKd,0BAA0B;AAC3B;;AAEA;CAKC,mCAAmC;AACpC;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,eAAe;CACf,kBAAkB;CAClB,cAAc;CACd,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,cAAc;CACd,qBAAqB;CAKrB,0BAA0B;AAC3B;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,gBAAgB;CAChB,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,iBAAiB;CACjB,eAAe;AAChB;;AAEA;CACC,YAAY;CACZ,UAAU;AACX;;AAEA;CACC,UAAU;CACV,SAAS;AACV;;AAEA;CACC,UAAU;CACV,SAAS;AACV;;AAEA;CACC,YAAY;CACZ,WAAW;AACZ;;AAEA;CACC,YAAY;CACZ,WAAW;CACX,6DAA6D;AAC9D;;AAEA;CACC,YAAY;CACZ,WAAW;CACX,6DAA6D;AAC9D;;AAEA;;;;;;GAMG;;AAEH;CACC,kBAAkB;CAClB,qBAAqB;AACtB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,mBAAmB;CACnB,oBAAoB;CACpB,yBAAyB;CACzB,yBAAyB;CACzB,2CAA2C;CAK3C,0BAA0B;CAC1B,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,MAAM;CACN,YAAY;CACZ,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,OAAO;CACP,MAAM;CACN,YAAY;CACZ,WAAW;CACX,yBAAyB;CACzB,WAAW;CAKX,uBAAuB;CAKvB,0BAA0B;AAC3B;;AAEA;CAKC,sBAAsB;AACvB;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,QAAQ;CACR,WAAW;CACX,eAAe;CACf,gBAAgB;CAChB,iBAAiB;CACjB,kBAAkB;CAClB,cAAc;CAKd,0BAA0B;AAC3B;;AAEA;CAKC,mCAAmC;AACpC;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,eAAe;CACf,kBAAkB;CAClB,cAAc;CACd,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,cAAc;CACd,qBAAqB;CAKrB,0BAA0B;AAC3B;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,gBAAgB;CAChB,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,QAAQ;CACR,iBAAiB;CACjB,eAAe;CACf,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,kBAAkB;CAClB,iBAAiB;CACjB,eAAe;CACf,cAAc;CACd,yBAAyB;CACzB,mBAAmB;CAKnB,0BAA0B;AAC3B;;AAEA;CACC,yBAAyB;CACzB,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,2CAA2C;AAC5C;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;;;AAGA;;;;;;GAMG;;AAEH;CACC,kBAAkB;CAClB,yBAAyB;AAC1B;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,UAAU;CACV,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,kBAAkB;CAClB,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,eAAe;CACf,kBAAkB;CAClB,cAAc;CACd,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,4CAA4C;AAC7C;;AAEA;CACC,kBAAkB;CAClB,OAAO;CACP,MAAM;CACN,YAAY;CACZ,UAAU;CACV,4BAA4B;CAC5B,gCAAgC;CAChC,sBAAsB;AACvB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,cAAc;CACd,WAAW;CACX,YAAY;AACb;;;AAGA;;;;;;GAMG;;AAEH;CACC,kBAAkB;CAClB,oBAAoB;AACrB;;AAEA;CACC,kBAAkB;CAClB,OAAO;CACP,MAAM;CACN,YAAY;CACZ,WAAW;CACX,yCAAyC;CACzC,WAAW;AACZ;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,kBAAkB;CAClB,yBAAyB;CACzB,2CAA2C;CAC3C,YAAY;CACZ,aAAa;CACb,cAAc;CAKd,0BAA0B;;AAE3B;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,cAAc;CACd,WAAW;CAKX,0BAA0B;AAC3B;;AAEA;CACC,YAAY;CAKZ,qBAAqB;AACtB;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,QAAQ;CACR,UAAU;CACV,WAAW;CACX,kBAAkB;CAClB,yCAAyC;CACzC,yCAAyC;CAKzC,+BAA+B;CAI/B,sBAAsB;CAGtB,8BAA8B;AAC/B;;AAEA;CAGC,sBAAsB;CAGtB,6BAA6B;CAC7B,UAAU;AACX;;;AAGA;CACC,kBAAkB;CAClB,OAAO;CACP,WAAW;CACX,QAAQ;CAKR,2BAA2B;CAC3B,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,eAAe;CACf,kBAAkB;CAClB,cAAc;CACd,gBAAgB;CAChB,UAAU;CACV,kBAAkB;CAKlB,2BAA2B;CAK3B,0BAA0B;AAC3B;;AAEA;CACC,UAAU;CAKV,0BAA0B;CAK1B,uBAAuB;AACxB;;;AAGA;CACC,cAAc;CAKd,0BAA0B;AAC3B;;AAEA,wCAAwC;;AAExC;CACC,kBAAkB;CAClB,cAAc;CACd,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,gBAAgB;CAChB,mBAAmB;CACnB,UAAU;CAKV,2BAA2B;CAK3B,0BAA0B;AAC3B;;AAEA;CACC,UAAU;CAKV,0BAA0B;CAK1B,uBAAuB;AACxB;;AAEA;CACC,kBAAkB;CAClB,UAAU;CAKV,2BAA2B;CAK3B,0BAA0B;AAC3B;;AAEA;CACC,UAAU;CAKV,0BAA0B;CAK1B,uBAAuB;AACxB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,WAAW;CACX,YAAY;CACZ,eAAe;CACf,iBAAiB;CACjB,yBAAyB;CACzB,kBAAkB;CAKlB,0BAA0B;AAC3B;;AAEA;CACC,cAAc;AACf;;AAEA;;;;;;GAMG;;AAEH;CACC,kBAAkB;CAClB,qBAAqB;CACrB,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,yBAAyB;CACzB,gBAAgB;CAChB,oBAAoB;CACpB,2CAA2C;CAC3C,yBAAyB;CACzB,gCAAgC;CAChC,gBAAgB;CAChB,cAAc;CAKd,0BAA0B;AAC3B;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,OAAO;CACP,MAAM;CACN,YAAY;CACZ,WAAW;CACX,2DAA2D;CAC3D,4BAA4B;CAC5B,2BAA2B;CAC3B,qBAAqB;CACrB,WAAW;CACX,YAAY;AACb;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,kBAAkB;CAClB,4BAA4B;CAC5B,yBAAyB;CACzB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,eAAe;CACf,kBAAkB;CAClB,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,cAAc;CAKd,0BAA0B;AAC3B;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,mBAAmB;CACnB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,aAAa;CACb,YAAY;CACZ,gBAAgB;CAChB,yBAAyB;CACzB,wCAAwC;CACxC,kBAAkB;CAClB,UAAU;CACV,gBAAgB;AACjB;;AAEA;CACC,cAAc;CACd,WAAW;CAKX,0BAA0B;AAC3B;;AAEA;CAKC,qBAAqB;AACtB;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,WAAW;CACX,YAAY;CACZ,yBAAyB;CACzB,eAAe;CACf,iBAAiB;CACjB,yBAAyB;CACzB,kBAAkB;CAKlB,0BAA0B;AAC3B;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,eAAe;AAChB;;AAEA;CAKC,oBAAoB;CACpB,OAAO;CACP,MAAM;AACP;;AAEA;CACC,WAAW;CACX,aAAa;CACb,YAAY;AACb;;AAEA;CACC,YAAY;CACZ,QAAQ;AACT;;AAEA;CACC,aAAa;CACb,YAAY;CACZ,8DAA8D;AAC/D;;AAEA;CACC,aAAa;CACb,YAAY;CACZ,8DAA8D;CAC9D,qBAAqB;AACtB;;AAEA;;;;;;GAMG;;AAEH;CACC,kBAAkB;CAClB,qBAAqB;CACrB,4BAA4B;CAC5B,2BAA2B;CAC3B,sBAAsB;CACtB,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,yBAAyB;CACzB,gBAAgB;CAChB,oBAAoB;CACpB,gBAAgB;CAChB,cAAc;CACd,gBAAgB;CAChB,2CAA2C;CAK3C,0BAA0B;AAC3B;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,kBAAkB;CAClB,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,YAAY;CACZ,SAAS;CACT,YAAY;CACZ,wDAAwD;CAKxD,oBAAoB;CACpB,4BAA4B;CAC5B,8BAA8B;CAC9B,sBAAsB;CACtB,WAAW;AACZ;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,aAAa;CACb,YAAY;CACZ,gBAAgB;CAChB,yBAAyB;CACzB,wCAAwC;CACxC,kBAAkB;CAClB,UAAU;CACV,gBAAgB;CAKhB,0BAA0B;AAC3B;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,WAAW;CAKX,0BAA0B;AAC3B;;AAEA;CAKC,qBAAqB;AACtB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,kBAAkB;CAClB,mBAAmB;CACnB,yBAAyB;AAC1B;;AAEA;CACC,kBAAkB;CAClB,OAAO;CACP,YAAY;CACZ,yBAAyB;CACzB,WAAW;CACX,MAAM;CACN,YAAY;CAKZ,uBAAuB;CACvB,4BAA4B;AAC7B;;AAEA;CACC,kBAAkB;CAClB,eAAe;CACf,kBAAkB;CAClB,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,cAAc;CAKd,0BAA0B;AAC3B;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,UAAU;CACV,4BAA4B;CAK5B,0BAA0B;AAC3B;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,WAAW;CACX,YAAY;CACZ,yBAAyB;CACzB,eAAe;CACf,iBAAiB;CACjB,yBAAyB;CACzB,kBAAkB;CAKlB,0BAA0B;AAC3B;;AAEA;CACC,cAAc;AACf;;AAEA;;;;;;GAMG;;AAEH;CACC,kBAAkB;CAClB,qBAAqB;AACtB;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;CACnB,gBAAgB;CAChB,0BAA0B;CAC1B,wCAAwC;AACzC;;AAEA;CACC,cAAc;CACd,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,eAAe;CACf,gBAAgB;CAChB,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,eAAe;CACf,gBAAgB;CAChB,gBAAgB;CAChB,mBAAmB;CACnB,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,eAAe;CACf,gBAAgB;CAChB,gBAAgB;CAChB,mBAAmB;CACnB,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,eAAe;CACf,gBAAgB;CAChB,gBAAgB;CAChB,mBAAmB;CACnB,2BAA2B;AAC5B;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,eAAe;CACf,kBAAkB;CAClB,cAAc;CACd,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;CAChB,uBAAuB;AACxB;;;AAGA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,gBAAgB;CAChB,mBAAmB;AACpB;;;AAGA;;;;;;GAMG;;AAEH;CACC,kBAAkB;CAClB,sBAAsB;CACtB,4BAA4B;CAC5B,2BAA2B;CAC3B,sBAAsB;CACtB,yBAAyB;CACzB,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,aAAa;AACd;;AAEA;CACC,YAAY;CACZ,UAAU;CACV,YAAY;AACb;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,mBAAmB;AACpB;;AAEA;;;GAGG;;AAEH;CACC,kBAAkB;CAClB,qBAAqB;CACrB,aAAa;CACb,YAAY;CACZ,mBAAmB;CACnB,yBAAyB;CACzB,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,gBAAgB;CAChB,gBAAgB;CAChB,kBAAkB;CAClB,iBAAiB;CACjB,kBAAkB;CAClB,eAAe;CACf,mBAAmB;CACnB,yBAAyB;CAKzB,0BAA0B;AAC3B;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,SAAS;CACT,iBAAiB;CACjB,yBAAyB;CACzB,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,cAAc;CACd,4BAA4B;AAC7B;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,SAAS;CACT,YAAY;CACZ,kBAAkB;CAClB,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,cAAc;AACf;;AAEA;CACC,cAAc;CACd,eAAe;CACf,gBAAgB;CAChB,gBAAgB;CAChB,cAAc;CACd,yBAAyB;AAC1B;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,0CAA0C;AAC3C;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA,kBAAkB;AAClB;CACC,yBAAyB;AAC1B;;AAEA,uBAAuB;;AAEvB;;CAEC,cAAc;AACf;;AAEA;;CAEC,cAAc;AACf;;AAEA;;CAEC,cAAc;AACf;;AAEA;;CAEC,cAAc;AACf;;AAEA,kBAAkB;AAClB;;CAEC,cAAc;AACf;;AAEA,uBAAuB;AACvB;CACC,8CAA8C;CAC9C,yBAAyB;AAC1B;;AAEA;CACC,8CAA8C;CAC9C,yBAAyB;AAC1B;;AAEA;CACC,6CAA6C;CAC7C,yBAAyB;AAC1B;;AAEA;CACC,6CAA6C;CAC7C,yBAAyB;AAC1B;;AAEA,kBAAkB;AAClB;CACC,8CAA8C;CAC9C,yBAAyB;AAC1B;;AAEA,uBAAuB;AACvB;CACC,kBAAkB;AACnB;;AAEA,yBAAyB;;AAEzB;CACC,kBAAkB;CAClB,qBAAqB;AACtB;;AAEA;CACC,cAAc;CACd,WAAW;CACX,WAAW;AACZ;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,UAAU;CACV,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,uBAAuB;CACvB,yBAAyB;CACzB,yBAAyB;CACzB,wCAAwC;CACxC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,MAAM;CACN,aAAa;CACb,WAAW;CACX,+BAA+B;CAC/B,WAAW;CACX,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,SAAS;CACT,kCAAkC;CAClC,gCAAgC;CAChC,qCAAqC;CACrC,WAAW;AACZ;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,YAAY;CACZ,QAAQ;CACR,aAAa;CACb,yBAAyB;CACzB,kBAAkB;CAClB,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,gBAAgB;CAChB,oBAAoB;CACpB,kBAAkB;CAClB,0BAA0B;CAC1B,wCAAwC;AACzC;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,iBAAiB;CACjB,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,OAAO;CACP,MAAM;CACN,WAAW;CACX,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,cAAc;CACd,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,eAAe;CACf,kBAAkB;CAClB,cAAc;CACd,gBAAgB;CAChB,mBAAmB;CACnB,iBAAiB;AAClB;;AAEA;CACC,cAAc;CACd,qBAAqB;CAKrB,0BAA0B;AAC3B;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,iBAAiB;CACjB,eAAe;CACf,yBAAyB;CACzB,cAAc;CACd,iCAAiC;CACjC,oCAAoC;CACpC,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,8CAA8C;AAC/C;;AAEA;CACC,WAAW;CACX,iBAAiB;AAClB;;AAEA;CACC,cAAc;CACd,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,UAAU;CACV,iBAAiB;CACjB,eAAe;CACf,aAAa;AACd;;AAEA;CACC,WAAW;CACX,UAAU;CACV,eAAe;CACf,+BAA+B;AAChC;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,UAAU;CACV,aAAa;AACd;;AAEA;CACC,eAAe;CACf,mBAAmB;AACpB;;AAEA;CACC,UAAU;CACV,QAAQ;AACT;;AAEA;;CAEC,qBAAqB;CACrB,aAAa;AACd;;AAEA;;CAEC,qBAAqB;AACtB;;AAEA;;CAEC,qBAAqB;AACtB;;AAEA;;CAEC,qBAAqB;AACtB;;AAEA;;CAEC,qBAAqB;AACtB;;;AAGA,cAAc;;AAEd;CACC,yBAAyB;AAC1B;;AAEA;CACC,cAAc;CACd,kBAAkB;CAClB,gBAAgB;CAChB,qBAAqB;AACtB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,gBAAgB;CAChB,qBAAqB;AACtB;;;;;;AAMA;CACC,yBAAyB;AAC1B;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,gBAAgB;CAChB,qBAAqB;AACtB;;;;AAIA;CACC,yBAAyB;AAC1B;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,gBAAgB;CAChB,qBAAqB;AACtB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,gBAAgB;CAChB,qBAAqB;AACtB;;;AAGA,UAAU;;AAEV;;;CAGC,cAAc;AACf;;AAEA;;;CAGC,cAAc;AACf;;AAEA;;;CAGC,cAAc;AACf;;AAEA;;;CAGC,cAAc;AACf;;AAEA;;;CAGC,cAAc;AACf;;AAEA;;;;;;GAMG;;AAEH;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,OAAO;CACP,MAAM;CACN,SAAS;CACT,UAAU;CACV,SAAS;CACT,gBAAgB;CAChB,YAAY;CACZ,WAAW;CACX,mBAAmB;CACnB,gBAAgB;CAChB,eAAe;AAChB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,SAAS;CACT,uBAAuB;CACvB,wCAAwC;AACzC;;AAEA;;CAEC,aAAa;AACd;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,cAAc;AACf;;AAEA;;;;;;GAMG;;AAEH;CACC,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,UAAU;CACV,SAAS;CACT,gBAAgB;CAChB,gBAAgB;CAChB,yBAAyB;AAC1B;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,kBAAkB;CAClB,OAAO;CACP,MAAM;CACN,SAAS;CACT,UAAU;CACV,SAAS;CACT,gBAAgB;CAChB,YAAY;CACZ,WAAW;CACX,mBAAmB;CACnB,gBAAgB;CAChB,eAAe;AAChB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,SAAS;CACT,uBAAuB;CACvB,wCAAwC;AACzC;;AAEA;;CAEC,aAAa;AACd;;AAEA;CACC,kBAAkB;AACnB;;AAEA;;;;;;GAMG;;AAEH;CACC,kBAAkB;CAClB,qBAAqB;AACtB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,cAAc;CACd,WAAW;CACX,YAAY;AACb;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,gBAAgB;CAChB,yBAAyB;CACzB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,OAAO;CACP,MAAM;CACN,eAAe;CACf,iBAAiB;CACjB,cAAc;AACf;;AAEA;CACC,cAAc;CACd,eAAe;CACf,kBAAkB;CAClB,cAAc;CACd,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,OAAO;CACP,MAAM;CACN,WAAW;CACX,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,cAAc;AACf;;AAEA;CACC,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,cAAc;CACd,WAAW;AACZ;;AAEA;CACC,eAAe;CACf,kBAAkB;CAClB,cAAc;CACd,gBAAgB;CAChB,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;;;;;;GAMG;;AAEH;CACC,kBAAkB;CAClB,qBAAqB;CACrB,gBAAgB;AACjB;;AAEA;CACC,iBAAiB;CACjB,cAAc;AACf;;;AAGA;CACC,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,eAAe;CACf,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,yBAAyB;CACzB,2CAA2C;CAC3C,iBAAiB;CACjB,gBAAgB;CAChB,cAAc;CACd,iCAAiC;CACjC;AACD;;AAEA;CACC,kBAAkB;CAClB,oBAAoB;CACpB,yBAAyB;CACzB,kBAAkB;CAClB;AACD;;AAEA;CACC,kBAAkB;CAClB,OAAO;CACP,SAAS;CACT,YAAY;CACZ,WAAW;CACX,0BAA0B;CAC1B,yBAAyB;CACzB,WAAW;AACZ;;;AAGA;CACC,kBAAkB;CAClB,aAAa;CACb,YAAY;CACZ,yBAAyB;CACzB,kBAAkB;CAClB,cAAc;CACd,aAAa;AACd;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,aAAa;CACb,YAAY;CACZ,kBAAkB;CAClB,yBAAyB;CACzB,kBAAkB;CAClB,eAAe;CACf,cAAc;CAKd,0BAA0B;AAC3B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,eAAe;CACf,kBAAkB;CAClB,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,cAAc;CACd,eAAe;CACf,cAAc;CACd,gBAAgB;CAChB,cAAc;AACf;;;AAGA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,gBAAgB;CAChB,cAAc;CACd,kBAAkB;CAClB,iCAAiC;AAClC;;AAEA;CACC,kBAAkB;CAClB,OAAO;CACP,QAAQ;CACR,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,2BAA2B;CAC3B,cAAc;AACf;;AAEA;CACC,cAAc;CACd,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,gBAAgB;CAChB,iBAAiB;CACjB,yBAAyB;CACzB,mBAAmB;CACnB,iCAAiC;CACjC,oCAAoC;CAKpC,0BAA0B;AAC3B;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;CACd,gBAAgB;CAChB,kBAAkB;CAClB,qBAAqB;AACtB;;AAEA;;CAEC,qBAAqB;AACtB;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;CACC,cAAc;CACd,gBAAgB;CAChB,kBAAkB;CAClB,qBAAqB;AACtB;;AAEA;;CAEC,cAAc;AACf;;AAEA;;CAEC,qBAAqB;AACtB;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;;CAEC,cAAc;AACf;;AAEA;CACC,cAAc;CACd,gBAAgB;CAChB,kBAAkB;CAClB,qBAAqB;AACtB;;;;AAIA;CACC,YAAY;CACZ,aAAa;CACb,6DAA6D;AAC9D;;AAEA;CACC,YAAY;CACZ,aAAa;CACb,8DAA8D;AAC/D;;AAEA;CACC,YAAY;CACZ,aAAa;CACb,4DAA4D;AAC7D;;AAEA;CACC,YAAY;CACZ,UAAU;CACV,YAAY;AACb;;AAEA;CACC,aAAa;CACb,QAAQ;CACR,YAAY;AACb;;AAEA;CACC,YAAY;CACZ,cAAc;CACd,YAAY;AACb;;AAEA;;;CAOC,+BAA+B;AAChC;;AAEA;;;;;;GAMG;;AAEH;CACC,kBAAkB;CAClB,qBAAqB;CACrB,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,yBAAyB;AAC1B;;;AAGA;CACC,kBAAkB;CAClB,iBAAiB;CACjB,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,yBAAyB;CACzB,uBAAuB;CACvB,gBAAgB;CAChB,cAAc;CACd,yBAAyB;CACzB,2CAA2C;CAK3C,0BAA0B;AAC3B;;AAEA;CACC,uCAAuC;AACxC;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,eAAe;CACf,kBAAkB;CAClB,cAAc;CACd,gBAAgB;CAChB,yBAAyB;CACzB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,qBAAqB;AACtB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,gBAAgB;CAChB,mBAAmB;CACnB,kBAAkB;CAClB,mBAAmB;CACnB,4BAA4B;CAC5B,4BAA4B;CAK5B,0BAA0B;CAG1B,yIAAyI;CACzI,kHAAkH;CAClH,0BAA0B;AAC3B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,gBAAgB;CAChB,cAAc;CACd,kBAAkB;CAClB,iCAAiC;AAClC;;AAEA;CACC,kBAAkB;CAClB,OAAO;CACP,QAAQ;CACR,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,2BAA2B;CAC3B,cAAc;AACf;;AAEA;CACC,cAAc;CACd,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,SAAS;CACT,QAAQ;AACT;;AAEA;CACC,SAAS;CACT,WAAW;AACZ;;AAEA;CACC,YAAY;CACZ,cAAc;CACd,YAAY;AACb;;AAEA;CACC,YAAY;CACZ,aAAa;CACb,wDAAwD;CACxD,qBAAqB;AACtB;;AAEA;;;;;;GAMG;;AAEH;CACC,kBAAkB;CAClB,qBAAqB;CACrB,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,iBAAiB;CACjB,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,yBAAyB;CACzB,mBAAmB;CACnB,uBAAuB;CACvB,kBAAkB;CAClB,gBAAgB;CAChB,cAAc;CACd,wCAAwC;CAKxC,0BAA0B;AAC3B;;AAEA,uCAAuC;;AAEvC;CACC,kBAAkB;CAClB,cAAc;CACd,eAAe;CACf,gBAAgB;CAChB,cAAc;CACd,gBAAgB;CAChB,yBAAyB;CACzB,oBAAoB;CACpB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,SAAS;CACT,kBAAkB;CAClB,WAAW;CACX,yBAAyB;CACzB,WAAW;CACX,WAAW;AACZ;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,gBAAgB;CAChB,iBAAiB;CACjB,cAAc;CACd,gBAAgB;CAChB,kCAAkC;CAClC,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,gBAAgB;CAChB,cAAc;CACd,iCAAiC;AAClC;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,SAAS;CACT,QAAQ;AACT;;AAEA;CACC,SAAS;CACT,WAAW;AACZ;;AAEA;CACC,YAAY;CACZ,cAAc;CACd,YAAY;AACb;;AAEA;;;;;;GAMG;;AAEH;CACC,kBAAkB;CAClB,qBAAqB;AACtB;;AAEA;CACC,kBAAkB;CAClB,OAAO;CACP,MAAM;CACN,YAAY;CACZ,WAAW;CACX,4BAA4B;CAC5B,2BAA2B;CAC3B,sBAAsB;CACtB,0DAA0D;CAC1D,WAAW;CACX,YAAY;AACb;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,eAAe;CACf,gBAAgB;CAChB,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,eAAe;CACf,cAAc;CACd,mBAAmB;CACnB,aAAa;CACb,YAAY;CACZ,kBAAkB;CAClB,kBAAkB;CAClB,gBAAgB;CAKhB,0BAA0B;CAC1B,yBAAyB;CACzB,6CAA6C;AAC9C;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,eAAe;CACf,gBAAgB;CAChB,cAAc;CACd,+CAA+C;CAC/C,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,cAAc;AACf;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,4BAA4B;CAC5B,2BAA2B;CAC3B,sBAAsB;AACvB;;AAEA;CACC,mBAAmB;CACnB,UAAU;AACX;;AAEA;CACC,cAAc;AACf;;;;AAIA;;qDAEqD;;AAErD;CACC,kBAAkB;CAClB,qBAAqB;AACtB;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA,kBAAkB;;AAElB;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;CACnB,wCAAwC;AACzC;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,eAAe;CACf,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,gBAAgB;CAChB,kBAAkB;CAClB,4BAA4B;CAC5B,mBAAmB;CACnB,yBAAyB;CACzB,yBAAyB;CAKzB,0BAA0B;AAC3B;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,SAAS;CACT,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,kBAAkB;CAKlB,yBAAyB;CAKzB,0BAA0B;AAC3B;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,wCAAwC;AACzC;;AAEA;CAKC,uBAAuB;AACxB;;AAEA;CACC,kBAAkB;CAClB,aAAa;CACb,yBAAyB;CACzB,yBAAyB;CACzB,aAAa;AACd;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,eAAe;CACf,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,eAAe;CACf,iBAAiB;CACjB,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;;AAGA;;;;;;GAMG;;AAEH;CACC,kBAAkB;CAClB,sBAAsB;CACtB,yBAAyB;AAC1B;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;;;;;;CAMC,kBAAkB;CAClB,cAAc;CACd,WAAW;CACX,eAAe;CACf,cAAc;CACd,iBAAiB;CACjB,kBAAkB;CAClB,yBAAyB;CACzB,gBAAgB;CAChB,YAAY;CACZ,yBAAyB;CAKzB,0BAA0B;AAC3B;;AAEA;;;CAGC,wCAAwC;AACzC;;AAEA;CACC,aAAa;CACb,YAAY;CACZ,iBAAiB;AAClB;;AAEA;CACC,SAAS;CACT,eAAe;CACf,gBAAgB;CAChB,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,cAAc;AACf;;;AAGA;;;;;;GAMG;;AAEH;CACC,kBAAkB;CAClB,yBAAyB;CACzB,qBAAqB;AACtB;;AAEA;CACC,kBAAkB;CAClB;AACD;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,cAAc;CACd,WAAW;AACZ;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;;AAGA;;;;;;GAMG;;AAEH;CACC,kBAAkB;CAClB,yBAAyB;CACzB,eAAe;CACf,UAAU;AACX;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,qBAAqB;CACrB,eAAe;CACf,YAAY;AACb;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,iBAAiB;AAClB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,kBAAkB;CAClB,mBAAmB;CAKnB,0BAA0B;AAC3B;;AAEA;CAGC,+CAA+C;CAC/C,8CAA8C;CAC9C,2CAA2C;AAC5C;;;AAGA;;;;;;GAMG;;AAEH;CACC,kBAAkB;CAClB,qBAAqB;AACtB;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,2CAA2C;CAC3C,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,cAAc;CACd,WAAW;CACX,YAAY;AACb;;AAEA;CACC,kBAAkB;CAClB,OAAO;CACP,MAAM;CACN,YAAY;CACZ,WAAW;CACX,kBAAkB;CAClB,WAAW;CACX,UAAU;CACV,yBAAyB;CAKzB,oBAAoB;CACpB,oBAAoB;CAKpB,0BAA0B;AAC3B;;AAEA;CAKC,mBAAmB;CACnB,WAAW;CACX,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,SAAS;CACT,iBAAiB;CACjB,iBAAiB;AAClB;;AAEA;CACC,cAAc;CACd,YAAY;CACZ,WAAW;CACX,yBAAyB;CACzB,cAAc;CACd,kBAAkB;CAClB,gBAAgB;CAChB,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,gBAAgB;AACjB;;;;AAIA;;;;;;GAMG;;AAEH;CACC,kBAAkB;CAClB,sBAAsB;AACvB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,kBAAkB;CAClB,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,yBAAyB;CACzB,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,yBAAyB;CACzB,gBAAgB;CAChB,mBAAmB;CACnB,UAAU;CAKV,0BAA0B;AAC3B;;AAEA;;CAEC,cAAc;CACd,yBAAyB;AAC1B;;AAEA;CACC,kBAAkB;CAClB,yBAAyB;CACzB,yBAAyB;CACzB,kBAAkB;CAClB,0CAA0C;AAC3C;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,eAAe;CACf,kBAAkB;CAClB,cAAc;CACd,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,cAAc;CACd,eAAe;CACf,kBAAkB;AACnB;;;AAGA;CACC,kBAAkB;CAClB,cAAc;CACd,eAAe;CACf,kBAAkB;CAClB,cAAc;CACd,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,OAAO;CACP,MAAM;CACN,eAAe;CACf,iBAAiB;CACjB,cAAc;AACf;;AAEA;CACC,cAAc;CACd,qBAAqB;CAKrB,0BAA0B;AAC3B;;AAEA;CACC,cAAc;CACd,0BAA0B;AAC3B;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,yBAAyB;CACzB,iBAAiB;CACjB,gBAAgB;AACjB;;AAEA;CACC,cAAc;CACd,WAAW;CACX,YAAY;AACb;;AAEA,iCAAiC;;AAEjC;;CAEC,kBAAkB;CAClB,OAAO;CACP,MAAM;CACN,YAAY;CACZ,WAAW;AACZ;;AAEA;CACC,WAAW;CACX,UAAU;CACV,WAAW;AACZ;;;;;AAKA;;;;;;GAMG;;AAEH;CACC,kBAAkB;CAClB,gBAAgB;CAChB,yBAAyB;AAC1B;;AAEA;CACC,kBAAkB;CAClB,OAAO;CACP,MAAM;CACN,YAAY;CACZ,WAAW;CACX,4BAA4B;CAC5B,kCAAkC;CAClC,qBAAqB;CACrB,YAAY;AACb;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,eAAe;CACf,iBAAiB;CACjB,WAAW;CACX,YAAY;CACZ,yBAAyB;CACzB,cAAc;CACd,kBAAkB;CAClB,mBAAmB;CACnB,2CAA2C;AAC5C;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,gBAAgB;CAChB,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,eAAe;CACf,kBAAkB;CAClB,cAAc;CACd,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,eAAe;CACf,iBAAiB;CACjB,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,WAAW;AACZ;;AAEA;;CAEC,kBAAkB;CAClB,WAAW;CACX,MAAM;CACN,YAAY;CACZ,WAAW;CACX,eAAe;CACf,cAAc;CACd,iBAAiB;CACjB,iBAAiB;CACjB,kBAAkB;CAClB,kBAAkB;CAClB,yBAAyB;CAKzB,0BAA0B;AAC3B;;AAEA;CACC,UAAU;CACV,YAAY;AACb;;AAEA;;CAEC,wCAAwC;AACzC;;;AAGA;;;;;;GAMG;;AAEH;CACC,kBAAkB;CAClB,qBAAqB;CACrB,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,yBAAyB;CACzB,wCAAwC;AACzC;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,UAAU;CACV,WAAW;CACX,WAAW;CACX,YAAY;CACZ,UAAU;CACV,qCAAqC;CACrC;;;;iCAIgC;AACjC;;AAEA;CACC,UAAU;CACV,SAAS;CACT,UAAU;CACV,uCAAuC;CACvC,sCAAsC;CACtC,kCAAkC;AACnC;;AAEA;CACC,cAAc;CACd,WAAW;AACZ;;AAEA;CACC,kBAAkB;CAClB,uBAAuB;AACxB;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,iBAAiB;CACjB,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,eAAe;CACf,kBAAkB;CAClB,cAAc;CACd,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,cAAc;CACd,qBAAqB;CAKrB,0BAA0B;AAC3B;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,iBAAiB;CACjB,yBAAyB;CACzB,kBAAkB;CAClB,yBAAyB;CAKzB,0BAA0B;AAC3B;;AAEA;CACC,gBAAgB;CAChB,cAAc;CACd,qBAAqB;AACtB;;AAEA;CACC,aAAa;CACb,cAAc;CACd,YAAY;CAKZ,+BAA+B;AAChC;;;AAGA;CACC,YAAY;CACZ,UAAU;AACX;;AAEA;CACC,UAAU;CACV,SAAS;AACV;;AAEA;CACC,UAAU;CACV,SAAS;AACV;;;AAGA;;;;;;GAMG;;AAEH;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,eAAe;AAChB;;;AAGA;;;;;;GAMG;;AAEH;CACC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,cAAc;CACd,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,mBAAmB;CACnB,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,kBAAkB;CAClB,yBAAyB;CACzB,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,SAAS;CACT,eAAe;CACf,gBAAgB;CAChB,cAAc;AACf;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,gBAAgB;CAChB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,OAAO;CACP,SAAS;CACT,WAAW;CACX,WAAW;CACX,yBAAyB;CACzB,WAAW;AACZ;;AAEA,qBAAqB;;AAErB;CACC,kBAAkB;CAClB,mBAAmB;CACnB,6BAA6B;CAC7B,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;AACtB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,eAAe;CACf,iBAAiB;CACjB,yBAAyB;CACzB,cAAc;CACd,iBAAiB;CACjB,gBAAgB;CAKhB,0BAA0B;AAC3B;;AAEA;CACC,cAAc;AACf;;AAEA,qBAAqB;;AAErB;CACC,kBAAkB;CAClB,kBAAkB;CAClB,yBAAyB;CACzB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;CACnB,gBAAgB;CAChB,mBAAmB;CACnB,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,OAAO;CACP,MAAM;CACN,YAAY;CACZ,WAAW;CACX,kBAAkB;CAClB,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,cAAc;CACd,WAAW;AACZ;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,eAAe;CACf,kBAAkB;CAClB,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,cAAc;CACd,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,gBAAgB;CAChB,eAAe;AAChB;;AAEA;CACC,cAAc;CACd,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,gBAAgB;CAKhB,0BAA0B;AAC3B;;AAEA;CACC,gBAAgB;CAChB,YAAY;CACZ,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC,cAAc;AACf;;;AAGA;;;;;;GAMG;;AAEH;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,iBAAiB;AAClB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,iBAAiB;CACjB,eAAe;CACf,YAAY;CACZ,WAAW;CACX,cAAc;CACd,gBAAgB;CAChB,kBAAkB;CAClB,mBAAmB;CACnB,yBAAyB;CACzB,gCAAgC;CAKhC,0BAA0B;AAC3B;;AAEA;;CAEC,yBAAyB;CACzB,cAAc;CACd,0CAA0C;AAC3C;;AAEA;;;;;;GAMG;;AAEH;CACC,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,OAAO;CACP,MAAM;CACN,YAAY;CACZ,WAAW;CACX,0DAA0D;CAC1D,4BAA4B;CAC5B,2BAA2B;CAC3B,sBAAsB;CACtB,WAAW;CACX,YAAY;AACb;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,mCAAmC;AACpC;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,eAAe;CACf,kBAAkB;CAClB,cAAc;CACd,WAAW;CACX,gBAAgB;CAChB,iBAAiB;CACjB,4CAA4C;CAC5C,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,iBAAiB;CACjB,eAAe;CACf,gBAAgB;CAChB,yBAAyB;CACzB,6BAA6B;CAC7B,kBAAkB;CAClB,cAAc;CACd,YAAY;CACZ,mBAAmB;CACnB,4CAA4C;AAC7C;;AAEA;;CAEC,cAAc;AACf;;AAEA;;CAEC,cAAc;AACf;;AAEA;;CAEC,cAAc;AACf;;AAEA;;CAEC,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,eAAe;CACf,gBAAgB;CAChB,gBAAgB;CAChB,mBAAmB;CACnB,4CAA4C;AAC7C;;AAEA;CACC,kBAAkB;CAClB,eAAe;CACf,gBAAgB;CAChB,iBAAiB;CACjB,cAAc;CACd,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,gBAAgB;CAChB,cAAc;CACd,WAAW;CACX,mBAAmB;CACnB,6CAA6C;CAC7C,mBAAmB;AACpB;;AAEA;;;;;CAKC,kBAAkB;CAClB,cAAc;CACd,WAAW;CACX,iBAAiB;CACjB,YAAY;CACZ,eAAe;CACf,cAAc;CACd,gBAAgB;CAChB,uBAAuB;CACvB,mBAAmB;CACnB,mBAAmB;CAKnB,0BAA0B;AAC3B;;AAEA;;CAEC,kBAAkB;CAClB,WAAW;CACX,SAAS;CACT,iBAAiB;CACjB,eAAe;CACf,cAAc;CACd,gBAAgB;CAChB,6BAA6B;CAC7B,eAAe;AAChB;;AAEA;;CAEC,cAAc;AACf;;AAEA;CACC,WAAW;CACX,aAAa;CACb,YAAY;CAKZ,+BAA+B;AAChC;;AAEA;CACC,SAAS;CACT,QAAQ;AACT;;AAEA;CACC,UAAU;CACV,WAAW;CACX,YAAY;CAKZ,+BAA+B;AAChC;;AAEA;CACC,aAAa;CACb,WAAW;CACX,YAAY;AACb;;AAEA;;;;;;GAMG;;AAEH;CACC,kBAAkB;CAClB,4BAA4B;CAC5B,sBAAsB;CACtB,sBAAsB;CACtB,4BAA4B;AAC7B;;AAEA;CACC,kBAAkB;CAClB,OAAO;CACP,MAAM;CACN,YAAY;CACZ,WAAW;CACX,4BAA4B;CAG5B,qFAAqF;CACrF,kHAAkH;CAClH,YAAY;CACZ,WAAW;AACZ;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,gBAAgB;CAChB,yBAAyB;CACzB,mBAAmB;AACpB;;AAEA;CACC,cAAc;CACd,eAAe;CACf,kBAAkB;CAClB,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,YAAY;CACZ,kBAAkB;CAClB,yBAAyB;CACzB,eAAe;CACf,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,UAAU;CAKV,0BAA0B;AAC3B;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,YAAY;CACZ,WAAW;CACX,kBAAkB;CAClB,iBAAiB;CACjB,yBAAyB;CACzB,cAAc;CACd,UAAU;CACV,iBAAiB;CACjB,eAAe;CACf,cAAc;CAKd,kBAAkB;CAGlB,oDAAoD;CACpD,mDAAmD;CACnD,gDAAgD;CAKhD,wBAAwB;AACzB;;AAEA;;;CAGC,kBAAkB;CAClB,QAAQ;CACR,SAAS;CACT,YAAY;CACZ,WAAW;CAKX,gCAAgC;CAKhC,kBAAkB;CAGlB,+CAA+C;CAC/C,8CAA8C;CAC9C,2CAA2C;CAK3C,6BAA6B;AAC9B;;AAEA;CAKC,oBAAoB;CACpB,WAAW;CACX,kBAAkB;AACnB;;AAEA;CAKC,oBAAoB;CACpB,WAAW;CACX,kBAAkB;AACnB;;AAYA;CACC;EACC,6CAA6C;CAC9C;;CAEA;EACC,0CAA0C;CAC3C;AACD;;AAEA;;;;;;GAMG;;AAEH;CACC,kBAAkB;CAClB,2BAA2B;CAC3B,4BAA4B;CAC5B,sBAAsB;CACtB,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,OAAO;CACP,MAAM;CACN,YAAY;CACZ,WAAW;CACX,yBAAyB;CACzB,YAAY;CACZ,WAAW;AACZ;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,gBAAgB;CAChB,yBAAyB;CACzB,mBAAmB;AACpB;;AAEA;CACC,cAAc;CACd,eAAe;CACf,kBAAkB;CAClB,cAAc;CACd,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;AACnB;;;AAGA;;;;;;GAMG;;AAEH;CACC,kBAAkB;CAClB,gBAAgB;CAChB,yBAAyB;CACzB,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,2CAA2C;CAC3C,yBAAyB;AAC1B;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,UAAU;CACV,wDAAwD;CACxD,4BAA4B;CAC5B,2BAA2B;CAC3B,sBAAsB;AACvB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,uBAAuB;AACxB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,mBAAmB;CACnB,yBAAyB;CACzB,aAAa;CACb,YAAY;CACZ,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,eAAe;CACf,cAAc;AACf;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,eAAe;CACf,cAAc;AACf;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,uBAAuB;CACvB,yBAAyB;AAC1B;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,eAAe;CACf,kBAAkB;CAClB,cAAc;CACd,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,SAAS;CACT,iBAAiB;CACjB,cAAc;CACd,eAAe;CACf,UAAU;AACX;;AAEA;;;;;;;;CAQC,kBAAkB;CAClB,cAAc;CACd,WAAW;CACX,iBAAiB;CACjB,kBAAkB;CAClB,YAAY;CACZ,cAAc;CACd,eAAe;CACf,yBAAyB;CACzB,yBAAyB;CACzB,kBAAkB;CAKlB,0BAA0B;AAC3B;;AAEA;;;;CAIC,qBAAqB;AACtB;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,WAAW;CACX,iBAAiB;CACjB,kBAAkB;CAClB,aAAa;CACb,kBAAkB;AACnB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,eAAe;CACf,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,WAAW;CACX,YAAY;AACb;;AAEA;CACC,SAAS;CACT,OAAO;AACR;;;;AAIA;;;;;;GAMG;;AAEH;CACC,kBAAkB;CAClB,qBAAqB;AACtB;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;;;;;;;CAOC,kBAAkB;CAClB,cAAc;CACd,WAAW;CACX,eAAe;CACf,gBAAgB;CAChB,iBAAiB;CACjB,iBAAiB;CACjB,yBAAyB;CACzB,wBAAwB;CACxB,gBAAgB;CAChB,YAAY;CAKZ,0BAA0B;CAC1B,kBAAkB;AACnB;;AAEA;;;CAGC,qBAAqB;AACtB;;AAEA;CACC,YAAY;CACZ,YAAY;AACb;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;;;CAGC,qBAAqB;AACtB;;AAEA;CACC,cAAc;CACd,gBAAgB;CAChB,eAAe;CACf,0BAA0B;CAC1B,iBAAiB;CACjB,cAAc;CACd,gBAAgB;CAChB,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,cAAc;CACd,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,gBAAgB;CAChB,SAAS;AACV;;AAEA;CACC,cAAc;CACd,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,OAAO;CACP,MAAM;CACN,YAAY;CACZ,WAAW;CACX,kBAAkB;CAClB,kBAAkB;CAClB,eAAe;CACf,iBAAiB;CACjB,yBAAyB;CACzB,cAAc;AACf;;AAEA;CACC,cAAc;CAKd,0BAA0B;AAC3B;;AAEA;CACC,cAAc;AACf;;;AAGA;;;;;;GAMG;;AAEH;CACC,kBAAkB;CAClB,cAAc;CACd,qBAAqB;AACtB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,eAAe;CACf,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,kBAAkB;CAClB,kBAAkB;CAClB,cAAc;AACf;;AAEA;CACC,aAAa;CACb,yBAAyB;AAC1B;;;AAGA;;;;;;GAMG;;AAEH;CACC,kBAAkB;CAClB,yBAAyB;AAC1B;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,OAAO;CACP,SAAS;CACT,WAAW;CACX,WAAW;CACX,yBAAyB;CACzB,WAAW;AACZ;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,oBAAoB;CACpB,mBAAmB;CACnB,gBAAgB;CAChB,yBAAyB;CACzB,kBAAkB;CAClB,wCAAwC;AACzC;;AAEA;CACC,kBAAkB;CAClB,OAAO;CACP,SAAS;CACT,YAAY;CACZ,WAAW;CACX,0DAA0D;CAC1D,4BAA4B;CAC5B,2BAA2B;CAC3B,sBAAsB;CACtB,WAAW;CAKX,qBAAqB;AACtB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,cAAc;CACd,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,OAAO;CACP,QAAQ;CACR,YAAY;CACZ,WAAW;CACX,yBAAyB;CACzB,kBAAkB;CAClB,cAAc;CACd,iBAAiB;CACjB,eAAe;CACf,kBAAkB;CAClB,wCAAwC;CACxC,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,oBAAoB;CACpB,gBAAgB;CAChB,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;;;CAGC,cAAc;CACd,YAAY;CACZ,WAAW;CACX,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,gBAAgB;CAChB,kBAAkB;CAClB,yBAAyB;CAKzB,0BAA0B;AAC3B;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,QAAQ;CACR,gBAAgB;CAChB,iBAAiB;CACjB,kBAAkB;CAClB,0BAA0B;CAC1B,gBAAgB;CAChB,gBAAgB;CAChB,eAAe;AAChB;;AAEA;;;;;;GAMG;;AAEH;CACC,kBAAkB;CAClB,eAAe;CACf,UAAU;AACX;;;AAGA;CAKC,qBAAqB;CACrB,QAAQ;CACR,YAAY;CACZ,YAAY;AACb;;AAEA;CACC,YAAY;CACZ,QAAQ;CAKR,yCAAyC;AAC1C;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,WAAW;CACX,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,aAAa;CACb,YAAY;CACZ,kBAAkB;CAClB,4BAA4B;CAG5B,qFAAqF;CACrF,kHAAkH;CAClH,UAAU;CACV,eAAe;CACf,kBAAkB;CAClB,cAAc;CACd,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,WAAW;CACX,WAAW;CACX,mBAAmB;CACnB,mBAAmB;CACnB,UAAU;CACV,yCAAyC;CACzC,mBAAmB;AACpB;;AAEA;;;;;;CAMC,kBAAkB;CAClB,cAAc;CACd,WAAW;CACX,iBAAiB;CACjB,YAAY;CACZ,eAAe;CACf,cAAc;CACd,mBAAmB;CACnB,iBAAiB;CACjB,6BAA6B;CAK7B,0BAA0B;AAC3B;;AAEA;;CAEC,kBAAkB;CAClB,UAAU;CACV,QAAQ;CACR,YAAY;CACZ,WAAW;CACX,kBAAkB;CAClB,iBAAiB;CACjB,eAAe;CACf,iBAAiB;CACjB,yBAAyB;CACzB,cAAc;CACd,eAAe;AAChB;;AAEA;0CAC0C;;AAE1C;;;;;;GAMG;;AAEH;CACC,kBAAkB;CAClB,qBAAqB;AACtB;;AAEA;CACC,kBAAkB;CAClB,OAAO;CACP,MAAM;CACN,YAAY;CACZ,WAAW;CACX,4DAA4D;CAC5D,WAAW;CACX,YAAY;CACZ,4BAA4B;CAC5B,2BAA2B;CAC3B,sBAAsB;CAKtB,oBAAoB;AACrB;;;AAGA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;;CAEC,aAAa;AACd;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,gBAAgB;CAChB,yBAAyB;CACzB,wCAAwC;CACxC,yBAAyB;CAKzB,0BAA0B;AAC3B;;AAEA;CACC,gBAAgB;AACjB;;;AAGA;CACC,cAAc;CACd,WAAW;CACX,qBAAqB;CACrB,UAAU;CAKV,0BAA0B;AAC3B;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,qBAAqB;CACrB,eAAe;CACf,kBAAkB;CAClB,yBAAyB;CACzB,cAAc;CACd,kBAAkB;CAClB,gBAAgB;CAChB,mBAAmB;CACnB,mBAAmB;AACpB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;;AAGA;CACC,WAAW;CACX,UAAU;AACX;;AAEA;CACC,YAAY;CACZ,UAAU;CACV,YAAY;CAKZ,yCAAyC;AAC1C;;AAEA;;;;;;GAMG;;AAEH;CACC,kBAAkB;CAClB,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,OAAO;CACP,MAAM;CACN,YAAY;CACZ,WAAW;CACX,4DAA4D;CAC5D,WAAW;CACX,YAAY;CACZ,4BAA4B;CAC5B,2BAA2B;CAC3B,sBAAsB;CAKtB,oBAAoB;AACrB;;;AAGA;CACC,kBAAkB;AACnB;;AAEA;;CAEC,aAAa;AACd;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,gBAAgB;CAKhB,0BAA0B;AAC3B;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,YAAY;CAKZ,0BAA0B;AAC3B;;AAEA;CACC,UAAU;AACX;;AAEA;;;;;;GAMG;;AAEH;CACC,kBAAkB;CAClB,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,OAAO;CACP,MAAM;CACN,YAAY;CACZ,WAAW;CACX,4DAA4D;CAC5D,WAAW;CACX,YAAY;CACZ,4BAA4B;CAC5B,2BAA2B;CAC3B,sBAAsB;CAKtB,oBAAoB;AACrB;;;AAGA;CACC,kBAAkB;AACnB;;AAEA;;CAEC,aAAa;AACd;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,gBAAgB;CAKhB,0BAA0B;AAC3B;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,cAAc;CACd,YAAY;CACZ,qBAAqB;CAKrB,0BAA0B;AAC3B;;AAEA;CACC,UAAU;AACX;;AAEA;;;;;;GAMG;;AAEH;CACC,kBAAkB;CAClB,yBAAyB;CACzB,uDAAuD;AACxD;;AAEA;CACC,kBAAkB;CAClB,4BAA4B;CAC5B,2BAA2B;CAC3B,sBAAsB;CACtB,qBAAqB;AACtB;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,eAAe;CACf,gBAAgB;CAChB,cAAc;CACd,iBAAiB;CACjB,oBAAoB;CACpB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,OAAO;CACP,SAAS;CACT,WAAW;CACX,WAAW;CACX,yBAAyB;CACzB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,UAAU;AACX;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,cAAc;CACd,eAAe;CACf,YAAY;AACb;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA,eAAe;;AAEf;CACC,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,OAAO;CACP,MAAM;CACN,YAAY;CACZ,WAAW;CACX,gBAAgB;AACjB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;CACd,WAAW;CACX,YAAY;AACb;;AAEA;CACC,kBAAkB;CAClB,eAAe;CACf,cAAc;CACd,iBAAiB;CACjB,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,cAAc;CAKd,0BAA0B;AAC3B;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,eAAe;CACf,iBAAiB;CACjB,cAAc;AACf;;AAEA;CACC,cAAc;CACd,iBAAiB;CACjB,YAAY;AACb;;AAEA,qBAAqB;;AAErB;CACC,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,gBAAgB;CAChB,eAAe;CACf,8BAA8B;CAK9B,0BAA0B;AAC3B;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,OAAO;CACP,MAAM;CACN,eAAe;CACf,iBAAiB;CACjB,cAAc;AACf;;AAEA;CACC,cAAc;CACd,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,cAAc;CAKd,0BAA0B;AAC3B;;AAEA;CACC,cAAc;AACf;;;AAGA,qBAAqB;;AAErB;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,SAAS;AACV;;AAEA;CACC,qBAAqB;CACrB,YAAY;CACZ,WAAW;CACX,kBAAkB;CAClB,yBAAyB;CACzB,cAAc;CACd,eAAe;CACf,kBAAkB;CAKlB,0BAA0B;AAC3B;;AAEA;CACC,wCAAwC;CACxC,yBAAyB;CACzB,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,eAAe;CACf,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,cAAc;CACd,WAAW;AACZ;;AAEA;CACC,kBAAkB;CAClB,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,OAAO;CACP,MAAM;CACN,YAAY;CACZ,WAAW;CACX,mBAAmB;CACnB,YAAY;CACZ,YAAY;CACZ,WAAW;CAKX,mBAAmB;CAKnB,0BAA0B;AAC3B;;AAEA;CAKC,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,WAAW;CACX,SAAS;CACT,QAAQ;CACR,kBAAkB;CAClB,iBAAiB;CACjB,kBAAkB;CAClB,iBAAiB;CACjB,eAAe;CACf,cAAc;CACd,gBAAgB;CAChB,gBAAgB;CAChB,kCAAkC;CAKlC,mBAAmB;CAKnB,0BAA0B;AAC3B;;AAEA;CAKC,mBAAmB;AACpB;;AAEA,wBAAwB;;AAExB;CACC,kBAAkB;CAClB,WAAW;CACX,0CAA0C;CAC1C,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,iBAAiB;CACjB,eAAe;CACf,cAAc;CACd,gBAAgB;CAChB,gBAAgB;AACjB;;AAEA;CACC,cAAc;CACd,gBAAgB;CAChB,0BAA0B;CAK1B,0BAA0B;AAC3B;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,YAAY;AACb;;AAEA;CACC,kBAAkB;CAClB,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,iBAAiB;CACjB,iCAAiC;AAClC;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,gBAAgB;CAChB,iBAAiB;CACjB,yBAAyB;CACzB,yBAAyB;CAKzB,0BAA0B;AAC3B;;AAEA;CACC,cAAc;CACd,wCAAwC;AACzC;;AAEA;;;;;;GAMG;;AAEH;CACC,kBAAkB;CAClB,4BAA4B;CAC5B,2BAA2B;CAC3B,sBAAsB;CACtB,kBAAkB;CAClB,wBAAwB;IACrB,SAAS;CACZ,UAAU;;AAEX;AACA;IACI,kBAAkB;AACtB;;AAEA;CACC,kBAAkB;CAClB,oBAAoB;AACrB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,cAAc;CACd,eAAe;CACf,cAAc;CACd,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,aAAa;AACd;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,gBAAgB;CAKhB,0BAA0B;AAC3B;;AAEA;CACC;AACD;;AAEA;CACC,cAAc;CACd,mBAAmB;AACpB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,aAAa;AACd;;;AAGA;;;;;;GAMG;;AAEH;CACC,kBAAkB;CAClB,mBAAmB;CACnB,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,oBAAoB;AACrB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,cAAc;CACd,eAAe;CACf,cAAc;CACd,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,gBAAgB;CAKhB,0BAA0B;AAC3B;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;CACd,mBAAmB;AACpB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,aAAa;AACd;;;AAGA;CACC,YAAY;CACZ,cAAc;CACd,YAAY;CAKZ,yCAAyC;AAC1C;;AAEA;CACC,SAAS;CACT,QAAQ;AACT;;AAEA;CACC,aAAa;CACb,WAAW;CACX,YAAY;AACb;;AAEA;;;;;;GAMG;AACH;CACC,kBAAkB;CAClB,kBAAkB;CAClB,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,OAAO;CACP,MAAM;CACN,YAAY;CACZ,WAAW;CACX,0DAA0D;CAC1D,4BAA4B;CAC5B,2BAA2B;CAC3B,sBAAsB;CACtB,WAAW;CACX,YAAY;AACb;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,eAAe;CACf,gBAAgB;CAChB,gBAAgB;CAChB,4CAA4C;AAC7C;;;AAGA;CACC,cAAc;CACd,eAAe;CACf,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,cAAc;CACd,eAAe;CACf,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,mBAAmB;CACnB,2CAA2C;AAC5C;;AAEA;CACC,WAAW;CACX,aAAa;CACb,YAAY;CAKZ,yCAAyC;AAC1C;;AAEA;CACC,SAAS;CACT,QAAQ;AACT;;AAEA;CACC,UAAU;CACV,WAAW;CACX,YAAY;CAKZ,yCAAyC;AAC1C;;AAEA;CACC,aAAa;CACb,WAAW;CACX,YAAY;AACb;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,OAAO;CACP,MAAM;CACN,YAAY;CACZ,WAAW;CACX,0DAA0D;CAC1D,4BAA4B;CAC5B,2BAA2B;CAC3B,sBAAsB;CACtB,WAAW;CACX,YAAY;AACb;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,eAAe;CACf,gBAAgB;CAChB,gBAAgB;CAChB,4CAA4C;AAC7C;;;AAGA;CACC,cAAc;CACd,eAAe;CACf,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,cAAc;CACd,eAAe;CACf,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,mBAAmB;CACnB,2CAA2C;AAC5C;;AAEA;CACC,WAAW;CACX,aAAa;CACb,YAAY;CAKZ,yCAAyC;AAC1C;;AAEA;CACC,SAAS;CACT,QAAQ;AACT;;AAEA;CACC,UAAU;CACV,WAAW;CACX,YAAY;CAKZ,yCAAyC;AAC1C;;AAEA;CACC,aAAa;CACb,WAAW;CACX,YAAY;AACb;;AAEA;;;;;;GAMG;;AAEH;CACC,kBAAkB;CAClB,uBAAuB;AACxB;;AAEA;;CAEC,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;AACjB;;AAEA,kBAAkB;;AAElB;CACC,kBAAkB;CAClB,cAAc;CACd,eAAe;CACf,kBAAkB;CAClB,cAAc;CACd,gBAAgB;CAChB,mBAAmB;CACnB,oBAAoB;CACpB,gCAAgC;AACjC;;AAEA,oBAAoB;;AAEpB;CACC,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,WAAW;AACZ;;AAEA;;CAEC,kBAAkB;CAClB,4BAA4B;CAC5B,yBAAyB;CACzB,mBAAmB;CACnB,cAAc;CACd,eAAe;CACf,iBAAiB;CACjB,WAAW;CACX,YAAY;CACZ,cAAc;CAKd,0BAA0B;AAC3B;;AAEA;;CAEC,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,MAAM;CACN,YAAY;CACZ,WAAW;CACX,cAAc;CACd,eAAe;CACf,cAAc;CACd,iBAAiB;CACjB,mBAAmB;CACnB,mBAAmB;CACnB,UAAU;CACV,eAAe;AAChB;;AAEA;CACC,cAAc;AACf;;AAEA,cAAc;;AAEd;CACC,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,QAAQ;CACR,WAAW;AACZ;;AAEA;CACC,cAAc;CACd,WAAW;CAKX,yBAAyB;AAC1B;;AAEA;CACC,kBAAkB;CAClB,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,cAAc;CACd,WAAW;AACZ;;AAEA;CACC,cAAc;CAKd,yBAAyB;AAC1B;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,eAAe;CACf,cAAc;CACd,gBAAgB;CAChB,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA,oBAAoB;;AAEpB;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,cAAc;CACd,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,mBAAmB;CAKnB,0BAA0B;AAC3B;;AAEA;CACC,YAAY;AACb;;;AAGA;CACC,cAAc;AACf;;AAEA,eAAe;;AAEf;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,YAAY;CACZ,qBAAqB;CACrB,cAAc;CACd,kBAAkB;CAClB,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,gCAAgC;CAChC,yBAAyB;CAKzB,0BAA0B;AAC3B;;AAEA;CACC,qBAAqB;CACrB,cAAc;AACf;;AAEA;;;;;;IAMI;;AAEJ;CACC,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,eAAe;CACf,kBAAkB;CAClB,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,QAAQ;CACR,YAAY;CACZ,WAAW;CACX,mBAAmB;CACnB,kBAAkB;CAClB,gBAAgB;CAChB,yBAAyB;AAC1B;;AAEA;CACC,WAAW;CACX,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,kBAAkB;CAClB,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,cAAc;CACd,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,gBAAgB;CAChB,iBAAiB;AAClB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,iBAAiB;AAClB;;AAEA;;;;;;IAMI;;AAEJ;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;;;;CAIC,kBAAkB;CAClB,cAAc;CACd,YAAY;CACZ,WAAW;CACX,eAAe;CACf,cAAc;CACd,iBAAiB;CACjB,gBAAgB;CAChB,kBAAkB;CAClB,yBAAyB;CACzB,yBAAyB;CAKzB,0BAA0B;AAC3B;;AAEA;;;CAGC,qBAAqB;AACtB;;AAEA;CACC,aAAa;CACb,YAAY;AACb;;AAEA;;CAEC,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,eAAe;AAChB;;AAEA;;0DAE0D;;AAE1D;CACC,kBAAkB;CAClB,sBAAsB;AACvB;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,eAAe;CACf,kBAAkB;CAClB,cAAc;CACd,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,eAAe;CACf,kBAAkB;CAClB,cAAc;CACd,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,yBAAyB;CACzB,UAAU;CACV,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,WAAW;CACX,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;;;;;;;CAOC,kBAAkB;CAClB,cAAc;CACd,WAAW;CACX,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,gBAAgB;CAChB,YAAY;CACZ,kBAAkB;CAClB,yBAAyB;CACzB,yBAAyB;CAKzB,0BAA0B;AAC3B;;AAEA;;;CAGC,yBAAyB;CACzB,qBAAqB;CACrB,cAAc;CACd,6CAA6C;AAC9C;;AAEA;CACC,aAAa;CACb,YAAY;AACb;;AAEA;;CAEC,eAAe;CACf,cAAc;CACd,WAAW;AACZ;;AAEA;CACC,kBAAkB;CAClB,eAAe;CACf,iBAAiB;CACjB,cAAc;AACf;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,cAAc;CACd,0BAA0B;AAC3B;;AAEA;CACC,kBAAkB;CAClB,QAAQ;AACT;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,eAAe;CACf,kBAAkB;CAClB,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;CACd,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,YAAY;CACZ,cAAc;CACd,YAAY;CAKZ,+BAA+B;AAChC;;AAEA;CACC,aAAa;CACb,WAAW;CACX,YAAY;AACb;;;AAGA;;0DAE0D;;AAE1D;CACC,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;;CAEC,cAAc;AACf;;AAEA;;CAEC,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;;;CAGC,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;;;CAGC,cAAc;AACf;;AAEA;;;CAGC,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;;;CAGC,cAAc;AACf;;AAEA;CACC,cAAc;CACd,WAAW;AACZ;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;CACd,cAAc;AACf;;AAEA;;CAEC,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;;CAEC,cAAc;AACf;;AAEA;;CAEC,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;;CAEC,cAAc;AACf;;AAEA;;;CAGC,cAAc;AACf;;AAEA,sBAAsB;AACtB;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;;;CAGC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;;;CAGC,yBAAyB;AAC1B;;AAEA;;;CAGC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;;;CAGC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;CACzB,WAAW;AACZ;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;CACzB,cAAc;AACf;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;;;CAGC,yBAAyB;AAC1B;;AAEA;CACC,cAAc;AACf;;AAEA;;;;;;GAMG;;AAEH;CACC,cAAc;CACd,iBAAiB;AAClB;;AAEA;;;;;CAKC,yBAAyB;AAC1B;;AAEA;;CAEC,qBAAqB;AACtB;;AAEA;;;;CAIC,YAAY;AACb;;AAEA;;;;CAIC,YAAY;AACb;;AAEA;;;CAGC,WAAW;AACZ;;AAEA;;;;;;;;;;;;;;;;CAgBC,UAAU;CACV,QAAQ;AACT;;AAEA;CACC,WAAW;CACX,UAAU;AACX;;AAEA;;;;;CAKC,WAAW;CACX,OAAO;AACR;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,cAAc;AACf;;AAEA;CACC,YAAY;CACZ,cAAc;CACd,kBAAkB;AACnB;;AAEA;CACC,sBAAsB;CACtB,kBAAkB;AACnB;;AAEA;CACC,sBAAsB;CACtB,kBAAkB;AACnB;;AAEA;CACC,YAAY;CACZ,kBAAkB;CAClB,cAAc;AACf;;AAEA;CACC,YAAY;CACZ,iBAAiB;AAClB;;AAEA;CACC,WAAW;CACX,WAAW;AACZ;;AAEA;CACC,eAAe;CACf,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,oBAAoB;AACrB;;AAEA;CACC,UAAU;CACV,WAAW;AACZ;;AAEA;CACC,cAAc;CACd,mBAAmB;AACpB;;AAEA;;;;;;;;CAQC,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,UAAU;CACV,WAAW;AACZ;;AAEA;CACC,cAAc;CACd,+BAA+B;AAChC;;AAEA;CACC,eAAe;CACf,mBAAmB;AACpB;;AAEA;CACC,UAAU;CACV,UAAU;AACX;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;;CAEC,iBAAiB;AAClB;;AAEA;CACC,eAAe;CACf,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,cAAc;CACd,mBAAmB;AACpB;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,mBAAmB;CACnB,eAAe;AAChB;;AAEA;;CAEC,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC,eAAe;CACf,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,mBAAmB;CACnB,eAAe;AAChB;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,eAAe;CACf,mBAAmB;AACpB;;AAEA;CACC,oBAAoB;CACpB,mBAAmB;AACpB;;AAEA;CACC,UAAU;CACV,WAAW;AACZ;;AAEA;CACC,WAAW;CACX,UAAU;AACX;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,QAAQ;CACR,WAAW;CACX,4BAA4B;AAC7B;;AAEA;;CAEC,iBAAiB;AAClB;;AAEA;CACC,4BAA4B;CAC5B,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,UAAU;AACX;;AAEA;CACC,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,OAAO;CACP,mBAAmB;AACpB;;AAEA;CACC,YAAY;CACZ,gBAAgB;CAChB,eAAe;AAChB;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,UAAU;CACV,UAAU;AACX;;AAEA;;CAEC,WAAW;CACX,UAAU;CACV,qBAAqB;AACtB;;AAEA;CACC,eAAe;CACf,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;CAChB,eAAe;AAChB;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,iBAAiB;CACjB,eAAe;AAChB;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,mBAAmB;AACpB;;AAEA;;CAEC,4BAA4B;AAC7B;;AAEA;CACC,eAAe;CACf,oBAAoB;AACrB;;AAEA;CACC,YAAY;CACZ,uBAAuB;AACxB;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,UAAU;CACV,WAAW;AACZ;;AAEA;CACC,eAAe;CACf,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC,eAAe;CACf,mBAAmB;AACpB;;;AAGA;;CAEC,eAAe;CACf,mBAAmB;AACpB;;AAEA;;CAEC,UAAU;CACV,QAAQ;AACT;;AAEA;CACC,iBAAiB;CACjB,iBAAiB;AAClB;;AAEA;CACC,WAAW;CACX,WAAW;AACZ;;AAEA;CACC,SAAS;CACT,WAAW;AACZ;;AAEA;CACC,QAAQ;AACT;;AAEA;CACC,QAAQ;AACT;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,UAAU;CACV,UAAU;AACX;;AAEA;CACC,iBAAiB;AAClB;;AAEA;;;;;;GAMG;;AAEH;CACC,iBAAiB;CACjB,cAAc;CACd,yBAAyB;CACzB,gBAAgB;CAChB,wCAAwC;AACzC;;AAEA;CACC,iBAAiB;CACjB,OAAO;CACP,QAAQ;CACR,cAAc;AACf;;AAEA;CACC,yBAAyB;CACzB,2BAA2B;CAC3B,4BAA4B;CAC5B,yDAAyD;AAC1D;;AAEA;CACC,kBAAkB;AACnB;;AAEA,eAAe;;AAEf;CACC,kBAAkB;CAClB,yBAAyB;CAKzB,0BAA0B;AAC3B;;AAEA;CACC,kBAAkB;CAClB,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,eAAe;AAChB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,kBAAkB;CAClB,iBAAiB;CACjB,WAAW;AACZ;;AAEA;CACC,kBAAkB;CAClB,iBAAiB;CACjB,qBAAqB;AACtB;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,eAAe;CAKf,yBAAyB;AAC1B;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,WAAW;CACX,eAAe;CACf,oBAAoB;CACpB,iBAAiB;CACjB,yBAAyB;AAC1B;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,QAAQ;CACR,UAAU;AACX;;AAEA;;CAEC,cAAc;AACf;;AAEA;;CAEC,cAAc;AACf;;AAEA;;CAEC,cAAc;AACf;;AAEA;;CAEC,cAAc;AACf;;AAEA;;CAEC,cAAc;AACf;;AAEA;;CAEC,cAAc;AACf;;AAEA;;CAEC,cAAc;AACf;;AAEA;;CAEC,cAAc;AACf;;AAEA;;CAEC,cAAc;AACf;;AAEA;;CAEC,cAAc;AACf;;AAEA;;CAEC,cAAc;AACf;;AAEA;;CAEC,cAAc;AACf;;AAEA;;CAEC,aAAa;AACd;;AAEA;CACC,eAAe;CACf,WAAW;AACZ;;AAEA,uBAAuB;;AAEvB;CACC,kBAAkB;CAClB,wBAAwB;CACxB,sBAAsB;CACtB,4BAA4B;CAK5B,0BAA0B;AAC3B;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,gBAAgB;CAChB,kBAAkB;CAClB,qBAAqB;CACrB,yBAAyB;AAC1B;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,qBAAqB;CACrB,yBAAyB;AAC1B;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,cAAc;CACd,eAAe;CACf,gBAAgB;CAChB,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,cAAc;CACd,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,yBAAyB;AAC1B;;AAEA;CACC,gBAAgB;CAChB,cAAc;CACd,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,yBAAyB;AAC1B;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,gBAAgB;CAChB,eAAe;CACf,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,gBAAgB;CAChB,eAAe;CACf,kBAAkB;CAClB,eAAe;AAChB;;AAEA;;;;;;GAMG;;AAEH;CACC,kBAAkB;CAClB,UAAU;AACX;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,SAAS;CACT,WAAW;CACX,WAAW;CACX,YAAY;CACZ,yBAAyB;AAC1B;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,sBAAsB;CACtB,yBAAyB;CACzB,kBAAkB;CAClB,kBAAkB;CAClB;;;uHAGsH;CACtH,wCAAwC;AACzC;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;;AAEnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,gBAAgB;CAChB,YAAY;CACZ,kBAAkB;CAClB,eAAe;CACf,cAAc;CACd,SAAS;CACT,gBAAgB;CAChB,kBAAkB;CAClB,yBAAyB;AAC1B;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,QAAQ;CACR,YAAY;CACZ,eAAe;CACf,gBAAgB;CAChB,cAAc;CACd,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,eAAe;CACf,gBAAgB;CAChB,cAAc;CACd,gBAAgB;CAChB,oBAAoB;CACpB,kBAAkB;AACnB;;;;;;;AAOA;CACC,kBAAkB;CAClB,kDAAkD;AACnD;;AAEA;CACC,kBAAkB;CAClB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,iBAAiB;CACjB,mBAAmB;CACnB,qBAAqB;CACrB,iDAAiD;AAClD;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,eAAe;CACf,gBAAgB;CAChB,cAAc;CACd,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,YAAY;AACb;;AAEA;CACC,kBAAkB;CAClB,WAAW;AACZ;;AAEA;CACC,kBAAkB;CAClB,iBAAiB;CACjB,iBAAiB;CACjB,qBAAqB;AACtB;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,eAAe;AAChB;;AAEA;;;;;;GAMG;;AAEH;CACC,kBAAkB;CAClB,wBAAwB;CACxB,gBAAgB;AACjB;;;;;AAKA;CACC,kBAAkB;CAClB,SAAS;CACT,QAAQ;CACR,UAAU;CACV,WAAW;AACZ;;AAEA;CACC,kBAAkB;CAClB,oBAAoB;CACpB,mBAAmB;CACnB,WAAW;CACX,YAAY;CACZ,qBAAqB;CACrB,4BAA4B;AAC7B;;AAEA;CACC,kBAAkB;CAClB,oBAAoB;CACpB,mBAAmB;CACnB,WAAW;CACX,YAAY;CACZ,qBAAqB;CACrB,4BAA4B;AAC7B;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;CACnB,mBAAmB;CACnB,WAAW;CACX,YAAY;CACZ,qBAAqB;CACrB,4BAA4B;AAC7B;;AAEA;CACC,kBAAkB;CAClB,oBAAoB;CACpB,mBAAmB;CACnB,WAAW;CACX,YAAY;CACZ,qBAAqB;CACrB,4BAA4B;AAC7B;;AAEA;CACC,kBAAkB;CAClB,oBAAoB;CACpB,mBAAmB;CACnB,WAAW;CACX,YAAY;CACZ,qBAAqB;CACrB,4BAA4B;AAC7B;;AAEA;CACC,kBAAkB;CAClB,oBAAoB;CACpB,mBAAmB;CACnB,WAAW;CACX,YAAY;CACZ,qBAAqB;CACrB,4BAA4B;AAC7B;;AAEA;CACC,kBAAkB;CAClB,oBAAoB;CACpB,mBAAmB;CACnB,WAAW;CACX,YAAY;CACZ,qBAAqB;CACrB,4BAA4B;AAC7B;;;;;AAKA;CACC,kBAAkB;CAClB,oBAAoB;CACpB,mBAAmB;CACnB,WAAW;CACX,YAAY;CACZ,qBAAqB;CACrB,4BAA4B;AAC7B;;AAEA;CACC,kBAAkB;CAClB,oBAAoB;CACpB,mBAAmB;CACnB,WAAW;CACX,YAAY;CACZ,qBAAqB;CACrB,4BAA4B;AAC7B;;AAEA;CACC,kBAAkB;CAClB,oBAAoB;CACpB,mBAAmB;CACnB,WAAW;CACX,YAAY;CACZ,qBAAqB;CACrB,4BAA4B;AAC7B;;AAEA;CACC,kBAAkB;CAClB,oBAAoB;CACpB,mBAAmB;CACnB,WAAW;CACX,YAAY;CACZ,qBAAqB;CACrB,4BAA4B;AAC7B;;AAEA;CACC,kBAAkB;CAClB,oBAAoB;CACpB,mBAAmB;CACnB,WAAW;CACX,YAAY;CACZ,qBAAqB;CACrB,4BAA4B;AAC7B;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,mBAAmB;CACnB,WAAW;CACX,YAAY;CACZ,qBAAqB;CACrB,4BAA4B;AAC7B;;AAEA;CACC,kBAAkB;CAClB,oBAAoB;CACpB,mBAAmB;CACnB,WAAW;CACX,YAAY;CACZ,qBAAqB;CACrB,4BAA4B;AAC7B;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,SAAS;CACT,QAAQ;CACR,UAAU;CACV,WAAW;CACX,qCAAqC;AACtC;;AAEA;CACC,SAAS;CACT,aAAa;AACd;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,MAAM;CACN,YAAY;CACZ,UAAU;AACX;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,MAAM;CACN,YAAY;CACZ,UAAU;AACX;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,QAAQ;CAKR,2BAA2B;AAC5B;;AAEA;CACC,kBAAkB;CAClB,WAAW;AACZ;;AAEA;CACC,cAAc;CACd,eAAe;CACf,cAAc;CACd,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,cAAc;CACd,eAAe;CACf,kBAAkB;CAClB,cAAc;CACd,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,kBAAkB;CAClB,WAAW;CACX,kBAAkB;CAClB,eAAe;CACf,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,SAAS;CACT,YAAY;CACZ,eAAe;CACf,gBAAgB;CAChB,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,OAAO;CACP,UAAU;CACV,aAAa;CACb,WAAW;CACX,WAAW;CACX,gCAAgC;CAChC,yBAAyB;CACzB;oCACmC;CACnC,WAAW;AACZ;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,eAAe;CACf,gBAAgB;CAChB,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;AACjB;;;;;AAKA;;;;;;GAMG;;AAEH;CACC,eAAe;CACf,SAAS;CACT,aAAa;CACb,WAAW;CACX,YAAY;CACZ,aAAa;CACb,kBAAkB;CAClB,UAAU;CACV,cAAc;CACd,+BAA+B;CAC/B,0BAA0B;CAC1B,+BAA+B;CAC/B,kCAAkC;CAClC,8BAA8B;CAC9B,6BAA6B;AAC9B;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,QAAQ;CACR,UAAU;CACV,WAAW;CACX,cAAc;AACf;;AAEA;CACC,SAAS;CACT,mBAAmB;CACnB,UAAU;AACX;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,SAAS;CACT,eAAe;CACf,cAAc;CACd,eAAe;CACf,UAAU;AACX;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,iBAAiB;CACjB,cAAc;CACd,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,2CAA2C;CAC3C,mBAAmB;CACnB,2BAA2B;CAC3B,uBAAuB;CACvB,sBAAsB;CACtB,wBAAwB;AACzB;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,6BAA6B;CAC7B,mBAAmB;CACnB,iBAAiB;CACjB,eAAe;CACf,cAAc;CACd,kBAAkB;CAClB,0BAA0B;CAC1B,sBAAsB;CACtB,qBAAqB;CACrB,uBAAuB;AACxB;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,UAAU;CACV,QAAQ;CACR,kBAAkB;CAClB,YAAY;CACZ,YAAY;CACZ,4BAA4B;CAC5B,yBAAyB;CACzB,yBAAyB;CACzB,iBAAiB;CACjB,eAAe;CACf,cAAc;CACd,eAAe;CACf,yBAAyB;CACzB,8BAA8B;CAC9B,mCAAmC;CACnC,kCAAkC;CAClC,iCAAiC;CACjC,sCAAsC;AACvC;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,cAAc;CACd,mBAAmB;CACnB,kBAAkB;AACnB;;AAEA;CACC,eAAe;CACf,cAAc;CACd,kBAAkB;AACnB;;AAEA;CACC,qBAAqB;CACrB,yBAAyB;AAC1B;;AAEA;CACC,cAAc;CACd,iBAAiB;CACjB,yBAAyB;CACzB,iBAAiB;CACjB,cAAc;CACd,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,qBAAqB;AACtB;;;AAGA;;;;;GAKG;;AAEH;CACC,eAAe;CACf,SAAS;CACT,aAAa;CACb,WAAW;CACX,YAAY;CACZ,aAAa;CACb,kBAAkB;CAClB,UAAU;CACV,cAAc;CACd,+BAA+B;CAC/B,0BAA0B;CAC1B,+BAA+B;CAC/B,kCAAkC;CAClC,8BAA8B;CAC9B,6BAA6B;AAC9B;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,QAAQ;CACR,UAAU;CACV,WAAW;CACX,cAAc;AACf;;AAEA;CACC,SAAS;CACT,mBAAmB;CACnB,UAAU;AACX;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,SAAS;CACT,eAAe;CACf,cAAc;CACd,eAAe;CACf,UAAU;AACX;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,iBAAiB;CACjB,cAAc;CACd,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,2CAA2C;CAC3C,mBAAmB;CACnB,2BAA2B;CAC3B,uBAAuB;CACvB,sBAAsB;CACtB,wBAAwB;AACzB;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,6BAA6B;CAC7B,mBAAmB;CACnB,iBAAiB;CACjB,eAAe;CACf,cAAc;CACd,kBAAkB;CAClB,0BAA0B;CAC1B,sBAAsB;CACtB,qBAAqB;CACrB,uBAAuB;AACxB;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,UAAU;CACV,QAAQ;CACR,kBAAkB;CAClB,YAAY;CACZ,YAAY;CACZ,4BAA4B;CAC5B,yBAAyB;CACzB,yBAAyB;CACzB,iBAAiB;CACjB,eAAe;CACf,cAAc;CACd,eAAe;CACf,yBAAyB;CACzB,8BAA8B;CAC9B,mCAAmC;CACnC,kCAAkC;CAClC,iCAAiC;CACjC,sCAAsC;AACvC;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,cAAc;CACd,mBAAmB;CACnB,kBAAkB;AACnB;;AAEA;CACC,eAAe;CACf,cAAc;CACd,kBAAkB;AACnB;;AAEA;CACC,qBAAqB;CACrB,yBAAyB;AAC1B;;AAEA;CACC,cAAc;CACd,iBAAiB;CACjB,yBAAyB;CACzB,iBAAiB;CACjB,cAAc;CACd,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,qBAAqB;AACtB;;AAEA,gBAAgB;;;;;;AAMhB;CACC,eAAe;CACf,SAAS;CACT,aAAa;CACb,WAAW;CACX,YAAY;CACZ,aAAa;CACb,kBAAkB;CAClB,UAAU;CACV,cAAc;CACd,+BAA+B;CAC/B,0BAA0B;CAC1B,+BAA+B;CAC/B,kCAAkC;CAClC,8BAA8B;CAC9B,6BAA6B;AAC9B;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,QAAQ;CACR,UAAU;CACV,WAAW;CACX,cAAc;AACf;;AAEA;CACC,SAAS;CACT,mBAAmB;CACnB,UAAU;AACX;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,SAAS;CACT,eAAe;CACf,cAAc;CACd,eAAe;CACf,UAAU;AACX;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,iBAAiB;CACjB,cAAc;CACd,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,2CAA2C;CAC3C,mBAAmB;CACnB,2BAA2B;CAC3B,uBAAuB;CACvB,sBAAsB;CACtB,wBAAwB;AACzB;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,6BAA6B;CAC7B,mBAAmB;CACnB,iBAAiB;CACjB,eAAe;CACf,cAAc;CACd,kBAAkB;CAClB,0BAA0B;CAC1B,sBAAsB;CACtB,qBAAqB;CACrB,uBAAuB;AACxB;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,UAAU;CACV,QAAQ;CACR,kBAAkB;CAClB,YAAY;CACZ,YAAY;CACZ,4BAA4B;CAC5B,yBAAyB;CACzB,yBAAyB;CACzB,iBAAiB;CACjB,eAAe;CACf,cAAc;CACd,eAAe;CACf,yBAAyB;CACzB,8BAA8B;CAC9B,mCAAmC;CACnC,kCAAkC;CAClC,iCAAiC;CACjC,sCAAsC;AACvC;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,cAAc;CACd,mBAAmB;CACnB,kBAAkB;AACnB;;AAEA;CACC,eAAe;CACf,cAAc;CACd,kBAAkB;AACnB;;AAEA;CACC,qBAAqB;CACrB,yBAAyB;AAC1B;;AAEA;CACC,cAAc;CACd,iBAAiB;CACjB,yBAAyB;CACzB,iBAAiB;CACjB,cAAc;CACd,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,qBAAqB;AACtB;;AAEA,gBAAgB;AAChB;CACC,eAAe;CACf,SAAS;CACT,aAAa;CACb,WAAW;CACX,YAAY;CACZ,aAAa;CACb,kBAAkB;CAClB,UAAU;CACV,cAAc;CACd,+BAA+B;CAC/B,0BAA0B;CAC1B,+BAA+B;CAC/B,kCAAkC;CAClC,8BAA8B;CAC9B,6BAA6B;AAC9B;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,QAAQ;CACR,UAAU;CACV,WAAW;CACX,cAAc;AACf;;AAEA;CACC,SAAS;CACT,mBAAmB;CACnB,UAAU;AACX;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,SAAS;CACT,eAAe;CACf,cAAc;CACd,eAAe;CACf,UAAU;AACX;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,iBAAiB;CACjB,cAAc;CACd,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,2CAA2C;CAC3C,mBAAmB;CACnB,2BAA2B;CAC3B,uBAAuB;CACvB,sBAAsB;CACtB,wBAAwB;AACzB;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,6BAA6B;CAC7B,mBAAmB;CACnB,iBAAiB;CACjB,eAAe;CACf,cAAc;CACd,kBAAkB;CAClB,0BAA0B;CAC1B,sBAAsB;CACtB,qBAAqB;CACrB,uBAAuB;AACxB;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,UAAU;CACV,QAAQ;CACR,kBAAkB;CAClB,YAAY;CACZ,YAAY;CACZ,4BAA4B;CAC5B,yBAAyB;CACzB,yBAAyB;CACzB,iBAAiB;CACjB,eAAe;CACf,cAAc;CACd,eAAe;CACf,yBAAyB;CACzB,8BAA8B;CAC9B,mCAAmC;CACnC,kCAAkC;CAClC,iCAAiC;CACjC,sCAAsC;AACvC;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,cAAc;CACd,mBAAmB;CACnB,kBAAkB;AACnB;;AAEA;CACC,eAAe;CACf,cAAc;CACd,kBAAkB;AACnB;;AAEA;CACC,qBAAqB;CACrB,yBAAyB;AAC1B;;AAEA;CACC,cAAc;CACd,iBAAiB;CACjB,yBAAyB;CACzB,iBAAiB;CACjB,cAAc;CACd,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,qBAAqB;AACtB;;AAEA,gBAAgB;AAChB;CACC,eAAe;CACf,SAAS;CACT,aAAa;CACb,WAAW;CACX,YAAY;CACZ,aAAa;CACb,kBAAkB;CAClB,UAAU;CACV,cAAc;CACd,+BAA+B;CAC/B,0BAA0B;CAC1B,+BAA+B;CAC/B,kCAAkC;CAClC,8BAA8B;CAC9B,6BAA6B;AAC9B;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,QAAQ;CACR,UAAU;CACV,WAAW;CACX,cAAc;AACf;;AAEA;CACC,SAAS;CACT,mBAAmB;CACnB,UAAU;AACX;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,SAAS;CACT,eAAe;CACf,cAAc;CACd,eAAe;CACf,UAAU;AACX;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,iBAAiB;CACjB,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,2CAA2C;CAC3C,mBAAmB;CACnB,2BAA2B;CAC3B,uBAAuB;CACvB,sBAAsB;CACtB,wBAAwB;AACzB;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,6BAA6B;CAC7B,mBAAmB;CACnB,iBAAiB;CACjB,eAAe;CACf,cAAc;CACd,kBAAkB;CAClB,0BAA0B;CAC1B,sBAAsB;CACtB,qBAAqB;CACrB,uBAAuB;AACxB;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,UAAU;CACV,QAAQ;CACR,kBAAkB;CAClB,YAAY;CACZ,YAAY;CACZ,4BAA4B;CAC5B,yBAAyB;CACzB,yBAAyB;CACzB,iBAAiB;CACjB,eAAe;CACf,cAAc;CACd,eAAe;CACf,yBAAyB;CACzB,8BAA8B;CAC9B,mCAAmC;CACnC,kCAAkC;CAClC,iCAAiC;CACjC,sCAAsC;AACvC;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,cAAc;CACd,mBAAmB;CACnB,kBAAkB;AACnB;;AAEA;CACC,eAAe;CACf,cAAc;CACd,kBAAkB;AACnB;;AAEA;CACC,qBAAqB;CACrB,yBAAyB;AAC1B;;AAEA;CACC,cAAc;CACd,iBAAiB;CACjB,yBAAyB;CACzB,iBAAiB;CACjB,cAAc;CACd,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,qBAAqB;AACtB;;AAEA,gBAAgB;AAChB;CACC,eAAe;CACf,SAAS;CACT,aAAa;CACb,WAAW;CACX,YAAY;CACZ,aAAa;CACb,kBAAkB;CAClB,UAAU;CACV,cAAc;CACd,+BAA+B;CAC/B,0BAA0B;CAC1B,+BAA+B;CAC/B,kCAAkC;CAClC,8BAA8B;CAC9B,6BAA6B;AAC9B;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,QAAQ;CACR,UAAU;CACV,WAAW;CACX,cAAc;AACf;;AAEA;CACC,SAAS;CACT,mBAAmB;CACnB,UAAU;AACX;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,SAAS;CACT,eAAe;CACf,cAAc;CACd,eAAe;CACf,UAAU;AACX;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,iBAAiB;CACjB,cAAc;CACd,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,2CAA2C;CAC3C,mBAAmB;CACnB,2BAA2B;CAC3B,uBAAuB;CACvB,sBAAsB;CACtB,wBAAwB;AACzB;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,6BAA6B;CAC7B,mBAAmB;CACnB,iBAAiB;CACjB,eAAe;CACf,cAAc;CACd,kBAAkB;CAClB,0BAA0B;CAC1B,sBAAsB;CACtB,qBAAqB;CACrB,uBAAuB;AACxB;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,UAAU;CACV,QAAQ;CACR,kBAAkB;CAClB,YAAY;CACZ,YAAY;CACZ,4BAA4B;CAC5B,yBAAyB;CACzB,yBAAyB;CACzB,iBAAiB;CACjB,eAAe;CACf,cAAc;CACd,eAAe;CACf,yBAAyB;CACzB,8BAA8B;CAC9B,mCAAmC;CACnC,kCAAkC;CAClC,iCAAiC;CACjC,sCAAsC;AACvC;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,cAAc;CACd,mBAAmB;CACnB,kBAAkB;AACnB;;AAEA;CACC,eAAe;CACf,cAAc;CACd,kBAAkB;AACnB;;AAEA;CACC,qBAAqB;CACrB,yBAAyB;AAC1B;;AAEA;CACC,cAAc;CACd,iBAAiB;CACjB,yBAAyB;CACzB,iBAAiB;CACjB,cAAc;CACd,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,qBAAqB;AACtB;;AAEA;CACC,kBAAkB;CAClB,wBAAwB;AACzB;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,kBAAkB;CAClB,cAAc;CACd,WAAW;CACX,yBAAyB;CACzB,yBAAyB;AAC1B;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,eAAe;CACf,gBAAgB;CAChB,kBAAkB;CAClB,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA,gBAAgB;;AAEhB;CACC,kBAAkB;AACnB;;AAEA;CACC,eAAe;CACf,cAAc;CACd,gBAAgB;CAChB,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;CACnB,eAAe;CACf,cAAc;AACf;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;CACjB,eAAe;CACf,mBAAmB;CACnB,gBAAgB;CAChB,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,mBAAmB;CACnB,YAAY;CACZ,eAAe;CACf,eAAe;AAChB;;AAEA;;CAEC,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,iBAAiB;CACjB,WAAW;CACX,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,eAAe;CACf,cAAc;CACd,UAAU;AACX;;AAEA;CACC,cAAc;CACd,cAAc;CACd,0BAA0B;CAC1B,eAAe;CACf,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;;;;;;;;CAQC,kBAAkB;CAClB,cAAc;CACd,WAAW;CACX,mBAAmB;CACnB,iBAAiB;CACjB,iBAAiB;CACjB,YAAY;CACZ,yBAAyB;CACzB,0BAA0B;CAC1B,kCAAkC;CAClC,8BAA8B;CAC9B,6BAA6B;CAC7B,+BAA+B;AAChC;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;CAClB,cAAc;AACf;;AAEA,cAAc;AACd;CACC,kBAAkB;AACnB;;;AAGA;CACC,kBAAkB;CAClB,cAAc;CACd,kBAAkB;CAClB,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,gCAAgC;CAChC,yBAAyB;CAKzB,0BAA0B;CAC1B,cAAc;AACf;;AAEA;CACC,qBAAqB;CACrB,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,kBAAkB;CAClB,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,gCAAgC;CAChC,yBAAyB;CAKzB,0BAA0B;CAC1B,cAAc;AACf;;AAEA;CACC,qBAAqB;CACrB,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,kBAAkB;CAClB,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,gCAAgC;CAChC,yBAAyB;CAKzB,0BAA0B;CAC1B,cAAc;AACf;;AAEA;CACC,qBAAqB;CACrB,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,kBAAkB;CAClB,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,gCAAgC;CAChC,yBAAyB;CAKzB,0BAA0B;CAC1B,cAAc;AACf;;AAEA;CACC,qBAAqB;CACrB,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,kBAAkB;CAClB,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,gCAAgC;CAChC,yBAAyB;CAKzB,0BAA0B;CAC1B,cAAc;AACf;;AAEA;CACC,qBAAqB;CACrB,cAAc;AACf;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,oBAAoB;AACrB;;AAEA;CACC,cAAc;CACd,eAAe;CACf,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,qCAAqC;AACtC;;AAEA;CACC,kBAAkB;CAClB,oBAAoB;AACrB;;AAEA;CACC,aAAa;CACb,WAAW;CACX,YAAY;AACb;;;;AAIA;CACC,kBAAkB;CAClB,oBAAoB;CACpB,iBAAiB;CACjB,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,OAAO;CACP,MAAM;CACN,WAAW;CACX,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,cAAc;CACd,gBAAgB;CAChB,kBAAkB;CAClB,gCAAgC;AACjC;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,YAAY;CACZ,cAAc;CACd,YAAY;CAKZ,+BAA+B;AAChC;;;AAGA;CACC,kCAAkC;CAClC,gBAAgB;CAChB,eAAe;CACf,mBAAmB;CACnB,gBAAgB;CAChB,sBAAsB;AACvB;;;;;AAKA;CACC;EACC,aAAa;EACb,2BAA2B;CAC5B;AACD;;AAEA;CACC;EACC,aAAa;EACb,2BAA2B;CAC5B;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,yBAAyB;CAC1B;;CAEA;EACC,yBAAyB;CAC1B;;CAEA;EACC,2BAA2B;CAC5B;;CAEA;EACC,2BAA2B;CAC5B;;CAEA;EACC,kBAAkB;EAClB,6BAA6B;CAC9B;;AAED;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;;AAEjB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,sCAAsC;AACvC;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,mBAAmB;CACnB,YAAY;CACZ,gBAAgB;AACjB;;AAEA;CACC,oCAAoC;AACrC;;AAEA;CACC,yBAAyB;CACzB;;;;gBAIe;CACf,0BAA0B;CAC1B,2BAA2B;CAC3B,0BAA0B;CAC1B,WAAW;CACX,qBAAqB;CACrB,4BAA4B;CAC5B,6BAA6B;CAC7B,oCAAoC;CACpC,sCAAsC;CACtC,qBAAqB;CACrB,gBAAgB;AACjB;;AAEA;CACC;EACC,gCAAgC;CACjC;AACD;;AAEA;CACC,WAAW;CACX,gBAAgB;CAChB,kBAAkB;CAClB,yBAAyB;AAC1B;;AAEA;CACC;EACC,gBAAgB;CACjB;AACD;;AAEA;CACC,iBAAiB;CACjB,eAAe;CACf,YAAY;CACZ,WAAW;CACX,gBAAgB;AACjB;;AAEA;;CAEC,wBAAwB;CACxB,SAAS;AACV;;AAEA,YAAY;AACZ;CACC,0BAA0B;AAC3B;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,QAAQ;CACR,gCAAgC;AACjC;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,SAAS;CACT,2BAA2B;CAC3B,eAAe;AAChB;;AAEA;IACI,sBAAsB;IACtB,mCAAmC;IACnC,kBAAkB;IAClB,aAAa;AACjB;AACA;IACI,WAAW;AACf;AACA;IACI,WAAW;AACf;AACA;CACC,yBAAyB;CACzB,YAAY;CACZ,mBAAmB;CACnB,eAAe;CACf,gBAAgB;CAChB,iBAAiB;CACjB,WAAW;AACZ;AACA;IACI,YAAY;IACZ,oCAAoC;IACpC,aAAa;IACb,mBAAmB;IACnB,6BAA6B;AACjC;AACA;IACI,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;CACtB,aAAa;AACd;AACA;CACC,iBAAiB;IACd,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,4BAA4B;IAC5B,gBAAgB;CACnB,iBAAiB;IACd,gBAAgB;AACpB;AACA;CACC,aAAa;AACd;AACA;CACC,YAAY;AACb;AACA;IACI,mBAAmB;IACnB,aAAa;AACjB;AACA;IACI,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,8BAA8B;CACjC,gBAAgB;IACb;AACJ;AACA;CACC,mBAAmB;CACnB,yBAAyB;CACzB,mBAAmB;CACnB,kBAAkB;CAClB,iBAAiB;AAClB;AACA;CACC,aAAa;AACd;;AAEA,iBAAiB;;AAEjB;IACI,sDAAsD;IACtD,WAAW;IACX,kBAAkB;IAClB,kBAAkB;CACrB,uBAAuB;CACvB,4BAA4B;AAC7B;AACA;IACI,oDAAoD;CACvD,WAAW;AACZ;AACA;IACI,aAAa;IACb,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;CACrB,uBAAuB;AACxB;AACA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,eAAe;AACnB;AACA;IACI,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,2BAA2B;IAC3B,+BAA+B;IAC/B,gBAAgB;IAChB,cAAc;IACd,YAAY;AAChB;AACA;IACI,WAAW;IACX,eAAe;CAClB,eAAe;IACZ,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IACI,qBAAqB;IACrB,UAAU;AACd;AACA;IACI,UAAU;AACd;AACA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;AACb;AACA;CACC,qBAAqB;IAClB,aAAa;IACb,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,iCAAiC;IACjC,sCAAsC;CACzC,kBAAkB;CAClB,WAAW;AACZ;;AAEA;IACI,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,mCAAmC;IACnC,UAAU;IACV,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;CACnB,WAAW;AACZ;;AAEA;IACI,SAAS;IACT,eAAe;AACnB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,4BAA4B;IAC5B,0EAA0E;AAC9E;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,UAAU;IACV,WAAW;IACX,SAAS;IACT,gCAAgC;IAChC,mCAAmC;IACnC,4BAA4B;IAC5B,mBAAmB;IACnB,8BAA8B;IAC9B,UAAU;AACd;;AAEA;CACC,yDAAgD;CAChD,iCAAiC;IAC9B,sBAAsB;IACtB,4BAA4B;IAC5B,4BAA4B;CAC/B,yBAAyB;AAC1B;;AAEA;CACC,kBAAkB;IACf,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,2BAA2B;IAC3B,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,QAAQ;IACR,mCAAmC;CACtC,yDAAmD;CACnD,wBAAwB;IACrB,4BAA4B;CAC/B,qBAAqB;CACrB,OAAO;AACR;;AAEA;CACC,WAAW;IACR,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,QAAQ;IACR,yDAAmD;IACnD,mCAAmC;IACnC,wBAAwB;IACxB,4BAA4B;CAC/B,QAAQ;AACT;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;IACzB,aAAa;AACjB;;AAEA,eAAe,mBAAmB,CAAC;;AAEnC;IACI,qBAAqB;IACrB,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,yDAA0C;IAC1C,wCAAwC;IACxC,4BAA4B;IAC5B,wBAAwB;IACxB,qBAAqB;IACrB,WAAW;CACd,OAAO;AACR;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,4BAA4B;IAC5B,kBAAkB;IAClB,kCAAkC;CACrC,qBAAqB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;CACC,yDAAmD;IAChD,sBAAsB;IACtB,2BAA2B;IAC3B,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,WAAW;IACX,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,sDAAsD;IACtD,YAAY;CACf,UAAU;CACV,kBAAkB;IACf,mBAAmB;CACtB,gBAAgB;AACjB;;AAEA;IACI,YAAY;CACf,UAAU;CACV,uBAAuB;AACxB;;AAEA;IACI,sBAAsB;IACtB,2BAA2B;CAC9B,iBAAiB;AAClB;;AAEA;IACI,sBAAsB;IACtB,2BAA2B;IAC3B,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,WAAW;AACf;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,SAAS;CACZ,4BAA4B;AAC7B;;AAEA;CACC,WAAW;AACZ;;AAEA,gBAAgB;;AAEhB;CACC,MAAM,sBAAsB,CAAC;CAC7B,kBAAkB,qCAAqC,CAAC,mBAAmB,CAAC,uBAAuB,CAAC;CACpG,oBAAoB,iBAAiB,CAAC,8BAA8B,CAAC,aAAa,EAAE,mBAAmB,CAAC;CACxG,yBAAyB,eAAe,CAAC,gCAAgC,CAAC,gBAAgB,CAAC,gBAAgB,CAAC;CAC5G,2BAA2B,eAAe,CAAC;AAC5C;;AAEA;CACC,yBAAyB,mBAAmB,CAAC;AAC9C;;AAEA;CACC,kBAAkB,qCAAqC,CAAC;CACxD,kBAAkB,qCAAqC,CAAC;CACxD,iCAAiC,aAAa,CAAC,2BAA2B,CAAC;CAC3E,kCAAkC,eAAe,CAAC;CAClD,gCAAgC,sBAAsB,CAAC;CACvD,cAAc,UAAU,CAAC,kBAAkB,CAAC,mBAAmB,CAAC;CAChE,gCAAgC,sBAAsB,CAAC;CACvD,qBAAqB,sBAAsB,CAAC,2BAA2B,CAAC;CACxE,MAAM,qBAAqB,CAAC;CAC5B,8BAA8B,sBAAsB,CAAC;CACrD,qCAAqC,+BAA+B,CAAC,oCAAoC,CAAC,gCAAgC,CAAC,kCAAkC,CAAC;AAC/K","sourcesContent":["@import url('https://fonts.googleapis.com/css?family=Poppins:200,300,400,500,600,700,800,900|Orbitron:500,700|Ubuntu:400,500,700&display=swap');\n\n@import url('fontawesome-all.css');\n@import url('flaticon.css');\n@import url('elegent-icon.css');\n@import url('animate.css');\n@import url('swiper.css');\n@import url('owl.css');\n@import url('jquery.fancybox.min.css');\n\n* {\n\tmargin: 0px;\n\tpadding: 0px;\n\tborder: none;\n\toutline: none;\n}\n\nbody {\n\toverflow-x:hidden;\n\tfont-size: 14px;\n\tcolor: #777777;\n\tline-height: 1.7em;\n\tfont-weight: 400;\n\tbackground: #ffffff;\n\t-webkit-font-smoothing: antialiased;\n\t-moz-font-smoothing: antialiased;\n\tfont-family: 'Poppins', sans-serif;\n}\n\na {\n\ttext-decoration: none;\n\tcursor: pointer;\n\tcolor: #890025;\n}\n\nbutton,\na:hover,\na:focus,\na:visited {\n\ttext-decoration: none;\n\toutline: none !important;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n\tposition: relative;\n\tfont-weight: normal;\n\tmargin: 0px;\n\tbackground: none;\n\tline-height: 1.6em;\n\tfont-family: 'Ubuntu', sans-serif;\n}\n\ninput,\nbutton,\nselect,\ntextarea {}\n\ntextarea {\n\toverflow: hidden;\n}\n\np,\n.text {\n\tposition: relative;\n\tfont-size: 16px;\n\tline-height: 26px;\n\tcolor: #888888;\n\tfont-weight: 400;\n}\n\n.set-logo-images {\n\tposition: relative;\n}\n\nimg.set-images {\n\theight: 50px;\n\twidth: 50px !important;\n\tborder-radius: 50px;\n\tborder: 3px solid #890023;\n}\n\n.inner-column {\n\twidth: 522px;\n\tmargin: auto;\n\t/* box-shadow: 2px 4px 12px 5px #d5d3d3; */\n\tpadding: 20px;\n\t/* border-radius: 28px;\n\tborder: 0.3px solid #cc003726; */\n}\n\n.btn.btn-primary {\n\tbackground-color: #890025;\n\tborder: none;\n\tborder-radius: 50px;\n\tfont-size: 15px;\n\tfont-weight: 400;\n\tpadding: 6px 18px;\n}\n\n.btn.btn-secondary {\n\tborder: none;\n\tborder-radius: 50px;\n\tfont-size: 15px;\n\tfont-weight: 400;\n\tpadding: 6px 18px;\n}\n\ni.fa.fa-times.time-set {\n\tposition: absolute;\n\tpadding: 0px 8px;\n\tborder-radius: 50px;\n\ttop: -4px;\n\tright: -11px;\n\tfont-size: 13px;\n\tfont-weight: 700;\n\tcolor: #890025;\n}\n\n.auto-container {\n\tposition: static;\n\t/* max-width: 1140px; */\n\tpadding: 0px 15px;\n\tmargin: 0 auto;\n}\n\n.large-container {\n\tposition: static;\n\tmax-width: 1550px;\n\tpadding: 0px 15px;\n\tmargin: 0 auto;\n}\n\n.medium-container {\n\tmax-width: 850px;\n}\n\n.page-wrapper {\n\tposition: relative;\n\tmargin: 0 auto;\n\twidth: 100%;\n\tmin-width: 300px;\n\toverflow: hidden;\n}\n\nul,\nli {\n\tlist-style: none;\n\tpadding: 0px;\n\tmargin: 0px;\n}\n\nimg {\n\tdisplay: inline-block;\n\tmax-width: 100%;\n\theight: auto;\n}\n\n.theme-btn {\n\tdisplay: inline-block;\n\t-webkit-transition: all 0.3s ease;\n\t-moz-transition: all 0.3s ease;\n\t-ms-transition: all 0.3s ease;\n\t-o-transition: all 0.3s ease;\n\ttransition: all 0.3s ease;\n}\n\n.centered {\n\ttext-align: center;\n}\n\n.theme-btn .flaticon-arrow {\n\tdisplay: inherit;\n\tfont-size: inherit;\n\tmargin-left: 3px;\n\tfont-size: 14px;\n\t-webkit-transform: scaleX(-1) translateY(-1px);\n\t-moz-transform: scaleX(-1) translateY(-1px);\n\t-ms-transform: scaleX(-1) translateY(-1px);\n\t-o-transform: scaleX(-1) translateY(-1px);\n\ttransform: scaleX(-1) translateY(-1px);\n}\n\n::-webkit-input-placeholder {\n\tcolor: inherit;\n}\n\n::-moz-input-placeholder {\n\tcolor: inherit;\n}\n\n::-ms-input-placeholder {\n\tcolor: inherit;\n}\n\n\n::selection {\n\tbackground: #ec167f;\n\tcolor: #ffffff;\n}\n\n::-moz-selection {\n\tbackground: #ec167f;\n\tcolor: #ffffff;\n}\n\n::-webkit-selection {\n\tbackground: #ec167f;\n\tcolor: #ffffff;\n}\n\n.theme-btn {\n\tposition: relative;\n\ttransition: all 300ms ease;\n}\n\n.btn-style-one {\n\tposition: relative;\n\tpadding: 10px 30px;\n\tfont-size: 16px;\n\tline-height: 30px;\n\tcolor: #ffffff;\n\tfont-weight: 400;\n\ttext-align: center;\n\tbackground-color: #890025;\n\toverflow: hidden;\n\tborder-radius: 10px;\n}\n\n.btn-style-one .btn-title {\n\tposition: relative;\n}\n\n.btn-style-one:hover {\n\t-webkit-box-shadow: 0 10px 30px rgba(0, 0, 0, 0.10);\n\t-moz-box-shadow: 0 10px 30px rgba(0, 0, 0, 0.10);\n\t-ms-box-shadow: 0 10px 30px rgba(0, 0, 0, 0.10);\n\t-o-box-shadow: 0 10px 30px rgba(0, 0, 0, 0.10);\n\tbox-shadow: 0 10px 30px rgba(0, 0, 0, 0.10);\n}\n\n.btn-style-one:before {\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0;\n\theight: 100%;\n\twidth: 100%;\n\tcontent: \"\";\n\tbackground-color: #ffffff;\n\t-webkit-transform: scale(0, 1);\n\t-ms-transform: scale(0, 1);\n\ttransform: scale(0, 1);\n\t-webkit-transform-origin: top right;\n\t-ms-transform-origin: top right;\n\ttransform-origin: top right;\n\t-webkit-transition: transform 500ms cubic-bezier(0.860, 0.000, 0.070, 1.000);\n\t-moz-transition: transform 500ms cubic-bezier(0.860, 0.000, 0.070, 1.000);\n\t-o-transition: transform 500ms cubic-bezier(0.860, 0.000, 0.070, 1.000);\n\ttransition: transform 500ms cubic-bezier(0.860, 0.000, 0.070, 1.000);\n\t/* easeInOutQuint */\n\t-webkit-transition-timing-function: cubic-bezier(0.860, 0.000, 0.070, 1.000);\n\t-moz-transition-timing-function: cubic-bezier(0.860, 0.000, 0.070, 1.000);\n\t-o-transition-timing-function: cubic-bezier(0.860, 0.000, 0.070, 1.000);\n\ttransition-timing-function: cubic-bezier(0.860, 0.000, 0.070, 1.000);\n\t/* easeInOutQuint */\n}\n\n.btn-style-one:hover:before {\n\t-webkit-transform: scale(1, 1);\n\t-ms-transform: scale(1, 1);\n\ttransform: scale(1, 1);\n\t-webkit-transform-origin: bottom left;\n\t-ms-transform-origin: bottom left;\n\ttransform-origin: bottom left;\n}\n\n.btn-style-two {\n\tposition: relative;\n\tpadding: 10px 30px;\n\tfont-size: 16px;\n\tline-height: 30px;\n\tcolor: #ffffff;\n\tfont-weight: 400;\n\ttext-align: center;\n\tbackground-color: #eb2869;\n\toverflow: hidden;\n\tborder-radius: 10px;\n}\n\n.btn-style-two .btn-title {\n\tposition: relative;\n}\n\n.btn-style-two:hover {\n\tcolor: #faaC1D;\n\t-webkit-box-shadow: 0 10px 30px rgba(0, 0, 0, 0.10);\n\t-moz-box-shadow: 0 10px 30px rgba(0, 0, 0, 0.10);\n\t-ms-box-shadow: 0 10px 30px rgba(0, 0, 0, 0.10);\n\t-o-box-shadow: 0 10px 30px rgba(0, 0, 0, 0.10);\n\tbox-shadow: 0 10px 30px rgba(0, 0, 0, 0.10);\n}\n\n.btn-style-two:before {\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0;\n\theight: 100%;\n\twidth: 100%;\n\tcontent: \"\";\n\tbackground-color: #ffffff;\n\t-webkit-transform: scale(0, 1);\n\t-ms-transform: scale(0, 1);\n\ttransform: scale(0, 1);\n\t-webkit-transform-origin: top right;\n\t-ms-transform-origin: top right;\n\ttransform-origin: top right;\n\t-webkit-transition: transform 500ms cubic-bezier(0.860, 0.000, 0.070, 1.000);\n\t-moz-transition: transform 500ms cubic-bezier(0.860, 0.000, 0.070, 1.000);\n\t-o-transition: transform 500ms cubic-bezier(0.860, 0.000, 0.070, 1.000);\n\ttransition: transform 500ms cubic-bezier(0.860, 0.000, 0.070, 1.000);\n\t/* easeInOutQuint */\n\t-webkit-transition-timing-function: cubic-bezier(0.860, 0.000, 0.070, 1.000);\n\t-moz-transition-timing-function: cubic-bezier(0.860, 0.000, 0.070, 1.000);\n\t-o-transition-timing-function: cubic-bezier(0.860, 0.000, 0.070, 1.000);\n\ttransition-timing-function: cubic-bezier(0.860, 0.000, 0.070, 1.000);\n\t/* easeInOutQuint */\n}\n\n.btn-style-two:hover:before {\n\t-webkit-transform: scale(1, 1);\n\t-ms-transform: scale(1, 1);\n\ttransform: scale(1, 1);\n\t-webkit-transform-origin: bottom left;\n\t-ms-transform-origin: bottom left;\n\ttransform-origin: bottom left;\n}\n\n\n/* Button style three*/\n\n.btn-style-three {\n\tposition: relative;\n\tpadding: 10px 30px;\n\tfont-size: 16px;\n\tline-height: 30px;\n\tcolor: #ffffff;\n\tfont-weight: 400;\n\ttext-align: center;\n\tbackground-color: #FFA886;\n\toverflow: hidden;\n\tborder-radius: 10px;\n}\n\n.btn-style-three .btn-title {\n\tposition: relative;\n}\n\n.btn-style-three:hover {\n\tcolor: #1c94d2;\n\t-webkit-box-shadow: 0 10px 30px rgba(0, 0, 0, 0.10);\n\t-moz-box-shadow: 0 10px 30px rgba(0, 0, 0, 0.10);\n\t-ms-box-shadow: 0 10px 30px rgba(0, 0, 0, 0.10);\n\t-o-box-shadow: 0 10px 30px rgba(0, 0, 0, 0.10);\n\tbox-shadow: 0 10px 30px rgba(0, 0, 0, 0.10);\n}\n\n.btn-style-three:before {\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0;\n\theight: 100%;\n\twidth: 100%;\n\tcontent: \"\";\n\tbackground-color: #ffffff;\n\t-webkit-transform: scale(0, 1);\n\t-ms-transform: scale(0, 1);\n\ttransform: scale(0, 1);\n\t-webkit-transform-origin: top right;\n\t-ms-transform-origin: top right;\n\ttransform-origin: top right;\n\t-webkit-transition: transform 500ms cubic-bezier(0.860, 0.000, 0.070, 1.000);\n\t-moz-transition: transform 500ms cubic-bezier(0.860, 0.000, 0.070, 1.000);\n\t-o-transition: transform 500ms cubic-bezier(0.860, 0.000, 0.070, 1.000);\n\ttransition: transform 500ms cubic-bezier(0.860, 0.000, 0.070, 1.000);\n\t/* easeInOutQuint */\n\t-webkit-transition-timing-function: cubic-bezier(0.860, 0.000, 0.070, 1.000);\n\t-moz-transition-timing-function: cubic-bezier(0.860, 0.000, 0.070, 1.000);\n\t-o-transition-timing-function: cubic-bezier(0.860, 0.000, 0.070, 1.000);\n\ttransition-timing-function: cubic-bezier(0.860, 0.000, 0.070, 1.000);\n\t/* easeInOutQuint */\n}\n\n.btn-style-three:hover:before {\n\t-webkit-transform: scale(1, 1);\n\t-ms-transform: scale(1, 1);\n\ttransform: scale(1, 1);\n\t-webkit-transform-origin: bottom left;\n\t-ms-transform-origin: bottom left;\n\ttransform-origin: bottom left;\n}\n\n\n\n/* Button style four*/\n\n.btn-style-four {\n\tposition: relative;\n\tpadding: 10px 30px;\n\tfont-size: 16px;\n\tline-height: 30px;\n\tcolor: #ffffff;\n\tfont-weight: 400;\n\ttext-align: center;\n\tbackground-color: #24293d;\n\toverflow: hidden;\n\tborder-radius: 10px;\n}\n\n.btn-style-four .btn-title {\n\tposition: relative;\n}\n\n.btn-style-four:hover {\n\tcolor: #24293d;\n\t-webkit-box-shadow: 0 10px 30px rgba(0, 0, 0, 0.10);\n\t-moz-box-shadow: 0 10px 30px rgba(0, 0, 0, 0.10);\n\t-ms-box-shadow: 0 10px 30px rgba(0, 0, 0, 0.10);\n\t-o-box-shadow: 0 10px 30px rgba(0, 0, 0, 0.10);\n\tbox-shadow: 0 10px 30px rgba(0, 0, 0, 0.10);\n}\n\n.btn-style-four:before {\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0;\n\theight: 100%;\n\twidth: 100%;\n\tcontent: \"\";\n\tbackground-color: #ffffff;\n\t-webkit-transform: scale(0, 1);\n\t-ms-transform: scale(0, 1);\n\ttransform: scale(0, 1);\n\t-webkit-transform-origin: top right;\n\t-ms-transform-origin: top right;\n\ttransform-origin: top right;\n\t-webkit-transition: transform 500ms cubic-bezier(0.860, 0.000, 0.070, 1.000);\n\t-moz-transition: transform 500ms cubic-bezier(0.860, 0.000, 0.070, 1.000);\n\t-o-transition: transform 500ms cubic-bezier(0.860, 0.000, 0.070, 1.000);\n\ttransition: transform 500ms cubic-bezier(0.860, 0.000, 0.070, 1.000);\n\t-webkit-transition-timing-function: cubic-bezier(0.860, 0.000, 0.070, 1.000);\n\t-moz-transition-timing-function: cubic-bezier(0.860, 0.000, 0.070, 1.000);\n\t-o-transition-timing-function: cubic-bezier(0.860, 0.000, 0.070, 1.000);\n\ttransition-timing-function: cubic-bezier(0.860, 0.000, 0.070, 1.000);\n}\n\n.btn-style-four:hover:before {\n\t-webkit-transform: scale(1, 1);\n\t-ms-transform: scale(1, 1);\n\ttransform: scale(1, 1);\n\t-webkit-transform-origin: bottom left;\n\t-ms-transform-origin: bottom left;\n\ttransform-origin: bottom left;\n}\n\n/* List Style One */\n\n.list-style-one {\n\tposition: relative;\n}\n\n.list-style-one li {\n\tposition: relative;\n\tfont-size: 16px;\n\tline-height: 26px;\n\tcolor: #444444;\n\tfont-weight: 400;\n\tpadding-left: 35px;\n\tmargin-bottom: 10px;\n}\n\n.list-style-one li:before {\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0;\n\tfont-size: 16px;\n\tcontent: \"\\52\";\n\tfont-family: 'ElegantIcons';\n\tcolor: #e1137b;\n}\n\n/* List Style Two */\n\n.list-style-two {\n\tposition: relative;\n}\n\n.list-style-two li {\n\tposition: relative;\n\tfont-size: 16px;\n\tline-height: 30px;\n\tcolor: #888888;\n\tfont-weight: 400;\n\tpadding-left: 25px;\n\tmargin-bottom: 10px;\n}\n\n.list-style-two li:before {\n\tposition: absolute;\n\tleft: 0;\n\ttop: 12px;\n\theight: 6px;\n\twidth: 6px;\n\tbackground-color: #e1137b;\n\tcontent: \"\";\n}\n\n/* csign up field */\n.candidate-field {\n\twidth: 100%;\n}\n\n/* sign up field */\n/***\n\n====================================================================\n\tSocial Icons\n====================================================================\n\n ***/\n\n/*Social Icon One*/\n\n.social-icon-one {\n\tposition: relative;\n}\n\n.social-icon-one li {\n\tposition: relative;\n\tdisplay: inline-block;\n\tmargin-right: 8px;\n\tmargin-bottom: 10px;\n}\n\n.social-icon-one li:last-child {\n\tmargin-right: 0;\n}\n\n.social-icon-one li a .fab {\n\tposition: relative;\n\tdisplay: block;\n\theight: 40px;\n\twidth: 40px;\n\tline-height: 40px;\n\ttext-align: center;\n\tfont-size: 16px;\n\tcolor: #ffffff;\n\tborder-radius: 5px;\n\tbackground-color: #373851;\n\ttransition: all 900ms ease;\n\t-moz-transition: all 900ms ease;\n\t-webkit-transition: all 900ms ease;\n\t-ms-transition: all 900ms ease;\n\t-o-transition: all 900ms ease;\n}\n\n.social-icon-one li a:hover .fab {\n\ttransform: rotate(360deg);\n}\n\n.social-icon-one li a:hover .fab {\n\tbackground-color: #890025;\n\tborder-color: #890025;\n\tcolor: #ffffff;\n}\n\n/*Social Icon Two*/\n\n.social-icon-two {\n\tposition: relative;\n\tdisplay: block;\n}\n\n.social-icon-two li {\n\tposition: relative;\n\tdisplay: inline-block;\n\tmargin-right: 8px;\n\tmargin-bottom: 10px;\n}\n\n.social-icon-two li a .fab {\n\tposition: relative;\n\tdisplay: block;\n\theight: 40px;\n\twidth: 40px;\n\tline-height: 40px;\n\ttext-align: center;\n\tfont-size: 16px;\n\tborder: 1px solid #dddddd;\n\tbackground-color: #ffffff;\n\t-webkit-transition: all 300ms ease;\n\t-moz-transition: all 300ms ease;\n\t-ms-transition: all 300ms ease;\n\t-o-transition: all 300ms ease;\n\ttransition: all 300ms ease;\n}\n\n.social-icon-two li a:hover .fab {\n\tcolor: #ffffff;\n\tbackground-color: #d24c59;\n}\n\n/*Social Icon Three*/\n\n.social-icon-three {\n\tposition: relative;\n\tdisplay: block;\n}\n\n.social-icon-three li {\n\tposition: relative;\n\tdisplay: inline-block;\n\tmargin-left: 30px;\n\tmargin-bottom: 10px;\n}\n\n.social-icon-three li a {\n\tposition: relative;\n\tdisplay: block;\n\tline-height: 30px;\n\ttext-align: center;\n\tfont-size: 16px;\n\t-webkit-transition: all 300ms ease;\n\t-moz-transition: all 300ms ease;\n\t-ms-transition: all 300ms ease;\n\t-o-transition: all 300ms ease;\n\ttransition: all 300ms ease;\n}\n\n.social-icon-three li a:hover {\n\tcolor: #222222;\n}\n\n.theme_color {\n\tcolor: #d24c59;\n}\n\n.pull-left {\n\tfloat: left;\n}\n\n.pull-right {\n\tfloat: right;\n}\n\n.scroll-to-top {\n\tposition: fixed;\n\tbottom: 15px;\n\tright: 90px;\n\twidth: 40px;\n\theight: 40px;\n\tcolor: #ffffff;\n\tborder-radius: 5px;\n\tfont-size: 18px;\n\ttext-transform: uppercase;\n\tline-height: 40px;\n\ttext-align: center;\n\tz-index: 100;\n\tcursor: pointer;\n\tbackground: #890025;\n\tdisplay: none;\n\t-webkit-transition: all 300ms ease;\n\t-moz-transition: all 300ms ease;\n\t-ms-transition: all 300ms ease;\n\t-o-transition: all 300ms ease;\n\ttransition: all 300ms ease;\n}\n\n.tabs-box {\n\tposition: relative;\n}\n\n.tabs-box .tab {\n\tdisplay: none;\n}\n\n.tabs-box .tab.active-tab {\n\tdisplay: block;\n}\n\n.page-title {\n\tposition: relative;\n\ttext-align: center;\n\toverflow: hidden;\n\tz-index: 1;\n\tpadding: 120px 0;\n\tbackground-repeat: no-repeat;\n\tbackground-position: center bottom;\n\tbackground-size: cover;\n}\n\n.page-title h1 {\n\tposition: relative;\n\tdisplay: block;\n\tfont-size: 60px;\n\tcolor: #ffffff;\n\tline-height: 1em;\n\tfont-weight: 700;\n\tmargin-bottom: 10px;\n}\n\n.page-title .bread-crumb {\n\tposition: relative;\n}\n\n.page-title .bread-crumb li {\n\tposition: relative;\n\tdisplay: inline-block;\n\tfont-size: 18px;\n\tline-height: 30px;\n\tcolor: #ffffff;\n\tfont-weight: 500;\n\tcursor: default;\n\tpadding-right: 15px;\n\tmargin-right: 15px;\n}\n\n.page-title .bread-crumb li:before {\n\tposition: absolute;\n\tright: -3px;\n\tfont-size: 18px;\n\tline-height: 30px;\n\tcolor: #ffffff;\n\tfont-weight: 400;\n\tcontent: \"|\";\n}\n\n.page-title .bread-crumb li:last-child {\n\tpadding-right: 0;\n\tmargin-right: 0;\n}\n\n.page-title .bread-crumb li:last-child:before {\n\tdisplay: none;\n}\n\n.page-title .bread-crumb li a {\n\tcolor: #ffffff;\n\t-webkit-transition: all 300ms ease;\n\t-moz-transition: all 300ms ease;\n\t-ms-transition: all 300ms ease;\n\t-o-transition: all 300ms ease;\n\ttransition: all 300ms ease;\n}\n\n.page-title .bread-crumb li a:hover {\n\tcolor: #f0c52e;\n}\n\n.sec-title {\n\tposition: relative;\n\tmargin-bottom: 30px;\n}\n\n.sec-title .title {\n\tposition: relative;\n\tdisplay: block;\n\tfont-size: 16px;\n\tline-height: 1em;\n\tcolor: #ff8a01;\n\tfont-weight: 500;\n\tbackground: #ff8a01;\n\tbackground: -moz-linear-gradient(to left, #ff8a01, #890025 25%, #ff8a01 75%, #890025 100%);\n\n\tfilter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#F70068', endColorstr='#441066', GradientType=1);\n\tcolor: transparent;\n\t-webkit-background-clip: text;\n\t-webkit-text-fill-color: transparent;\n\ttext-transform: uppercase;\n\tletter-spacing: 5px;\n\tmargin-bottom: 15px;\n}\n\n.sec-title h2 {\n\tposition: relative;\n\tdisplay: inline-block;\n\tfont-size: 48px;\n\tline-height: 1.2em;\n\tcolor: #1e1f36;\n\tfont-weight: 700;\n}\n\n.sec-title .text {\n\tposition: relative;\n\tfont-size: 16px;\n\tline-height: 28px;\n\tcolor: #888888;\n\tmargin-top: 15px;\n}\n\n.sec-title.light h2,\n.sec-title.light .title {\n\tcolor: #ffffff;\n\t-webkit-text-fill-color: inherit;\n}\n\n\n\n.anim-icons {\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0;\n\tright: 0;\n\theight: 100%;\n\twidth: 100%;\n\tmax-width: 1170px;\n\tmargin: 0 auto;\n}\n\n/* .anim-icons.full-width {\n\tmax-width: 100%;\n} */\n\n.avatar-edit.kils {\n    bottom: inherit;\n    padding: 6px 6px;\n    width: 40px;\n    height: 40px;\n}\nlabel.pensil:hover {\n    background: #ff000000 !important;\n}\n.anim-icons .icon {\n\tposition: absolute;\n\tbackground-position: center;\n\tbackground-repeat: no-repeat;\n}\n\n.logo h6 {\n\tanimation: Color 4s linear infinite;\n\t-webkit-animation: Color 4s ease-in-out infinite;\n\tfont-size: 32px;\n}\n\n@keyframes Color {\n\t0% {\n\t\tcolor: #890025;\n\t}\n\n\t20% {\n\t\tcolor: #ea7207;\n\t}\n\n\t40% {\n\t\tcolor: #FFCE54;\n\t}\n\n\t60% {\n\t\tcolor: #FC6E51;\n\t}\n\n\t80% {\n\t\tcolor: #ED5565;\n\t}\n\n\t100% {\n\t\tcolor: #AC92EC;\n\t}\n}\n\n@-moz-keyframes Color {\n\t0% {\n\t\tcolor: #A0D468;\n\t}\n\n\t20% {\n\t\tcolor: #4FC1E9;\n\t}\n\n\t40% {\n\t\tcolor: #FFCE54;\n\t}\n\n\t60% {\n\t\tcolor: #FC6E51;\n\t}\n\n\t80% {\n\t\tcolor: #ED5565;\n\t}\n\n\t100% {\n\t\tcolor: #AC92EC;\n\t}\n}\n\n@-webkit-keyframes Color {\n\t0% {\n\t\tcolor: #A0D468;\n\t}\n\n\t20% {\n\t\tcolor: #4FC1E9;\n\t}\n\n\t40% {\n\t\tcolor: #FFCE54;\n\t}\n\n\t60% {\n\t\tcolor: #FC6E51;\n\t}\n\n\t80% {\n\t\tcolor: #ED5565;\n\t}\n\n\t100% {\n\t\tcolor: #AC92EC;\n\t}\n}\n\n.main-header {\n\t/* position: fixed; */\n\ttop: 0;\n\tleft: 0;\n\tz-index: 999;\n\twidth: 100%;\n\t-webkit-transition: all 300ms ease;\n\t-moz-transition: all 300ms ease;\n\t-ms-transition: all 300ms ease;\n\t-o-transition: all 300ms ease;\n\ttransition: all 300ms ease;\n}\n\n.main-header .main-box {\n\tposition: relative;\n\tpadding: 10px 0;\n\t-webkit-transition: all 300ms ease;\n\t-moz-transition: all 300ms ease;\n\t-ms-transition: all 300ms ease;\n\t-o-transition: all 300ms ease;\n\ttransition: all 300ms ease;\n\tbackground-color: #d79c80;\n}\n\n.main-header .logo-box {\n\tposition: relative;\n\tfloat: left;\n\t-webkit-transition: all 300ms ease;\n\t-moz-transition: all 300ms ease;\n\t-ms-transition: all 300ms ease;\n\t-o-transition: all 300ms ease;\n\ttransition: all 300ms ease;\n}\n\n.main-header .logo-box .logo img {\n\tdisplay: inline-block;\n\tmax-width: 100%;\n\ttransition: all 300ms ease;\n\twidth: 60px;\n\theight: 60px;\n\tobject-fit: cover;\n}\n\n.search-box-btn {\n\tdisplay: flex;\n\talign-items: center;\n}\n\n.main-header .nav-outer {\n\tposition: relative;\n\tfloat: right;\n\ttransition: all 600ms ease;\n\tpadding: 6px 10px;\n}\n\n.main-header .nav-outer .main-menu {\n\tposition: static;\n\tfloat: left;\n}\n\n.main-menu .navigation {\n\tposition: static;\n\tmargin: 0px;\n}\n\n.main-menu .navigation>li {\n\tposition: relative;\n\tfloat: left;\n\tmargin-left: 24px;\n\t-webkit-transition: all 300ms ease;\n\t-moz-transition: all 300ms ease;\n\t-ms-transition: all 300ms ease;\n\t-o-transition: all 300ms ease;\n\ttransition: all 300ms ease;\n}\n\n.main-menu .navigation>li>a {\n\tposition: relative;\n\tdisplay: block;\n\tfont-size: 16px;\n\tline-height: 30px;\n\tfont-weight: 500;\n\tpadding: 10px 0;\n\tcolor: #fff !important;\n\topacity: 1;\n\ttext-align: center;\n\t-webkit-transition: all 300ms ease;\n\t-moz-transition: all 300ms ease;\n\t-ms-transition: all 300ms ease;\n\t-o-transition: all 300ms ease;\n\ttransition: all 300ms ease;\n}\n\n.main-menu .navigation>li>a:before {\n\tposition: absolute;\n\tleft: 50%;\n\tbottom: 10px;\n\theight: 2px;\n\twidth: 0%;\n\tcontent: \"\";\n\t-webkit-transform: scale(-1);\n\t-moz-transform: scale(-1);\n\t-ms-transform: scale(-1);\n\t-o-transform: scale(-1);\n\ttransform: scale(-1);\n\tbackground: #ffa8B6;\n\t-webkit-transition: all 300ms ease;\n\t-moz-transition: all 300ms ease;\n\t-ms-transition: all 300ms ease;\n\t-o-transition: all 300ms ease;\n\ttransition: all 300ms ease;\n}\n\n.main-menu .navigation>li.current>a:before,\n.main-menu .navigation>li:hover>a:before {\n\tleft: 0;\n\twidth: 100%;\n}\n\n.main-menu .navigation>li>ul>li.dropdown>a:before {\n\tfont-family: 'Font Awesome 5 Free';\n\tcontent: \"\\f105\";\n\tposition: absolute;\n\tright: 25px;\n\ttop: 8px;\n\twidth: 10px;\n\theight: 20px;\n\tdisplay: block;\n\tline-height: 20px;\n\tfont-size: 16px;\n\tfont-weight: 900;\n\ttext-align: center;\n\tz-index: 5;\n}\n\n.main-menu .navigation>li>ul>li>ul>li.dropdown:hover>a:after {\n\tcolor: #ffffff;\n}\n\n.main-menu .navigation>li>ul {\n\tposition: absolute;\n\tleft: 0px;\n\ttop: 100%;\n\twidth: 250px;\n\tz-index: 100;\n\tdisplay: none;\n\topacity: 0;\n\tvisibility: hidden;\n\tpadding: 20px 0px;\n\tbackground: #ffffff;\n\tborder-radius: 3px;\n\t-webkit-transform-origin: top;\n\t-moz-transform-origin: top;\n\t-ms-transform-origin: top;\n\t-o-transform-origin: top;\n\ttransform-origin: top;\n\t-moz-transform: rotateX(90deg);\n\t-webkit-transform: rotateX(90deg);\n\t-ms-transform: rotateX(90deg);\n\t-o-transform: rotateX(90deg);\n\ttransform: rotateX(90deg);\n\tborder-bottom: 3px solid #f20487;\n\tborder-radius: 0 0 6px 6px;\n\t-webkit-box-shadow: 2px 2px 5px 1px rgba(0, 0, 0, 0.05), -2px 0px 5px 1px rgba(0, 0, 0, 0.05);\n\t-ms-box-shadow: 2px 2px 5px 1px rgba(0, 0, 0, 0.05), -2px 0px 5px 1px rgba(0, 0, 0, 0.05);\n\t-o-box-shadow: 2px 2px 5px 1px rgba(0, 0, 0, 0.05), -2px 0px 5px 1px rgba(0, 0, 0, 0.05);\n\t-moz-box-shadow: 2px 2px 5px 1px rgba(0, 0, 0, 0.05), -2px 0px 5px 1px rgba(0, 0, 0, 0.05);\n\tbox-shadow: 2px 2px 5px 1px rgba(0, 0, 0, 0.05), -2px 0px 5px 1px rgba(0, 0, 0, 0.05);\n}\n\n.main-menu .navigation>li>ul:before {\n\tposition: absolute;\n\tcontent: '';\n\tleft: 0px;\n\ttop: -30px;\n\twidth: 100%;\n\theight: 30px;\n\tdisplay: block;\n}\n\n.main-menu .navigation>li>ul.from-right {\n\tleft: auto;\n\tright: 0px;\n}\n\n.main-menu .navigation>li>ul>li {\n\tposition: relative;\n\twidth: 115%;\n\tmargin-bottom: 0px;\n}\n\n.main-menu .navigation>li>ul>li:last-child {\n\tmargin-bottom: 0px;\n}\n\n.main-menu .navigation>li>ul>li>a {\n\tposition: relative;\n\tdisplay: block;\n\tpadding: 5px 25px;\n\tline-height: 24px;\n\tfont-weight: 400;\n\tfont-size: 16px;\n\ttext-transform: capitalize;\n\tcolor: #222222;\n\ttransition: all 500ms ease;\n\t-moz-transition: all 500ms ease;\n\t-webkit-transition: all 500ms ease;\n\t-ms-transition: all 500ms ease;\n\t-o-transition: all 500ms ease;\n}\n\n.main-menu .navigation>li>ul>li:hover>a {\n\tcolor: #FFA886;\n}\n\n.main-menu .navigation>li>ul>li>ul {\n\tposition: absolute;\n\tleft: 100%;\n\ttop: 100%;\n\twidth: 220px;\n\tz-index: 100;\n\tdisplay: none;\n\topacity: 0;\n\tvisibility: hidden;\n\tmargin-top: -50px;\n\tpadding: 20px 0px;\n\tbackground: #ffffff;\n\t-webkit-transform-origin: top;\n\t-moz-transform-origin: top;\n\t-ms-transform-origin: top;\n\t-o-transform-origin: top;\n\ttransform-origin: top;\n\t-webkit-transform: rotateX(90deg);\n\t-moz-transform: rotateX(90deg);\n\t-ms-transform: rotateX(90deg);\n\t-o-transform: rotateX(90deg);\n\ttransform: rotateX(90deg);\n\tborder-bottom: 3px solid #f20487;\n\tborder-radius: 0 0 6px 6px;\n\t-webkit-box-shadow: 2px 2px 5px 1px rgba(0, 0, 0, 0.05), -2px 0px 5px 1px rgba(0, 0, 0, 0.05);\n\t-ms-box-shadow: 2px 2px 5px 1px rgba(0, 0, 0, 0.05), -2px 0px 5px 1px rgba(0, 0, 0, 0.05);\n\t-o-box-shadow: 2px 2px 5px 1px rgba(0, 0, 0, 0.05), -2px 0px 5px 1px rgba(0, 0, 0, 0.05);\n\t-moz-box-shadow: 2px 2px 5px 1px rgba(0, 0, 0, 0.05), -2px 0px 5px 1px rgba(0, 0, 0, 0.05);\n\tbox-shadow: 2px 2px 5px 1px rgba(0, 0, 0, 0.05), -2px 0px 5px 1px rgba(0, 0, 0, 0.05);\n}\n\n.main-menu .navigation>li>ul>li>ul.from-right {\n\tleft: auto;\n\tright: 0px;\n}\n\n.main-menu .navigation>li>ul>li>ul>li {\n\tposition: relative;\n\twidth: 100%;\n\tmargin-bottom: 0px;\n}\n\n.main-menu .navigation>li>ul>li>ul>li:last-child {\n\tmargin-bottom: 0px;\n}\n\n.main-menu .navigation>li>ul>li>ul>li>a {\n\tposition: relative;\n\tdisplay: block;\n\tpadding: 5px 25px;\n\tline-height: 24px;\n\tfont-weight: 400;\n\tfont-size: 16px;\n\ttext-transform: capitalize;\n\tcolor: #222222;\n\ttransition: all 500ms ease;\n\t-moz-transition: all 500ms ease;\n\t-webkit-transition: all 500ms ease;\n\t-ms-transition: all 500ms ease;\n\t-o-transition: all 500ms ease;\n}\n\n.main-menu .navigation>li>ul>li>ul>li:hover>a {\n\tcolor: #e1137b;\n}\n\n.main-menu .navigation>li.dropdown:hover>ul {\n\tvisibility: visible;\n\topacity: 1;\n\t-webkit-transform: rotateX(0deg);\n\t-moz-transform: rotateX(0deg);\n\t-ms-transform: rotateX(0deg);\n\t-o-transform: rotateX(0deg);\n\ttransform: rotateX(0deg);\n\t-webkit-transition: all 500ms ease;\n\t-moz-transition: all 500ms ease;\n\t-ms-transition: all 500ms ease;\n\t-o-transition: all 500ms ease;\n\ttransition: all 500ms ease;\n}\n\n.main-menu .navigation li>ul>li.dropdown:hover>ul {\n\tvisibility: visible;\n\topacity: 1;\n\t-moz-transform: rotateX(0deg);\n\t-webkit-transform: rotateX(0deg);\n\t-ms-transform: rotateX(0deg);\n\t-o-transform: rotateX(0deg);\n\ttransform: rotateX(0deg);\n\t-webkit-transition: all 500ms ease;\n\t-moz-transition: all 500ms ease;\n\t-ms-transition: all 500ms ease;\n\t-o-transition: all 500ms ease;\n\ttransition: all 500ms ease;\n}\n\n.main-menu .navbar-collapse>ul li.dropdown .dropdown-btn {\n\tposition: absolute;\n\tright: 10px;\n\ttop: 6px;\n\twidth: 30px;\n\theight: 30px;\n\ttext-align: center;\n\tcolor: #ffffff;\n\tline-height: 28px;\n\tborder: 1px solid #ffffff;\n\tbackground-size: 20px;\n\tcursor: pointer;\n\tz-index: 5;\n\tdisplay: none;\n}\n\n/* Outer box */\n.main-header .outer-box {\n\tposition: relative;\n\tfloat: right;\n\tmargin-left: 20px;\n}\n\n.main-header .search-box-outer {\n\tposition: relative;\n\tfloat: left;\n\t-webkit-transition: all 300ms ease;\n\t-moz-transition: all 300ms ease;\n\t-ms-transition: all 300ms ease;\n\t-o-transition: all 300ms ease;\n\ttransition: all 300ms ease;\n}\n\n.main-header .search-box-outer2 {\n\tposition: relative;\n\tfloat: left;\n\t-webkit-transition: all 300ms ease;\n\t-moz-transition: all 300ms ease;\n\t-ms-transition: all 300ms ease;\n\t-o-transition: all 300ms ease;\n\ttransition: all 300ms ease;\n}\n.nav-outer.clearfix {\n    display: flex;\n    align-items: center;\n}\n.main-header .search-box-btn {\n\tposition: relative;\n\tfloat: left;\n\tfont-size: 19px;\n\tline-height: 30px;\n\tcursor: pointer;\n\tbackground: none;\n\tcolor: #ffffff;\n\tfont-weight: 600;\n\tcursor: pointer;\n\tmargin-top: 8px;\n\ttransition: all 300ms ease;\n}\n\n.main-header .search-box-btn2 {\n\tposition: relative;\n\tfloat: left;\n\tfont-size: 24px;\n\tline-height: 30px;\n\tcursor: pointer;\n\tbackground: none;\n\tcolor: #ffffff;\n\tfont-weight: 400;\n\tcursor: pointer;\n\tmargin-top: 10px;\n\t-webkit-transition: all 300ms ease;\n\t-moz-transition: all 300ms ease;\n\t-ms-transition: all 300ms ease;\n\t-o-transition: all 300ms ease;\n\ttransition: all 300ms ease;\n}\n\n.main-header .search-box-btn3 {\n\tposition: relative;\n\tfloat: left;\n\tfont-size: 24px;\n\tline-height: 30px;\n\tcursor: pointer;\n\tbackground: none;\n\tcolor: #ffffff;\n\tfont-weight: 400;\n\tcursor: pointer;\n\tmargin-top: 10px;\n\t-webkit-transition: all 300ms ease;\n\t-moz-transition: all 300ms ease;\n\t-ms-transition: all 300ms ease;\n\t-o-transition: all 300ms ease;\n\ttransition: all 300ms ease;\n}\n\n.main-header .search-box-btn4 {\n\tposition: relative;\n\tfloat: left;\n\tfont-size: 24px;\n\tline-height: 30px;\n\tcursor: pointer;\n\tbackground: none;\n\tcolor: #ffffff;\n\tfont-weight: 400;\n\tcursor: pointer;\n\tmargin-top: 10px;\n\t-webkit-transition: all 300ms ease;\n\t-moz-transition: all 300ms ease;\n\t-ms-transition: all 300ms ease;\n\t-o-transition: all 300ms ease;\n\ttransition: all 300ms ease;\n}\n\n.main-header .search-box-btn5 {\n\tposition: relative;\n\tfloat: left;\n\tfont-size: 24px;\n\tline-height: 30px;\n\tcursor: pointer;\n\tbackground: none;\n\tcolor: #ffffff;\n\tfont-weight: 400;\n\tcursor: pointer;\n\tmargin-top: 10px;\n\t-webkit-transition: all 300ms ease;\n\t-moz-transition: all 300ms ease;\n\t-ms-transition: all 300ms ease;\n\t-o-transition: all 300ms ease;\n\ttransition: all 300ms ease;\n}\n\n.main-header .search-box-btn6 {\n\tposition: relative;\n\tfloat: left;\n\tfont-size: 24px;\n\tline-height: 30px;\n\tcursor: pointer;\n\tbackground: none;\n\tcolor: #ffffff;\n\tfont-weight: 400;\n\tcursor: pointer;\n\tmargin-top: 10px;\n\t-webkit-transition: all 300ms ease;\n\t-moz-transition: all 300ms ease;\n\t-ms-transition: all 300ms ease;\n\t-o-transition: all 300ms ease;\n\ttransition: all 300ms ease;\n}\n\n.dropdown-toggle::after {\n\tdisplay: none;\n}\n\n.main-header .search-box-outer .dropdown-menu {\n\ttop: 44px !important;\n\tleft: auto !important;\n\tright: 0;\n\tpadding: 0px;\n\twidth: 280px;\n\tborder-radius: 0px;\n\t-webkit-transform: none !important;\n\t-ms-transform: none !important;\n\ttransform: none !important;\n\tborder-top: 3px solid #df6512;\n}\n\n.main-header .search-box-outer2 .dropdown-menu {\n\ttop: 44px !important;\n\tleft: auto !important;\n\tright: 0;\n\tpadding: 0px;\n\twidth: 280px;\n\tborder-radius: 0px;\n\t-webkit-transform: none !important;\n\t-ms-transform: none !important;\n\ttransform: none !important;\n\tborder-top: 3px solid #df6512;\n}\n\n.main-header .search-panel .form-container {\n\tpadding: 25px 20px;\n}\n\n.main-header .search-panel .form-group {\n\tposition: relative;\n\tmargin: 0px;\n}\n\n.main-header .search-panel input[type=\"text\"],\n.main-header .search-panel input[type=\"number\"],\n.main-header .search-panel input[type=\"search\"],\n.main-header .search-panel input[type=\"password\"],\n.main-header .search-panel select {\n\tdisplay: block;\n\twidth: 100%;\n\tline-height: 24px;\n\tpadding: 7px 40px 7px 15px;\n\theight: 40px;\n\tfont-size: 14px;\n\tborder: 1px solid #e0e0e0;\n\tbackground: #ffffff;\n}\n\n.main-header .search-panel input:focus,\n.main-header .search-panel select:focus {\n\tborder-color: #25262c;\n}\n\n.main-header .search-panel .search-btn {\n\tposition: absolute;\n\tright: 0px;\n\ttop: 0px;\n\twidth: 40px;\n\theight: 40px;\n\ttext-align: center;\n\tcolor: #555555;\n\tfont-size: 12px;\n\tbackground: none;\n\tcursor: pointer;\n}\n\n.main-header .outer-box .btn-box {\n\tposition: relative;\n\tfloat: right;\n\tpadding: 5px 0;\n\tmargin-left: 20px;\n}\n\n.main-header .outer-box .btn-box a {\n\tposition: relative;\n\tfloat: right;\n\tborder-radius: 50px;\n\tline-height: 20px;\n\tpadding: 6px 18px;\n\tfont-size: 14px;\n}\n\n.nav-outer .mobile-nav-toggler {\n\tposition: relative;\n\tfloat: right;\n\tfont-size: 40px;\n\tline-height: 50px;\n\tcursor: pointer;\n\tcolor: #e1137b;\n\tmargin: 7px 0px 2px;\n\tdisplay: none;\n}\n\n.nav-outer .mobileapp_Icon {\n\tdisplay: none;\n}\n\n.nav-outer .mobileapp_Icon1 {\n\tdisplay: none;\n}\n\n/***\n\n====================================================================\n\tHeader Style Two\n====================================================================\n\n***/\n\n.header-span {\n\theight: 90px;\n\tdisplay: block;\n}\n\n\n.header-style-two .main-box {\n\tpadding: 0;\n\tbox-shadow: 0 0 30px rgba(0, 0, 0, 0.10);\n}\n\n.header-style-two .outer-box,\n.header-style-two .logo-box,\n.header-style-two .main-menu .navigation>li {\n\tpadding: 10px 0;\n\t-webkit-transition: all 300ms ease;\n\t-moz-transition: all 300ms ease;\n\t-ms-transition: all 300ms ease;\n\t-o-transition: all 300ms ease;\n\ttransition: all 300ms ease;\n}\n\n.header-style-two .search-box-btn,\n.header-style-two .main-menu .navigation>li>a {\n\tcolor: #3f4161;\n}\n\n.header-style-two .search-box-btn2,\n.header-style-two .main-menu .navigation>li>a {\n\tcolor: #3f4161;\n}\n\n.header-style-two .search-box-btn3,\n.header-style-two .main-menu .navigation>li>a {\n\tcolor: #3f4161;\n}\n\n.header-style-two .search-box-btn4,\n.header-style-two .main-menu .navigation>li>a {\n\tcolor: #3f4161;\n}\n\n.header-style-two .search-box-btn5,\n.header-style-two .main-menu .navigation>li>a {\n\tcolor: #3f4161;\n}\n\n.header-style-two .search-box-btn6,\n.header-style-two .main-menu .navigation>li>a {\n\tcolor: #3f4161;\n}\n\n.header-style-two.fixed-header {\n\tbox-shadow: 0 0 30px rgba(0, 0, 0, 0.10);\n}\n\n.main-header.header-style-two.fixed-header .main-box {\n\tbackground-color: #ffffff;\n\tpadding: 0;\n}\n\n.header-style-two.fixed-header .outer-box,\n.header-style-two.fixed-header .logo-box,\n.header-style-two.fixed-header .main-menu .navigation>li {\n\tpadding: 10px 0;\n}\n\n/***\n\n====================================================================\n\tHeader Style Three\n====================================================================\n\n***/\n\n.header-style-three .main-menu .navigation>li {\n\tmargin-left: 35px;\n}\n\n.header-style-three .nav-outer {\n\tfloat: left;\n}\n\n.header-style-three .nav-outer .main-menu {\n\tmargin-left: 45px;\n}\n\n.header-style-three .outer-box {\n\tposition: relative;\n\tfloat: right;\n}\n\n.header-style-three .outer-box .btn-box a {\n\tborder-radius: 3px;\n}\n\n/***\n\n====================================================================\n\t\tFixed Header\n====================================================================\n\n***/\n\n.main-header.fixed-header .main-box {\n\tpadding: 10px 0;\n\tbackground-color: #d79c80;\n}\n\n/***\n\n====================================================================\n\t\t\tMobile Menu\n====================================================================\n\n***/\n\n.mobile-menu {\n\tposition: fixed;\n\tright: 0;\n\ttop: 0;\n\twidth: 100%;\n\tpadding-right: 30px;\n\tmax-width: 100%;\n\theight: 100%;\n\topacity: 0;\n\tvisibility: hidden;\n\tz-index: 999999;\n}\n\n.mobile-menu .nav-logo {\n\tposition: relative;\n\tpadding: 20px 20px;\n\ttext-align: left;\n}\n\n.mobile-menu .nav-logo img {\n\tmax-width: 200px;\n}\n\n.mobile-menu-visible {\n\toverflow: hidden;\n}\n\n.mobile-menu-visible .mobile-menu {\n\topacity: 1;\n\tvisibility: visible;\n}\n\n.mobile-menu .menu-backdrop {\n\tposition: fixed;\n\tright: 0;\n\ttop: 0;\n\twidth: 100%;\n\theight: 100%;\n\tz-index: 1;\n\topacity: 0;\n}\n\n.mobile-menu-visible .mobile-menu .menu-backdrop {\n\topacity: 1;\n\tvisibility: visible;\n}\n\n.mobile-menu .menu-box {\n\tposition: absolute;\n\tleft: 0px;\n\ttop: 0px;\n\twidth: 100%;\n\theight: 100%;\n\tmax-height: 100%;\n\toverflow-y: auto;\n\tbackground: #ffffff;\n\tpadding: 0px 0px;\n\tz-index: 5;\n\topacity: 0;\n\tborder-radius: 0px;\n\tvisibility: hidden;\n\t-webkit-transform: scale(0);\n\t-moz-transform: scale(0);\n\t-ms-transform: scale(0);\n\t-o-transform: scale(0);\n\ttransform: scale(0);\n\t-webkit-transform-origin: top right;\n\t-moz-transform-origin: top right;\n\t-ms-transform-origin: top right;\n\t-o-transform-origin: top right;\n\ttransform-origin: top right;\n\t-webkit-transition: all 400ms ease;\n\t-moz-transition: all 400ms ease;\n\t-ms-transition: all 400ms ease;\n\t-o-transition: all 400ms ease;\n\ttransition: all 400ms ease;\n}\n\n.mobile-menu-visible .mobile-menu .menu-box {\n\topacity: 1;\n\tvisibility: visible;\n\t-webkit-transform: scale(1);\n\t-moz-transform: scale(1);\n\t-ms-transform: scale(1);\n\t-o-transform: scale(1);\n\ttransform: scale(1);\n}\n\n.btn-primary:not(:disabled):not(.disabled).active:focus,\n.btn-primary:not(:disabled):not(.disabled):active:focus,\n.show>.btn-primary.dropdown-toggle:focus {\n\tbox-shadow: 0 0 0 0.2rem rgb(0 123 255 / 0%);\n}\n\n.btn-primary:not(:disabled):not(.disabled).active,\n.btn-primary:not(:disabled):not(.disabled):active,\n.show>.btn-primary.dropdown-toggle {\n\tcolor: #fff;\n\tbackground-color: #890025;\n\tborder-color: #890025;\n}\n\n.clikcxs {\n\topacity: 0;\n\tposition: absolute;\n\twidth: 109px;\n\ttop: 3px;\n}\n\n\n.btn:focus-visible {\n\n\n\tbox-shadow: 0px 0px 0px 0px;\n}\n\n.mobile-menu .close-btn {\n\tposition: absolute;\n\tright: 15px;\n\ttop: 25px;\n\tline-height: 30px;\n\twidth: 30px;\n\ttext-align: center;\n\tfont-size: 14px;\n\tcolor: #ffffff;\n\tbackground-color: #e1137b;\n\tcursor: pointer;\n\tz-index: 10;\n\t-webkit-transition: all 0.5s ease;\n\t-moz-transition: all 0.5s ease;\n\t-ms-transition: all 0.5s ease;\n\t-o-transition: all 0.5s ease;\n\ttransition: all 0.5s ease;\n\t-webkit-transform: translateY(-50px);\n\t-ms-transform: translateY(-50px);\n\ttransform: translateY(-50px);\n}\n\n.mobile-menu-visible .mobile-menu .close-btn {\n\t-webkit-transform: translateY(0px);\n\t-ms-transform: translateY(0px);\n\ttransform: translateY(0px);\n}\n\n.mobile-menu .close-btn:hover {\n\topacity: 0.50;\n}\n\n.mobile-menu .navigation {\n\tposition: relative;\n\tdisplay: block;\n\tborder-top: 1px solid rgba(0, 0, 0, 0.10);\n}\n\n.mobile-menu .navigation li {\n\tposition: relative;\n\tdisplay: block;\n\tborder-bottom: 1px solid rgba(0, 0, 0, 0.10);\n}\n\n.mobile-menu .navigation li>ul>li:last-child {\n\tborder-bottom: none;\n}\n\n.mobile-menu .navigation li>ul>li:first-child {\n\tborder-top: 1px solid rgba(0, 0, 0, 0.10);\n}\n\n.mobile-menu .navigation li>a {\n\tposition: relative;\n\tdisplay: block;\n\tline-height: 24px;\n\tpadding: 10px 20px;\n\tfont-size: 16px;\n\tcolor: #404040;\n\tfont-weight: 600;\n\ttext-transform: capitalize;\n}\n\n.mobile-menu .navigation li:hover>a,\n.mobile-menu .navigation li.current>a {\n\tcolor: #e1137b;\n}\n\n.mobile-menu .navigation li.dropdown .dropdown-btn {\n\tposition: absolute;\n\tright: 0px;\n\ttop: 0px;\n\twidth: 44px;\n\theight: 44px;\n\ttext-align: center;\n\tfont-size: 16px;\n\tline-height: 44px;\n\tcolor: #404040;\n\tcursor: pointer;\n\tz-index: 5;\n}\n\n.mobile-menu .navigation li.dropdown .dropdown-btn:after {\n\tcontent: '';\n\tposition: absolute;\n\tleft: 0px;\n\ttop: 10px;\n\twidth: 1px;\n\theight: 24px;\n\tborder-left: 1px solid rgba(0, 0, 0, 0.10);\n}\n\n.mobile-menu .navigation li>ul,\n.mobile-menu .navigation li>ul>li>ul {\n\tdisplay: none;\n}\n\n/***\n\n====================================================================\n\t\tBanner Section\n====================================================================\n\n***/\n\n.banner-section {\n\tposition: relative;\n}\n\n.banner-carousel {\n\tposition: relative;\n}\n\n.banner-carousel .slide-item {\n\tposition: relative;\n\tbackground-repeat: no-repeat;\n\tbackground-position: center;\n\tbackground-size: cover;\n\tpadding: 220px 0 100px;\n\ttext-align: center;\n}\n\n.banner-carousel .slide-item:before {\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0;\n\theight: 100%;\n\twidth: 100%;\n\t/*  */\n\n\tcontent: \"\";\n}\n\n.banner-carousel .content-box {\n\tposition: relative;\n}\n\n.banner-carousel .content-box .title {\n\tdisplay: block;\n\tfont-size: 28px;\n\tcolor: #faaC1D;\n\tfont-weight: 500;\n\tmargin-bottom: 25px;\n\topacity: 0;\n\t-webkit-transform: translateY(100px);\n\t-moz-transform: translateY(100px);\n\t-ms-transform: translateY(100px);\n\t-o-transform: translateY(100px);\n\ttransform: translateY(100px);\n\t-webkit-transition: all 500ms ease;\n\t-moz-transition: all 500ms ease;\n\t-ms-transition: all 500ms ease;\n\t-o-transition: all 500ms ease;\n\ttransition: all 500ms ease;\n}\n\n.banner-carousel .active .content-box .title {\n\topacity: 1;\n\t-webkit-transform: translateY(0);\n\t-moz-transform: translateY(0);\n\t-ms-transform: translateY(0);\n\t-o-transform: translateY(0);\n\ttransform: translateY(0);\n}\n\n.banner-carousel .content-box h2 {\n\tdisplay: block;\n\tfont-size: 54px;\n\tline-height: 1.2em;\n\tcolor: #ffffff;\n\tfont-weight: 700;\n\tmargin-bottom: 30px;\n\topacity: 0;\n\t-webkit-transform: translateY(100px);\n\t-moz-transform: translateY(100px);\n\t-ms-transform: translateY(100px);\n\t-o-transform: translateY(100px);\n\ttransform: translateY(100px);\n\t-webkit-transition: all 500ms ease;\n\t-moz-transition: all 500ms ease;\n\t-ms-transition: all 500ms ease;\n\t-o-transition: all 500ms ease;\n\ttransition: all 500ms ease;\n}\n\n.banner-carousel .active .content-box h2 {\n\topacity: 1;\n\t-webkit-transform: translateY(0);\n\t-moz-transform: translateY(0);\n\t-ms-transform: translateY(0);\n\t-o-transform: translateY(0);\n\ttransform: translateY(0);\n\t-webkit-transition-delay: 300ms;\n\t-moz-transition-delay: 300ms;\n\t-ms-transition-delay: 300ms;\n\t-o-transition-delay: 300ms;\n\ttransition-delay: 300ms;\n}\n\n.banner-carousel .content-box .info-list {\n\tposition: relative;\n\tmargin-bottom: 45px;\n\topacity: 0;\n\t-webkit-transform: translateY(100px);\n\t-moz-transform: translateY(100px);\n\t-ms-transform: translateY(100px);\n\t-o-transform: translateY(100px);\n\ttransform: translateY(100px);\n\t-webkit-transition: all 500ms ease;\n\t-moz-transition: all 500ms ease;\n\t-ms-transition: all 500ms ease;\n\t-o-transition: all 500ms ease;\n\ttransition: all 500ms ease;\n}\n\n.banner-carousel .active .content-box .info-list {\n\topacity: 1;\n\t-webkit-transform: translateY(0);\n\t-moz-transform: translateY(0);\n\t-ms-transform: translateY(0);\n\t-o-transform: translateY(0);\n\ttransform: translateY(0);\n\t-webkit-transition-delay: 600ms;\n\t-moz-transition-delay: 600ms;\n\t-ms-transition-delay: 600ms;\n\t-o-transition-delay: 600ms;\n\ttransition-delay: 600ms;\n}\n\n.banner-carousel .content-box .info-list li {\n\tposition: relative;\n\tdisplay: inline-block;\n\tfont-size: 18px;\n\tline-height: 26px;\n\tcolor: #ffffff;\n\tfont-weight: 400;\n\tmargin: 0 10px;\n\ttext-transform: uppercase;\n}\n\n.banner-carousel .content-box .info-list li .icon {\n\t/* color: #faaC1D; */\n\tmargin-right: 10px;\n\tfloat: left;\n\tfont-size: 18px;\n\tline-height: 26px;\n}\n\n.banner-carousel .content-box .btn-box {\n\topacity: 0;\n\t-webkit-transform: translateY(100px);\n\t-moz-transform: translateY(100px);\n\t-ms-transform: translateY(100px);\n\t-o-transform: translateY(100px);\n\ttransform: translateY(100px);\n\t-webkit-transition: all 500ms ease;\n\t-moz-transition: all 500ms ease;\n\t-ms-transition: all 500ms ease;\n\t-o-transition: all 500ms ease;\n\ttransition: all 500ms ease;\n}\n\n.banner-carousel .active .content-box .btn-box {\n\topacity: 1;\n\t-webkit-transform: translateY(0);\n\t-moz-transform: translateY(0);\n\t-ms-transform: translateY(0);\n\t-o-transform: translateY(0);\n\ttransform: translateY(0);\n\t-webkit-transition-delay: 900ms;\n\t-moz-transition-delay: 900ms;\n\t-ms-transition-delay: 900ms;\n\t-o-transition-delay: 900ms;\n\ttransition-delay: 900ms;\n}\n\n.banner-carousel .owl-nav {\n\tposition: absolute;\n\tleft: 0;\n\ttop: 50%;\n\twidth: 100%;\n}\n\n.banner-carousel .owl-next,\n.banner-carousel .owl-prev {\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0;\n\theight: 100px;\n\twidth: 30px;\n\tcolor: #ffffff;\n\tbackground-color: rgba(255, 255, 255, 0.10);\n\tfont-size: 20px;\n\tline-height: 100px;\n\ttext-align: center;\n\t-webkit-transition: all 500ms ease;\n\t-moz-transition: all 500ms ease;\n\t-ms-transition: all 500ms ease;\n\t-o-transition: all 500ms ease;\n\ttransition: all 500ms ease;\n}\n\n.banner-carousel .owl-next {\n\tleft: auto;\n\tright: 0;\n}\n\n.banner-carousel .owl-next:hover,\n.banner-carousel .owl-prev:hover {\n\tbackground-color: rgba(255, 255, 255, .90);\n\tcolor: #222222;\n}\n\n/***\n\n====================================================================\n\t\tBanner Conference\n====================================================================\n\n***/\n\n.banner-conference {\n\tposition: relative;\n\tpadding: 200px 0;\n\toverflow: hidden;\n}\n\n\n\n\n\n\n.banner-conference .icons {\n\tposition: absolute;\n\tleft: 0px;\n\ttop: 0px;\n\tright: 0px;\n\tbottom: 0px;\n}\n\n.banner-conference .icons .icon-one {\n\tposition: absolute;\n\tleft: 10% !important;\n\ttop: 17% !important;\n\twidth: 12px;\n\theight: 12px;\n\tdisplay: inline-block;\n\tbackground-repeat: no-repeat;\n}\n\n.banner-conference .icons .icon-two {\n\tposition: absolute;\n\tleft: 35% !important;\n\ttop: 25% !important;\n\twidth: 16px;\n\theight: 16px;\n\tdisplay: inline-block;\n\tbackground-repeat: no-repeat;\n}\n\n.banner-conference .icons .icon-three {\n\tposition: absolute;\n\tleft: 6% !important;\n\ttop: 58% !important;\n\twidth: 34px;\n\theight: 10px;\n\tdisplay: inline-block;\n\tbackground-repeat: no-repeat;\n}\n\n.banner-conference .icons .icon-four {\n\tposition: absolute;\n\tleft: 56% !important;\n\ttop: 60% !important;\n\twidth: 34px;\n\theight: 20px;\n\tdisplay: inline-block;\n\tbackground-repeat: no-repeat;\n}\n\n.banner-conference .icons .icon-five {\n\tposition: absolute;\n\tleft: 79% !important;\n\ttop: 25% !important;\n\twidth: 35px;\n\theight: 16px;\n\tdisplay: inline-block;\n\tbackground-repeat: no-repeat;\n}\n\n.banner-conference .icons .icon-six {\n\tposition: absolute;\n\tleft: 90% !important;\n\ttop: 88% !important;\n\twidth: 20px;\n\theight: 20px;\n\tdisplay: inline-block;\n\tbackground-repeat: no-repeat;\n}\n\n.banner-conference .icons .icon-seven {\n\tposition: absolute;\n\tleft: 80% !important;\n\ttop: 60% !important;\n\twidth: 20px;\n\theight: 20px;\n\tdisplay: inline-block;\n\tbackground-repeat: no-repeat;\n}\n\n.banner-conference .icons .icon-eight {\n\tposition: absolute;\n\tleft: 52% !important;\n\ttop: 40% !important;\n\twidth: 12px;\n\theight: 12px;\n\tdisplay: inline-block;\n\tbackground-repeat: no-repeat;\n}\n\n.banner-conference .icons .icon-nine {\n\tposition: absolute;\n\tleft: 52% !important;\n\ttop: 12% !important;\n\twidth: 16px;\n\theight: 16px;\n\tdisplay: inline-block;\n\tbackground-repeat: no-repeat;\n}\n\n.banner-conference .icons .icon-ten {\n\tposition: absolute;\n\tleft: 34% !important;\n\ttop: 68% !important;\n\twidth: 34px;\n\theight: 10px;\n\tdisplay: inline-block;\n\tbackground-repeat: no-repeat;\n}\n\n.banner-conference .icons .icon-eleven {\n\tposition: absolute;\n\tleft: 89% !important;\n\ttop: 80% !important;\n\twidth: 34px;\n\theight: 20px;\n\tdisplay: inline-block;\n\tbackground-repeat: no-repeat;\n}\n\n.banner-conference .icons .icon-twelve {\n\tposition: absolute;\n\tleft: 69% !important;\n\ttop: 70% !important;\n\twidth: 35px;\n\theight: 16px;\n\tdisplay: inline-block;\n\tbackground-repeat: no-repeat;\n}\n\n.banner-conference .icons .icon-thirteen {\n\tposition: absolute;\n\tleft: 200% !important;\n\ttop: 88% !important;\n\twidth: 20px;\n\theight: 20px;\n\tdisplay: inline-block;\n\tbackground-repeat: no-repeat;\n}\n\n.banner-conference .icons .icon-fourteen {\n\tposition: absolute;\n\tleft: 95% !important;\n\ttop: 95% !important;\n\twidth: 20px;\n\theight: 20px;\n\tdisplay: inline-block;\n\tbackground-repeat: no-repeat;\n}\n\n.banner-conference-two .icon-dots {\n\tleft: 40%;\n\tbottom: 180px;\n}\n\n.banner-conference-two .layer-outer {\n\tposition: absolute;\n\tright: 0;\n\ttop: 0;\n\theight: 100%;\n\twidth: 50%;\n}\n\n.banner-conference-two .images-outer {\n\tposition: absolute;\n\tright: 0;\n\ttop: 0;\n\theight: 100%;\n\twidth: 50%;\n}\n\n.banner-conference-two .images-outer .speaker-img {\n\tposition: absolute;\n\tright: 150px;\n\ttop: 52%;\n\t-webkit-transform: translateY(-50%);\n\t-moz-transform: translateY(-50%);\n\t-ms-transform: translateY(-50%);\n\t-o-transform: translateY(-50%);\n\ttransform: translateY(-50%);\n}\n\n.banner-conference-two .content-box {\n\tposition: relative;\n\tz-index: 99;\n}\n\n.banner-conference-two .content-box .title {\n\tdisplay: block;\n\tfont-size: 16px;\n\tcolor: #ffffff;\n\tfont-weight: 400;\n\tmargin-bottom: 20px;\n}\n\n.banner-conference-two .content-box h2 {\n\tdisplay: block;\n\tfont-size: 50px;\n\tline-height: 1.2em;\n\tcolor: #ffffff;\n\tfont-weight: 700;\n\tmargin-bottom: 50px;\n}\n\n.banner-conference-two .time-counter {\n\tposition: relative;\n\tmargin-bottom: 30px;\n}\n\n.banner-conference-two .time-countdown {\n\tposition: relative;\n}\n\n.banner-conference-two .time-countdown .counter-column {\n\tposition: relative;\n\tdisplay: inline-block;\n\tmargin-right: 30px;\n\twidth: 90px;\n\ttext-align: center;\n\tfont-size: 14px;\n\tcolor: #ffffff;\n\tfont-weight: 500;\n}\n\n.banner-conference-two .time-countdown .counter-column:last-child {\n\tmargin-right: 0;\n}\n\n.banner-conference-two .time-countdown .counter-column:before {\n\tposition: absolute;\n\tcontent: ':';\n\ttop: 10px;\n\tright: -20px;\n\tfont-size: 30px;\n\tline-height: 1em;\n\tcolor: #ffffff;\n}\n\n.banner-conference-two .time-countdown .counter-column:after {\n\tposition: absolute;\n\tleft: 0;\n\ttop: -20px;\n\theight: 100px;\n\twidth: 90px;\n\tz-index: -1;\n\tborder-radius: 5px 30px 5px 30px;\n\tbackground-color: #ec167f;\n\t/* border-top: 3px solid #ec167f;\n\tborder-bottom: 3px solid #ec167f; */\n\tcontent: \"\";\n}\n\n.banner-conference-two .time-countdown .counter-column:last-child:before {\n\tdisplay: none;\n}\n\n.banner-conference-two .time-countdown .counter-column .count {\n\tposition: relative;\n\tdisplay: block;\n\tfont-size: 40px;\n\tline-height: 1em;\n\tcolor: #ffffff;\n\tfont-weight: 700;\n}\n\n.banner-conference-two .content-box .btn-box {\n\tposition: relative;\n\tmargin-top: 60px;\n}\n\n\n\n\n\n\n\n.banner-conference .icon-circle-3 {\n\tleft: -150px;\n\ttop: -150px;\n}\n\n.banner-conference .icon-dots {\n\tleft: 40%;\n\tbottom: 180px;\n}\n\n\n.banner-conference .layer-outer {\n\tposition: absolute;\n\tright: 0;\n\ttop: 0;\n\theight: 100%;\n\twidth: 50%;\n}\n\n.banner-conference .gradient-layer {\n\tposition: absolute;\n\tleft: 120px;\n\twidth: 140%;\n\theight: 140%;\n\ttop: -20%;\n\tborder-radius: 50%;\n\t-webkit-transform: skew(-200deg);\n\t-moz-transform: skew(-200deg);\n\t-ms-transform: skew(-200deg);\n\t-o-transform: skew(-200deg);\n\ttransform: skew(-200deg);\n\tbackground: rgb(247, 0, 104);\n\tbackground: -moz-linear-gradient(to left, rgba(247, 0, 104, 1) 0%, rgba(68, 16, 102, 1) 100%);\n\tbackground: -webkit-linear-gradient(to left, rgba(247, 0, 104, 1) 0%, rgba(68, 16, 102, 1) 100%);\n\tbackground: linear-gradient(to left, rgba(247, 0, 104) 0%, rgba(68, 16, 102, 1) 100%);\n\tfilter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#F70068', endColorstr='#441066', GradientType=1);\n\topacity: 2;\n}\n\n.banner-conference .images-outer {\n\tposition: absolute;\n\tright: 0;\n\ttop: 0;\n\theight: 100%;\n\twidth: 50%;\n}\n\n.banner-conference .images-outer .speaker-img {\n\tposition: absolute;\n\tleft: -100px;\n\ttop: 50%;\n\t-webkit-transform: translateY(-50%);\n\t-moz-transform: translateY(-50%);\n\t-ms-transform: translateY(-50%);\n\t-o-transform: translateY(-50%);\n\ttransform: translateY(-50%);\n}\n\n.banner-conference .content-box {\n\tposition: relative;\n\tz-index: 99;\n}\n\n.banner-conference .content-box .title {\n\tdisplay: block;\n\tfont-size: 24px;\n\tcolor: #222222;\n\tfont-weight: 500;\n\tmargin-bottom: 20px;\n}\n\n.banner-conference .content-box h2 {\n\tdisplay: block;\n\tfont-size: 54px;\n\tline-height: 1.2em;\n\tcolor: #e78f45;\n\tbackground: rgb(247, 0, 104);\n\tbackground: -moz-linear-gradient(to left, rgba(247, 0, 104, 1) 0%, rgba(68, 16, 102, 1) 100%);\n\tbackground: -webkit-linear-gradient(to left, rgba(247, 0, 104, 1) 0%, rgba(68, 16, 102, 1) 100%);\n\tbackground: linear-gradient(to left, rgba(247, 0, 104) 0%, rgba(68, 16, 102, 1) 100%);\n\tfilter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#F70068', endColorstr='#441066', GradientType=1);\n\tcolor: transparent;\n\t-webkit-background-clip: text;\n\t-webkit-text-fill-color: transparent;\n\tfont-weight: 700;\n\tmargin-bottom: 50px;\n}\n\n.banner-conference .time-counter {\n\tposition: relative;\n\tmargin-bottom: 30px;\n}\n\n.banner-conference .time-countdown {\n\tposition: relative;\n}\n\n.banner-conference .time-countdown .counter-column {\n\tposition: relative;\n\tdisplay: inline-block;\n\tmargin-right: 30px;\n\twidth: 80px;\n\ttext-align: center;\n\tfont-size: 14px;\n\tcolor: #4a763c;\n\tfont-weight: 500;\n}\n\n.banner-conference .time-countdown .counter-column:last-child {\n\tmargin-right: 0;\n}\n\n\n.banner-conference .time-countdown .counter-column:before {\n\tposition: absolute;\n\tcontent: ':';\n\ttop: 10px;\n\tright: -20px;\n\tfont-size: 30px;\n\tline-height: 1em;\n\tcolor: #d84343;\n}\n\n.banner-conference .time-countdown .counter-column:after {\n\tposition: absolute;\n\tleft: 0;\n\ttop: -20px;\n\theight: 80px;\n\twidth: 80px;\n\tborder-radius: 50px;\n\tborder-top: 5px solid #d84343;\n\tcontent: \"\";\n}\n\n\n.banner-conference .time-countdown .counter-column:last-child:before {\n\tdisplay: none;\n}\n\n.banner-conference .time-countdown .counter-column .count {\n\tposition: relative;\n\tdisplay: block;\n\tfont-size: 40px;\n\tline-height: 1em;\n\tcolor: #d84343;\n\tfont-weight: 700;\n}\n\n.banner-conference .content-box .btn-box {\n\tposition: relative;\n}\n\n/***\n\n====================================================================\n\t\tBanner MeetUp\n====================================================================\n\n***/\n\n.banner-meetup {\n\tposition: relative;\n\tpadding: 140px 0;\n\tz-index: 1;\n}\n\n.banner-meetup .bg-pattern {\n\tposition: absolute;\n\tright: 0;\n\ttop: 0;\n\twidth: 100%;\n\theight: 100%;\n\tbackground-repeat: no-repeat;\n\tbackground-position: center;\n\tbackground-size: cover;\n}\n\n.banner-meetup .content-box {\n\tposition: relative;\n\ttext-align: center;\n}\n\n.banner-meetup h2 {\n\tdisplay: block;\n\tfont-size: 80px;\n\tline-height: 1.2em;\n\tcolor: #ffffff;\n\tfont-weight: 700;\n\tmargin-bottom: 40px;\n\ttext-shadow: 0 20px 40px rgba(0, 0, 0, .80);\n}\n\n.banner-meetup .address {\n\tposition: relative;\n\tdisplay: block;\n\tfont-size: 20px;\n\tline-height: 26px;\n\tcolor: #ffffff;\n\tfont-weight: 700;\n\ttext-align: center;\n\tmargin-bottom: 20px;\n\ttext-shadow: 0 10px 20px rgba(0, 0, 0, 0.80);\n}\n\n.banner-meetup .address .icon {\n\tposition: relative;\n\tdisplay: inline-block;\n\tmargin-right: 10px;\n\tfont-size: 18px;\n\tline-height: 26px;\n\tcolor: #ec167f;\n}\n\n.banner-meetup .btn-box {\n\tposition: relative;\n\ttext-align: center;\n\tmargin-top: 30px;\n}\n\n.banner-meetup .btn-box .theme-btn {\n\tpadding: 15px 34px;\n\tline-height: 20px;\n\tborder-radius: 5px;\n\tfont-weight: 700;\n}\n\n.banner-meetup .countdown {\n\tposition: relative;\n\ttext-align: center;\n\tfont-family: 'Orbitron', sans-serif;\n}\n\n.banner-meetup .countdown .time-counter {\n\tposition: relative;\n\tdisplay: inline-block;\n}\n\n.banner-meetup .countdown .counter-column:before {\n\tposition: absolute;\n\tcontent: '';\n\tleft: -10px;\n\ttop: -15px;\n\twidth: 120px;\n\theight: 120px;\n\topacity: 0.5;\n\tborder: 2px solid #ffffff;\n\ttransform: rotate(45deg);\n}\n\n.banner-meetup .countdown .counter-column {\n\tposition: relative;\n\tdisplay: inline-block;\n\tline-height: 30px;\n\tfont-size: 16px;\n\tfont-weight: 700;\n\ttext-transform: uppercase;\n\tbackground-color: transparent;\n\tborder-radius: 50%;\n\tcolor: #fafafa;\n\twidth: 100px;\n\tmargin: 0 20px 30px;\n\ttext-shadow: 0 10px 20px rgba(0, 0, 0, 0.60);\n\n}\n\n.banner-meetup .countdown .counter-column .count {\n\tposition: relative;\n\tdisplay: block;\n\tfont-size: 45px;\n\tline-height: 1.2em;\n\tcolor: #fafafa;\n\twidth: auto;\n\tfont-weight: 600;\n\tletter-spacing: 0;\n\ttext-shadow: 0 15px 20px rgba(0, 0, 0, 0.60);\n}\n\n.banner-meetup .btn-box .theme-btn {\n\tposition: relative;\n\tbox-shadow: 0 20px 30px rgba(0, 0, 0, 0.30);\n}\n\n\n/***\n\n====================================================================\n\t\tAbout Section\n====================================================================\n\n***/\n\n.about-section {\n\tposition: relative;\n\tpadding: 50px 0 30px;\n}\n\n.about-section .content-column {\n\tposition: relative;\n\tmargin-bottom: 50px;\n}\n\n.about-section .content-column .inner-column {\n\tposition: relative;\n\tpadding-right: 80px;\n}\n\n.about-section .content-column .sec-title {\n\tposition: relative;\n\tmargin-bottom: 20px;\n}\n\n.about-section .content-column .sec-title .text {\n\tmargin-top: 20px;\n}\n\n.about-section .content-column .sec-title h2 {\n\tfont-size: 40px;\n}\n\n.about-section .content-column .list-style-one {\n\tmargin-bottom: 30px;\n}\n\n.about-section .content-column .btn-box {\n\tposition: relative;\n}\n\n.about-section .content-column .btn-box a {\n\tpadding: 15px 30px;\n\tline-height: 20px;\n\tfont-weight: 600;\n\tfont-size: 15px;\n}\n\n.about-section .image-column {\n\tposition: relative;\n\tmargin-bottom: 50px;\n}\n\n.about-section .image-column .image-box {\n\tposition: relative;\n\tpadding-left: 80px;\n}\n\n.about-section .image-column .image-box img {\n\tposition: relative;\n\tz-index: 1;\n\tborder-radius: 50%;\n\tborder: 15px solid #ffffff;\n\tbox-shadow: 0 0 20px rgba(0, 0, 0, 0.10);\n}\n\n.about-section .image-column .image {\n\tposition: relative;\n\tmargin-bottom: 0;\n}\n\n.about-section .image-column .image:before {\n\tposition: absolute;\n\tright: -10%;\n\ttop: -10%;\n\theight: 120%;\n\twidth: 120%;\n\t/* background-image: url(../images/icons/shape-2.png); */\n\tbackground-repeat: no-repeat;\n\tbackground-position: center;\n\tbackground-size: 100%;\n\t-webkit-animation: dizzling 10s infinite;\n\t-moz-animation: dizzling 10s infinite;\n\t-ms-animation: dizzling 10s infinite;\n\t-o-animation: dizzling 10s infinite;\n\tanimation: dizzling 10s infinite;\n\t-webkit-transition: all 300ms ease;\n\t-moz-transition: all 300ms ease;\n\t-ms-transition: all 300ms ease;\n\t-o-transition: all 300ms ease;\n\ttransition: all 300ms ease;\n\tcontent: \"\";\n}\n\n@keyframes dizzling {\n\t0% {\n\t\t-webkit-transform: rotate(0);\n\t\t-moz-transform: rotate(0);\n\t\t-ms-transform: rotate(0);\n\t\t-o-transform: rotate(0);\n\t\ttransform: rotate(0);\n\t}\n\n\t50% {\n\t\t-webkit-transform: rotate(5deg);\n\t\t-moz-transform: rotate(5deg);\n\t\t-ms-transform: rotate(5deg);\n\t\t-o-transform: rotate(5deg);\n\t\ttransform: rotate(5deg);\n\t}\n\n\t100% {\n\t\t-webkit-transform: rotate(0);\n\t\t-moz-transform: rotate(0);\n\t\t-ms-transform: rotate(0);\n\t\t-o-transform: rotate(0);\n\t\ttransform: rotate(0);\n\t}\n}\n\n.icon-shape-1 {\n\twidth: 484px;\n\theight: 225px;\n\t/* background-image: url(../images/icons/shape-1.png); */\n}\n\n.icon-shape-2 {\n\twidth: 325px;\n\theight: 280px;\n\t/* background-image: url(../images/icons/shape-2.png); */\n}\n\n.icon-line-1 {\n\twidth: 128px;\n\theight: 128px;\n\t/* background-image: url(../images/icons/icon-line-1.png); */\n}\n\n.icon-dots {\n\twidth: 72px;\n\theight: 60px;\n\t/* background-image: url(../images/icons/icon-dots.png); */\n}\n\n.icon-dots-3 {\n\twidth: 204px;\n\theight: 114px;\n\t/* background-image: url(../images/icons/icon-dots-3.png); */\n}\n\n.icon-circle-1 {\n\twidth: 500px;\n\theight: 500px;\n\t/* background-image: url(../images/icons/icon-circle-1.png); */\n\tbackground-size: 100%;\n}\n\n.icon-circle-blue {\n\twidth: 300px;\n\theight: 300px;\n\t/* background-image: url(../images/icons/circle-blue.png); */\n}\n\n.about-section .icon-circle-blue {\n\tright: -150px;\n\tbottom: -150px;\n\topacity: .70;\n\t-webkit-animation: fa-spin 30s infinite;\n\t-moz-animation: fa-spin 30s infinite;\n\t-ms-animation: fa-spin 30s infinite;\n\t-o-animation: fa-spin 30s infinite;\n\tanimation: fa-spin 30s infinite;\n}\n\n.about-section .icon-dots {\n\tleft: 50%;\n\ttop: 30%;\n}\n\n.about-section .icon-circle-1 {\n\tleft: -200px;\n\ttop: -200px;\n\topacity: .05;\n}\n\n/***\n\n====================================================================\n\t\tAbout Section Two\n====================================================================\n\n***/\n\n.about-section-two {\n\tposition: relative;\n\tpadding: 50px 0 70px;\n}\n\n.about-section-two .content-column {\n\tposition: relative;\n\tmargin-bottom: 50px;\n}\n\n.about-section-two .content-column .inner-column {\n\tposition: relative;\n\tpadding-top: 50px;\n}\n\n.about-section-two .content-column .sec-title {\n\tposition: relative;\n\tmargin-bottom: 20px;\n}\n\n.about-section-two .content-column .sec-title .text {\n\tmargin-top: 20px;\n}\n\n.about-section-two .content-column .sec-title h2 {\n\tfont-size: 40px;\n}\n\n.about-section-two .content-column .list-style-one {\n\tmargin-bottom: 30px;\n}\n\n.about-section-two .content-column .btn-box {\n\tposition: relative;\n}\n\n.about-section-two .content-column .btn-box a {\n\tpadding: 15px 30px;\n\tline-height: 20px;\n\tfont-weight: 600;\n\tfont-size: 15px;\n}\n\n.about-section-two .about-block {\n\tposition: relative;\n\tmargin-bottom: 30px;\n}\n\n.about-section-two .about-block .inner-box {\n\tposition: relative;\n}\n\n.about-section-two .about-block h4 {\n\tposition: relative;\n\tpadding-left: 35px;\n\tfont-size: 24px;\n\tline-height: 50px;\n\tcolor: #24293d;\n}\n\n.about-section-two .about-block .icon {\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0;\n\tfont-size: 24px;\n\tline-height: 50px;\n\tcolor: #e6275a;\n}\n\n.about-section-two .about-block .text {\n\tfont-size: 16px;\n\tcolor: #888888;\n\tline-height: 1.2em;\n\tfont-weight: 500;\n}\n\n.about-section-two .image-column {\n\tposition: relative;\n\tmargin-bottom: 50px;\n}\n\n.about-section-two .image-column .image-box {\n\tposition: relative;\n\tpadding-right: 50px;\n}\n\n.about-section-two .image-column .image-box img {\n\tdisplay: block;\n\twidth: 100%;\n\tz-index: 1;\n}\n\n.about-section-two .image-column .image {\n\tposition: relative;\n\tmargin-bottom: 0;\n}\n\n.about-section-two .image-column .image:before {\n\tposition: absolute;\n\tleft: -1px;\n\ttop: -1px;\n\tright: -1px;\n\tbottom: -1px;\n\t/* background-image: url(../images/icons/icon-shape.png); */\n\tbackground-repeat: no-repeat;\n\tbackground-position: center;\n\tbackground-size: cover;\n\tcontent: \"\";\n\tz-index: 8;\n}\n\n\n.about-section-two .icon-circle-blue {\n\tleft: -150px;\n\tbottom: -150px;\n\topacity: .70;\n\t-webkit-animation: fa-spin 30s infinite;\n\t-moz-animation: fa-spin 30s infinite;\n\t-ms-animation: fa-spin 30s infinite;\n\t-o-animation: fa-spin 30s infinite;\n\tanimation: fa-spin 30s infinite;\n}\n\n.about-section-two .icon-dots {\n\tleft: 5%;\n\ttop: 20%;\n}\n\n.about-section-two .icon-circle-1 {\n\tright: -200px;\n\ttop: -200px;\n\topacity: .05;\n}\n\n/***\n\n====================================================================\n\t\tComing Soon\n====================================================================\n\n***/\n\n.coming-soon-section {\n\tposition: relative;\n\tz-index: 2;\n}\n\n.coming-soon-section .outer-box {\n\tposition: relative;\n\tdisplay: block;\n\tpadding: 30px 80px;\n\tbackground-color: #ffffff;\n\ttext-align: center;\n\tmargin-top: -72px;\n\tbackground: #FFA886;\n\tbackground: linear-gradient(to left, #A28089, #C63800);\n\tfilter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#F70068', endColorstr='#441066', GradientType=1);\n\tbox-shadow: 0 0 30px rgba(0, 0, 0, 0.30);\n\tborder-radius: 10px;\n}\n\n.coming-soon-section .timer-column {\n\tposition: relative;\n}\n\n.coming-soon-section .time-counter {\n\tposition: relative;\n}\n\n.coming-soon-section .time-countdown {\n\tposition: relative;\n}\n\n.coming-soon-section .time-countdown .counter-column {\n\tposition: relative;\n\tdisplay: inline-block;\n\tmargin: 0px 40px;\n\twidth: 100px;\n\ttext-align: center;\n\tfont-size: 18px;\n\tcolor: #ffffff;\n\tfont-weight: 500;\n}\n\n.coming-soon-section .time-countdown .counter-column:before {\n\tposition: absolute;\n\tcontent: ':';\n\ttop: 10px;\n\tright: -50px;\n\tfont-size: 56px;\n\tline-height: 1em;\n\tcolor: #ffffff;\n}\n\n.coming-soon-section .time-countdown .counter-column:last-child:before {\n\tdisplay: none;\n}\n\n.coming-soon-section .time-countdown .counter-column .count {\n\tposition: relative;\n\tdisplay: block;\n\tfont-size: 60px;\n\tline-height: 1em;\n\tcolor: #ffffff;\n\tfont-weight: 700;\n}\n\n/***\n\n====================================================================\n\t\tFeatures Section\n====================================================================\n\n***/\n\n.features-section {\n\tposition: relative;\n\tpadding: 120px 0 80px;\n}\n\n.feature-block {\n\tposition: relative;\n\tmargin-bottom: 40px;\n}\n\n.feature-block .inner-box {\n\tposition: relative;\n\tpadding: 40px 30px;\n\tbackground-color: #ffffff;\n\tborder: 1px solid #eeeeee;\n\tbox-shadow: 0 30px 40px rgba(0, 0, 0, 0.10);\n\t-webkit-transition: all 500ms ease;\n\t-moz-transition: all 500ms ease;\n\t-ms-transition: all 500ms ease;\n\t-o-transition: all 500ms ease;\n\ttransition: all 500ms ease;\n\ttext-align: center;\n\toverflow: hidden;\n}\n\n.feature-block .inner-box:hover {\n\tbox-shadow: none;\n}\n\n.feature-block .icon-box {\n\tposition: relative;\n\tdisplay: block;\n\tmargin-bottom: 30px;\n}\n\n.feature-block .icon-box .icon {\n\tposition: relative;\n\tdisplay: inline-block;\n\tfont-size: 70px;\n\tline-height: 1em;\n\tcolor: #40cbb4;\n\t-webkit-transition: all 400ms ease;\n\t-moz-transition: all 400ms ease;\n\t-ms-transition: all 400ms ease;\n\t-o-transition: all 400ms ease;\n\ttransition: all 400ms ease;\n}\n\n.feature-block:nth-child(3n + 2) h4 a:hover,\n.feature-block:nth-child(3n + 2) .icon-box .icon {\n\tcolor: #4c35a9;\n}\n\n.feature-block:nth-child(3n + 3) h4 a:hover,\n.feature-block:nth-child(3n + 3) .icon-box .icon {\n\tcolor: #e6275a;\n}\n\n.feature-block .inner-box:hover .icon-box .icon {\n\t-webkit-transform: scale(-1) rotate(180deg);\n\t-moz-transform: scale(-1) rotate(180deg);\n\t-ms-transform: scale(-1) rotate(180deg);\n\t-o-transform: scale(-1) rotate(180deg);\n\ttransform: scale(-1) rotate(180deg);\n}\n\n.feature-block h4 {\n\tposition: relative;\n\tdisplay: block;\n\tfont-size: 22px;\n\tline-height: 1.2em;\n\tcolor: #12114a;\n\tfont-weight: 700;\n\tmargin-bottom: 20px;\n}\n\n.feature-block h4 a {\n\tcolor: #12114a;\n\tdisplay: inline-block;\n\t-webkit-transition: all 300ms ease;\n\t-moz-transition: all 300ms ease;\n\t-ms-transition: all 300ms ease;\n\t-o-transition: all 300ms ease;\n\ttransition: all 300ms ease;\n}\n\n.feature-block h4 a:hover {\n\tcolor: #40cbb4;\n}\n\n.feature-block .text {\n\tposition: relative;\n\tdisplay: block;\n\tfont-size: 15px;\n\tline-height: 24px;\n\tcolor: #888888;\n\tfont-weight: 400;\n\tmargin-bottom: 25px;\n\tcursor: default;\n}\n\n.feature-block .link-box {\n\tposition: relative;\n\tdisplay: block;\n}\n\n.feature-block .link-box a {\n\tposition: relative;\n\tdisplay: inline-block;\n\tpadding: 10px 20px;\n\tline-height: 20px;\n\tfont-size: 14px;\n\tcolor: #ffffff;\n\tbackground-color: #40cbb4;\n\tborder-radius: 10px;\n\tborder-top: 2px solid transparent;\n\tborder-bottom: 2px solid transparent;\n\t-webkit-transition: all 400ms ease;\n\t-moz-transition: all 400ms ease;\n\t-ms-transition: all 400ms ease;\n\t-o-transition: all 400ms ease;\n\ttransition: all 400ms ease;\n}\n\n.feature-block .inner-box:hover .link-box a {\n\tborder-radius: 0px;\n\tcolor: #40cbb4;\n\tbackground: none;\n\tborder-color: #40cbb4;\n}\n\n.feature-block:nth-child(3n + 2) .link-box a {\n\tbackground-color: #4c35a9;\n}\n\n.feature-block:nth-child(3n + 2) .inner-box:hover .link-box a {\n\tbackground: none;\n\tcolor: #4c35a9;\n\tborder-color: #4c35a9;\n}\n\n.feature-block:nth-child(3n + 3) .link-box a {\n\tbackground-color: #e6275a;\n}\n\n.feature-block:nth-child(3n + 3) .inner-box:hover .link-box a {\n\tbackground: none;\n\tcolor: #e6275a;\n\tborder-color: #e6275a;\n}\n\n.features-section .anim-icons {\n\tmax-width: 100%;\n}\n\n.icon-shape-3 {\n\theight: 490px;\n\twidth: 290px;\n\t/* background-image: url(../images/icons/shape-3.png); */\n\tbackground-size: 100%;\n}\n\n.features-section .icon-shape-3 {\n\ttop: 0px;\n\tleft: -110px;\n\topacity: .70;\n\t-webkit-transform: scaleX(-1);\n\t-moz-transform: scaleX(-1);\n\t-ms-transform: scaleX(-1);\n\t-o-transform: scaleX(-1);\n\ttransform: scaleX(-1);\n}\n\n.features-section .icon-line-1 {\n\tright: 10%;\n\ttop: 35%;\n\t-webkit-animation: fa-spin 30s infinite alternate;\n\t-moz-animation: fa-spin 30s infinite alternate;\n\t-ms-animation: fa-spin 30s infinite alternate;\n\t-o-animation: fa-spin 30s infinite alternate;\n\tanimation: fa-spin 30s infinite alternate;\n}\n\n.features-section .icon-dots {\n\tright: 10%;\n\ttop: 35%;\n}\n\n/***\n\n====================================================================\n\tFeatures Section Two\n====================================================================\n\n***/\n\n.features-section-two {\n\tposition: relative;\n\tpadding: 120px 0 15px;\n}\n\n.features-section-two .title-block {\n\tposition: relative;\n\tmargin-bottom: 40px;\n}\n\n.features-section-two .title-block .inner-box {\n\tpadding: 50px 30px 0;\n\tbackground-color: #ffffff;\n}\n\n.features-section-two .title-block .sec-title {\n\tmargin-bottom: 0;\n}\n\n.features-section-two .title-block .sec-title .title {\n\tmargin-bottom: 5px;\n}\n\n.feature-block-two {\n\tposition: relative;\n\tmargin-bottom: 40px;\n}\n\n.feature-block-two .inner-box {\n\tposition: relative;\n\tpadding: 40px 30px;\n\tpadding-left: 100px;\n\tbackground-color: #ffffff;\n\tborder: 1px solid #eeeeee;\n\tbox-shadow: 0 30px 40px rgba(0, 0, 0, 0.10);\n\t-webkit-transition: all 500ms ease;\n\t-moz-transition: all 500ms ease;\n\t-ms-transition: all 500ms ease;\n\t-o-transition: all 500ms ease;\n\ttransition: all 500ms ease;\n\toverflow: hidden;\n}\n\n.feature-block-two .inner-box:hover {\n\tbox-shadow: none;\n}\n\n.feature-block-two .icon-box {\n\tposition: absolute;\n\tleft: 30px;\n\ttop: 50px;\n\tdisplay: block;\n\tmargin-bottom: 30px;\n}\n\n.feature-block-two .icon-box .icon {\n\tposition: relative;\n\tdisplay: inline-block;\n\tfont-size: 50px;\n\tline-height: 1em;\n\tbackground: rgb(247, 0, 104);\n\tbackground: -moz-linear-gradient(to left, rgba(247, 0, 104, 1) 0%, rgba(68, 16, 102, 1) 100%);\n\tbackground: -webkit-linear-gradient(to left, rgba(247, 0, 104, 1) 0%, rgba(68, 16, 102, 1) 100%);\n\tbackground: linear-gradient(to left, rgba(247, 0, 104) 0%, rgba(68, 16, 102, 1) 100%);\n\tfilter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#F70068', endColorstr='#441066', GradientType=1);\n\tbackground: none;\n\tcolor: #f14b59;\n\t-webkit-transition: all 400ms ease;\n\t-moz-transition: all 400ms ease;\n\t-ms-transition: all 400ms ease;\n\t-o-transition: all 400ms ease;\n\ttransition: all 400ms ease;\n}\n\n.feature-block-two .inner-box:hover .icon-box .icon {\n\t-webkit-transform: scale(-1) rotate(180deg);\n\t-moz-transform: scale(-1) rotate(180deg);\n\t-ms-transform: scale(-1) rotate(180deg);\n\t-o-transform: scale(-1) rotate(180deg);\n\ttransform: scale(-1) rotate(180deg);\n}\n\n.feature-block-two h4 {\n\tposition: relative;\n\tdisplay: block;\n\tfont-size: 22px;\n\tline-height: 1.2em;\n\tcolor: #12114a;\n\tfont-weight: 700;\n\tmargin-bottom: 10px;\n}\n\n.feature-block-two h4 a {\n\tcolor: #12114a;\n\tdisplay: inline-block;\n\t-webkit-transition: all 300ms ease;\n\t-moz-transition: all 300ms ease;\n\t-ms-transition: all 300ms ease;\n\t-o-transition: all 300ms ease;\n\ttransition: all 300ms ease;\n}\n\n.feature-block-two h4 a:hover {\n\tcolor: #f14b59;\n}\n\n.feature-block-two .text {\n\tposition: relative;\n\tdisplay: block;\n\tfont-size: 15px;\n\tline-height: 24px;\n\tcolor: #888888;\n\tfont-weight: 400;\n\tcursor: default;\n}\n\n.feature-block-two .link-box {\n\tposition: relative;\n\tdisplay: block;\n}\n\n.feature-block-two .link-box a {\n\tpadding: 10px 20px;\n\tline-height: 20px;\n\tfont-size: 14px;\n}\n\n.features-section-two .twist-line-1 {\n\tleft: -110px;\n\ttop: 290px;\n}\n\n.features-section-two .twist-line-2 {\n\tleft: -10%;\n\ttop: 80px;\n}\n\n.features-section-two .twist-line-3 {\n\tleft: 90px;\n\ttop: 50px;\n}\n\n.twist-line-1 {\n\theight: 70px;\n\twidth: 80px;\n}\n\n.twist-line-2 {\n\theight: 73px;\n\twidth: 70px;\n\t/* background-image: url(../images/icons/twist-line-2.png); */\n}\n\n.twist-line-3 {\n\theight: 73px;\n\twidth: 70px;\n\t/* background-image: url(../images/icons/twist-line-3.png); */\n}\n\n/***\n\n====================================================================\n\tFeatures Section Three\n====================================================================\n\n***/\n\n.features-section-three {\n\tposition: relative;\n\tpadding: 120px 0 80px;\n}\n\n.features-section-three.no-pd-top {\n\tpadding-top: 0;\n}\n\n.feature-block-three {\n\tposition: relative;\n\tmargin-bottom: 40px;\n}\n\n.feature-block-three .inner-box {\n\tposition: relative;\n\tpadding: 20px 30px;\n\tpadding-left: 170px;\n\tpadding-right: 100px;\n\tbackground-color: #ffffff;\n\tborder: 1px solid #eeeeee;\n\tbox-shadow: 0 30px 40px rgba(0, 0, 0, 0.10);\n\t-webkit-transition: all 500ms ease;\n\t-moz-transition: all 500ms ease;\n\t-ms-transition: all 500ms ease;\n\t-o-transition: all 500ms ease;\n\ttransition: all 500ms ease;\n\toverflow: hidden;\n}\n\n.feature-block-three .inner-box:hover {\n\tbox-shadow: none;\n}\n\n.feature-block-three .icon-box {\n\tposition: absolute;\n\tleft: 50px;\n\ttop: 0;\n\theight: 100%;\n\twidth: 70px;\n\tpadding: 0 20px;\n}\n\n.feature-block-three .icon-box:before {\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0;\n\theight: 100%;\n\twidth: 100%;\n\tbackground-color: #40cbb4;\n\tcontent: \"\";\n\t-webkit-transform: skew(-15deg);\n\t-moz-transform: skew(-15deg);\n\t-ms-transform: skew(-15deg);\n\t-o-transform: skew(-15deg);\n\ttransform: skew(-15deg);\n\t-webkit-transition: all 600ms ease;\n\t-ms-transition: all 600ms ease;\n\t-o-transition: all 600ms ease;\n\t-moz-transition: all 600ms ease;\n\ttransition: all 600ms ease;\n}\n\n.feature-block-three .inner-box:hover .icon-box:before {\n\t-webkit-transform: skew(15deg);\n\t-moz-transform: skew(15deg);\n\t-ms-transform: skew(15deg);\n\t-o-transform: skew(15deg);\n\ttransform: skew(15deg);\n}\n\n.feature-block-three .icon-box .icon {\n\tposition: absolute;\n\tleft: 50%;\n\ttop: 50%;\n\twidth: 40px;\n\tfont-size: 40px;\n\tline-height: 1em;\n\tmargin-top: -20px;\n\tmargin-left: -20px;\n\tcolor: #ffffff;\n\t-webkit-transition: all 400ms ease;\n\t-moz-transition: all 400ms ease;\n\t-ms-transition: all 400ms ease;\n\t-o-transition: all 400ms ease;\n\ttransition: all 400ms ease;\n}\n\n.feature-block-three .inner-box:hover .icon-box .icon {\n\t-webkit-transform: scale(-1) rotate(180deg);\n\t-moz-transform: scale(-1) rotate(180deg);\n\t-ms-transform: scale(-1) rotate(180deg);\n\t-o-transform: scale(-1) rotate(180deg);\n\ttransform: scale(-1) rotate(180deg);\n}\n\n.feature-block-three h4 {\n\tposition: relative;\n\tdisplay: block;\n\tfont-size: 20px;\n\tline-height: 1.2em;\n\tcolor: #12114a;\n\tfont-weight: 700;\n\tmargin-bottom: 10px;\n}\n\n.feature-block-three h4 a {\n\tcolor: #12114a;\n\tdisplay: inline-block;\n\t-webkit-transition: all 300ms ease;\n\t-moz-transition: all 300ms ease;\n\t-ms-transition: all 300ms ease;\n\t-o-transition: all 300ms ease;\n\ttransition: all 300ms ease;\n}\n\n.feature-block-three h4 a:hover {\n\tcolor: #40cbb4;\n}\n\n.feature-block-three .text {\n\tposition: relative;\n\tdisplay: block;\n\tfont-size: 14px;\n\tline-height: 24px;\n\tcolor: #888888;\n\tfont-weight: 400;\n\tcursor: default;\n}\n\n.feature-block-three .link-box {\n\tposition: absolute;\n\tright: 30px;\n\ttop: 50%;\n\tmargin-top: -20px;\n\tfont-size: 20px;\n\tborder-radius: 50%;\n}\n\n.feature-block-three .link-box a {\n\tposition: relative;\n\tdisplay: inline-block;\n\tpadding: 10px 20px;\n\tline-height: 20px;\n\tfont-size: 14px;\n\tcolor: #ffffff;\n\tbackground-color: #40cbb4;\n\tborder-radius: 10px;\n\t-webkit-transition: all 600ms ease;\n\t-ms-transition: all 600ms ease;\n\t-o-transition: all 600ms ease;\n\t-moz-transition: all 600ms ease;\n\ttransition: all 600ms ease;\n}\n\n.feature-block-three .inner-box:hover .link-box a {\n\ttransform: rotate(360deg);\n\tborder-radius: 0px;\n}\n\n.feature-block-three .inner-box:hover .link-box a {\n\tcolor: #ffffff;\n\tbox-shadow: 0 10px 20px rgba(0, 0, 0, 0.10);\n}\n\n.feature-block-three:nth-child(3n + 2) .icon-box:before,\n.feature-block-three:nth-child(3n + 2) .link-box a {\n\tbackground-color: #4c35a9;\n}\n\n.feature-block-three:nth-child(3n + 3) .icon-box:before,\n.feature-block-three:nth-child(3n + 3) .link-box a {\n\tbackground-color: #e6275a;\n}\n\n.feature-block-three:nth-child(3n + 4) .icon-box:before,\n.feature-block-three:nth-child(3n + 4) .link-box a {\n\tbackground-color: #1c94d2;\n}\n\n\n/***\n\n====================================================================\n\t\t\tFluid Section One\n====================================================================\n\n***/\n\n.fluid-section-one {\n\tposition: relative;\n\tbackground-color: #41cbb4;\n}\n\n.fluid-section-one .outer-box {\n\tposition: relative;\n}\n\n.fluid-section-one .content-column {\n\tposition: relative;\n\tfloat: right;\n\twidth: 50%;\n\tpadding: 0 15px;\n}\n\n.fluid-section-one .content-column .inner-column {\n\tposition: relative;\n\tmax-width: 600px;\n\tpadding: 80px 20px;\n\tmargin: 0 auto;\n}\n\n.fluid-section-one .content-column h3 {\n\tposition: relative;\n\tfont-size: 40px;\n\tline-height: 1.2em;\n\tcolor: #ffffff;\n\tfont-weight: 700;\n\tmargin-bottom: 28px;\n}\n\n.fluid-section-one .content-column .text {\n\tfont-size: 16px;\n\tline-height: 30px;\n\tcolor: #ffffff;\n\tmargin-bottom: 30px;\n}\n\n.fluid-section-one .content-column .theme-btn {\n\tborder-radius: 5px;\n\tbox-shadow: 0 10px 30px rgba(80, 4, 42, .15);\n}\n\n.fluid-section-one .image-column {\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0;\n\theight: 100%;\n\twidth: 50%;\n\tbackground-repeat: no-repeat;\n\tbackground-position: center left;\n\tbackground-size: cover;\n}\n\n.fluid-section-one .image-column .image-box {\n\tdisplay: none;\n}\n\n.fluid-section-one .image-column .image {\n\tposition: relative;\n\tmargin-bottom: 0;\n}\n\n.fluid-section-one .image-column .image img {\n\tdisplay: block;\n\twidth: 100%;\n\theight: auto;\n}\n\n\n/***\n\n====================================================================\n\t\tSpeakers Section\n====================================================================\n\n***/\n\n.speakers-section {\n\tposition: relative;\n\tpadding: 60px 0 90px;\n}\n\n.speakers-section:before {\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0;\n\theight: 100%;\n\twidth: 100%;\n\tbackground-color: rgba(28, 139, 210, .50);\n\tcontent: \"\";\n}\n\n.speaker-block {\n\tposition: relative;\n\tmargin-bottom: 40px;\n}\n\n.speaker-block .inner-box {\n\tposition: relative;\n\toverflow: hidden;\n\tborder-radius: 50%;\n\tborder: 6px solid #ffffff;\n\tbox-shadow: 0 30px 30px rgba(0, 0, 0, 0.40);\n\twidth: 257px;\n\theight: 251px;\n\tmargin: 0 auto;\n\t-webkit-transition: all 300ms ease;\n\t-moz-transition: all 300ms ease;\n\t-ms-transition: all 300ms ease;\n\t-o-transition: all 300ms ease;\n\ttransition: all 500ms ease;\n\n}\n\n.speaker-block .inner-box:hover {\n\tbox-shadow: none;\n}\n\n.speaker-block .image-box {\n\tposition: relative;\n}\n\n.speaker-block .image-box .image {\n\tposition: relative;\n\tmargin-bottom: 0;\n}\n\n.speaker-block .image-box .image img {\n\tdisplay: block;\n\twidth: 100%;\n\t-webkit-transition: all 300ms ease;\n\t-moz-transition: all 300ms ease;\n\t-ms-transition: all 300ms ease;\n\t-o-transition: all 300ms ease;\n\ttransition: all 300ms ease;\n}\n\n.speaker-block .inner-box:hover .image img {\n\topacity: .80;\n\t-webkit-transform: scale(1.1);\n\t-moz-transform: scale(1.1);\n\t-ms-transform: scale(1.1);\n\t-o-transform: scale(1.1);\n\ttransform: scale(1.1);\n}\n\n.speaker-block .info-box {\n\tposition: absolute;\n\tleft: 0px;\n\ttop: 0px;\n\tright: 0px;\n\tbottom: 0px;\n\ttext-align: center;\n\tbackground-color: rgba(28, 139, 210, .70);\n\tbackground-color: rgba(237, 23, 127, .90);\n\n\n\t-webkit-transition: -webkit-transform 0.4s ease;\n\ttransition: -webkit-transform 0.4s ease;\n\ttransition: transform 0.4s ease;\n\ttransition: transform 0.4s ease, -webkit-transform 0.4s ease;\n\t-webkit-transform: scale(0, 1);\n\t-ms-transform: scale(0, 1);\n\ttransform: scale(0, 1);\n\t-webkit-transform-origin: right center;\n\t-ms-transform-origin: right center;\n\ttransform-origin: right center;\n}\n\n.speaker-block .inner-box:hover .info-box {\n\t-webkit-transform: scale(1, 1);\n\t-ms-transform: scale(1, 1);\n\ttransform: scale(1, 1);\n\t-webkit-transform-origin: left center;\n\t-ms-transform-origin: left center;\n\ttransform-origin: left center;\n\topacity: 1;\n}\n\n\n.speaker-block .info-box .inner {\n\tposition: absolute;\n\tleft: 0;\n\twidth: 100%;\n\ttop: 50%;\n\t-webkit-transform: translateY(-50%);\n\t-moz-transform: translateY(-50%);\n\t-ms-transform: translateY(-50%);\n\t-o-transform: translateY(-50%);\n\ttransform: translateY(-50%);\n\tpadding: 0 40px;\n}\n\n.speaker-block .info-box .name {\n\tposition: relative;\n\tdisplay: block;\n\tfont-size: 22px;\n\tline-height: 1.2em;\n\tcolor: #ffffff;\n\tfont-weight: 700;\n\topacity: 0;\n\tmargin-bottom: 5px;\n\t-webkit-transform: translateY(20px);\n\t-moz-transform: translateY(20px);\n\t-ms-transform: translateY(20px);\n\t-o-transform: translateY(20px);\n\ttransform: translateY(20px);\n\t-webkit-transition: all 400ms ease;\n\t-moz-transition: all 400ms ease;\n\t-ms-transition: all 400ms ease;\n\t-o-transition: all 400ms ease;\n\ttransition: all 300ms ease;\n}\n\n.speaker-block .inner-box:hover .info-box .name {\n\topacity: 1;\n\t-webkit-transform: translateY(0px);\n\t-moz-transform: translateY(0px);\n\t-ms-transform: translateY(0px);\n\t-o-transform: translateY(0px);\n\ttransform: translateY(0px);\n\t-webkit-transition-delay: 300ms;\n\t-moz-transition-delay: 300ms;\n\t-ms-transition-delay: 300ms;\n\t-o-transition-delay: 300ms;\n\ttransition-delay: 300ms;\n}\n\n\n.speaker-block .info-box .name a {\n\tcolor: #ffffff;\n\t-webkit-transition: all 300ms ease;\n\t-moz-transition: all 300ms ease;\n\t-ms-transition: all 300ms ease;\n\t-o-transition: all 300ms ease;\n\ttransition: all 300ms ease;\n}\n\n.speaker-block .info-box .name a:hover {}\n\n.speaker-block .info-box .designation {\n\tposition: relative;\n\tdisplay: block;\n\tfont-size: 13px;\n\tline-height: 30px;\n\tcolor: #ffffff;\n\tfont-weight: 400;\n\tmargin-bottom: 15px;\n\topacity: 0;\n\t-webkit-transform: translateY(20px);\n\t-moz-transform: translateY(20px);\n\t-ms-transform: translateY(20px);\n\t-o-transform: translateY(20px);\n\ttransform: translateY(20px);\n\t-webkit-transition: all 400ms ease;\n\t-moz-transition: all 400ms ease;\n\t-ms-transition: all 400ms ease;\n\t-o-transition: all 400ms ease;\n\ttransition: all 300ms ease;\n}\n\n.speaker-block .inner-box:hover .info-box .designation {\n\topacity: 1;\n\t-webkit-transform: translateY(0px);\n\t-moz-transform: translateY(0px);\n\t-ms-transform: translateY(0px);\n\t-o-transform: translateY(0px);\n\ttransform: translateY(0px);\n\t-webkit-transition-delay: 500ms;\n\t-moz-transition-delay: 500ms;\n\t-ms-transition-delay: 500ms;\n\t-o-transition-delay: 500ms;\n\ttransition-delay: 500ms;\n}\n\n.speaker-block .social-links {\n\tposition: relative;\n\topacity: 0;\n\t-webkit-transform: translateY(20px);\n\t-moz-transform: translateY(20px);\n\t-ms-transform: translateY(20px);\n\t-o-transform: translateY(20px);\n\ttransform: translateY(20px);\n\t-webkit-transition: all 400ms ease;\n\t-moz-transition: all 400ms ease;\n\t-ms-transition: all 400ms ease;\n\t-o-transition: all 400ms ease;\n\ttransition: all 300ms ease;\n}\n\n.speaker-block .inner-box:hover .social-links {\n\topacity: 1;\n\t-webkit-transform: translateY(0px);\n\t-moz-transform: translateY(0px);\n\t-ms-transform: translateY(0px);\n\t-o-transform: translateY(0px);\n\ttransform: translateY(0px);\n\t-webkit-transition-delay: 700ms;\n\t-moz-transition-delay: 700ms;\n\t-ms-transition-delay: 700ms;\n\t-o-transition-delay: 700ms;\n\ttransition-delay: 700ms;\n}\n\n.speaker-block .social-links li {\n\tposition: relative;\n\tdisplay: inline-block;\n\tmargin-bottom: 10px;\n}\n\n.speaker-block .social-links li a i {\n\tposition: relative;\n\tdisplay: block;\n\twidth: 32px;\n\theight: 32px;\n\tfont-size: 16px;\n\tline-height: 30px;\n\tbackground-color: #ffffff;\n\ttext-align: center;\n\t-webkit-transition: all 300ms ease;\n\t-moz-transition: all 300ms ease;\n\t-ms-transition: all 300ms ease;\n\t-o-transition: all 300ms ease;\n\ttransition: all 300ms ease;\n}\n\n.speaker-block .social-links li a:hover i {\n\tcolor: #ffffff;\n}\n\n/***\n\n====================================================================\n\tSpeakers Section Two\n====================================================================\n\n***/\n\n.speakers-section-two {\n\tposition: relative;\n\tpadding: 120px 0 70px;\n\toverflow: hidden;\n}\n\n.speaker-block-two {\n\tposition: relative;\n\tmargin-bottom: 50px;\n}\n\n.speaker-block-two .inner-box {\n\tposition: relative;\n\tbackground-color: #ffffff;\n\toverflow: hidden;\n\tpadding: 50px 0 40px;\n\tbox-shadow: 0 20px 30px rgba(0, 0, 0, 0.10);\n\tborder: 1px solid #dddddd;\n\tborder-bottom: 5px solid #1c94d2;\n\tmax-width: 300px;\n\tmargin: 0 auto;\n\t-webkit-transition: all 600ms ease;\n\t-moz-transition: all 600ms ease;\n\t-ms-transition: all 600ms ease;\n\t-o-transition: all 600ms ease;\n\ttransition: all 600ms ease;\n}\n\n.speaker-block-two .inner-box:hover {\n\tbox-shadow: none;\n}\n\n.speaker-block-two .inner-box:before {\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0;\n\theight: 100%;\n\twidth: 100%;\n\t/* background-image: url(../images/icons/speaker-bg.png); */\n\tbackground-repeat: no-repeat;\n\tbackground-position: center;\n\tbackground-size: 100%;\n\tcontent: \"\";\n\topacity: .30;\n}\n\n.speaker-block-two .info-box {\n\tposition: relative;\n\tdisplay: inline-block;\n\tpadding: 10px 30px;\n\tborder-radius: 0 30px 30px 0;\n\tbackground-color: #1c94d2;\n\tmargin-bottom: 50px;\n}\n\n.speaker-block-two .info-box .name {\n\tposition: relative;\n\tfont-size: 18px;\n\tline-height: 1.2em;\n\tcolor: #ffffff;\n\tfont-weight: 500;\n}\n\n.speaker-block-two .info-box .name a {\n\tcolor: #ffffff;\n\t-webkit-transition: all 300ms ease;\n\t-moz-transition: all 300ms ease;\n\t-ms-transition: all 300ms ease;\n\t-o-transition: all 300ms ease;\n\ttransition: all 300ms ease;\n}\n\n.speaker-block-two .info-box .name a:hover {\n\tcolor: #ffffff;\n}\n\n.speaker-block-two .info-box .designation {\n\tposition: relative;\n\tdisplay: block;\n\tfont-size: 14px;\n\tline-height: 20px;\n\tcolor: #ffffff;\n\tfont-weight: 400;\n}\n\n.speaker-block-two .image-box {\n\tposition: relative;\n\tdisplay: block;\n\tmargin-bottom: 30px;\n\ttext-align: center;\n}\n\n.speaker-block-two .image-box .image {\n\tposition: relative;\n\tdisplay: inline-block;\n\theight: 150px;\n\twidth: 150px;\n\toverflow: hidden;\n\tborder: 4px solid #1c94d2;\n\tbox-shadow: 0 0 20px rgba(0, 0, 0, 0.10);\n\tborder-radius: 50%;\n\tz-index: 9;\n\tmargin-bottom: 0;\n}\n\n.speaker-block-two .image-box .image img {\n\tdisplay: block;\n\twidth: 100%;\n\t-webkit-transition: all 300ms ease;\n\t-moz-transition: all 300ms ease;\n\t-ms-transition: all 300ms ease;\n\t-o-transition: all 300ms ease;\n\ttransition: all 300ms ease;\n}\n\n.speaker-block-two .inner-box:hover .image img {\n\t-webkit-transform: scale(1.1);\n\t-moz-transform: scale(1.1);\n\t-ms-transform: scale(1.1);\n\t-o-transform: scale(1.1);\n\ttransform: scale(1.1);\n}\n\n.speaker-block-two .social-box {\n\tposition: relative;\n\tdisplay: block;\n\ttext-align: center;\n}\n\n.speaker-block-two .social-links li {\n\tposition: relative;\n\tdisplay: inline-block;\n\tmargin-bottom: 10px;\n}\n\n.speaker-block-two .social-links li a i {\n\tposition: relative;\n\tdisplay: block;\n\twidth: 32px;\n\theight: 32px;\n\tborder: 1px solid #eeeeee;\n\tfont-size: 16px;\n\tline-height: 30px;\n\tbackground-color: #ffffff;\n\ttext-align: center;\n\t-webkit-transition: all 300ms ease;\n\t-moz-transition: all 300ms ease;\n\t-ms-transition: all 300ms ease;\n\t-o-transition: all 300ms ease;\n\ttransition: all 300ms ease;\n}\n\n.speaker-block-two .social-links li a:hover i {\n\tcolor: #ffffff;\n}\n\n.speakers-section-two .anim-icons {\n\tmax-width: 100%;\n}\n\n.speakers-section-two .icon-shape-1 {\n\t-webkit-transform: scale(-1);\n\t-moz-transform: scale(-1);\n\t-ms-transform: scale(-1);\n\t-o-transform: scale(-1);\n\ttransform: scale(-1);\n\tleft: 0;\n\ttop: 0;\n}\n\n.speakers-section-two .icon-circle-3 {\n\tleft: -90px;\n\tbottom: -90px;\n\topacity: .70;\n}\n\n.speakers-section-two .icon-circle-4 {\n\tright: -75px;\n\ttop: 30%;\n}\n\n.icon-circle-4 {\n\theight: 156px;\n\twidth: 156px;\n\t/* background-image: url(../images/icons/icon-circle-4.png); */\n}\n\n.icon-circle-3 {\n\theight: 360px;\n\twidth: 360px;\n\t/* background-image: url(../images/icons/icon-circle-3.png); */\n\tbackground-size: 100%;\n}\n\n/***\n\n====================================================================\n\tSpeakers Section Three\n====================================================================\n\n***/\n\n.speakers-section-three {\n\tposition: relative;\n\tpadding: 120px 0 90px;\n\tbackground-repeat: no-repeat;\n\tbackground-position: center;\n\tbackground-size: cover;\n\toverflow: hidden;\n}\n\n.speaker-block-three {\n\tposition: relative;\n\tmargin-bottom: 50px;\n}\n\n.speaker-block-three .inner-box {\n\tposition: relative;\n\tbackground-color: #ffffff;\n\toverflow: hidden;\n\tpadding-bottom: 30px;\n\tmax-width: 300px;\n\tmargin: 0 auto;\n\toverflow: hidden;\n\tbox-shadow: 0 20px 30px rgba(0, 0, 0, 0.10);\n\t-webkit-transition: all 300ms ease;\n\t-moz-transition: all 600ms ease;\n\t-ms-transition: all 600ms ease;\n\t-o-transition: all 600ms ease;\n\ttransition: all 600ms ease;\n}\n\n.speaker-block-three .inner-box:hover {\n\tbox-shadow: 0 0px 5px rgba(0, 0, 0, 0.10);\n}\n\n.speaker-block-three .image-box {\n\tposition: relative;\n\tdisplay: block;\n\ttext-align: center;\n\tpadding: 25px 0;\n}\n\n.speaker-block-three .image-box:before {\n\tposition: absolute;\n\tleft: -10px;\n\tright: -10px;\n\ttop: -4px;\n\theight: 100%;\n\t/* background-image: url(../images/icons/shape-5.png); */\n\t-webkit-transform: scale(-1);\n\t-moz-transform: scale(-1);\n\t-ms-transform: scale(-1);\n\t-o-transform: scale(-1);\n\ttransform: scale(-1);\n\tbackground-repeat: no-repeat;\n\tbackground-position: right top;\n\tbackground-size: cover;\n\tcontent: \"\";\n}\n\n.speaker-block-three .image-box .image {\n\tposition: relative;\n\tdisplay: inline-block;\n\theight: 200px;\n\twidth: 200px;\n\toverflow: hidden;\n\tborder: 4px solid #682372;\n\tbox-shadow: 0 0 20px rgba(0, 0, 0, 0.30);\n\tborder-radius: 50%;\n\tz-index: 9;\n\tmargin-bottom: 0;\n\t-webkit-transition: all 600ms ease;\n\t-ms-transition: all 600ms ease;\n\t-o-transition: all 600ms ease;\n\t-moz-transition: all 600ms ease;\n\ttransition: all 600ms ease;\n}\n\n.speaker-block-three .inner-box:hover .image-box .image {\n\tborder-radius: 0px;\n}\n\n.speaker-block-three .image-box .image img {\n\tdisplay: block;\n\twidth: 100%;\n\t-webkit-transition: all 300ms ease;\n\t-moz-transition: all 300ms ease;\n\t-ms-transition: all 300ms ease;\n\t-o-transition: all 300ms ease;\n\ttransition: all 300ms ease;\n}\n\n.speaker-block-three .inner-box:hover .image img {\n\t-webkit-transform: scale(1.1);\n\t-moz-transform: scale(1.1);\n\t-ms-transform: scale(1.1);\n\t-o-transform: scale(1.1);\n\ttransform: scale(1.1);\n}\n\n.speaker-block-three .info-box {\n\tposition: relative;\n\tdisplay: inline-block;\n\tpadding: 10px 30px;\n\tpadding-right: 10px;\n\tbackground-color: #f20487;\n}\n\n.speaker-block-three .info-box:before {\n\tposition: absolute;\n\tleft: 0;\n\tright: -30px;\n\tbackground-color: #f20487;\n\tcontent: \"\";\n\ttop: 0;\n\theight: 100%;\n\t-webkit-transform: skew(-30deg);\n\t-moz-transform: skew(-30deg);\n\t-ms-transform: skew(-30deg);\n\t-o-transform: skew(-30deg);\n\ttransform: skew(-30deg);\n\tborder-radius: 0 14px 14px 0;\n}\n\n.speaker-block-three .info-box .name {\n\tposition: relative;\n\tfont-size: 18px;\n\tline-height: 1.2em;\n\tcolor: #ffffff;\n\tfont-weight: 500;\n}\n\n.speaker-block-three .info-box .name a {\n\tcolor: #ffffff;\n\t-webkit-transition: all 300ms ease;\n\t-moz-transition: all 300ms ease;\n\t-ms-transition: all 300ms ease;\n\t-o-transition: all 300ms ease;\n\ttransition: all 300ms ease;\n}\n\n.speaker-block-three .info-box .name a:hover {\n\tcolor: #ffffff;\n}\n\n.speaker-block-three .info-box .designation {\n\tposition: relative;\n\tdisplay: block;\n\tfont-size: 14px;\n\tline-height: 20px;\n\tcolor: #ffffff;\n\tfont-weight: 400;\n}\n\n.speaker-block-three .social-box {\n\tposition: absolute;\n\ttop: 90px;\n\tleft: -8px;\n\ttransform: translateX(-50px);\n\t-webkit-transition: all 600ms ease;\n\t-ms-transition: all 600ms ease;\n\t-o-transition: all 600ms ease;\n\t-moz-transition: all 600ms ease;\n\ttransition: all 600ms ease;\n}\n\n.speaker-block-three .social-box .social-links li {\n\tmargin-bottom: 2px;\n}\n\n.speaker-block-three .inner-box:hover .social-box {\n\ttransform: translateX(10px);\n}\n\n.speaker-block-two .social-links li {\n\tposition: relative;\n\tdisplay: inline-block;\n\tmargin-bottom: 10px;\n}\n\n.speaker-block-three .social-links li a i {\n\tposition: relative;\n\tdisplay: block;\n\twidth: 32px;\n\theight: 32px;\n\tborder: 1px solid #eeeeee;\n\tfont-size: 16px;\n\tline-height: 30px;\n\tbackground-color: #ffffff;\n\ttext-align: center;\n\t-webkit-transition: all 300ms ease;\n\t-moz-transition: all 300ms ease;\n\t-ms-transition: all 300ms ease;\n\t-o-transition: all 300ms ease;\n\ttransition: all 300ms ease;\n}\n\n.speaker-block-three .social-links li a:hover i {\n\tcolor: #ffffff;\n}\n\n/***\n\n====================================================================\n\tSpeker Detail\n====================================================================\n\n***/\n\n.speaker-detail {\n\tposition: relative;\n\tpadding: 120px 0 70px;\n}\n\n.speaker-detail .image-column {\n\tposition: relative;\n\tmargin-bottom: 50px;\n}\n\n.speaker-detail .image-column .image-box {\n\tposition: relative;\n\tpadding-right: 20px;\n}\n\n.speaker-detail .image-column .image {\n\tposition: relative;\n\tmargin-bottom: 30px;\n\toverflow: hidden;\n\tborder: 10px solid #ffffff;\n\tbox-shadow: 0 0 30px rgba(0, 0, 0, 0.10);\n}\n\n.speaker-detail .image-column .image img {\n\tdisplay: block;\n\twidth: 100%;\n}\n\n.speaker-detail .info-column {\n\tposition: relative;\n}\n\n.speaker-detail .info-column .inner-column {\n\tposition: relative;\n}\n\n.speaker-detail .info-column h1 {\n\tposition: relative;\n\tfont-size: 50px;\n\tline-height: 1em;\n\tfont-weight: 700;\n\tmargin-bottom: 20px;\n}\n\n.speaker-detail .info-column h3 {\n\tposition: relative;\n\tdisplay: block;\n\tfont-size: 40px;\n\tline-height: 1em;\n\tfont-weight: 600;\n\tmargin-bottom: 20px;\n\tcolor: #101130;\n}\n\n.speaker-detail .info-column h4 {\n\tposition: relative;\n\tdisplay: block;\n\tfont-size: 24px;\n\tline-height: 1em;\n\tfont-weight: 500;\n\tmargin-bottom: 20px;\n\tcolor: #222222;\n}\n\n.speaker-detail .info-column h5 {\n\tposition: relative;\n\tdisplay: block;\n\tfont-size: 18px;\n\tline-height: 1em;\n\tfont-weight: 500;\n\tmargin-bottom: 10px;\n\tcolor: rgba(68, 16, 102, 1);\n}\n\n.speaker-detail .info-column .text-box {\n\tposition: relative;\n}\n\n.speaker-detail .info-column p {\n\tposition: relative;\n\tfont-size: 16px;\n\tline-height: 1.6em;\n\tcolor: #888888;\n\tmargin-bottom: 30px;\n}\n\n.speaker-detail .speaker-session-info {\n\tposition: relative;\n\tmargin-bottom: 30px;\n}\n\n.speaker-detail .speaker-session-info p {\n\tmargin-bottom: 0;\n\tcolor: rgb(247, 0, 104);\n}\n\n\n.speaker-detail .bottom-box {\n\tposition: relative;\n\tpadding-left: 80px;\n\tmin-height: 50px;\n\tmargin-bottom: 30px;\n}\n\n\n/***\n\n====================================================================\n\tschedule Section\n====================================================================\n\n***/\n\n.schedule-section {\n\tposition: relative;\n\tpadding: 120px 0 100px;\n\tbackground-repeat: no-repeat;\n\tbackground-position: center;\n\tbackground-size: cover;\n\tbackground-color: #fafafa;\n\toverflow: hidden;\n}\n\n.schedule-section .icon-circle-4 {\n\tright: -200px;\n\tbottom: 160px;\n}\n\n.schedule-section .icon-circle-3 {\n\tleft: -375px;\n\ttop: 340px;\n\topacity: .30;\n}\n\n.tabs-box {\n\tposition: relative;\n}\n\n.tabs-box .tab {\n\tdisplay: none;\n}\n\n.tabs-box .tab.active-tab {\n\tdisplay: block;\n}\n\n.schedule-tabs {\n\tposition: relative;\n\tmargin-top: 30px;\n}\n\n.schedule-tabs .btns-box {\n\tposition: relative;\n\tdisplay: block;\n\tmargin-bottom: 40px;\n}\n\n/* .schedule-tabs .tab-buttons{\n\tposition: relative;\n\ttext-align: center;\n} */\n\n.schedule-tabs .tab-buttons li {\n\tposition: relative;\n\tdisplay: inline-block;\n\theight: 135px;\n\twidth: 160px;\n\tborder-radius: 20px;\n\tbackground-color: #ffffff;\n\tfont-size: 16px;\n\tline-height: 20px;\n\tcolor: #222222;\n\tfont-weight: 600;\n\ttext-align: left;\n\tpadding: 15px 15px;\n\tpadding-top: 60px;\n\tpadding-left: 90px;\n\tcursor: pointer;\n\tmargin: 0 15px 20px;\n\tborder: 1px solid #dddddd;\n\t-webkit-transition: all 300ms ease;\n\t-moz-transition: all 300ms ease;\n\t-ms-transition: all 300ms ease;\n\t-o-transition: all 300ms ease;\n\ttransition: all 300ms ease;\n}\n\n.schedule-tabs .tab-buttons li .day {\n\tposition: absolute;\n\tleft: 0px;\n\ttop: 20px;\n\tpadding: 5px 20px;\n\tbackground-color: #222222;\n\tfont-size: 14px;\n\tline-height: 20px;\n\tfont-weight: 600;\n\tcolor: #ffffff;\n\tborder-radius: 0 15px 15px 0;\n}\n\n.schedule-tabs .tab-buttons li .date {\n\tposition: absolute;\n\tleft: -0;\n\ttop: 80px;\n\twidth: 150px;\n\ttext-align: center;\n\tfont-size: 38px;\n\tline-height: 20px;\n\tfont-weight: 600;\n\tcolor: #222222;\n}\n\n.schedule-tabs .tab-buttons li .month {\n\tdisplay: block;\n\tfont-size: 20px;\n\tline-height: 1em;\n\tfont-weight: 600;\n\tcolor: #222222;\n\ttext-transform: uppercase;\n}\n\n.schedule-tabs .tab-buttons li .year {\n\tfont-size: 30px;\n}\n\n.schedule-tabs .tab-buttons li.active-btn {\n\tbox-shadow: 0 20px 30px rgba(0, 0, 0, .10);\n}\n\n.schedule-tabs .tab-buttons li:nth-child(4n + 1) .day {\n\tbackground-color: #ffc20b;\n}\n\n.schedule-tabs .tab-buttons li:nth-child(4n + 2) .day {\n\tbackground-color: #40cbb4;\n}\n\n.schedule-tabs .tab-buttons li:nth-child(4n + 3) .day {\n\tbackground-color: #4c35a9;\n}\n\n.schedule-tabs .tab-buttons li:nth-child(4n + 4) .day {\n\tbackground-color: #e6275a;\n}\n\n/* new tab-5 css */\n.schedule-tabs .tab-buttons li:nth-child(4n + 5) .day {\n\tbackground-color: #05a7dc;\n}\n\n/* end  new tab-5 css */\n\n.schedule-tabs .tab-buttons li:nth-child(4n + 1) .month,\n.schedule-tabs .tab-buttons li:nth-child(4n + 1) .date {\n\tcolor: #ffc20b;\n}\n\n.schedule-tabs .tab-buttons li:nth-child(4n + 2) .month,\n.schedule-tabs .tab-buttons li:nth-child(4n + 2) .date {\n\tcolor: #40cbb4;\n}\n\n.schedule-tabs .tab-buttons li:nth-child(4n + 3) .month,\n.schedule-tabs .tab-buttons li:nth-child(4n + 3) .date {\n\tcolor: #4c35a9;\n}\n\n.schedule-tabs .tab-buttons li:nth-child(4n + 4) .month,\n.schedule-tabs .tab-buttons li:nth-child(4n + 4) .date {\n\tcolor: #e6275a;\n}\n\n/* new tab-5 css */\n.schedule-tabs .tab-buttons li:nth-child(4n + 5) .month,\n.schedule-tabs .tab-buttons li:nth-child(4n + 5) .date {\n\tcolor: #e6275a;\n}\n\n/* end  new tab-5 css */\n.schedule-tabs .tab-buttons li:nth-child(4n + 1).active-btn {\n\tbox-shadow: 0 0px 30px rgba(255, 194, 11, .30);\n\tborder: 1px solid #ffc20b;\n}\n\n.schedule-tabs .tab-buttons li:nth-child(4n + 2).active-btn {\n\tbox-shadow: 0 0px 30px rgba(64, 203, 180, .30);\n\tborder: 1px solid #40cbb4;\n}\n\n.schedule-tabs .tab-buttons li:nth-child(4n + 3).active-btn {\n\tbox-shadow: 0 0px 30px rgba(76, 53, 169, .30);\n\tborder: 1px solid #4c35a9;\n}\n\n.schedule-tabs .tab-buttons li:nth-child(4n + 4).active-btn {\n\tbox-shadow: 0 0px 30px rgba(230, 39, 90, .30);\n\tborder: 1px solid #e6275a;\n}\n\n/* new tab-5 css */\n.schedule-tabs .tab-buttons li:nth-child(4n + 5).active-btn {\n\tbox-shadow: 0 0px 30px rgba(43, 199, 234, .30);\n\tborder: 1px solid #05a7dc;\n}\n\n/* end  new tab-5 css */\n.schedule-timeline {\n\tposition: relative;\n}\n\n/*=== Schedule Block ===*/\n\n.schedule-block {\n\tposition: relative;\n\tmargin-bottom: -120px;\n}\n\n.schedule-block:after {\n\tdisplay: table;\n\tclear: both;\n\tcontent: \"\";\n}\n\n.schedule-block .inner-box {\n\tposition: relative;\n\tfloat: right;\n\twidth: 50%;\n\ttext-align: left;\n}\n\n.schedule-block .inner-box .inner {\n\tposition: relative;\n\tpadding: 20px 30px 20px;\n\tbackground-color: #ffffff;\n\tborder: 1px solid #dddddd;\n\tbox-shadow: 0 0 30px rgba(0, 0, 0, 0.05);\n\tmargin-left: 80px;\n\tborder-radius: 20px;\n}\n\n.schedule-block .inner:before {\n\tposition: absolute;\n\ttop: 0;\n\tbottom: 240px;\n\tright: 100%;\n\tborder-left: 2px dashed #dddddd;\n\tcontent: \"\";\n\tmargin-right: 80px;\n}\n\n.schedule-block .inner:after {\n\tposition: absolute;\n\tright: 100%;\n\ttop: 35px;\n\tborder-top: 15px solid transparent;\n\tborder-right: 20px solid #cccccc;\n\tborder-bottom: 15px solid transparent;\n\tcontent: \"\";\n}\n\n.schedule-block .date {\n\tposition: absolute;\n\tleft: -132px;\n\twidth: 100px;\n\ttop: 0px;\n\theight: 100px;\n\tbackground-color: #ffffff;\n\ttext-align: center;\n\tfont-size: 14px;\n\tline-height: 18px;\n\tcolor: #212639;\n\tfont-weight: 500;\n\tpadding: 20px 15px 0;\n\tborder-radius: 50%;\n\tborder: 2px dashed #dddddd;\n\tbox-shadow: 0 0 30px rgba(0, 0, 0, 0.05);\n}\n\n.schedule-block .speaker-info {\n\tposition: relative;\n\tpadding-left: 80px;\n\tpadding-top: 10px;\n\tmin-height: 60px;\n}\n\n.schedule-block .speaker-info .thumb {\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0;\n\twidth: 60px;\n\tborder-radius: 50%;\n\toverflow: hidden;\n}\n\n.schedule-block .speaker-info .name {\n\tfont-size: 16px;\n\tcolor: #212639;\n\tfont-weight: 500;\n\tline-height: 1.2em;\n}\n\n.schedule-block .speaker-info .designation {\n\tfont-size: 13px;\n}\n\n.schedule-block h4 {\n\tposition: relative;\n\tfont-size: 22px;\n\tline-height: 1.2em;\n\tcolor: #0f1925;\n\tfont-weight: 600;\n\tmargin-bottom: 15px;\n\tpadding-top: 15px;\n}\n\n.schedule-block h4 a {\n\tcolor: #212639;\n\tdisplay: inline-block;\n\t-webkit-transition: all 300ms ease;\n\t-moz-transition: all 300ms ease;\n\t-ms-transition: all 300ms ease;\n\t-o-transition: all 300ms ease;\n\ttransition: all 300ms ease;\n}\n\n.schedule-block h4 a:hover {\n\tcolor: #f14b59;\n}\n\n.schedule-block .text {\n\tposition: relative;\n\tfont-size: 16px;\n\tline-height: 26px;\n\tcolor: #888888;\n\tmargin-bottom: 15px;\n}\n\n.schedule-block .btn-box {\n\tposition: relative;\n\tpadding: 6px 0;\n}\n\n.schedule-block .btn-box a {\n\tpadding: 10px 20px;\n\tline-height: 20px;\n\tfont-size: 14px;\n\tbackground-color: #444444;\n\tcolor: #ffffff;\n\tborder-top: 2px solid transparent;\n\tborder-bottom: 2px solid transparent;\n\tborder-radius: 5px;\n}\n\n.schedule-block .btn-box a:hover {\n\tcolor: #ffffff;\n\t/* box-shadow: 0 10px 20px rgba(0,0,0,0.10); */\n}\n\n.schedule-block.even .inner-box {\n\tfloat: left;\n\ttext-align: right;\n}\n\n.schedule-block.even .inner-box .inner {\n\tmargin-left: 0;\n\tmargin-right: 80px;\n}\n\n.schedule-block.even .inner:before {\n\tright: auto;\n\tleft: 100%;\n\tmargin-left: 80px;\n\tmargin-right: 0;\n\tbottom: -40px;\n}\n\n.schedule-block.even .inner:after {\n\tright: auto;\n\tleft: 100%;\n\tborder-right: 0;\n\tborder-left: 20px solid #cccccc;\n}\n\n.schedule-block:last-child .inner:before {\n\tdisplay: none;\n}\n\n.schedule-block.even .date {\n\tleft: auto;\n\tright: -132px;\n}\n\n.schedule-block.even .speaker-info {\n\tpadding-left: 0;\n\tpadding-right: 80px;\n}\n\n.schedule-block.even .speaker-info .thumb {\n\tleft: auto;\n\tright: 0;\n}\n\n.schedule-block:nth-child(4n + 1) .date,\n.schedule-block:nth-child(4n + 1) .inner:before {\n\tborder-color: #ffc20b;\n\tbottom: 188px;\n}\n\n.schedule-block:nth-child(4n + 2) .date,\n.schedule-block:nth-child(4n + 2) .inner:before {\n\tborder-color: #05a7dc;\n}\n\n.schedule-block:nth-child(4n + 3) .date,\n.schedule-block:nth-child(4n + 3) .inner:before {\n\tborder-color: #40cbb4;\n}\n\n.schedule-block:nth-child(4n + 4) .date,\n.schedule-block:nth-child(4n + 4) .inner:before {\n\tborder-color: #4c35a9;\n}\n\n.schedule-block:nth-child(4n + 5) .date,\n.schedule-block:nth-child(4n + 5) .inner:before {\n\tborder-color: #e6275a;\n}\n\n\n/* Backgroud */\n\n.schedule-block:nth-child(4n + 1) .btn-box a {\n\tbackground-color: #ffc20b;\n}\n\n.schedule-block:nth-child(4n + 1) .btn-box a:hover {\n\tcolor: #ffc20b;\n\tborder-radius: 0px;\n\tbackground: none;\n\tborder-color: #ffc20b;\n}\n\n.schedule-block:nth-child(4n + 2) .btn-box a {\n\tbackground-color: #40cbb4;\n}\n\n.schedule-block:nth-child(4n + 2) .btn-box a:hover {\n\tborder-radius: 0px;\n\tcolor: #40cbb4;\n\tbackground: none;\n\tborder-color: #40cbb4;\n}\n\n\n\n\n\n.schedule-block:nth-child(4n + 3) .btn-box a {\n\tbackground-color: #4c35a9;\n}\n\n.schedule-block:nth-child(4n + 3) .btn-box a:hover {\n\tborder-radius: 0px;\n\tcolor: #4c35a9;\n\tbackground: none;\n\tborder-color: #4c35a9;\n}\n\n\n\n.schedule-block:nth-child(4n + 4) .btn-box a {\n\tbackground-color: #e6275a;\n}\n\n.schedule-block:nth-child(4n + 4) .btn-box a:hover {\n\tborder-radius: 0px;\n\tcolor: #e6275a;\n\tbackground: none;\n\tborder-color: #e6275a;\n}\n\n.schedule-block:nth-child(4n + 5) .btn-box a {\n\tbackground-color: #05a7dc;\n}\n\n.schedule-block:nth-child(4n + 5) .btn-box a:hover {\n\tborder-radius: 0px;\n\tcolor: #05a7dc;\n\tbackground: none;\n\tborder-color: #05a7dc;\n}\n\n\n/* color */\n\n.schedule-section.style-three .schedule-block:nth-child(4n + 1) .date,\n.schedule-section.style-two .schedule-block:nth-child(4n + 1) .date,\n.schedule-block:nth-child(4n + 1) h4 a:hover {\n\tcolor: #ffc20b;\n}\n\n.schedule-section.style-three .schedule-block:nth-child(4n + 2) .date,\n.schedule-section.style-two .schedule-block:nth-child(4n + 2) .date,\n.schedule-block:nth-child(4n + 2) h4 a:hover {\n\tcolor: #40cbb4;\n}\n\n.schedule-section.style-three .schedule-block:nth-child(4n + 3) .date,\n.schedule-section.style-two .schedule-block:nth-child(4n + 3) .date,\n.schedule-block:nth-child(4n + 3) h4 a:hover {\n\tcolor: #4c35a9;\n}\n\n.schedule-section.style-three .schedule-block:nth-child(4n + 4) .date,\n.schedule-section.style-two .schedule-block:nth-child(4n + 4) .date,\n.schedule-block:nth-child(4n + 4) h4 a:hover {\n\tcolor: #e6275a;\n}\n\n.schedule-section.style-three .schedule-block:nth-child(4n + 5) .date,\n.schedule-section.style-two .schedule-block:nth-child(4n + 5) .date,\n.schedule-block:nth-child(4n + 5) h4 a:hover {\n\tcolor: #05a7dc;\n}\n\n/***\n\n====================================================================\n\tschedule Section Style two\n====================================================================\n\n***/\n\n.schedule-section.style-two {\n\tposition: relative;\n}\n\n.schedule-section.style-two .schedule-block .date {\n\tposition: relative;\n\tleft: 0;\n\ttop: 0;\n\tmargin: 0;\n\tpadding: 0;\n\tborder: 0;\n\tbox-shadow: none;\n\theight: auto;\n\twidth: auto;\n\tmargin-bottom: 20px;\n\ttext-align: left;\n\tfont-size: 16px;\n}\n\n.schedule-section.style-two .schedule-block .inner-box {\n\twidth: 100%;\n}\n\n.schedule-section.style-two .schedule-block .inner-box .inner {\n\tmargin: 0;\n\tpadding: 50px 50px 40px;\n\tbox-shadow: 0 0 30px rgba(0, 0, 0, 0.10);\n}\n\n.schedule-section.style-two .schedule-block .inner:before,\n.schedule-section.style-two .schedule-block .inner:after {\n\tdisplay: none;\n}\n\n.schedule-section.style-two .schedule-timeline {\n\tposition: relative;\n\tmax-width: 900px;\n\tmargin: 0 auto;\n}\n\n/***\n\n====================================================================\n\tschedule Section Style Three\n====================================================================\n\n***/\n\n.schedule-section.style-three {\n\tposition: relative;\n}\n\n.schedule-tabs.style-three .tab-buttons li {\n\tfloat: left;\n\twidth: 25%;\n\tmargin: 0;\n\tbox-shadow: none;\n\tborder-radius: 0;\n\tborder-color: transparent;\n}\n\n.schedule-tabs.style-three .tab-buttons li.active-btn {\n\tz-index: 2;\n}\n\n.schedule-section.style-three .schedule-block .date {\n\tposition: relative;\n\tleft: 0;\n\ttop: 0;\n\tmargin: 0;\n\tpadding: 0;\n\tborder: 0;\n\tbox-shadow: none;\n\theight: auto;\n\twidth: auto;\n\tmargin-bottom: 20px;\n\ttext-align: left;\n\tfont-size: 16px;\n}\n\n.schedule-section.style-three .schedule-block .inner-box {\n\twidth: 100%;\n}\n\n.schedule-section.style-three .schedule-block .inner-box .inner {\n\tmargin: 0;\n\tpadding: 50px 50px 40px;\n\tbox-shadow: 0 0 30px rgba(0, 0, 0, 0.10);\n}\n\n.schedule-section.style-three .schedule-block .inner:before,\n.schedule-section.style-three .schedule-block .inner:after {\n\tdisplay: none;\n}\n\n.schedule-section.style-three .schedule-timeline {\n\tposition: relative;\n}\n\n/***\n\n====================================================================\n\t\tEvent Detail\n====================================================================\n\n***/\n\n.event-detail {\n\tposition: relative;\n\tpadding: 120px 0 90px;\n}\n\n.event-detail .auto-container {\n\tmax-width: 1000px;\n}\n\n.event-detail .image-box {\n\tposition: relative;\n\tmargin-bottom: 30px;\n}\n\n.event-detail .image-box .image {\n\tposition: relative;\n\tmargin-bottom: 0;\n}\n\n.event-detail .image-box .image img {\n\tdisplay: block;\n\twidth: 100%;\n\theight: auto;\n}\n\n.event-detail .content-box {\n\tposition: relative;\n}\n\n.event-detail .upper-info {\n\tposition: relative;\n\tmargin-bottom: 20px;\n}\n\n.event-detail .upper-info li {\n\tposition: relative;\n\tdisplay: inline-block;\n\tfont-size: 14px;\n\tline-height: 24px;\n\tcolor: #222222;\n\tfont-weight: 500;\n\ttext-transform: uppercase;\n\tpadding-left: 25px;\n\tmargin-right: 20px;\n}\n\n.event-detail .upper-info .icon {\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0;\n\tfont-size: 16px;\n\tline-height: 24px;\n\tcolor: #e1137b;\n}\n\n.event-detail .content-box h2 {\n\tdisplay: block;\n\tfont-size: 32px;\n\tline-height: 1.2em;\n\tcolor: #222222;\n\tfont-weight: 700;\n\tmargin-bottom: 25px;\n}\n\n.event-detail .speaker-info {\n\tposition: relative;\n\tpadding-left: 75px;\n\tmin-height: 60px;\n\tmargin-bottom: 25px;\n}\n\n.event-detail .speaker-info .thumb {\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0;\n\twidth: 60px;\n\tborder-radius: 50%;\n\toverflow: hidden;\n}\n\n.event-detail .speaker-info .name {\n\tfont-size: 16px;\n\tline-height: 30px;\n\tfont-weight: 500;\n\tcolor: #222222;\n}\n\n.event-detail .speaker-info .designation {\n\tfont-size: 14px;\n\tline-height: 20px;\n}\n\n.event-detail .content-box p {\n\tposition: relative;\n\tdisplay: block;\n\tfont-size: 16px;\n\tline-height: 30px;\n\tcolor: #888888;\n\tfont-weight: 400;\n\tmargin-bottom: 30px;\n}\n\n.event-detail .two-column {\n\tposition: relative;\n}\n\n.event-detail .two-column .column {\n\tmargin-bottom: 30px;\n}\n\n.event-detail .two-column .image {\n\tposition: relative;\n\tmargin-bottom: 0;\n}\n\n.event-detail .two-column .image img {\n\tdisplay: block;\n\twidth: 100%;\n}\n\n.event-detail .two-column h4 {\n\tfont-size: 20px;\n\tline-height: 1.2em;\n\tcolor: #222222;\n\tfont-weight: 500;\n\tmargin-bottom: 20px;\n\tmargin-top: 20px;\n}\n\n/***\n\n====================================================================\n\t\tPricing Section\n====================================================================\n\n***/\n\n.pricing-section {\n\tposition: relative;\n\tpadding: 120px 0 80px;\n\toverflow: hidden;\n}\n\n.pricing-section .outer-box {\n\tmax-width: 1100px;\n\tmargin: 0 auto;\n}\n\n\n.pricing-section .row {\n\tmargin: 0 -30px;\n}\n\n.pricing-block {\n\tposition: relative;\n\tpadding: 0 30px;\n\tmargin-bottom: 40px;\n}\n\n.pricing-block .inner-box {\n\tposition: relative;\n\tbackground-color: #ffffff;\n\tbox-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);\n\tpadding: 0 0 30px;\n\tmax-width: 370px;\n\tmargin: 0 auto;\n\tborder-bottom: 20px solid #40cbb4;\n\tborder-radius: 5px\n}\n\n.pricing-block .icon-box {\n\tposition: relative;\n\tpadding: 50px 30px 0;\n\tbackground-color: #40cbb4;\n\ttext-align: center;\n\tborder-radius: 5px\n}\n\n.pricing-block .icon-box:before {\n\tposition: absolute;\n\tleft: 0;\n\tbottom: 0;\n\theight: 75px;\n\twidth: 100%;\n\tborder-radius: 50% 50% 0 0;\n\tbackground-color: #ffffff;\n\tcontent: \"\";\n}\n\n\n.pricing-block .icon-box .icon-outer {\n\tposition: relative;\n\theight: 150px;\n\twidth: 150px;\n\tbackground-color: #ffffff;\n\tborder-radius: 50%;\n\tmargin: 0 auto;\n\tpadding: 10px;\n}\n\n.pricing-block .icon-box .icon {\n\tposition: relative;\n\tdisplay: block;\n\theight: 130px;\n\twidth: 130px;\n\tline-height: 120px;\n\tborder: 5px solid #40cbb4;\n\tborder-radius: 50%;\n\tfont-size: 70px;\n\tcolor: #40cbb4;\n\t-webkit-transition: all 600ms ease;\n\t-ms-transition: all 600ms ease;\n\t-o-transition: all 600ms ease;\n\t-moz-transition: all 600ms ease;\n\ttransition: all 600ms ease;\n}\n\n.pricing-block .inner-box:hover .icon-box .icon {\n\ttransform: rotate(360deg);\n}\n\n.pricing-block .price-box {\n\tposition: relative;\n\ttext-align: center;\n\tpadding: 10px 20px;\n}\n\n.pricing-block .title {\n\tposition: relative;\n\tdisplay: block;\n\tfont-size: 24px;\n\tline-height: 1.2em;\n\tcolor: #222222;\n\tfont-weight: 600;\n}\n\n.pricing-block .price {\n\tdisplay: block;\n\tfont-size: 30px;\n\tcolor: #222222;\n\tfont-weight: 700;\n\tcolor: #40cbb4;\n}\n\n\n.pricing-block .features {\n\tposition: relative;\n\tmax-width: 200px;\n\tmargin: 0 auto 20px;\n}\n\n.pricing-block .features li {\n\tposition: relative;\n\tdisplay: block;\n\tfont-size: 14px;\n\tline-height: 30px;\n\tcolor: #848484;\n\tfont-weight: 500;\n\tpadding: 5px 0;\n\tpadding-left: 30px;\n\tborder-bottom: 1px dashed #dddddd;\n}\n\n.pricing-block .features li:before {\n\tposition: absolute;\n\tleft: 0;\n\ttop: 5px;\n\tfont-size: 16px;\n\tline-height: 30px;\n\tcontent: \"\\52\";\n\tfont-family: 'ElegantIcons';\n\tcolor: #2bd40f;\n}\n\n.pricing-block .features li.false:before {\n\tcolor: #e1137b;\n\tcontent: \"\\51\";\n}\n\n.pricing-block .features li a {\n\tcolor: #848484;\n}\n\n.pricing-block .features li:last-child {\n\tborder-bottom: 0;\n}\n\n.pricing-block .btn-box {\n\tposition: relative;\n\ttext-align: center;\n}\n\n.pricing-block .btn-box a {\n\tposition: relative;\n\tdisplay: inline-block;\n\tfont-size: 14px;\n\tline-height: 25px;\n\tcolor: #ffffff;\n\tfont-weight: 500;\n\tpadding: 8px 30px;\n\tbackground-color: #40cbb4;\n\tborder-radius: 10px;\n\tborder-top: 2px solid transparent;\n\tborder-bottom: 2px solid transparent;\n\t-webkit-transition: all 400ms ease;\n\t-moz-transition: all 400ms ease;\n\t-ms-transition: all 400ms ease;\n\t-o-transition: all 400ms ease;\n\ttransition: all 300ms ease;\n}\n\n.pricing-block .btn-box a:hover {\n\tcolor: #ffffff;\n}\n\n.pricing-block .inner-box:hover .btn-box a {\n\tcolor: #40cbb4;\n\tbackground: none;\n\tborder-radius: 0px;\n\tborder-color: #40cbb4;\n}\n\n.pricing-block:nth-child(2) .icon-box .icon,\n.pricing-block:nth-child(2) .inner-box {\n\tborder-color: #1d95d2;\n}\n\n.pricing-block:nth-child(2) .btn-box a,\n.pricing-block:nth-child(2) .icon-box {\n\tbackground-color: #1d95d2;\n}\n\n.pricing-block:nth-child(2) .inner-box:hover .btn-box a {\n\tcolor: #1d95d2;\n\tbackground: none;\n\tborder-radius: 0px;\n\tborder-color: #1d95d2;\n}\n\n.pricing-block:nth-child(2) .icon-box .icon,\n.pricing-block:nth-child(2) .price {\n\tcolor: #1d95d2;\n}\n\n.pricing-block:nth-child(3) .icon-box .icon,\n.pricing-block:nth-child(3) .inner-box {\n\tborder-color: #ffc20b;\n}\n\n.pricing-block:nth-child(3) .btn-box a,\n.pricing-block:nth-child(3) .icon-box {\n\tbackground-color: #ffc20b;\n}\n\n.pricing-block:nth-child(3) .icon-box .icon,\n.pricing-block:nth-child(3) .price {\n\tcolor: #ffc20b;\n}\n\n.pricing-block:nth-child(3) .inner-box:hover .btn-box a {\n\tcolor: #ffc20b;\n\tbackground: none;\n\tborder-radius: 0px;\n\tborder-color: #ffc20b;\n}\n\n\n\n.icon-circle-green {\n\twidth: 300px;\n\theight: 300px;\n\t/* background-image: url(../images/icons/circle-green.png); */\n}\n\n.icon-circle-orange {\n\twidth: 300px;\n\theight: 300px;\n\t/* background-image: url(../images/icons/circle-orange.png); */\n}\n\n.icon-circle-pink {\n\twidth: 300px;\n\theight: 300px;\n\t/* background-image: url(../images/icons/circle-pink.png); */\n}\n\n.pricing-section .icon-circle-green {\n\tleft: -375px;\n\ttop: -50px;\n\topacity: .50;\n}\n\n.pricing-section .icon-circle-blue {\n\tright: -375px;\n\ttop: 50%;\n\topacity: .50;\n}\n\n.pricing-section .icon-circle-pink {\n\tleft: -375px;\n\tbottom: -100px;\n\topacity: .50;\n}\n\n.pricing-section .icon-circle-green,\n.pricing-section .icon-circle-blue,\n.pricing-section .icon-circle-pink {\n\t-webkit-animation: fa-spin 30s infinite;\n\t-moz-animation: fa-spin 30s infinite;\n\t-ms-animation: fa-spin 30s infinite;\n\t-o-animation: fa-spin 30s infinite;\n\tanimation: fa-spin 30s infinite;\n}\n\n/***\n\n====================================================================\n\t\tPricing Section Two\n====================================================================\n\n***/\n\n.pricing-section-two {\n\tposition: relative;\n\tpadding: 120px 0 70px;\n\toverflow: hidden;\n}\n\n.pricing-section-two.alternate {\n\tposition: relative;\n\tbackground-color: #fafafa;\n}\n\n\n.pricing-section-two .outer-box {\n\tposition: relative;\n\tmax-width: 1000px;\n\tmargin: 0 auto;\n}\n\n.pricing-block-two {\n\tposition: relative;\n\tdisplay: block;\n\tmargin-bottom: 50px;\n}\n\n.pricing-block-two .inner-box {\n\tposition: relative;\n\tbackground-color: #ffffff;\n\tpadding: 30px 30px 25px;\n\tmax-width: 300px;\n\tmargin: 0 auto;\n\tborder: 1px solid #dddddd;\n\tbox-shadow: 0 20px 40px rgba(0, 0, 0, 0.07);\n\t-webkit-transition: all 500ms ease;\n\t-moz-transition: all 500ms ease;\n\t-ms-transition: all 500ms ease;\n\t-o-transition: all 500ms ease;\n\ttransition: all 500ms ease;\n}\n\n.pricing-block-two .inner-box:hover {\n\tbox-shadow: 0 0 0px rgba(0, 0, 0, 0.07);\n}\n\n.pricing-block-two .inner-box:hover .theme-btn {\n\tborder-radius: 0px;\n}\n\n.pricing-block-two .title {\n\tposition: relative;\n\tdisplay: block;\n\tfont-size: 20px;\n\tline-height: 1.2em;\n\tcolor: #212639;\n\tfont-weight: 500;\n\ttext-transform: uppercase;\n\tmargin-bottom: 25px;\n}\n\n.pricing-block-two .title .icon {\n\tfont-size: 22px;\n\tmargin-right: 5px;\n\tdisplay: inline-block;\n}\n\n.pricing-block-two .price-box {\n\tposition: relative;\n\tmargin-left: -30px;\n}\n\n.pricing-block-two .price {\n\tposition: relative;\n\tdisplay: inline-block;\n\tfont-size: 38px;\n\tline-height: .9em;\n\tcolor: #ffffff;\n\tfont-weight: 600;\n\tmargin-bottom: 20px;\n\tpadding: 20px 30px;\n\tpadding-right: 30px;\n\tborder-radius: 0 50px 50px 0;\n\tbackground: rgb(247, 0, 104);\n\t-webkit-transition: all 500ms ease;\n\t-moz-transition: all 500ms ease;\n\t-ms-transition: all 500ms ease;\n\t-o-transition: all 500ms ease;\n\ttransition: all 500ms ease;\n\tbackground: -moz-linear-gradient(to left, rgba(247, 0, 104, 1) 0%, rgba(68, 16, 102, 1) 25%, rgba(247, 0, 104, 1) 75%, rgba(68, 16, 102, 1) 100%);\n\tbackground: -webkit-linear-gradient(to left, rgba(247, 0, 104, 1) 0%, rgba(68, 16, 102, 1) 25%, rgba(247, 0, 104, 1) 75%, rgba(68, 16, 102, 1) 100%);\n\tbackground: linear-gradient(to left, rgba(247, 0, 104) 0%, rgba(68, 16, 102, 1) 25%, rgba(247, 0, 104, 1) 75%, rgba(68, 16, 102, 1) 100%);\n\tfilter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#F70068', endColorstr='#441066', GradientType=1);\n\tbackground-size: 600% 100%;\n}\n\n.pricing-block-two .inner-box:hover .price {\n\tpadding-right: 80px;\n}\n\n.pricing-block-two .features {\n\tposition: relative;\n\tmax-width: 300px;\n\tmargin: 0 auto 20px;\n}\n\n.pricing-block-two .features li {\n\tposition: relative;\n\tdisplay: block;\n\tfont-size: 14px;\n\tline-height: 30px;\n\tcolor: #848484;\n\tfont-weight: 500;\n\tpadding: 5px 0;\n\tpadding-left: 30px;\n\tborder-bottom: 1px dashed #dddddd;\n}\n\n.pricing-block-two .features li:before {\n\tposition: absolute;\n\tleft: 0;\n\ttop: 5px;\n\tfont-size: 16px;\n\tline-height: 30px;\n\tcontent: \"\\52\";\n\tfont-family: 'ElegantIcons';\n\tcolor: #2bd40f;\n}\n\n.pricing-block-two .features li.false:before {\n\tcolor: #e1137b;\n\tcontent: \"\\51\";\n}\n\n.pricing-block-two .features li a {\n\tcolor: #848484;\n}\n\n.pricing-block-two .features li:last-child {\n\tborder-bottom: 0;\n}\n\n.pricing-block-two .btn-box {\n\tposition: relative;\n\ttext-align: center;\n}\n\n.pricing-block-two .btn-box a {\n\tposition: relative;\n\tfont-size: 14px;\n\tline-height: 25px;\n\tfont-weight: 500;\n\tpadding: 8px 30px;\n\tborder-radius: 30px;\n}\n\n.pricing-section-two .icon-line-1 {\n\tright: 0%;\n\ttop: 15%;\n}\n\n.pricing-section-two .icon-dots {\n\tright: 0%;\n\tbottom: 15%;\n}\n\n.pricing-section-two .icon-circle-1 {\n\tleft: -400px;\n\tbottom: -200px;\n\topacity: .30;\n}\n\n.icon-shape-5 {\n\twidth: 540px;\n\theight: 330px;\n\t/* background-image: url(../images/icons/shape-5.png); */\n\tbackground-size: 100%;\n}\n\n/***\n\n====================================================================\n\t\tPricing Section Three\n====================================================================\n\n***/\n\n.pricing-section-three {\n\tposition: relative;\n\tpadding: 120px 0 70px;\n\toverflow: hidden;\n}\n\n.pricing-section-three .outer-box {\n\tposition: relative;\n\tmax-width: 1000px;\n\tmargin: 0 auto;\n}\n\n.pricing-block-three {\n\tposition: relative;\n\tmargin-bottom: 50px;\n}\n\n.pricing-block-three .inner-box {\n\tposition: relative;\n\tbackground-color: #ffffff;\n\tborder-radius: 30px;\n\tpadding: 70px 20px 60px;\n\ttext-align: center;\n\tmax-width: 400px;\n\tmargin: 0 auto;\n\tbox-shadow: 0 0 30px rgba(0, 0, 0, 0.10);\n\t-webkit-transition: all 500ms ease;\n\t-moz-transition: all 500ms ease;\n\t-ms-transition: all 500ms ease;\n\t-o-transition: all 500ms ease;\n\ttransition: all 500ms ease;\n}\n\n.pricing-block-three .inner-box:hover {}\n\n.pricing-block-three .title {\n\tposition: relative;\n\tdisplay: block;\n\tfont-size: 38px;\n\tline-height: 1em;\n\tcolor: #848484;\n\tfont-weight: 200;\n\ttext-transform: uppercase;\n\tpadding-bottom: 30px;\n\tmargin-bottom: 25px;\n}\n\n.pricing-block-three .title:before {\n\tposition: absolute;\n\tbottom: 0;\n\tleft: 50%;\n\tmargin-left: -40px;\n\twidth: 80px;\n\tbackground-color: #848484;\n\theight: 2px;\n\tcontent: \"\";\n}\n\n.pricing-block-three .price {\n\tposition: relative;\n\tdisplay: block;\n\tfont-size: 100px;\n\tline-height: .9em;\n\tcolor: #ec167f;\n\tfont-weight: 200;\n\tfont-family: 'Poppins', sans-serif;\n\tmargin-bottom: 20px;\n}\n\n.pricing-block-three .features {\n\tposition: relative;\n\tmax-width: 300px;\n\tmargin: 0 auto 20px;\n}\n\n.pricing-block-three .features li {\n\tposition: relative;\n\tdisplay: block;\n\tfont-size: 14px;\n\tline-height: 30px;\n\tcolor: #848484;\n\tfont-weight: 500;\n\tpadding: 5px 0;\n\tborder-bottom: 1px dashed #dddddd;\n}\n\n.pricing-block-three .features li a {\n\tcolor: #848484;\n}\n\n.pricing-block-three .features li:last-child {\n\tborder-bottom: 0;\n}\n\n.pricing-block-three .btn-box {\n\tposition: relative;\n\ttext-align: center;\n}\n\n.pricing-block-three .btn-box a {\n\tposition: relative;\n\tfont-size: 14px;\n\tline-height: 25px;\n\tfont-weight: 500;\n\tpadding: 8px 30px;\n\tborder-radius: 30px;\n}\n\n.pricing-section-three .icon-line-1 {\n\tright: 0%;\n\ttop: 15%;\n}\n\n.pricing-section-three .icon-dots {\n\tright: 0%;\n\tbottom: 15%;\n}\n\n.pricing-section-three .icon-circle-1 {\n\tleft: -400px;\n\tbottom: -200px;\n\topacity: .30;\n}\n\n/***\n\n====================================================================\n\t\tFun Fact Section\n====================================================================\n\n***/\n\n.fun-fact-section {\n\tposition: relative;\n\tpadding: 100px 0 50px;\n}\n\n.fun-fact-section:before {\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0;\n\theight: 100%;\n\twidth: 100%;\n\tbackground-repeat: no-repeat;\n\tbackground-position: center;\n\tbackground-size: cover;\n\t/* background-image: url(../images/icons/pattern-1.jpg); */\n\tcontent: \"\";\n\topacity: .10;\n}\n\n.fun-fact-section .fact-counter {\n\tposition: relative;\n}\n\n.fun-fact-section .counter-column {\n\tposition: relative;\n\ttext-align: center;\n\tmargin-bottom: 50px;\n}\n\n.fun-fact-section .count-box {\n\tposition: relative;\n\tfont-size: 80px;\n\tline-height: 1em;\n\tcolor: #222222;\n\tfont-weight: 700;\n}\n\n.fun-fact-section .count-box .icon {\n\tposition: relative;\n\tdisplay: inline-block;\n\tfont-size: 60px;\n\tcolor: #ffffff;\n\tmargin-bottom: 20px;\n\theight: 120px;\n\twidth: 120px;\n\tline-height: 120px;\n\tborder-radius: 50%;\n\tfont-weight: 400;\n\t-webkit-transition: all 600ms ease;\n\t-ms-transition: all 600ms ease;\n\t-o-transition: all 600ms ease;\n\t-moz-transition: all 600ms ease;\n\ttransition: all 600ms ease;\n\tbackground-color: #222222;\n\tbox-shadow: 5px 10px 30px rgba(0, 0, 0, 0.10);\n}\n\n.fun-fact-section .count-box:hover .icon {\n\ttransform: rotateY(360deg);\n}\n\n.fun-fact-section .count-box .count-text {\n\tposition: relative;\n\tdisplay: block;\n\tfont-size: 60px;\n\tline-height: 1em;\n\tcolor: #15212f;\n\ttext-shadow: 10px 10px 10px rgba(0, 0, 0, 0.10);\n\tfont-weight: 600;\n\tmargin-bottom: 10px;\n}\n\n.fun-fact-section .count-box .counter-title {\n\tposition: relative;\n\tdisplay: block;\n\tfont-size: 18px;\n\tline-height: 22px;\n\tfont-weight: 700;\n\tcolor: #222222;\n}\n\n.fun-fact-section .counter-column:nth-child(4n + 1) .count-box .icon {\n\tbackground-color: #ffc20b;\n}\n\n.fun-fact-section .counter-column:nth-child(4n + 2) .count-box .icon {\n\tbackground-color: #40cbb4;\n}\n\n.fun-fact-section .counter-column:nth-child(4n + 3) .count-box .icon {\n\tbackground-color: #4c35a9;\n}\n\n.fun-fact-section .counter-column:nth-child(4n + 4) .count-box .icon {\n\tbackground-color: #e6275a;\n}\n\n.fun-fact-section .counter-column:nth-child(4n + 1) .counter-title {\n\tcolor: #ffc20b;\n}\n\n.fun-fact-section .counter-column:nth-child(4n + 2) .counter-title {\n\tcolor: #40cbb4;\n}\n\n.fun-fact-section .counter-column:nth-child(4n + 3) .counter-title {\n\tcolor: #4c35a9;\n}\n\n.fun-fact-section .counter-column:nth-child(4n + 4) .counter-title {\n\tcolor: #e6275a;\n}\n\n.fun-fact-section.style-two {\n\tbackground-repeat: no-repeat;\n\tbackground-position: center;\n\tbackground-size: cover;\n}\n\n.fun-fact-section.style-two:before {\n\tbackground: #1c94d2;\n\topacity: 0;\n}\n\n.fun-fact-section.style-two .count-box .count-text {\n\tcolor: #ffffff;\n}\n\n\n\n/*====================================================\n\t\tFAQ's Section\n====================================================*/\n\n.faq-section {\n\tposition: relative;\n\tpadding: 120px 0 90px;\n}\n\n.faq-section .content-column {\n\tposition: relative;\n\tmargin-bottom: 30px;\n}\n\n/* Accordian Box */\n\n.accordion-box {\n\tposition: relative;\n}\n\n.accordion-box .block {\n\tposition: relative;\n\tmargin-bottom: 30px;\n\tbox-shadow: 0 0 20px rgba(0, 0, 0, 0.10);\n}\n\n.accordion-box .block:last-child {\n\tmargin-bottom: 0px;\n}\n\n.accordion-box .block .acc-btn {\n\tposition: relative;\n\tfont-size: 18px;\n\tcursor: pointer;\n\tline-height: 28px;\n\tcolor: #ffffff;\n\tfont-weight: 400;\n\tborder-radius: 4px;\n\tpadding: 15px 25px 15px 25px;\n\tpadding-right: 50px;\n\tborder: 1px solid #dddddd;\n\tbackground-color: #40cbb4;\n\t-webkit-transition: all 300ms ease;\n\t-moz-transition: all 300ms ease;\n\t-ms-transition: all 300ms ease;\n\t-o-transition: all 300ms ease;\n\ttransition: all 300ms ease;\n}\n\n.accordion-box .block .icon-outer {\n\tposition: absolute;\n\tright: 25px;\n\ttop: 10px;\n\tfont-size: 18px;\n\tline-height: 35px;\n\tcolor: #ffffff;\n\ttext-align: center;\n\t-webkit-transform: rotate(-90deg);\n\t-moz-transform: rotate(-90deg);\n\t-ms-transform: rotate(-90deg);\n\t-o-transform: rotate(-90deg);\n\ttransform: rotate(-90deg);\n\t-webkit-transition: all 300ms ease;\n\t-moz-transition: all 300ms ease;\n\t-ms-transition: all 300ms ease;\n\t-o-transition: all 300ms ease;\n\ttransition: all 300ms ease;\n}\n\n.accordion-box .block .acc-btn .icon-outer .icon {\n\tposition: relative;\n}\n\n.accordion-box .block.active-block {\n\tbox-shadow: 0 0 20px rgba(0, 0, 0, 0.10);\n}\n\n.accordion-box .block .acc-btn.active .icon-outer {\n\t-webkit-transform: rotate(0deg);\n\t-moz-transform: rotate(0deg);\n\t-ms-transform: rotate(0deg);\n\t-o-transform: rotate(0deg);\n\ttransform: rotate(0deg);\n}\n\n.accordion-box .block .acc-content {\n\tposition: relative;\n\tdisplay: none;\n\tbackground-color: #ffffff;\n\tborder: 1px solid #dddddd;\n\tborder-top: 0;\n}\n\n.accordion-box .block .acc-content.current {\n\tdisplay: block;\n}\n\n.accordion-box .block .content {\n\tposition: relative;\n\tfont-size: 16px;\n\tpadding: 30px 35px;\n}\n\n.accordion-box .block .content .text {\n\tposition: relative;\n\tfont-size: 16px;\n\tline-height: 26px;\n\tcolor: #888888;\n}\n\n.accordion-box .block .content p:last-child {\n\tmargin-bottom: 0px;\n}\n\n\n/***\n\n====================================================================\n\t\tFAQ Form Section\n====================================================================\n\n***/\n\n.faq-form-section {\n\tposition: relative;\n\tpadding: 120px 0 120px;\n\tbackground-color: #fafafa;\n}\n\n.faq-form-section .faq-form {\n\tposition: relative;\n}\n\n.faq-form .form-group {\n\tposition: relative;\n\tmargin-bottom: 20px;\n}\n\n.faq-form .form-group input[type=\"text\"],\n.faq-form .form-group input[type=\"number\"],\n.faq-form .form-group input[type=\"email\"],\n.faq-form .form-group input[type=\"url\"],\n.faq-form .form-group textarea,\n.faq-form .form-group select {\n\tposition: relative;\n\tdisplay: block;\n\twidth: 100%;\n\tfont-size: 15px;\n\tcolor: #222222;\n\tline-height: 28px;\n\tpadding: 10px 25px;\n\tbackground-color: #ffffff;\n\tfont-weight: 400;\n\theight: 50px;\n\tborder: 1px solid #dddddd;\n\t-webkit-transition: all 300ms ease;\n\t-moz-transition: all 300ms ease;\n\t-ms-transition: all 300ms ease;\n\t-o-transition: all 300ms ease;\n\ttransition: all 300ms ease;\n}\n\n.faq-form .form-group input:focus,\n.faq-form .form-group select:focus,\n.faq-form .form-group textarea:focus {\n\tbox-shadow: 0 0 20px rgba(0, 0, 0, 0.10);\n}\n\n.faq-form .form-group textarea {\n\theight: 200px;\n\tresize: none;\n\tpadding-top: 15px;\n}\n\n.faq-form .form-group button {\n\tborder: 0;\n\tfont-size: 14px;\n\tfont-weight: 400;\n\tmargin-top: 10px;\n}\n\n.faq-form-section .image-column {\n\tposition: relative;\n}\n\n.faq-form-section .image-column .image-box {\n\tposition: relative;\n}\n\n.faq-form-section .image-column .image {\n\tposition: relative;\n\tmargin-bottom: 0;\n}\n\n.faq-form-section .image-column .image img {\n\tdisplay: block;\n}\n\n\n/***\n\n====================================================================\n\t\t\tWhy Choose Us\n====================================================================\n\n***/\n\n.why-choose-us {\n\tposition: relative;\n\tbackground-color: #fafafa;\n\tpadding: 120px 0 70px;\n}\n\n.why-choose-us .image-column {\n\tposition: relative;\n\tmargin-bottom: 50px\n}\n\n.why-choose-us .image-column .image-box {\n\tposition: relative;\n}\n\n.why-choose-us .image-column .image-box .image {\n\tposition: relative;\n\tmargin-bottom: 0;\n}\n\n.why-choose-us .image-column .image-box img {\n\tdisplay: block;\n\twidth: 100%;\n}\n\n.why-choose-us .content-column {\n\tposition: relative;\n\tmargin-bottom: 50px;\n}\n\n.why-choose-us .content-column .inner-column {\n\tposition: relative;\n\tpadding-top: 20px;\n}\n\n.why-choose-us .content-column .sec-title {\n\tposition: relative;\n\tmargin-bottom: 30px;\n}\n\n.why-choose-us .content-column .list-style-one {\n\tmargin-bottom: 30px;\n}\n\n\n/***\n\n====================================================================\n\t\tApp Section\n====================================================================\n\n***/\n\n.app-section {\n\tposition: relative;\n\tbackground-color: #fafafa;\n\tpadding: 90px 0;\n\tz-index: 9;\n}\n\n.app-section .image-column {\n\tposition: relative;\n}\n\n.app-section .image-column .inner-column {\n\tposition: relative;\n\ttext-align: right;\n}\n\n.app-section .image-column .image-box {\n\tposition: relative;\n}\n\n.app-section .image {\n\tposition: relative;\n\tmargin-bottom: 0;\n}\n\n.app-section .image img {\n\tdisplay: inline-block;\n\tmax-width: 100%;\n\theight: auto;\n}\n\n.app-section .content-column {\n\tposition: relative;\n\tmargin-bottom: 50px;\n}\n\n.app-section .content-column .inner-column {\n\tposition: relative;\n\tpadding-top: 80px;\n}\n\n.app-section .content-column .sec-title {\n\tmargin-bottom: 30px;\n}\n\n.app-section .content-column .text-box {\n\tfont-size: 16px;\n\tmargin-bottom: 30px;\n}\n\n.app-section .link-box {\n\tposition: relative;\n}\n\n.app-section .link-box a {\n\tposition: relative;\n\tdisplay: inline-block;\n\tmargin-right: 25px;\n\tmargin-bottom: 10px;\n\t-webkit-transition: all 300ms ease;\n\t-moz-transition: all 300ms ease;\n\t-ms-transition: all 300ms ease;\n\t-o-transition: all 300ms ease;\n\ttransition: all 300ms ease;\n}\n\n.app-section .link-box a:hover {\n\t-webkit-box-shadow: 0 10px 25px rgba(0, 0, 0, 0.30);\n\t-moz-box-shadow: 0 10px 25px rgba(0, 0, 0, 0.30);\n\t-ms-box-shadow: 0 10px 25px rgba(0, 0, 0, 0.30);\n\t-o-box-shadow: 0 10px 25px rgba(0, 0, 0, 0.30);\n\tbox-shadow: 0 10px 25px rgba(0, 0, 0, 0.30);\n}\n\n\n/***\n\n====================================================================\n\t\tGallery Section\n====================================================================\n\n***/\n\n.gallery-section {\n\tposition: relative;\n\tpadding: 120px 0 90px;\n}\n\n.gallery-item {\n\tposition: relative;\n\tmargin-bottom: 90px;\n\tmargin-top: -5px;\n}\n\n.gallery-item .image-box {\n\tposition: relative;\n\tbox-shadow: 0 0px 30px rgba(8, 13, 62, .10);\n\toverflow: hidden;\n}\n\n.gallery-item .image-box .image {\n\tposition: relative;\n\tmargin-bottom: 0;\n}\n\n.gallery-item .image-box .image img {\n\tdisplay: block;\n\twidth: 100%;\n\theight: auto;\n}\n\n.gallery-item .overlay-box {\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0;\n\theight: 100%;\n\twidth: 100%;\n\ttext-align: center;\n\tcontent: \"\";\n\topacity: 0;\n\tbackground-color: #1d95d2;\n\t-webkit-transform: scale(.5);\n\t-moz-transform: scale(.5);\n\t-ms-transform: scale(.5);\n\t-o-transform: scale(.5);\n\ttransform: scale(.5);\n\tborder-radius: 500px;\n\t-webkit-transition: all 300ms ease;\n\t-moz-transition: all 300ms ease;\n\t-ms-transition: all 300ms ease;\n\t-o-transition: all 300ms ease;\n\ttransition: all 300ms ease;\n}\n\n.gallery-item .image-box:hover .overlay-box {\n\t-webkit-transform: scale(1);\n\t-moz-transform: scale(1);\n\t-ms-transform: scale(1);\n\t-o-transform: scale(1);\n\ttransform: scale(1);\n\topacity: .9;\n\tborder-radius: 0px;\n}\n\n.gallery-item .overlay-box a {\n\tposition: absolute;\n\tleft: 56%;\n\ttop: 67px;\n\tmargin-top: -20px;\n\tmargin-left: 86px;\n}\n\n.gallery-item .overlay-box a span {\n\tdisplay: block;\n\theight: 58px;\n\twidth: 58px;\n\tbackground-color: #ec167f;\n\tcolor: #ffffff;\n\tborder-radius: 50%;\n\tfont-weight: 700;\n\tfont-size: 18px;\n\tline-height: 58px;\n}\n\n.gallery-section .owl-nav {\n\tdisplay: none;\n}\n\n.gallery-section.style-two {\n\tpadding: 0;\n}\n\n.gallery-section.style-two .gallery-item {\n\tmargin-bottom: 0;\n}\n\n\n\n/***\n\n====================================================================\n\t\tEvent Info Section\n====================================================================\n\n***/\n\n.event-info-section {\n\tposition: relative;\n\tpadding: 120px 0 120px;\n}\n\n.event-info-section .info-column {\n\tposition: relative;\n}\n\n.event-info-section .info-column .inner-column {\n\tposition: relative;\n\tpadding-left: 30px;\n}\n\n.event-info-section .info-column .sec-title {\n\tmargin-bottom: 50px;\n}\n\n.event-info-section .info-column .sec-title h2 {\n\tfont-size: 40px;\n}\n\n.event-info-tabs {\n\tposition: relative;\n}\n\n.event-info-tabs .tab-buttons {\n\tposition: relative;\n}\n\n.event-info-tabs .tab-btn {\n\tposition: relative;\n\tfloat: left;\n\tpadding: 10px 25px;\n\tfont-size: 14px;\n\tline-height: 20px;\n\tcolor: #ffffff;\n\tbackground-color: #1d95d2;\n\tfont-weight: 600;\n\tcursor: pointer;\n\tmargin-right: 5px;\n\tborder: 1px solid #dddddd;\n\tborder-bottom: 0;\n\tmargin-bottom: -2px;\n\tz-index: 3;\n\t-webkit-transition: all 300ms ease;\n\t-moz-transition: all 300ms ease;\n\t-ms-transition: all 300ms ease;\n\t-o-transition: all 300ms ease;\n\ttransition: all 300ms ease;\n}\n\n.event-info-tabs .tab-btn:hover,\n.event-info-tabs .tab-btn.active-btn {\n\tcolor: #1d95d2;\n\tbackground-color: #ffffff;\n}\n\n.event-info-tabs .tabs-content {\n\tposition: relative;\n\tbackground-color: #ffffff;\n\tborder: 1px solid #dddddd;\n\tpadding: 30px 30px;\n\tbox-shadow: 0 30px 20px rgba(0, 0, 0, .05);\n}\n\n.event-info-tabs .tabs-content .tab {\n\tmin-height: 155px;\n}\n\n.event-info-tabs .tabs-content h4 {\n\tposition: relative;\n\tdisplay: block;\n\tfont-size: 24px;\n\tline-height: 1.2em;\n\tcolor: #3f4161;\n\tfont-weight: 500;\n\tmargin-bottom: 10px;\n}\n\n.event-info-tabs .tabs-content h4 .icon {\n\tcolor: #40cbb4;\n\tfont-size: 20px;\n\tmargin-right: 10px;\n}\n\n\n.event-info-tabs .tabs-content h5 {\n\tposition: relative;\n\tdisplay: block;\n\tfont-size: 20px;\n\tline-height: 1.2em;\n\tcolor: #3f4161;\n\tfont-weight: 500;\n\tmargin-bottom: 20px;\n}\n\n.event-info-tabs .tabs-content .text {\n\tfont-size: 16px;\n\tline-height: 28px;\n\tcolor: #888888;\n\tmax-width: 470px;\n}\n\n.event-info-tabs .tabs-content .info-list {\n\tposition: relative;\n\tmargin-top: 10px;\n}\n\n.event-info-tabs .tabs-content .info-list li {\n\tposition: relative;\n\tpadding-left: 30px;\n\tfont-size: 16px;\n\tline-height: 26px;\n\tcolor: #616977;\n\tfont-weight: 400;\n}\n\n.event-info-tabs .tabs-content .info-list li .icon {\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0;\n\tfont-size: 14px;\n\tline-height: 26px;\n\tcolor: #ec167f;\n}\n\n.event-info-tabs .tabs-content .info-list li a {\n\tcolor: #616977;\n\tdisplay: inline-block;\n\t-webkit-transition: all 300ms ease;\n\t-moz-transition: all 300ms ease;\n\t-ms-transition: all 300ms ease;\n\t-o-transition: all 300ms ease;\n\ttransition: all 300ms ease;\n}\n\n.event-info-tabs .tabs-content .info-list li a:hover {\n\tcolor: #f0228c;\n\ttext-decoration: underline;\n}\n\n.event-info-section .image-column {\n\tposition: relative;\n}\n\n.event-info-section .image-column .image {\n\tposition: relative;\n\tbackground-color: #ffffff;\n\tpadding-top: 60px;\n\tmargin-bottom: 0;\n}\n\n.event-info-section .image-column .image img {\n\tdisplay: block;\n\twidth: 100%;\n\theight: auto;\n}\n\n.event-info-section .map-column {}\n\n.event-info-section .map-outer .map-canvas,\n.event-info-section .map-outer {\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0;\n\theight: 100%;\n\twidth: 100%;\n}\n\n.event-info-section .map-outer .map-canvas {\n\tright: 15px;\n\tleft: 15px;\n\twidth: auto;\n}\n\n\n\n\n/***\n\n====================================================================\n\t\tTestimonial Section\n====================================================================\n\n***/\n\n.testimonial-section {\n\tposition: relative;\n\tpadding: 120px 0;\n\tbackground-color: #fdfdfd;\n}\n\n.testimonial-section .bg-layer {\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0;\n\theight: 100%;\n\twidth: 100%;\n\tbackground-repeat: no-repeat;\n\tbackground-position: center bottom;\n\tbackground-size: 100%;\n\topacity: .02;\n}\n\n.testimonial-section .sec-title {\n\tmargin-bottom: 50px;\n}\n\n.testimonial-section .carousel-outer {\n\tposition: relative;\n\tmax-width: 800px;\n\tmargin: 0 auto;\n}\n\n.testimonial-block {\n\tposition: relative;\n\ttext-align: center;\n}\n\n.testimonial-block .inner {\n\tposition: relative;\n}\n\n.testimonial-block .icon {\n\tposition: relative;\n\tdisplay: inline-block;\n\tfont-size: 40px;\n\tline-height: 80px;\n\twidth: 80px;\n\theight: 80px;\n\tbackground-color: #40cbb4;\n\tcolor: #ffffff;\n\tborder-radius: 50%;\n\tmargin-bottom: 30px;\n\ttext-shadow: 10px 10px 0 rgba(0, 0, 0, 0.2);\n}\n\n.testimonial-block .text {\n\tposition: relative;\n\tdisplay: block;\n\tfont-size: 20px;\n\tline-height: 36px;\n\tcolor: #888888;\n\tfont-weight: 400;\n\tmax-width: 700px;\n\tmargin: 0 auto 25px;\n}\n\n.testimonial-block .name {\n\tposition: relative;\n\tdisplay: block;\n\tfont-size: 20px;\n\tline-height: 1.2em;\n\tcolor: #222222;\n\tfont-weight: 500;\n\tmargin-bottom: 5px;\n}\n\n.testimonial-block .rating {\n\tposition: relative;\n\tfont-size: 15px;\n\tline-height: 25px;\n\tcolor: #ffc20b;\n}\n\n.testimonial-section .owl-nav {\n\tposition: absolute;\n\ttop: 50%;\n\twidth: 100%;\n}\n\n.testimonial-section .owl-next,\n.testimonial-section .owl-prev {\n\tposition: absolute;\n\tleft: -80px;\n\ttop: 0;\n\theight: 40px;\n\twidth: 40px;\n\tfont-size: 22px;\n\tcolor: #ffffff;\n\tline-height: 40px;\n\tmargin-left: 15px;\n\tborder-radius: 50%;\n\ttext-align: center;\n\tbackground-color: #1c94d2;\n\t-webkit-transition: all 300ms ease;\n\t-moz-transition: all 300ms ease;\n\t-ms-transition: all 300ms ease;\n\t-o-transition: all 300ms ease;\n\ttransition: all 300ms ease;\n}\n\n.testimonial-section .owl-next {\n\tleft: auto;\n\tright: -80px;\n}\n\n.testimonial-section .owl-next:hover,\n.testimonial-section .owl-prev:hover {\n\tbox-shadow: 0 0 20px rgba(0, 0, 0, 0.20);\n}\n\n\n/***\n\n====================================================================\n\t\tNews Section\n====================================================================\n\n***/\n\n.news-section {\n\tposition: relative;\n\tpadding: 110px 0 80px;\n\toverflow: hidden;\n}\n\n.news-section.alternate {\n\tpadding: 120px 0;\n}\n\n.news-section .styled-pagination {\n\tmargin-top: 30px;\n}\n\n.news-block {\n\tposition: relative;\n\tmargin-bottom: 40px;\n}\n\n.news-block .inner-box {\n\tposition: relative;\n\tbackground-color: #ffffff;\n\tbox-shadow: 0 0 20px rgba(0, 0, 0, 0.10);\n}\n\n.news-block .image-box {\n\tposition: relative;\n}\n\n.news-block .image {\n\tposition: relative;\n\toverflow: hidden;\n\tmargin-bottom: 0;\n}\n\n.news-block .image-box .image a:after {\n\tcontent: \"\";\n\tposition: absolute;\n\ttop: -110%;\n\tleft: -210%;\n\twidth: 200%;\n\theight: 200%;\n\topacity: 0;\n\tbackground: rgba(255, 255, 255, 0.13);\n\tbackground: linear-gradient(to right,\n\t\t\trgba(255, 255, 255, 0.13) 0%,\n\t\t\trgba(255, 255, 255, 0.13) 77%,\n\t\t\trgba(255, 255, 255, 0.5) 92%,\n\t\t\trgba(255, 255, 255, 0.0) 100%);\n}\n\n.news-block .inner-box:hover .image-box .image a:after {\n\topacity: 1;\n\ttop: -20%;\n\tleft: -30%;\n\ttransition-property: left, top, opacity;\n\ttransition-duration: 0.7s, 0.7s, 0.15s;\n\ttransition-timing-function: linear;\n}\n\n.news-block .image img {\n\tdisplay: block;\n\twidth: 100%;\n}\n\n.news-block .lower-content {\n\tposition: relative;\n\tpadding: 20px 30px 30px;\n}\n\n.news-block .post-info {\n\tposition: relative;\n\tmargin-bottom: 10px;\n}\n\n.news-block .post-info li {\n\tposition: relative;\n\tdisplay: inline-block;\n\tfont-size: 14px;\n\tline-height: 24px;\n\tcolor: #777777;\n\tfont-weight: 400;\n\tmargin-right: 25px;\n}\n\n.news-block .post-info li span {\n\tmargin-right: 5px;\n\tcolor: #1d95d2;\n}\n\n.news-block h4 {\n\tposition: relative;\n\tdisplay: block;\n\tfont-size: 22px;\n\tline-height: 1.4em;\n\tcolor: #222222;\n\tfont-weight: 500;\n\tmargin-bottom: 20px;\n}\n\n.news-block h4 a {\n\tcolor: #222222;\n\tdisplay: inline-block;\n\t-webkit-transition: all 300ms ease;\n\t-moz-transition: all 300ms ease;\n\t-ms-transition: all 300ms ease;\n\t-o-transition: all 300ms ease;\n\ttransition: all 300ms ease;\n}\n\n.news-block h4 a:hover {\n\tcolor: #e1137b;\n}\n\n.news-block .text {\n\tposition: relative;\n\tfont-size: 14px;\n\tline-height: 27px;\n\tcolor: #888888;\n\tfont-weight: 400;\n\tmargin-bottom: 20px;\n}\n\n.news-block .btn-box {\n\tposition: relative;\n}\n\n.news-block .btn-box a {\n\tposition: relative;\n\tdisplay: inline-block;\n\tfont-size: 12px;\n\tline-height: 20px;\n\tcolor: #ffffff;\n\tpadding: 4px 15px;\n\tbackground-color: #1d95d2;\n\tborder-radius: 2px;\n\tborder: 1px solid #1d95d2;\n\t-webkit-transition: all 300ms ease;\n\t-moz-transition: all 300ms ease;\n\t-ms-transition: all 300ms ease;\n\t-o-transition: all 300ms ease;\n\ttransition: all 300ms ease;\n}\n\n.news-block .btn-box a:hover {\n\tbackground: none;\n\tcolor: #1d95d2;\n\tborder-color: #1d95d2;\n}\n\n.news-section .icon-circle-blue {\n\tright: -305px;\n\tbottom: -120px;\n\topacity: .70;\n\t-webkit-animation: fa-spin 10s infinite;\n\t-moz-animation: fa-spin 10s infinite;\n\t-ms-animation: fa-spin 10s infinite;\n\t-o-animation: fa-spin 10s infinite;\n\tanimation: fa-spin 10s infinite;\n}\n\n\n.news-section .twist-line-1 {\n\tleft: -110px;\n\ttop: 290px;\n}\n\n.news-section .twist-line-2 {\n\tleft: -10%;\n\ttop: 80px;\n}\n\n.news-section .twist-line-3 {\n\tleft: 90px;\n\ttop: 50px;\n}\n\n\n/***\n\n====================================================================\n\t\tBlog Sidebar\n====================================================================\n\n***/\n\n.blog-sidebar {\n\tposition: relative;\n}\n\n.blog-sidebar .news-block {\n\tmargin-bottom: 50px;\n}\n\n.blog-sidebar .news-block .lower-content {\n\tpadding: 30px 30px;\n}\n\n.blog-sidebar .news-block h4 {\n\tfont-size: 26px;\n}\n\n\n/***\n\n====================================================================\n\t\tBlog Detail\n====================================================================\n\n***/\n\n.blog-single {\n\tposition: relative;\n}\n\n.blog-single .news-block {\n\tmargin-bottom: 0;\n}\n\n.blog-single .news-block .inner-box {\n\tbox-shadow: none;\n}\n\n.blog-single .lower-content {\n\tpadding: 20px 0 0;\n}\n\n.blog-single h2 {\n\tfont-size: 28px;\n\tline-height: 1.2em;\n\tfont-weight: 600;\n\tcolor: #222222;\n\tmargin-bottom: 15px;\n}\n\n.blog-single .lower-content p {\n\tfont-size: 16px;\n\tline-height: 30px;\n\tmargin-bottom: 30px;\n\tcolor: #888888;\n}\n\n.blog-single .lower-content blockquote {\n\tposition: relative;\n\tpadding: 35px 40px;\n\tpadding-left: 95px;\n\tbackground-color: #fafafa;\n\tmargin: 45px 0;\n}\n\n.blog-single .lower-content blockquote .icon {\n\tposition: absolute;\n\tleft: 40px;\n\ttop: 40px;\n\tfont-size: 30px;\n\tline-height: 1em;\n\tcolor: #f20487;\n}\n\n.blog-single .lower-content blockquote p {\n\tfont-size: 20px;\n\tline-height: 32px;\n\tcolor: #7f8897;\n\tfont-weight: 400;\n\tmargin-bottom: 15px;\n}\n\n.blog-single .lower-content blockquote cite {\n\tposition: relative;\n\tdisplay: block;\n\tfont-size: 15px;\n\tline-height: 30px;\n\tcolor: #f20487;\n\tfont-weight: 400;\n\tfont-style: normal;\n\tpadding-left: 30px;\n}\n\n.blog-single .lower-content blockquote cite:before {\n\tposition: absolute;\n\tleft: 0;\n\ttop: 14px;\n\theight: 1px;\n\twidth: 20px;\n\tbackground-color: #f20487;\n\tcontent: \"\";\n}\n\n/*post share options*/\n\n.blog-single .post-share-options {\n\tposition: relative;\n\tmargin-bottom: 65px;\n\tborder-top: 2px solid #eeeeee;\n\tpadding-top: 30px;\n}\n\n.blog-single .post-share-options .tags {\n\tposition: relative;\n\tdisplay: inline-block;\n}\n\n.blog-single .post-share-options .tags li {\n\tposition: relative;\n\tdisplay: inline-block;\n\tmargin-right: 5px;\n}\n\n.blog-single .post-share-options .tags a {\n\tposition: relative;\n\tdisplay: inline-block;\n\tfont-size: 14px;\n\tline-height: 20px;\n\tborder: 1px solid #dddddd;\n\tcolor: #7f8897;\n\tpadding: 5px 20px;\n\tfont-weight: 500;\n\t-webkit-transition: all 300ms ease;\n\t-moz-transition: all 300ms ease;\n\t-ms-transition: all 300ms ease;\n\t-o-transition: all 300ms ease;\n\ttransition: all 300ms ease;\n}\n\n.blog-single .post-share-options .tags a:hover {\n\tcolor: #e1137b;\n}\n\n/*=== Author Box ===*/\n\n.blog-single .author-box {\n\tposition: relative;\n\tpadding: 40px 50px;\n\tbackground-color: #f7f7fa;\n\tmargin-bottom: 90px;\n}\n\n.blog-single .author-box .inner-box {\n\tposition: relative;\n}\n\n.blog-single .author-box .info-box {\n\tposition: relative;\n\tpadding-left: 110px;\n\tmin-height: 80px;\n\tmargin-bottom: 20px;\n\tpadding-top: 15px;\n}\n\n.blog-single .author-box .thumb {\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0;\n\theight: 80px;\n\twidth: 80px;\n\tborder-radius: 50%;\n\toverflow: hidden;\n\tmargin-bottom: 10px;\n}\n\n.blog-single .author-box .thumb img {\n\tdisplay: block;\n\twidth: 100%;\n}\n\n.blog-single .author-box .name {\n\tposition: relative;\n\tdisplay: block;\n\tfont-size: 20px;\n\tline-height: 1.2em;\n\tcolor: #3f4161;\n\tfont-weight: 700;\n}\n\n.blog-single .author-box .designation {\n\tdisplay: block;\n\tfont-size: 18px;\n\tline-height: 25px;\n\tcolor: #7f8897;\n\tfont-weight: 400;\n\tmargin-top: 5px;\n}\n\n.blog-single .author-box .text {\n\tdisplay: block;\n\tfont-size: 16px;\n\tline-height: 30px;\n\tcolor: #888888;\n\tfont-weight: 400;\n\tmargin-bottom: 25px;\n}\n\n.blog-single .author-box .read-more {\n\tposition: relative;\n\tdisplay: inline-block;\n\tfont-size: 16px;\n\tline-height: 24px;\n\tcolor: #7f8897;\n\tfont-weight: 500;\n\t-webkit-transition: all 300ms ease;\n\t-moz-transition: all 300ms ease;\n\t-ms-transition: all 300ms ease;\n\t-o-transition: all 300ms ease;\n\ttransition: all 300ms ease;\n}\n\n.blog-single .author-box .read-more .icon {\n\tmargin-left: 7px;\n\tfloat: right;\n\tfont-size: 20px;\n\tline-height: 24px;\n}\n\n.blog-single .author-box .read-more:hover {\n\tcolor: #e1137b;\n}\n\n\n/***\n\n====================================================================\n\t\tStyled Pagination\n====================================================================\n\n***/\n\n.styled-pagination {\n\tposition: relative;\n}\n\n.styled-pagination li {\n\tposition: relative;\n\tdisplay: inline-block;\n\tmargin: 0 8px 0 0;\n}\n\n.styled-pagination li:last-child {\n\tmargin-right: 0;\n}\n\n.styled-pagination li a {\n\tposition: relative;\n\tdisplay: block;\n\tline-height: 50px;\n\tfont-size: 18px;\n\theight: 50px;\n\twidth: 50px;\n\tcolor: #222222;\n\tfont-weight: 500;\n\ttext-align: center;\n\tbackground: #ffffff;\n\tborder: 1px solid #dddddd;\n\tborder-bottom: 2px solid #ec167f;\n\t-webkit-transition: all 500ms ease;\n\t-moz-transition: all 500ms ease;\n\t-ms-transition: all 500ms ease;\n\t-o-transition: all 500ms ease;\n\ttransition: all 500ms ease;\n}\n\n.styled-pagination li a:hover,\n.styled-pagination li a.active {\n\tbackground-color: #ec167f;\n\tcolor: #ffffff;\n\tbox-shadow: 0 5px 10px rgba(0, 0, 0, 0.10);\n}\n\n/***\n\n====================================================================\n\t\t\tComing Soon\n====================================================================\n\n***/\n\n.coming-soon {\n\tposition: relative;\n\tpadding: 100px 0;\n}\n\n.coming-soon:before {\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0;\n\theight: 100%;\n\twidth: 100%;\n\t/* background-image: url(../images/icons/pattern-1.jpg); */\n\tbackground-repeat: no-repeat;\n\tbackground-position: center;\n\tbackground-size: cover;\n\tcontent: \"\";\n\topacity: .05;\n}\n\n.coming-soon .content {\n\tposition: relative;\n\ttext-align: center;\n}\n\n.coming-soon .content .logo {\n\tposition: relative;\n\tmargin-bottom: 30px;\n}\n\n.coming-soon .timer {\n\tposition: relative;\n\tdisplay: inline-block;\n\tmargin-bottom: 50px;\n}\n\n.coming-soon .cs-countdown {\n\tposition: relative;\n\ttext-align: center;\n\tfont-family: 'Orbitron', sans-serif;\n}\n\n.coming-soon .cs-countdown div {\n\tposition: relative;\n\tdisplay: inline-block;\n\tfont-size: 45px;\n\tline-height: 1.2em;\n\tcolor: #e6275a;\n\twidth: auto;\n\tfont-weight: 600;\n\tletter-spacing: 0;\n\ttext-shadow: 0 15px 20px rgba(0, 0, 0, 0.20);\n\tborder-radius: 50%;\n}\n\n.coming-soon .cs-countdown h6 {\n\tposition: relative;\n\tdisplay: block;\n\tline-height: 30px;\n\tfont-size: 16px;\n\tfont-weight: 700;\n\ttext-transform: uppercase;\n\tbackground-color: transparent;\n\tborder-radius: 50%;\n\tcolor: #e6275a;\n\twidth: 100px;\n\tmargin: 0 20px 30px;\n\ttext-shadow: 0 10px 20px rgba(0, 0, 0, 0.20);\n}\n\n.coming-soon .cs-countdown div:nth-child(2) h6,\n.coming-soon .cs-countdown div:nth-child(2) {\n\tcolor: #40cbb4;\n}\n\n.coming-soon .cs-countdown div:nth-child(3) h6,\n.coming-soon .cs-countdown div:nth-child(3) {\n\tcolor: #4c35a9;\n}\n\n.coming-soon .cs-countdown div:nth-child(4) h6,\n.coming-soon .cs-countdown div:nth-child(4) {\n\tcolor: #1c94d2;\n}\n\n.coming-soon .cs-countdown div:nth-child(5) h6,\n.coming-soon .cs-countdown div:nth-child(5) {\n\tcolor: #333333;\n}\n\n.coming-soon h1 {\n\tposition: relative;\n\tcolor: #222222;\n\tfont-size: 75px;\n\tfont-weight: 700;\n\tline-height: 1em;\n\tmargin-bottom: 30px;\n\ttext-shadow: 0 10px 20px rgba(0, 0, 0, 0.20);\n}\n\n.coming-soon .content .text {\n\tposition: relative;\n\tfont-size: 16px;\n\tfont-weight: 400;\n\tline-height: 26px;\n\tcolor: #888888;\n\tmargin-bottom: 50px;\n}\n\n.coming-soon .emailed-form .form-group {\n\tposition: relative;\n\tdisplay: block;\n\tmax-width: 460px;\n\tmargin: 0 auto;\n\twidth: 100%;\n\tmargin-bottom: 35px;\n\tbox-shadow: 0 8px 30px rgba(72, 69, 224, .20);\n\tborder-radius: 50px;\n}\n\n.coming-soon .emailed-form .form-group input[type=\"text\"],\n.coming-soon .emailed-form .form-group input[type=\"tel\"],\n.coming-soon .emailed-form .form-group input[type=\"email\"],\n.coming-soon .emailed-form .form-group input[type=\"number\"],\n.coming-soon .emailed-form .form-group textarea {\n\tposition: relative;\n\tdisplay: block;\n\twidth: 100%;\n\tline-height: 20px;\n\theight: 50px;\n\tfont-size: 15px;\n\tcolor: #222222;\n\toverflow: hidden;\n\tpadding: 15px 70px 15px;\n\tbackground: #ffffff;\n\tborder-radius: 50px;\n\t-webkit-transition: all 300ms ease;\n\t-moz-transition: all 300ms ease;\n\t-ms-transition: all 300ms ease;\n\t-o-transition: all 300ms ease;\n\ttransition: all 300ms ease;\n}\n\n.coming-soon .emailed-form .form-group input[type=\"submit\"],\n.coming-soon .emailed-form button {\n\tposition: absolute;\n\tright: 35px;\n\ttop: 10px;\n\tline-height: 30px;\n\tfont-size: 18px;\n\tcolor: #000000;\n\tfont-weight: 400;\n\tbackground-color: transparent;\n\tcursor: pointer;\n}\n\n.coming-soon .emailed-form .form-group input[type=\"submit\"]:hover,\n.coming-soon .emailed-form button:hover {\n\tcolor: #f20487;\n}\n\n.coming-soon .icon-circle-blue {\n\tleft: -80px;\n\tbottom: -80px;\n\topacity: .70;\n\t-webkit-animation: fa-spin 30s infinite;\n\t-moz-animation: fa-spin 30s infinite;\n\t-ms-animation: fa-spin 30s infinite;\n\t-o-animation: fa-spin 30s infinite;\n\tanimation: fa-spin 30s infinite;\n}\n\n.coming-soon .icon-dots {\n\tleft: 15%;\n\ttop: 20%;\n}\n\n.coming-soon .icon-line-1 {\n\tright: 15%;\n\tbottom: 20%;\n\topacity: .70;\n\t-webkit-animation: fa-spin 30s infinite;\n\t-moz-animation: fa-spin 30s infinite;\n\t-ms-animation: fa-spin 30s infinite;\n\t-o-animation: fa-spin 30s infinite;\n\tanimation: fa-spin 30s infinite;\n}\n\n.coming-soon .icon-circle-1 {\n\tright: -200px;\n\ttop: -200px;\n\topacity: .20;\n}\n\n/***\n\n====================================================================\n\t\tVideo Section\n====================================================================\n\n***/\n\n.video-section {\n\tposition: relative;\n\tbackground-repeat: no-repeat;\n\tbackground-size: cover;\n\tpadding: 120px 0 140px;\n\tbackground-attachment: fixed;\n}\n\n.video-section:before {\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0;\n\theight: 100%;\n\twidth: 100%;\n\tbackground: rgb(247, 0, 104);\n\tbackground: -moz-linear-gradient(to left, rgba(247, 0, 104, 1) 0%, rgba(68, 16, 102, 1) 100%);\n\tbackground: -webkit-linear-gradient(to left, rgba(247, 0, 104, 1) 0%, rgba(68, 16, 102, 1) 100%);\n\tbackground: linear-gradient(to left, rgba(247, 0, 104) 0%, rgba(68, 16, 102, 1) 100%);\n\tfilter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#F70068', endColorstr='#441066', GradientType=1);\n\topacity: .70;\n\tcontent: \"\";\n}\n\n.video-section .content-box {\n\tposition: relative;\n\ttext-align: center;\n}\n\n.video-section .content-box .text {\n\tposition: relative;\n\tdisplay: block;\n\tfont-size: 18px;\n\tline-height: 26px;\n\tcolor: #ffbc00;\n\tfont-weight: 500;\n\ttext-transform: uppercase;\n\tmargin-bottom: 15px;\n}\n\n.video-section .content-box h2 {\n\tdisplay: block;\n\tfont-size: 48px;\n\tline-height: 1.2em;\n\tcolor: #ffffff;\n\tfont-weight: 700;\n}\n\n.video-section .play-now {\n\tposition: relative;\n\tdisplay: inline-block;\n\tmargin-top: 50px;\n}\n\n.video-section .play-now .icon {\n\theight: 100px;\n\twidth: 100px;\n\tline-height: 100px;\n\tbackground-color: #ffbc00;\n\tpadding-left: 0;\n\tfont-size: 50px;\n}\n\n.play-now {\n\tposition: relative;\n\tdisplay: block;\n\tz-index: 9;\n\t-webkit-transition: all 300ms ease;\n\t-moz-transition: all 300ms ease;\n\t-ms-transition: all 300ms ease;\n\t-o-transition: all 300ms ease;\n\ttransition: all 300ms ease;\n}\n\n.play-now .icon {\n\tposition: relative;\n\tdisplay: inline-block;\n\theight: 80px;\n\twidth: 80px;\n\ttext-align: center;\n\tline-height: 80px;\n\tbackground-color: #000000;\n\tcolor: #ffffff;\n\tz-index: 1;\n\tpadding-left: 5px;\n\tfont-size: 24px;\n\tdisplay: block;\n\t-webkit-border-radius: 50%;\n\t-moz-border-radius: 50%;\n\t-ms-border-radius: 50%;\n\t-o-border-radius: 50%;\n\tborder-radius: 50%;\n\t-webkit-box-shadow: 0 0px 10px 0 rgba(255, 255, 255, .3);\n\t-moz-box-shadow: 0 0px 10px 0 rgba(255, 255, 255, .3);\n\t-ms-box-shadow: 0 0px 10px 0 rgba(255, 255, 255, .3);\n\t-o-box-shadow: 0 0px 10px 0 rgba(255, 255, 255, .3);\n\tbox-shadow: 0 0px 10px 0 rgba(255, 255, 255, .3);\n\t-webkit-transform-origin: center;\n\t-moz-transform-origin: center;\n\t-ms-transform-origin: center;\n\t-o-transform-origin: center;\n\ttransform-origin: center;\n}\n\n.play-now .ripple,\n.play-now .ripple:before,\n.play-now .ripple:after {\n\tposition: absolute;\n\ttop: 50%;\n\tleft: 50%;\n\theight: 70px;\n\twidth: 70px;\n\t-webkit-transform: translate(-50%, -50%);\n\t-moz-transform: translate(-50%, -50%);\n\t-ms-transform: translate(-50%, -50%);\n\t-o-transform: translate(-50%, -50%);\n\ttransform: translate(-50%, -50%);\n\t-webkit-border-radius: 50%;\n\t-moz-border-radius: 50%;\n\t-ms-border-radius: 50%;\n\t-o-border-radius: 50%;\n\tborder-radius: 50%;\n\t-webkit-box-shadow: 0 0 0 0 rgba(255, 255, 255, .6);\n\t-moz-box-shadow: 0 0 0 0 rgba(255, 255, 255, .6);\n\t-ms-box-shadow: 0 0 0 0 rgba(255, 255, 255, .6);\n\t-o-box-shadow: 0 0 0 0 rgba(255, 255, 255, .6);\n\tbox-shadow: 0 0 0 0 rgba(255, 255, 255, .6);\n\t-webkit-animation: ripple 3s infinite;\n\t-moz-animation: ripple 3s infinite;\n\t-ms-animation: ripple 3s infinite;\n\t-o-animation: ripple 3s infinite;\n\tanimation: ripple 3s infinite;\n}\n\n.play-now .ripple:before {\n\t-webkit-animation-delay: .9s;\n\t-moz-animation-delay: .9s;\n\t-ms-animation-delay: .9s;\n\t-o-animation-delay: .9s;\n\tanimation-delay: .9s;\n\tcontent: \"\";\n\tposition: absolute;\n}\n\n.play-now .ripple:after {\n\t-webkit-animation-delay: .6s;\n\t-moz-animation-delay: .6s;\n\t-ms-animation-delay: .6s;\n\t-o-animation-delay: .6s;\n\tanimation-delay: .6s;\n\tcontent: \"\";\n\tposition: absolute;\n}\n\n@-webkit-keyframes ripple {\n\t70% {\n\t\tbox-shadow: 0 0 0 70px rgba(255, 255, 255, 0);\n\t}\n\n\t100% {\n\t\tbox-shadow: 0 0 0 0 rgba(255, 255, 255, 0);\n\t}\n}\n\n@keyframes ripple {\n\t70% {\n\t\tbox-shadow: 0 0 0 70px rgba(255, 255, 255, 0);\n\t}\n\n\t100% {\n\t\tbox-shadow: 0 0 0 0 rgba(255, 255, 255, 0);\n\t}\n}\n\n/***\n\n====================================================================\n\t\tCall to Action\n====================================================================\n\n***/\n\n.call-to-action {\n\tposition: relative;\n\tbackground-position: center;\n\tbackground-repeat: no-repeat;\n\tbackground-size: cover;\n\tpadding: 100px 0;\n}\n\n.call-to-action:before {\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0;\n\theight: 100%;\n\twidth: 100%;\n\tbackground-color: #000000;\n\topacity: .50;\n\tcontent: \"\";\n}\n\n.call-to-action .content-box {\n\tposition: relative;\n\ttext-align: center;\n}\n\n.call-to-action .content-box .text {\n\tposition: relative;\n\tdisplay: block;\n\tfont-size: 18px;\n\tline-height: 26px;\n\tcolor: #ffbc00;\n\tfont-weight: 500;\n\ttext-transform: uppercase;\n\tmargin-bottom: 15px;\n}\n\n.call-to-action .content-box h2 {\n\tdisplay: block;\n\tfont-size: 42px;\n\tline-height: 1.2em;\n\tcolor: #ffffff;\n\tfont-weight: 700;\n\tmargin-bottom: 30px;\n}\n\n.call-to-action .content-box .btn-box {\n\tposition: relative;\n}\n\n\n/***\n\n====================================================================\n\t\tRegister Section\n====================================================================\n\n***/\n\n.register-section {\n\tposition: relative;\n\tpadding: 120px 0;\n\tbackground-color: #fafafa;\n\toverflow: hidden;\n}\n\n.register-section .outer-box {\n\tposition: relative;\n\tbox-shadow: 0 30px 50px rgba(0, 0, 0, 0.10);\n\tbackground-color: #ffffff;\n}\n\n.register-section .title-column {\n\tposition: relative;\n\tfloat: left;\n\twidth: 20%;\n\t/* background-image: url(../images/icons/form-bg.png); */\n\tbackground-repeat: no-repeat;\n\tbackground-position: center;\n\tbackground-size: cover;\n}\n\n.register-section .title-column .inner {\n\tposition: relative;\n\ttext-align: center;\n\tpadding: 80px 50px 20px;\n}\n\n.register-section .title-column .icon-box {\n\tposition: relative;\n\tdisplay: inline-block;\n\tmargin-bottom: 30px;\n\tbackground-color: #ffffff;\n\theight: 150px;\n\twidth: 150px;\n\tline-height: 150px;\n\tborder-radius: 50%;\n}\n\n.register-section .title-column .icon {\n\tposition: relative;\n\tdisplay: inline-block;\n\tfont-size: 80px;\n\tcolor: #222222;\n}\n\n.register-section .title-column .text {\n\tmargin-top: 20px;\n}\n\n.register-section .title-column h2 {\n\tposition: relative;\n\tfont-size: 34px;\n\tdisplay: block;\n}\n\n.register-section .title-column .text {\n\tfont-size: 16px;\n\tline-height: 26px;\n\tcolor: #ffffff;\n}\n\n.register-form {\n\tposition: relative;\n}\n\n.register-form .form-inner {\n\tposition: relative;\n\tpadding: 50px 30px 30px;\n\tbackground-color: #ffffff;\n}\n\n.register-form h2 {\n\tposition: relative;\n\tdisplay: block;\n\tfont-size: 34px;\n\tline-height: 1.2em;\n\tcolor: #181e44;\n\tfont-weight: 600;\n\tmargin-bottom: 25px;\n}\n\n.register-form .form-group {\n\tposition: relative;\n\tmargin-bottom: 20px;\n}\n\n.register-form .form-group .icon {\n\tposition: absolute;\n\tleft: 20px;\n\ttop: 10px;\n\tline-height: 33px;\n\tcolor: #aaaaaa;\n\tfont-size: 16px;\n\tz-index: 9;\n}\n\n.register-form .form-group input[type=\"text\"],\n.register-form .form-group input[type=\"email\"],\n.register-form .form-group input[type=\"url\"],\n.register-form .form-group input[type=\"number\"],\n.register-form .form-group input[type=\"date\"],\n.register-form .form-group input[type=\"email\"],\n.register-form .form-group textarea,\n.register-form .form-group select {\n\tposition: relative;\n\tdisplay: block;\n\twidth: 100%;\n\tline-height: 33px;\n\tpadding: 10px 20px;\n\theight: 52px;\n\tcolor: #777777;\n\tfont-size: 15px;\n\tbackground-color: #ffffff;\n\tborder: 1px solid #aaaaaa;\n\tpadding-left: 50px;\n\t-webkit-transition: all 300ms ease;\n\t-moz-transition: all 300ms ease;\n\t-ms-transition: all 300ms ease;\n\t-o-transition: all 300ms ease;\n\ttransition: all 300ms ease;\n}\n\n.register-form .form-group input[type=\"text\"]:focus,\n.register-form .form-group input[type=\"email\"]:focus,\n.register-form .form-group input[type=\"number\"]:focus,\n.register-form .form-group textarea:focus {\n\tborder-color: #f70068;\n}\n\n.register-form .form-group textarea {\n\tposition: relative;\n\tdisplay: block;\n\twidth: 100%;\n\tline-height: 33px;\n\tpadding: 10px 20px;\n\theight: 200px;\n\tpadding-left: 50px;\n}\n\n.register-form button {\n\tcursor: pointer;\n\tline-height: 25px;\n\tfont-size: 14px;\n\tpadding: 10px 30px;\n}\n\n.register-section .icon-circle-3 {\n\tright: -100px;\n\ttop: -120px;\n\topacity: .20;\n}\n\n.register-section .icon-shape-3 {\n\tright: 5%;\n\ttop: 0%;\n}\n\n\n\n/***\n\n====================================================================\n\t\tContact Page Section\n====================================================================\n\n***/\n\n.contact-page-section {\n\tposition: relative;\n\tpadding: 110px 0 70px;\n}\n\n.contact-page-section .form-column {\n\tposition: relative;\n\tmargin-bottom: 40px;\n}\n\n.contact-page-section .form-column .inner-column {\n\tposition: relative;\n}\n\n.contact-page-section .sec-title {\n\tmargin-bottom: 30px;\n}\n\n.contact-page-section .sec-title h2 {\n\tfont-size: 32px;\n}\n\n.contact-form .form-group {\n\tposition: relative;\n\tmargin-bottom: 30px;\n}\n\n.contact-form .form-group:last-child {\n\tmargin-bottom: 0;\n}\n\n.contact-form .form-group input[type=\"text\"],\n.contact-form .form-group input[type=\"email\"],\n.contact-form .form-group input[type=\"url\"],\n.contact-form .form-group input[type=\"password\"],\n.contact-form .form-group input[type=\"number\"],\n.contact-form .form-group textarea,\n.contact-form .form-group select {\n\tposition: relative;\n\tdisplay: block;\n\twidth: 100%;\n\tfont-size: 14px;\n\tcolor: #312d2dba;\n\tline-height: 32px;\n\tpadding: 0px 13px;\n\tborder: 1px solid #a1a7a1;\n\tbackground-color: ffffff;\n\tfont-weight: 400;\n\theight: 50px;\n\t-webkit-transition: all 300ms ease;\n\t-moz-transition: all 300ms ease;\n\t-ms-transition: all 300ms ease;\n\t-o-transition: all 300ms ease;\n\ttransition: all 300ms ease;\n\tborder-radius: 3px;\n}\n\n.contact-form .form-group input:focus,\n.contact-form .form-group select:focus,\n.contact-form .form-group textarea:focus {\n\tborder-color: #f20487;\n}\n\n.contact-form .form-group textarea {\n\theight: 75px;\n\tresize: none;\n}\n\n.contact-form .form-group button {\n\ttext-transform: capitalize;\n}\n\n.contact-form input.error:focus,\n.contact-form select.error:focus,\n.contact-form textarea.error:focus {\n\tborder-color: #ff0000;\n}\n\n.contact-form label.error {\n\tdisplay: block;\n\tfont-weight: 500;\n\tfont-size: 13px;\n\ttext-transform: capitalize;\n\tline-height: 24px;\n\tcolor: #ff0000;\n\tpadding-top: 7px;\n\tmargin-bottom: 0;\n}\n\n.contact-page-section .contact-column {\n\tposition: relative;\n\tmargin-bottom: 30px;\n}\n\n.contact-page-section .contact-info {\n\tposition: relative;\n\tmargin-bottom: 37px;\n}\n\n.contact-page-section .contact-info li {\n\tposition: relative;\n\tpadding-left: 55px;\n\tmargin-bottom: 30px;\n}\n\n.contact-page-section .contact-info li p {\n\tdisplay: block;\n\tfont-size: 14px;\n\tline-height: 24px;\n\tcolor: #777777;\n\tfont-weight: 400;\n\tmargin: 0;\n}\n\n.contact-page-section .contact-info li strong {\n\tdisplay: block;\n\tfont-size: 16px;\n\tline-height: 20px;\n\tcolor: #222222;\n\tfont-weight: 600;\n}\n\n.contact-page-section .contact-info li .icon {\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0;\n\theight: 40px;\n\twidth: 40px;\n\ttext-align: center;\n\tborder-radius: 5px;\n\tfont-size: 18px;\n\tline-height: 40px;\n\tbackground-color: #8e0026;\n\tcolor: #ffffff;\n}\n\n.contact-page-section .contact-info li a {\n\tcolor: #777777;\n\t-webkit-transition: all 300ms ease;\n\t-moz-transition: all 300ms ease;\n\t-ms-transition: all 300ms ease;\n\t-o-transition: all 300ms ease;\n\ttransition: all 300ms ease;\n}\n\n.contact-page-section .contact-info li a:hover {\n\tcolor: #f20487;\n}\n\n\n/***\n\n====================================================================\n\t\tMap Section\n====================================================================\n\n***/\n\n.map-section {\n\tposition: relative;\n\tdisplay: block;\n\tpadding-bottom: 120px;\n}\n\n.map-area {\n\tposition: relative;\n}\n\n.map-data {\n\ttext-align: center;\n\tfont-size: 14px;\n\tfont-weight: 400;\n\tline-height: 1.8em;\n}\n\n.map-data a {\n\tdisplay: block;\n}\n\n.map-data h6 {\n\tfont-size: 16px;\n\tfont-weight: 700;\n\ttext-align: center;\n\tmargin-bottom: 5px;\n\tcolor: #121212;\n}\n\n.map-section .map-canvas {\n\theight: 540px;\n\tbackground-color: #f9f9f9;\n}\n\n\n/***\n\n====================================================================\n\t\tSubscribe Section\n====================================================================\n\n***/\n\n.subscribe-section {\n\tposition: relative;\n\tbackground-color: #ffffff;\n}\n\n.subscribe-section .title-column {\n\tposition: relative;\n\tmargin-bottom: 40px;\n}\n\n.subscribe-section:before {\n\tposition: absolute;\n\tleft: 0;\n\tbottom: 0;\n\theight: 50%;\n\twidth: 100%;\n\tbackground-color: #101130;\n\tcontent: \"\";\n}\n\n.subscribe-section .content-box {\n\tposition: relative;\n\tz-index: 9;\n\tpadding: 40px 20px 0;\n\tborder-radius: 20px;\n\toverflow: hidden;\n\tbackground-color: #40cbb4;\n\ttext-align: center;\n\tbox-shadow: 0 0 30px rgba(0, 0, 0, 0.30);\n}\n\n.subscribe-section .content-box:before {\n\tposition: absolute;\n\tleft: 0;\n\tbottom: 0;\n\theight: 100%;\n\twidth: 100%;\n\t/* background-image: url(../images/icons/pattern-2.png); */\n\tbackground-repeat: no-repeat;\n\tbackground-position: center;\n\tbackground-size: cover;\n\tcontent: \"\";\n\t-webkit-transform: scaleY(-1);\n\t-moz-transform: scaleY(-1);\n\t-ms-transform: scaleY(-1);\n\t-o-transform: scaleY(-1);\n\ttransform: scaleY(-1);\n}\n\n.subscribe-section .content-box .sec-title {\n\tmargin-bottom: 0px;\n\tpadding-left: 90px;\n\ttext-align: left;\n}\n\n.subscribe-section .content-box .sec-title h2 {\n\tposition: relative;\n\tdisplay: block;\n\tcolor: #ffffff;\n\tfont-size: 30px;\n\tline-height: 35px;\n}\n\n.subscribe-section .content-box .sec-title .icon {\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0px;\n\theight: 70px;\n\twidth: 70px;\n\tbackground-color: #ffffff;\n\tborder-radius: 50%;\n\tcolor: #ec167f;\n\tline-height: 70px;\n\tfont-size: 28px;\n\ttext-align: center;\n\tbox-shadow: 0 0 20px rgba(0, 0, 0, 0.10);\n\tcolor: #1d95d2;\n}\n\n.subscribe-section .form-column {\n\tposition: relative;\n\tmargin-bottom: 40px;\n}\n\n.subscribe-section .newsletter-form {\n\tposition: relative;\n\tmax-width: 870px;\n\tmargin: 0 auto;\n}\n\n.subscribe-section .newsletter-form .form-group {\n\tposition: relative;\n\tpadding-right: 140px;\n\toverflow: hidden;\n\tborder-radius: 10px;\n\tmargin-bottom: 0;\n}\n\n.subscribe-section .newsletter-form .form-group input[type=\"number\"],\n.subscribe-section .newsletter-form .form-group input[type=\"text\"],\n.subscribe-section .newsletter-form .form-group input[type=\"email\"] {\n\tdisplay: block;\n\theight: 70px;\n\twidth: 100%;\n\tfont-size: 16px;\n\tline-height: 30px;\n\tcolor: #616977;\n\tfont-weight: 400;\n\tpadding: 20px 40px;\n\tbackground-color: #ffffff;\n\t-webkit-transition: all 300ms ease;\n\t-moz-transition: all 300ms ease;\n\t-ms-transition: all 300ms ease;\n\t-o-transition: all 300ms ease;\n\ttransition: all 300ms ease;\n}\n\n.subscribe-section .newsletter-form .form-group .theme-btn {\n\tposition: absolute;\n\tright: 0px;\n\ttop: 0px;\n\tmin-width: 140px;\n\tline-height: 30px;\n\tpadding: 20px 30px;\n\ttext-transform: capitalize;\n\tfont-weight: 500;\n\tborder-radius: 0;\n\tcursor: pointer;\n}\n\n/***\n\n====================================================================\n\tNewsletter Section\n====================================================================\n\n***/\n\n.newsletter-section {\n\tposition: relative;\n\tpadding: 10px 0;\n\tz-index: 1;\n}\n\n\n.newsletter-section .icon-shape-3 {\n\t-webkit-transform: scaleX(-1);\n\t-moz-transform: scaleX(-1);\n\t-ms-transform: scaleX(-1);\n\t-o-transform: scaleX(-1);\n\ttransform: scaleX(-1);\n\ttop: 0px;\n\tleft: -110px;\n\topacity: .70;\n}\n\n.newsletter-section .icon-line-1 {\n\tright: -70px;\n\ttop: 50%;\n\t-webkit-animation: fa-spin 30s infinite alternate;\n\t-moz-animation: fa-spin 30s infinite alternate;\n\t-ms-animation: fa-spin 30s infinite alternate;\n\t-o-animation: fa-spin 30s infinite alternate;\n\tanimation: fa-spin 30s infinite alternate;\n}\n\n.subscribe-form {\n\tposition: relative;\n}\n\n.subscribe-form .form-inner {\n\tposition: relative;\n\tmax-width: 60%;\n\twidth: 100%;\n\tmargin: 0 auto;\n}\n\n.subscribe-form .upper-box {\n\tposition: relative;\n\ttext-align: center;\n}\n\n.subscribe-form .sec-title {\n\tmargin-bottom: 40px;\n}\n\n.subscribe-form .sec-title .text {\n\tmargin-top: 20px;\n}\n\n.subscribe-form .upper-box .icon-box {\n\tposition: relative;\n\tdisplay: inline-block;\n\theight: 150px;\n\twidth: 150px;\n\tborder-radius: 50%;\n\tbackground: rgb(247, 0, 104);\n\tbackground: -moz-linear-gradient(to left, rgba(247, 0, 104, 1) 0%, rgba(68, 16, 102, 1) 100%);\n\tbackground: -webkit-linear-gradient(to left, rgba(247, 0, 104, 1) 0%, rgba(68, 16, 102, 1) 100%);\n\tbackground: linear-gradient(to left, rgba(247, 0, 104) 0%, rgba(68, 16, 102, 1) 100%);\n\tfilter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#F70068', endColorstr='#441066', GradientType=1);\n\tz-index: 1;\n\tfont-size: 70px;\n\tline-height: 150px;\n\tcolor: #ffffff;\n\tmargin-bottom: 30px;\n}\n\n.subscribe-form .form-group {\n\tposition: relative;\n\tdisplay: block;\n\tmargin: 0px;\n\twidth: 100%;\n\tpadding-right: 70px;\n\tbackground: #ffffff;\n\tz-index: 2;\n\t/*box-shadow: 0 0 30px rgba(0,0,0,0.10);*/\n\tmargin-bottom: 10px;\n}\n\n.subscribe-form .form-group input[type=\"text\"],\n.subscribe-form .form-group input[type=\"tel\"],\n.subscribe-form .form-group input[type=\"password\"],\n.subscribe-form .form-group input[type=\"email\"],\n.subscribe-form .form-group input[type=\"number\"],\n.subscribe-form .form-group textarea {\n\tposition: relative;\n\tdisplay: block;\n\twidth: 100%;\n\tline-height: 30px;\n\theight: 60px;\n\tfont-size: 15px;\n\tcolor: #222222;\n\tbackground: #ffffff;\n\tpadding: 0px 15px;\n\tborder: 1px solid transparent;\n\t-webkit-transition: all 300ms ease;\n\t-moz-transition: all 300ms ease;\n\t-ms-transition: all 300ms ease;\n\t-o-transition: all 300ms ease;\n\ttransition: all 300ms ease;\n}\n\n.subscribe-form .form-group input[type=\"submit\"],\n.subscribe-form .form-group button {\n\tposition: absolute;\n\tright: 0px;\n\ttop: 0px;\n\theight: 60px;\n\twidth: 60px;\n\ttext-align: center;\n\tline-height: 30px;\n\tfont-size: 18px;\n\tline-height: 60px;\n\tbackground-color: #ffffff;\n\tcolor: #222222;\n\tcursor: pointer;\n}\n\n.subscribe-form .form-group input[type=\"submit\"]:hover,\n.subscribe-form .form-group button:hover {}\n\n/***\n\n====================================================================\n\t\tClients Section\n====================================================================\n\n***/\n\n.clients-section {\n\tposition: relative;\n\tpadding: 120px 0 90px;\n}\n\n.clients-section:before {\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0;\n\theight: 100%;\n\twidth: 100%;\n\t/* background-image: url(../images/icons/icon-dots-2.png); */\n\tcontent: \"\";\n\topacity: .02;\n\tbackground-repeat: no-repeat;\n\tbackground-position: center;\n\tbackground-size: cover;\n\t-webkit-transform: scale(-1);\n\t-moz-transform: scale(-1);\n\t-ms-transform: scale(-1);\n\t-o-transform: scale(-1);\n\ttransform: scale(-1);\n}\n\n\n.clients-section .sponsors-outer {\n\tposition: relative;\n\tmargin-bottom: 50px;\n}\n\n.clients-section .sponsors-outer .owl-dots,\n.clients-section .sponsors-outer .owl-nav {\n\tdisplay: none;\n}\n\n.clients-section .sponsors-outer .client-block {\n\tposition: relative;\n\tmargin-bottom: 30px;\n}\n\n.clients-section .sponsors-outer .image-box {\n\tposition: relative;\n\ttext-align: center;\n\tmargin-bottom: 0;\n\tborder: 1px solid #dddddd;\n\tbox-shadow: 0 0 30px rgba(0, 0, 0, 0.10);\n\tbackground-color: #ffffff;\n\t-webkit-transition: all 300ms ease;\n\t-moz-transition: all 300ms ease;\n\t-ms-transition: all 300ms ease;\n\t-o-transition: all 300ms ease;\n\ttransition: all 500ms ease;\n}\n\n.clients-section .sponsors-outer .image-box:hover {\n\tbox-shadow: none;\n}\n\n\n.clients-section .sponsors-outer .image-box img {\n\tmax-width: 50%;\n\twidth: auto;\n\tdisplay: inline-block;\n\topacity: 1;\n\t-webkit-transition: all 300ms ease;\n\t-moz-transition: all 300ms ease;\n\t-ms-transition: all 300ms ease;\n\t-o-transition: all 300ms ease;\n\ttransition: all 300ms ease;\n}\n\n.clients-section .sponsors-outer .image-box:hover img {\n\topacity: .70;\n}\n\n.clients-section .sponsors-outer h3 {\n\tdisplay: inline-block;\n\tfont-size: 20px;\n\tline-height: 1.2em;\n\tbackground-color: #ec167f;\n\tcolor: #ffffff;\n\tpadding: 10px 30px;\n\tfont-weight: 700;\n\tmargin-bottom: 20px;\n\tborder-radius: 10px;\n}\n\n.clients-section .sponsors-outer:nth-child(3) h3 {\n\tbackground-color: #1d95d2;\n}\n\n.clients-section .sponsors-outer:nth-child(2) h3 {\n\tbackground-color: #40cbb4;\n}\n\n\n.clients-section .icon-dots-3 {\n\tleft: -60px;\n\ttop: 230px;\n}\n\n.clients-section .icon-circle-blue {\n\tleft: -370px;\n\ttop: 500px;\n\topacity: .50;\n\t-webkit-animation: fa-spin 30s infinite alternate;\n\t-moz-animation: fa-spin 30s infinite alternate;\n\t-ms-animation: fa-spin 30s infinite alternate;\n\t-o-animation: fa-spin 30s infinite alternate;\n\tanimation: fa-spin 30s infinite alternate;\n}\n\n/***\n\n====================================================================\n\t\tClients Section Two\n====================================================================\n\n***/\n\n.clients-section-two {\n\tposition: relative;\n\tpadding: 60px 0;\n}\n\n.clients-section-two:before {\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0;\n\theight: 100%;\n\twidth: 100%;\n\t/* background-image: url(../images/icons/icon-dots-2.png); */\n\tcontent: \"\";\n\topacity: .02;\n\tbackground-repeat: no-repeat;\n\tbackground-position: center;\n\tbackground-size: cover;\n\t-webkit-transform: scale(-1);\n\t-moz-transform: scale(-1);\n\t-ms-transform: scale(-1);\n\t-o-transform: scale(-1);\n\ttransform: scale(-1);\n}\n\n\n.clients-section-two .sponsors-outer {\n\tposition: relative;\n}\n\n.clients-section-two .sponsors-outer .owl-dots,\n.clients-section-two .sponsors-outer .owl-nav {\n\tdisplay: none;\n}\n\n.clients-section-two .sponsors-outer .client-block {\n\tposition: relative;\n}\n\n.clients-section-two .sponsors-outer .image-box {\n\tposition: relative;\n\ttext-align: center;\n\tmargin-bottom: 0;\n\t-webkit-transition: all 300ms ease;\n\t-moz-transition: all 300ms ease;\n\t-ms-transition: all 300ms ease;\n\t-o-transition: all 300ms ease;\n\ttransition: all 500ms ease;\n}\n\n.clients-section-two .sponsors-outer .image-box:hover {\n\tbox-shadow: none;\n}\n\n.clients-section-two .sponsors-outer .image-box img {\n\topacity: .80;\n\t-webkit-transition: all 300ms ease;\n\t-moz-transition: all 300ms ease;\n\t-ms-transition: all 300ms ease;\n\t-o-transition: all 300ms ease;\n\ttransition: all 300ms ease;\n}\n\n.clients-section-two .sponsors-outer .image-box:hover img {\n\topacity: 1;\n}\n\n/***\n\n====================================================================\n\t\tClients Section Three\n====================================================================\n\n***/\n\n.clients-section-three {\n\tposition: relative;\n\tpadding: 60px 0;\n}\n\n.clients-section-three:before {\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0;\n\theight: 100%;\n\twidth: 100%;\n\t/* background-image: url(../images/icons/icon-dots-2.png); */\n\tcontent: \"\";\n\topacity: .02;\n\tbackground-repeat: no-repeat;\n\tbackground-position: center;\n\tbackground-size: cover;\n\t-webkit-transform: scale(-1);\n\t-moz-transform: scale(-1);\n\t-ms-transform: scale(-1);\n\t-o-transform: scale(-1);\n\ttransform: scale(-1);\n}\n\n\n.clients-section-three .sponsors-outer {\n\tposition: relative;\n}\n\n.clients-section-three .sponsors-outer .owl-dots,\n.clients-section-three .sponsors-outer .owl-nav {\n\tdisplay: none;\n}\n\n.clients-section-three .sponsors-outer .client-block {\n\tposition: relative;\n}\n\n.clients-section-three .sponsors-outer .image-box {\n\tposition: relative;\n\ttext-align: center;\n\tmargin-bottom: 0;\n\t-webkit-transition: all 300ms ease;\n\t-moz-transition: all 300ms ease;\n\t-ms-transition: all 300ms ease;\n\t-o-transition: all 300ms ease;\n\ttransition: all 500ms ease;\n}\n\n.clients-section-three .sponsors-outer .image-box:hover {\n\tbox-shadow: none;\n}\n\n.clients-section-three .sponsors-outer .image-box img {\n\tmax-width: 70%;\n\topacity: .80;\n\tdisplay: inline-block;\n\t-webkit-transition: all 300ms ease;\n\t-moz-transition: all 300ms ease;\n\t-ms-transition: all 300ms ease;\n\t-o-transition: all 300ms ease;\n\ttransition: all 300ms ease;\n}\n\n.clients-section-three .sponsors-outer .image-box:hover img {\n\topacity: 1;\n}\n\n/***\n\n==================================================================\n\t\tMain Footer\n==================================================================\n\n***/\n\n.main-footer {\n\tposition: relative;\n\tbackground-color: #101130;\n\t/* background-image: url(../images/background/9.jpg); */\n}\n\n.main-footer .widgets-section {\n\tposition: relative;\n\tbackground-repeat: no-repeat;\n\tbackground-position: center;\n\tbackground-size: cover;\n\tpadding: 120px 0 50px;\n}\n\n.main-footer .footer-column {\n\tposition: relative;\n\tmargin-bottom: 40px;\n}\n\n.main-footer .footer-widget {\n\tposition: relative;\n}\n\n.main-footer .footer-column .widget-title {\n\tposition: relative;\n\tfont-size: 24px;\n\tfont-weight: 500;\n\tcolor: #ffffff;\n\tline-height: 30px;\n\tpadding-bottom: 10px;\n\tmargin-bottom: 30px;\n}\n\n.main-footer .footer-column .widget-title:before {\n\tposition: absolute;\n\tleft: 0;\n\tbottom: 0;\n\theight: 1px;\n\twidth: 40px;\n\tbackground-color: #f70068;\n\tcontent: '';\n}\n\n.main-footer .about-widget {\n\tposition: relative;\n}\n\n.main-footer .logo {\n\tposition: relative;\n\tmargin-bottom: 5px;\n\ttop: -20px;\n}\n\n.main-footer .footer-logo figure {\n\tmargin: 0;\n}\n\n.main-footer .footer-logo img {\n\tdisplay: block;\n\tmax-width: 100%;\n\twidth: 200px;\n}\n\n.main-footer .about-widget .text {\n\tposition: relative;\n\tmargin-bottom: 30px;\n}\n\n.main-footer .about-widget .text p {\n\tfont-size: 14px;\n\tline-height: 24px;\n\tcolor: #aaaaaa;\n\tfont-weight: 400;\n\tmargin-bottom: 30px;\n}\n\n/*Recent Posts*/\n\n.recent-posts {\n\tposition: relative;\n\tpadding-left: 40px;\n}\n\n.recent-posts .post {\n\tposition: relative;\n\tmin-height: 90px;\n\tmargin-bottom: 30px;\n}\n\n.recent-posts .post:last-child {\n\tmargin-bottom: 0;\n}\n\n.recent-posts .post .thumb {\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0;\n\theight: 90px;\n\twidth: 90px;\n\toverflow: hidden;\n}\n\n.recent-posts .post .thumb a {\n\tdisplay: block;\n}\n\n.recent-posts .post .thumb img {\n\tdisplay: block;\n\twidth: 100%;\n\theight: auto;\n}\n\n.recent-posts .post h4 {\n\tposition: relative;\n\tfont-size: 18px;\n\tcolor: #ffffff;\n\tline-height: 30px;\n\tfont-weight: 500;\n\tmargin-bottom: 5px;\n}\n\n.recent-posts .post h4 a {\n\tcolor: #ffffff;\n\t-webkit-transition: all 300ms ease;\n\t-moz-transition: all 300ms ease;\n\t-ms-transition: all 300ms ease;\n\t-o-transition: all 300ms ease;\n\ttransition: all 300ms ease;\n}\n\n.recent-posts .post h4 a:hover {\n\tcolor: #f70068;\n}\n\n.recent-posts .post .date {\n\tposition: relative;\n\tdisplay: block;\n\tfont-size: 14px;\n\tline-height: 30px;\n\tcolor: #bbbbbb;\n}\n\n.recent-posts .post .date span {\n\tcolor: #f70068;\n\tmargin-right: 4px;\n\topacity: .70;\n}\n\n/*=== User LInks ===*/\n\n.useful-links {\n\tposition: relative;\n\tpadding-left: 50px;\n}\n\n.user-links li {\n\tposition: relative;\n\tdisplay: block;\n\tmargin-bottom: 5px;\n}\n\n.user-links li a {\n\tposition: relative;\n\tdisplay: block;\n\tfont-size: 14px;\n\tline-height: 30px;\n\tcolor: #ffffff;\n\tfont-weight: 400;\n\tpadding: 0 15px;\n\tborder-left: 1px solid #f70068;\n\t-webkit-transition: all 300ms ease;\n\t-moz-transition: all 300ms ease;\n\t-ms-transition: all 300ms ease;\n\t-o-transition: all 300ms ease;\n\ttransition: all 300ms ease;\n}\n\n.user-links li a:hover {\n\tcolor: #f70068;\n}\n\n.main-footer .contact-list {\n\tposition: relative;\n}\n\n.main-footer .contact-list li {\n\tposition: relative;\n\tpadding-left: 40px;\n\tmargin-bottom: 25px;\n}\n\n.main-footer .contact-list li:last-child {\n\tmargin-bottom: 0;\n}\n\n.main-footer .contact-list li .icon {\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0;\n\tfont-size: 23px;\n\tline-height: 25px;\n\tcolor: #ffffff;\n}\n\n.main-footer .contact-list li .text {\n\tdisplay: block;\n\tfont-size: 14px;\n\tline-height: 24px;\n\tcolor: #ffffff;\n\tfont-weight: 400;\n}\n\n.main-footer .contact-list li .text a {\n\tcolor: #ffffff;\n\t-webkit-transition: all 300ms ease;\n\t-moz-transition: all 300ms ease;\n\t-ms-transition: all 300ms ease;\n\t-o-transition: all 300ms ease;\n\ttransition: all 300ms ease;\n}\n\n.main-footer .contact-list li .text a:hover {\n\tcolor: #f70068;\n}\n\n\n/* Instagram Widget */\n\n.instagram-widget {\n\tposition: relative;\n}\n\n.instagram-widget .link-box {\n\tposition: absolute;\n\tright: 30px;\n\ttop: 27px;\n}\n\n.instagram-widget .link-box a {\n\tdisplay: inline-block;\n\theight: 30px;\n\twidth: 30px;\n\tborder-radius: 50%;\n\tbackground-color: #f70068;\n\tcolor: #ffffff;\n\tfont-size: 18px;\n\ttext-align: center;\n\t-webkit-transition: all 300ms ease;\n\t-moz-transition: all 300ms ease;\n\t-ms-transition: all 300ms ease;\n\t-o-transition: all 300ms ease;\n\ttransition: all 300ms ease;\n}\n\n.instagram-widget .link-box a:hover {\n\tbox-shadow: 0 0 10px rgba(0, 0, 0, 0.10);\n\tbackground-color: #ffffff;\n\tcolor: #f70068;\n}\n\n.instagram-widget .outer {\n\tposition: relative;\n\tmargin: 0px -5px 0;\n}\n\n.instagram-widget .outer .image {\n\tposition: relative;\n\tfloat: left;\n\twidth: 33.3333%;\n\tpadding: 0px 4px;\n\tmargin-bottom: 10px;\n}\n\n.instagram-widget .image img {\n\tdisplay: block;\n\twidth: 100%;\n}\n\n.instagram-widget .image a {\n\tposition: relative;\n\tdisplay: block;\n}\n\n.instagram-widget .image a:before {\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0;\n\theight: 100%;\n\twidth: 100%;\n\tbackground: #ffffff;\n\tpadding: 5px;\n\topacity: .70;\n\tcontent: \"\";\n\t-webkit-transform: scale(0);\n\t-moz-transform: scale(0);\n\t-ms-transform: scale(0);\n\t-o-transform: scale(0);\n\ttransform: scale(0);\n\t-webkit-transition: all 300ms ease;\n\t-moz-transition: all 300ms ease;\n\t-ms-transition: all 300ms ease;\n\t-o-transition: all 300ms ease;\n\ttransition: all 300ms ease;\n}\n\n.instagram-widget .image a:hover:before {\n\t-webkit-transform: scale(1);\n\t-moz-transform: scale(1);\n\t-ms-transform: scale(1);\n\t-o-transform: scale(1);\n\ttransform: scale(1);\n}\n\n.instagram-widget .image a:after {\n\tposition: absolute;\n\theight: 20px;\n\twidth: 20px;\n\tleft: 50%;\n\ttop: 50%;\n\tmargin-left: -10px;\n\tmargin-top: -10px;\n\ttext-align: center;\n\tline-height: 20px;\n\tfont-size: 18px;\n\tcolor: #f70068;\n\tfont-weight: 900;\n\tcontent: \"\\f0c1\";\n\tfont-family: \"Font Awesome 5 Free\";\n\t-webkit-transform: scale(0);\n\t-moz-transform: scale(0);\n\t-ms-transform: scale(0);\n\t-o-transform: scale(0);\n\ttransform: scale(0);\n\t-webkit-transition: all 300ms ease;\n\t-moz-transition: all 300ms ease;\n\t-ms-transition: all 300ms ease;\n\t-o-transition: all 300ms ease;\n\ttransition: all 300ms ease;\n}\n\n.instagram-widget .image a:hover:after {\n\t-webkit-transform: scale(1);\n\t-moz-transform: scale(1);\n\t-ms-transform: scale(1);\n\t-o-transform: scale(1);\n\ttransform: scale(1);\n}\n\n/*=== Footer Bottom ===*/\n\n.main-footer .footer-bottom {\n\tposition: relative;\n\twidth: 100%;\n\tbackground-color: rgba(255, 255, 255, .10);\n\ttext-align: center;\n}\n\n.main-footer .footer-bottom .inner-container {\n\tposition: relative;\n}\n\n.main-footer .footer-bottom .copyright-text {\n\tposition: relative;\n\tpadding: 20px 0;\n}\n\n.main-footer .footer-bottom .copyright-text p {\n\tposition: relative;\n\tline-height: 20px;\n\tfont-size: 16px;\n\tcolor: #ffffff;\n\tfont-weight: 400;\n\tmargin-bottom: 0;\n}\n\n.main-footer .footer-bottom .copyright-text a {\n\tcolor: #ffffff;\n\tfont-weight: 600;\n\ttext-decoration: underline;\n\t-webkit-transition: all 300ms ease;\n\t-moz-transition: all 300ms ease;\n\t-ms-transition: all 300ms ease;\n\t-o-transition: all 300ms ease;\n\ttransition: all 300ms ease;\n}\n\n.main-footer .footer-bottom .copyright-text a:hover {\n\tcolor: #f70068;\n}\n\n.main-footer .footer-bottom .footer-nav {\n\tposition: relative;\n\tfloat: right;\n}\n\n.main-footer .footer-bottom .footer-nav ul {\n\tposition: relative;\n\tpadding: 15px 0;\n}\n\n.main-footer .footer-bottom .footer-nav ul li {\n\tposition: relative;\n\tfloat: left;\n\tmargin-left: 10px;\n\tfont-family: \"Oswald\", sans-serif;\n}\n\n.main-footer .footer-bottom .footer-nav ul li a {\n\tposition: relative;\n\tdisplay: block;\n\tfont-size: 14px;\n\tline-height: 20px;\n\tcolor: #ffffff;\n\tfont-weight: 400;\n\tpadding: 5px 10px;\n\ttext-transform: uppercase;\n\tbackground-color: #333333;\n\t-webkit-transition: all 300ms ease;\n\t-moz-transition: all 300ms ease;\n\t-ms-transition: all 300ms ease;\n\t-o-transition: all 300ms ease;\n\ttransition: all 300ms ease;\n}\n\n.main-footer .footer-bottom .footer-nav ul li a:hover {\n\tcolor: #f70068;\n\tbox-shadow: 0 0 10px rgba(0, 0, 0, 0.20);\n}\n\n/***\n\n==================================================================\n\t\tMain Footer Style Two\n==================================================================\n\n***/\n\n.main-footer.style-two {\n\tposition: relative;\n\tbackground-repeat: no-repeat;\n\tbackground-position: center;\n\tbackground-size: cover;\n\ttext-align: center;\n\t/* position: absolute; */\n    bottom: 0;\n\twidth:100%;\n\n}\n.footer-container {\n    position: relative;\n}\n\n.main-footer.style-two .footer-content {\n\tposition: relative;\n\tpadding: 70px 0 70px;\n}\n\n.main-footer.style-two .footer-logo {\n\tposition: relative;\n\ttext-align: center;\n\tmargin-bottom: 20px;\n}\n\n.main-footer.style-two .footer-logo img {\n\tdisplay: inline-block;\n}\n\n.main-footer.style-two .text {\n\tposition: relative;\n\tmax-width: 700px;\n\tmargin: 0 auto;\n\tfont-size: 16px;\n\tcolor: #ffffff;\n\tline-height: 28px;\n\tmargin-bottom: 30px;\n}\n\n.main-footer .footer-nav {\n\tposition: relative;\n\tmargin-bottom: 30px;\n}\n\n.main-footer .footer-nav li {\n\tposition: relative;\n\tdisplay: inline-block;\n\tmargin: 0 5px;\n}\n\n.main-footer .footer-nav li a {\n\tposition: relative;\n\tdisplay: block;\n\tfont-size: 16px;\n\tline-height: 30px;\n\tcolor: #ffffff;\n\tfont-weight: 500;\n\t-webkit-transition: all 300ms ease;\n\t-moz-transition: all 300ms ease;\n\t-ms-transition: all 300ms ease;\n\t-o-transition: all 300ms ease;\n\ttransition: all 300ms ease;\n}\n\n.main-footer .footer-nav li a:hover {\n\tcolor: #890025\n}\n\n.main-footer.style-two .copyright-text {\n\tcolor: #ffffff;\n\tmargin-bottom: 30px;\n}\n\n.main-footer.style-two .copyright-text a {\n\tcolor: #ffffff;\n}\n\n.main-footer.style-two .copyright-text a:hover {\n\tcolor: #e1137b;\n}\n\n.main-footer.style-two .copyright-text {\n\tborder-top: 0;\n}\n\n\n/***\n\n==================================================================\n\t\tMain Footer Style three\n==================================================================\n\n***/\n\n.main-footer.style-three {\n\tposition: relative;\n\tbackground: #ffffff;\n\ttext-align: center;\n\toverflow: hidden;\n}\n\n.main-footer.style-three .footer-content {\n\tposition: relative;\n\tpadding: 70px 0 70px;\n}\n\n.main-footer.style-three .footer-logo {\n\tposition: relative;\n\ttext-align: center;\n\tmargin-bottom: 20px;\n}\n\n.main-footer.style-three .footer-logo img {\n\tdisplay: inline-block;\n}\n\n.main-footer.style-three .text {\n\tposition: relative;\n\tmax-width: 700px;\n\tmargin: 0 auto;\n\tfont-size: 16px;\n\tcolor: #101130;\n\tline-height: 28px;\n\tmargin-bottom: 30px;\n}\n\n.main-footer.style-three .footer-nav li a {\n\tposition: relative;\n\tdisplay: block;\n\tfont-size: 16px;\n\tline-height: 30px;\n\tcolor: #101130;\n\tfont-weight: 500;\n\t-webkit-transition: all 300ms ease;\n\t-moz-transition: all 300ms ease;\n\t-ms-transition: all 300ms ease;\n\t-o-transition: all 300ms ease;\n\ttransition: all 300ms ease;\n}\n\n.main-footer.style-three .footer-nav li a:hover {\n\tcolor: #f20487;\n}\n\n.main-footer.style-three .copyright-text {\n\tcolor: #101130;\n\tmargin-bottom: 30px;\n}\n\n.main-footer.style-three .copyright-text a {\n\tcolor: #101130;\n}\n\n.main-footer.style-three .copyright-text a:hover {\n\tcolor: #e1137b;\n}\n\n.main-footer.style-three .copyright-text {\n\tborder-top: 0;\n}\n\n\n.main-footer.style-three .icon-circle-blue {\n\tleft: -150px;\n\tbottom: -100px;\n\topacity: .70;\n\t-webkit-animation: fa-spin 30s infinite alternate;\n\t-moz-animation: fa-spin 30s infinite alternate;\n\t-ms-animation: fa-spin 30s infinite alternate;\n\t-o-animation: fa-spin 30s infinite alternate;\n\tanimation: fa-spin 30s infinite alternate;\n}\n\n.main-footer.style-three .icon-dots {\n\tleft: 15%;\n\ttop: 20%;\n}\n\n.main-footer.style-three .icon-circle-1 {\n\tright: -200px;\n\ttop: -200px;\n\topacity: .05;\n}\n\n/***\n\n====================================================================\n\tError Section\n====================================================================\n\n***/\n.error-section2 {\n\tposition: relative;\n\ttext-align: center;\n\tpadding: 50px 0px;\n}\n\n.error-section2:before {\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0;\n\theight: 100%;\n\twidth: 100%;\n\t/* background-image: url(../images/icons/pattern-1.jpg); */\n\tbackground-repeat: no-repeat;\n\tbackground-position: center;\n\tbackground-size: cover;\n\tcontent: \"\";\n\topacity: .05;\n}\n\n.error-section2 .error-title {\n\tposition: relative;\n\tcolor: #ec167f;\n\tfont-size: 53px;\n\tfont-weight: 700;\n\tline-height: 1em;\n\ttext-shadow: 0 20px 30px rgba(0, 0, 0, 0.20);\n}\n\n\n.error-section2 h4 {\n\tcolor: #394963;\n\tfont-size: 40px;\n\tfont-weight: 700;\n\tmargin-bottom: 20px;\n}\n\n.error-section2 .text {\n\tcolor: #777777;\n\tfont-size: 22px;\n\tline-height: 1.4em;\n\tmargin-bottom: 30px;\n}\n\n.error-section2 .theme-btn {\n\tborder-radius: 5px;\n\tfont-weight: 500;\n\tmargin: 0 10px 10px;\n\tbox-shadow: 0 10px 30px rgba(0, 0, 0, 0.20);\n}\n\n.error-section2 .icon-circle-blue {\n\tleft: -80px;\n\tbottom: -80px;\n\topacity: .70;\n\t-webkit-animation: fa-spin 30s infinite alternate;\n\t-moz-animation: fa-spin 30s infinite alternate;\n\t-ms-animation: fa-spin 30s infinite alternate;\n\t-o-animation: fa-spin 30s infinite alternate;\n\tanimation: fa-spin 30s infinite alternate;\n}\n\n.error-section2 .icon-dots {\n\tleft: 15%;\n\ttop: 20%;\n}\n\n.error-section2 .icon-line-1 {\n\tright: 15%;\n\tbottom: 20%;\n\topacity: .70;\n\t-webkit-animation: fa-spin 30s infinite alternate;\n\t-moz-animation: fa-spin 30s infinite alternate;\n\t-ms-animation: fa-spin 30s infinite alternate;\n\t-o-animation: fa-spin 30s infinite alternate;\n\tanimation: fa-spin 30s infinite alternate;\n}\n\n.error-section2 .icon-circle-1 {\n\tright: -200px;\n\ttop: -200px;\n\topacity: .20;\n}\n\n.error-section {\n\tposition: relative;\n\ttext-align: center;\n\tpadding: 150px 0px;\n}\n\n.error-section:before {\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0;\n\theight: 100%;\n\twidth: 100%;\n\t/* background-image: url(../images/icons/pattern-1.jpg); */\n\tbackground-repeat: no-repeat;\n\tbackground-position: center;\n\tbackground-size: cover;\n\tcontent: \"\";\n\topacity: .05;\n}\n\n.error-section .error-title {\n\tposition: relative;\n\tcolor: #ec167f;\n\tfont-size: 53px;\n\tfont-weight: 700;\n\tline-height: 1em;\n\ttext-shadow: 0 20px 30px rgba(0, 0, 0, 0.20);\n}\n\n\n.error-section h4 {\n\tcolor: #394963;\n\tfont-size: 40px;\n\tfont-weight: 700;\n\tmargin-bottom: 20px;\n}\n\n.error-section .text {\n\tcolor: #888888;\n\tfont-size: 22px;\n\tline-height: 1.4em;\n\tmargin-bottom: 30px;\n}\n\n.error-section .theme-btn {\n\tborder-radius: 5px;\n\tfont-weight: 500;\n\tmargin: 0 10px 10px;\n\tbox-shadow: 0 10px 30px rgba(0, 0, 0, 0.20);\n}\n\n.error-section .icon-circle-blue {\n\tleft: -80px;\n\tbottom: -80px;\n\topacity: .70;\n\t-webkit-animation: fa-spin 30s infinite alternate;\n\t-moz-animation: fa-spin 30s infinite alternate;\n\t-ms-animation: fa-spin 30s infinite alternate;\n\t-o-animation: fa-spin 30s infinite alternate;\n\tanimation: fa-spin 30s infinite alternate;\n}\n\n.error-section .icon-dots {\n\tleft: 15%;\n\ttop: 20%;\n}\n\n.error-section .icon-line-1 {\n\tright: 15%;\n\tbottom: 20%;\n\topacity: .70;\n\t-webkit-animation: fa-spin 30s infinite alternate;\n\t-moz-animation: fa-spin 30s infinite alternate;\n\t-ms-animation: fa-spin 30s infinite alternate;\n\t-o-animation: fa-spin 30s infinite alternate;\n\tanimation: fa-spin 30s infinite alternate;\n}\n\n.error-section .icon-circle-1 {\n\tright: -200px;\n\ttop: -200px;\n\topacity: .20;\n}\n\n/***\n\n====================================================================\n\tSidebar Page Container\n====================================================================\n\n***/\n\n.sidebar-page-container {\n\tposition: relative;\n\tpadding: 120px 0px 70px;\n}\n\n.sidebar-page-container .content-side,\n.sidebar-page-container .sidebar-side {\n\tmargin-bottom: 50px;\n}\n\n.sidebar-page-container .sidebar.padding-left {\n\tpadding-left: 40px;\n}\n\n.sidebar-widget {\n\tposition: relative;\n\tmargin-bottom: 50px;\n}\n\n.sidebar-widget:last-child {\n\tmargin-bottom: 0;\n}\n\n/* Sidebar Title */\n\n.sidebar-title {\n\tposition: relative;\n\tdisplay: block;\n\tfont-size: 24px;\n\tline-height: 1.2em;\n\tcolor: #333333;\n\tfont-weight: 700;\n\tmargin-bottom: 20px;\n\tpadding-bottom: 20px;\n\tborder-bottom: 2px solid #eeeeee;\n}\n\n/*Search Box Widget*/\n\n.sidebar .search-box {\n\tmargin-bottom: 60px;\n}\n\n.sidebar .search-box .form-group {\n\tposition: relative;\n\tmargin: 0px;\n}\n\n.sidebar .search-box .form-group input[type=\"text\"],\n.sidebar .search-box .form-group input[type=\"search\"] {\n\tposition: relative;\n\tpadding: 20px 50px 20px 30px;\n\tborder: 2px solid #eeeeee;\n\tbackground: #ffffff;\n\tdisplay: block;\n\tfont-size: 15px;\n\tline-height: 18px;\n\twidth: 100%;\n\theight: 60px;\n\tcolor: #333333;\n\t-webkit-transition: all 500ms ease;\n\t-moz-transition: all 500ms ease;\n\t-ms-transition: all 500ms ease;\n\t-o-transition: all 500ms ease;\n\ttransition: all 500ms ease;\n}\n\n.sidebar .search-box .form-group input[type=\"text\"]:focus,\n.sidebar .search-box .form-group input[type=\"search\"]:focus {\n\tcolor: #666666;\n}\n\n.sidebar .search-box .form-group button {\n\tposition: absolute;\n\tright: 0;\n\ttop: 0;\n\theight: 60px;\n\twidth: 60px;\n\tdisplay: block;\n\tfont-size: 18px;\n\tcolor: #888888;\n\tline-height: 60px;\n\tfont-weight: normal;\n\tbackground: #eeeeee;\n\tz-index: 9;\n\tcursor: pointer;\n}\n\n.sidebar .search-box .form-group button:hover {\n\tcolor: #e1137b;\n}\n\n/*Post Widget*/\n\n.sidebar .popular-posts .post {\n\tposition: relative;\n\tmargin-bottom: 20px;\n}\n\n.sidebar .popular-posts .post .post-inner {\n\tposition: relative;\n\tpadding-left: 110px;\n\tmin-height: 90px;\n}\n\n.sidebar .popular-posts .post .post-thumb {\n\tposition: absolute;\n\tleft: 0px;\n\ttop: 0px;\n\twidth: 90px;\n}\n\n.sidebar .popular-posts .post .post-thumb img {\n\tdisplay: block;\n\twidth: 100%;\n\t-webkit-transition: all 0.3s ease;\n\t-moz-transition: all 0.3s ease;\n\t-ms-transition: all 0.3s ease;\n\t-o-transition: all 0.3s ease;\n\ttransition: all 0.3s ease;\n}\n\n.sidebar .popular-posts .post .text {\n\tposition: relative;\n\tfont-size: 18px;\n\tline-height: 26px;\n\tfont-weight: 600;\n\tcolor: #888888;\n\tmargin: 0px;\n}\n\n.sidebar .popular-posts .post .text a {\n\tcolor: #3f4161;\n\t-webkit-transition: all 0.3s ease;\n\t-moz-transition: all 0.3s ease;\n\t-ms-transition: all 0.3s ease;\n\t-o-transition: all 0.3s ease;\n\ttransition: all 0.3s ease;\n}\n\n.sidebar .popular-posts .post a:hover {\n\tcolor: #e1137b;\n}\n\n.sidebar .popular-posts .post-info {\n\tposition: relative;\n\tfont-size: 16px;\n\tcolor: #7f8897;\n\tfont-weight: 400;\n\tline-height: 30px;\n\tmargin-bottom: 5px;\n}\n\n/* Blog Categories */\n\n.blog-categories {\n\tposition: relative;\n}\n\n.blog-categories li {\n\tposition: relative;\n}\n\n.blog-categories li a {\n\tposition: relative;\n\tdisplay: block;\n\tcolor: #333333;\n\tfont-size: 18px;\n\tline-height: 30px;\n\tfont-weight: 400;\n\tmargin-bottom: 10px;\n\t-webkit-transition: all 500ms ease;\n\t-moz-transition: all 500ms ease;\n\t-ms-transition: all 500ms ease;\n\t-o-transition: all 500ms ease;\n\ttransition: all 500ms ease;\n}\n\n.blog-categories li a span {\n\tfloat: right;\n}\n\n\n.blog-categories li a:hover {\n\tcolor: #e1137b;\n}\n\n/*Popular Tags*/\n\n.sidebar .popular-tags .widget-content {\n\tposition: relative;\n}\n\n.sidebar .popular-tags a {\n\tposition: relative;\n\tfloat: left;\n\tpadding: 5px;\n\tmargin: 0 20px 10px 0;\n\tcolor: #333333;\n\ttext-align: center;\n\tfont-size: 16px;\n\tline-height: 20px;\n\tbackground: none;\n\tfont-weight: 400;\n\tborder-bottom: 2px solid #dddddd;\n\tbackground-color: #ffffff;\n\t-webkit-transition: all 300ms ease;\n\t-moz-transition: all 300ms ease;\n\t-ms-transition: all 300ms ease;\n\t-o-transition: all 300ms ease;\n\ttransition: all 300ms ease;\n}\n\n.sidebar .popular-tags a:hover {\n\tborder-color: #e1137b;\n\tcolor: #e1137b;\n}\n\n/***\n\n====================================================================\n\t\tComment Area\n====================================================================\n\n ***/\n\n.group-title {\n\tposition: relative;\n\tmargin-bottom: 40px;\n}\n\n.group-title h3 {\n\tposition: relative;\n\tdisplay: inline-block;\n\tfont-size: 28px;\n\tline-height: 1.2em;\n\tcolor: #222222;\n\tfont-weight: 500;\n}\n\n.comments-area {\n\tposition: relative;\n\tmargin-bottom: 70px;\n}\n\n.comments-area .comment-box {\n\tposition: relative;\n\tmargin-bottom: 50px;\n}\n\n.comments-area .comment-box.reply-comment {\n\tmargin-left: 70px;\n}\n\n.comments-area .comment-box:last-child {\n\tmargin-bottom: 0;\n}\n\n.comments-area .comment {\n\tposition: relative;\n\tmin-height: 50px;\n\tpadding-left: 70px;\n}\n\n.comments-area .comment-box .author-thumb {\n\tposition: absolute;\n\tleft: 0px;\n\ttop: 0px;\n\theight: 50px;\n\twidth: 50px;\n\tmargin-bottom: 20px;\n\tborder-radius: 50%;\n\toverflow: hidden;\n\tbackground-color: #7d7d7d;\n}\n\n.comments-area .comment-box .author-thumb img {\n\twidth: 100%;\n\tdisplay: block;\n}\n\n.comments-area .comment-info {\n\tposition: relative;\n\tdisplay: block;\n\tmargin-bottom: 5px;\n\tfont-size: 16px;\n\tline-height: 25px;\n\tfont-weight: 700;\n\tcolor: #12114a;\n}\n\n.comments-area .comment-box .name {\n\tposition: relative;\n\tdisplay: inline-block;\n\tfont-size: 16px;\n\tline-height: 25px;\n\tfont-weight: 700;\n\tcolor: #12114a;\n\tmargin-right: 10px;\n}\n\n.comments-area .comment-box .date {\n\tposition: relative;\n\tdisplay: inline-block;\n\tfont-size: 14px;\n\tline-height: 24px;\n\tcolor: #777777;\n\tfont-weight: 400;\n\tmargin-left: 10px;\n}\n\n.comments-area .comment-box .text {\n\tfont-size: 15px;\n\tline-height: 26px;\n\tcolor: #888888;\n\tfont-weight: 400;\n}\n\n.comments-area .comment-box .reply-btn {\n\tposition: relative;\n\tmargin-top: 20px;\n\tfont-size: 14px;\n\tline-height: 20px;\n\tpadding: 5px 20px;\n}\n\n/***\n\n====================================================================\n\t\tComment Form\n====================================================================\n\n ***/\n\n.comment-form {\n\tposition: relative;\n}\n\n.comment-form .form-group {\n\tposition: relative;\n\tmargin-bottom: 20px;\n}\n\n.comment-form .form-group:last-child {\n\tmargin-bottom: 0;\n}\n\n.comment-form .form-group input[type=\"text\"],\n.comment-form .form-group input[type=\"email\"],\n.comment-form .form-group textarea,\n.comment-form .form-group select {\n\tposition: relative;\n\tdisplay: block;\n\theight: 50px;\n\twidth: 100%;\n\tfont-size: 14px;\n\tcolor: #878787;\n\tline-height: 28px;\n\tfont-weight: 400;\n\tpadding: 10px 20px;\n\tbackground-color: #ffffff;\n\tborder: 1px solid #999999;\n\t-webkit-transition: all 300ms ease;\n\t-ms-transition: all 300ms ease;\n\t-o-transition: all 300ms ease;\n\t-moz-transition: all 300ms ease;\n\ttransition: all 300ms ease;\n}\n\n.comment-form .form-group input:focus,\n.comment-form .form-group select:focus,\n.comment-form .form-group textarea:focus {\n\tborder-color: #12114a;\n}\n\n.comment-form .form-group textarea {\n\theight: 190px;\n\tresize: none;\n}\n\n.comment-form .form-group input[type=\"submit\"],\n.comment-form .form-group button {\n\tfont-size: 15px;\n\tpadding: 10px 30px;\n\tfont-weight: 500;\n\tcursor: pointer;\n}\n\n/*=========================================================\n\t\t\tBuy Tickets\n=========================================================*/\n\n.buy-ticket {\n\tposition: relative;\n\tpadding: 120px 0 100px;\n}\n\n.buy-ticket .form-column {\n\tposition: relative;\n\tmargin-bottom: 30px;\n}\n\n.buy-ticket .form-column .inner-column {\n\tposition: relative;\n\tpadding-right: 30px;\n}\n\n.buy-ticket .content-column {\n\tposition: relative;\n\tmargin-bottom: 20px;\n}\n\n.buy-ticket p {\n\tposition: relative;\n\tmargin-bottom: 30px;\n}\n\n.buy-ticket h2 {\n\tposition: relative;\n\tdisplay: block;\n\tfont-size: 32px;\n\tline-height: 1.2em;\n\tcolor: #3f4161;\n\tfont-weight: 600;\n\tmargin-bottom: 15px;\n}\n\n.buy-ticket h2 span {\n\tcolor: #ec167f;\n}\n\n.buy-ticket h3 {\n\tposition: relative;\n\tdisplay: block;\n\tfont-size: 24px;\n\tline-height: 1.2em;\n\tcolor: #3f4161;\n\tfont-weight: 600;\n\tmargin-bottom: 15px;\n}\n\n.buy-ticket ul {\n\tmargin-bottom: 30px;\n}\n\n.buy-ticket .ticket-form {\n\tposition: relative;\n\tpadding: 40px 30px;\n\tbackground-color: #f7f7f7;\n\tz-index: 1;\n\tmargin-bottom: 40px;\n}\n\n.ticket-form .form-group {\n\tposition: relative;\n\tdisplay: block;\n\twidth: 100%;\n\tmargin-bottom: 20px;\n}\n\n.ticket-form .form-group:last-child {\n\tmargin-bottom: 0;\n}\n\n.ticket-form .form-group input[type=\"text\"],\n.ticket-form .form-group input[type=\"email\"],\n.ticket-form .form-group input[type=\"phone\"],\n.ticket-form .form-group input[type=\"number\"],\n.ticket-form .form-group input[type=\"tel\"],\n.ticket-form .form-group input[type=\"url\"] .ticket-form .form-group textarea,\n.ticket-form .form-group select {\n\tposition: relative;\n\tdisplay: block;\n\twidth: 100%;\n\tfont-size: 16px;\n\tline-height: 20px;\n\tcolor: #9da6b4;\n\tfont-weight: 400;\n\theight: 60px;\n\tpadding: 20px 30px;\n\tbackground-color: #ffffff;\n\tborder: 1px solid #dddddd;\n\t-webkit-transition: all 300ms ease;\n\t-moz-transition: all 300ms ease;\n\t-ms-transition: all 300ms ease;\n\t-o-transition: all 300ms ease;\n\ttransition: all 300ms ease;\n}\n\n.ticket-form .form-group input:focus,\n.ticket-form .form-group select:focus,\n.ticket-form .form-group textarea:focus {\n\tbackground-color: #ffffff;\n\tborder-color: #faeff5;\n\tcolor: #9da6b4;\n\tbox-shadow: 0 30px 30px rgba(14, 16, 48, .08);\n}\n\n.ticket-form .form-group textarea {\n\theight: 150px;\n\tresize: none;\n}\n\n.ticket-form .form-group input[type=submit],\n.ticket-form .form-group button {\n\tcursor: pointer;\n\tdisplay: block;\n\twidth: 100%;\n}\n\n.ticket-form .form-group label {\n\tposition: relative;\n\tfont-size: 14px;\n\tline-height: 24px;\n\tcolor: #888888;\n}\n\n.ticket-form .form-group label:hover {\n\tcursor: pointer;\n}\n\n.ticket-form .form-group label span {\n\tcolor: #ec167f;\n\ttext-decoration: underline;\n}\n\n.ticket-form .form-group input[type=checkbox] {\n\tposition: relative;\n\ttop: 3px;\n}\n\n.buy-ticket .follow-us {\n\tposition: relative;\n\tmargin-bottom: 30px;\n}\n\n.buy-ticket .support-box {\n\tposition: relative;\n}\n\n.buy-ticket .support-box p {\n\tmargin-bottom: 10px;\n}\n\n.buy-ticket .support-box .number {\n\tposition: relative;\n\tfont-size: 20px;\n\tline-height: 1.2em;\n\tcolor: #1c94d2;\n\tfont-weight: 500;\n}\n\n.buy-ticket .support-box .number a {\n\tcolor: #1c94d2;\n}\n\n.buy-ticket .support-box .number span {\n\tcolor: #3f4161;\n\tfont-size: 18px;\n\tmargin-right: 5px;\n}\n\n.buy-ticket .support-box .number a:hover {\n\ttext-decoration: underline;\n}\n\n.buy-ticket .icon-circle-blue {\n\tleft: -150px;\n\tbottom: -150px;\n\topacity: .70;\n\t-webkit-animation: fa-spin 30s infinite;\n\t-moz-animation: fa-spin 30s infinite;\n\t-ms-animation: fa-spin 30s infinite;\n\t-o-animation: fa-spin 30s infinite;\n\tanimation: fa-spin 30s infinite;\n}\n\n.buy-ticket .icon-circle-1 {\n\tright: -250px;\n\ttop: -250px;\n\topacity: .05;\n}\n\n\n/*=========================================================\n\t\t\tSocial icon Colored\n=========================================================*/\n\n.social-icon-colored .fa-adn {\n\tcolor: #504e54;\n}\n\n.social-icon-colored .fa-apple {\n\tcolor: #aeb5c5;\n}\n\n.social-icon-colored .fa-android {\n\tcolor: #A5C63B;\n}\n\n.social-icon-colored .fa-bitbucket,\n.social-icon-colored .fa-bitbucket-square {\n\tcolor: #F46899;\n}\n\n.social-icon-colored .fa-bitcoin,\n.social-icon-colored .fa-btc {\n\tcolor: #F7931A;\n}\n\n.social-icon-colored .fa-css3 {\n\tcolor: #1572B7;\n}\n\n.social-icon-colored .fa-dribbble {\n\tcolor: #F46899;\n}\n\n.social-icon-colored .fa-dropbox {\n\tcolor: #018BD3;\n}\n\n.social-icon-colored .fa-facebook,\n.social-icon-colored .fa-facebook-f,\n.social-icon-colored .fa-facebook-square {\n\tcolor: #3C599F;\n}\n\n.social-icon-colored .fa-flickr {\n\tcolor: #FF0084;\n}\n\n.social-icon-colored .fa-foursquare {\n\tcolor: #0086BE;\n}\n\n.social-icon-colored .fa-github,\n.social-icon-colored .fa-github-alt,\n.social-icon-colored .fa-github-square {\n\tcolor: #070709;\n}\n\n.social-icon-colored .fa-google-plus,\n.social-icon-colored .fa-google-plus-g,\n.social-icon-colored .fa-google-plus-square {\n\tcolor: #CF3D2E;\n}\n\n.social-icon-colored .fa-html5 {\n\tcolor: #E54D26;\n}\n\n.social-icon-colored .fa-instagram {\n\tcolor: #A1755C;\n}\n\n.social-icon-colored .fa-linkedin,\n.social-icon-colored .fa-linkedin-in,\n.social-icon-colored .fa-linkedin-square {\n\tcolor: #0085AE;\n}\n\n.social-icon-colored .fa-linux {\n\tcolor: #FBC002;\n\tcolor: #333;\n}\n\n.social-icon-colored .fa-maxcdn {\n\tcolor: #F6AE1C;\n}\n\n.social-icon-colored .fa-pagelines {\n\tcolor: #241E20;\n\tcolor: #3984EA;\n}\n\n.social-icon-colored .fa-pinterest,\n.social-icon-colored .fa-pinterest-square {\n\tcolor: #CC2127;\n}\n\n.social-icon-colored .fa-renren {\n\tcolor: #025DAC;\n}\n\n.social-icon-colored .fa-skype {\n\tcolor: #01AEF2;\n}\n\n.social-icon-colored .fa-stack-exchange {\n\tcolor: #245590;\n}\n\n.social-icon-colored .fa-stack-overflow {\n\tcolor: #FF7300;\n}\n\n.social-icon-colored .fa-trello {\n\tcolor: #265A7F;\n}\n\n.social-icon-colored .fa-tumblr,\n.social-icon-colored .fa-tumblr-square {\n\tcolor: #314E6C;\n}\n\n.social-icon-colored .fa-twitter,\n.social-icon-colored .fa-twitter-square {\n\tcolor: #32CCFE;\n}\n\n.social-icon-colored .fa-vimeo-square {\n\tcolor: #229ACC;\n}\n\n.social-icon-colored .fa-vk {\n\tcolor: #375474;\n}\n\n.social-icon-colored .fa-weibo {\n\tcolor: #D72B2B;\n}\n\n.social-icon-colored .fa-windows {\n\tcolor: #12B6F3;\n}\n\n.social-icon-colored .fa-xing,\n.social-icon-colored .fa-xing-square {\n\tcolor: #00555C;\n}\n\n.social-icon-colored .fa-youtube,\n.social-icon-colored .fa-youtube-play,\n.social-icon-colored .fa-youtube-square {\n\tcolor: #C52F30;\n}\n\n/*Social icon Colored*/\n.social-icon-colored li a:hover .fa-adn {\n\tbackground-color: #504e54;\n}\n\n.social-icon-colored li a:hover .fa-apple {\n\tbackground-color: #aeb5c5;\n}\n\n.social-icon-colored li a:hover .fa-android {\n\tbackground-color: #A5C63B;\n}\n\n.social-icon-colored li a:hover .fa-bitbucket,\n.social-icon-colored li a:hover .fa-bitbucket-square {\n\tbackground-color: #F46899;\n}\n\n.social-icon-colored li a:hover .fa-bitcoin,\n.social-icon-colored li a:hover .fa-btc {\n\tbackground-color: #F7931A;\n}\n\n.social-icon-colored li a:hover .fa-css3 {\n\tbackground-color: #1572B7;\n}\n\n.social-icon-colored li a:hover .fa-dribbble {\n\tbackground-color: #F46899;\n}\n\n.social-icon-colored li a:hover .fa-dropbox {\n\tbackground-color: #018BD3;\n}\n\n.social-icon-colored li a:hover .fa-facebook,\n.social-icon-colored li a:hover .fa-facebook-f,\n.social-icon-colored li a:hover .fa-facebook-square {\n\tbackground-color: #3C599F;\n}\n\n.social-icon-colored li a:hover .fa-flickr {\n\tbackground-color: #FF0084;\n}\n\n.social-icon-colored li a:hover .fa-foursquare {\n\tbackground-color: #0086BE;\n}\n\n.social-icon-colored li a:hover .fa-github,\n.social-icon-colored li a:hover .fa-github-alt,\n.social-icon-colored li a:hover .fa-github-square {\n\tbackground-color: #070709;\n}\n\n.social-icon-colored li a:hover .fa-google-plus,\n.social-icon-colored li a:hover .fa-google-plus-g,\n.social-icon-colored li a:hover .fa-google-plus-square {\n\tbackground-color: #CF3D2E;\n}\n\n.social-icon-colored li a:hover .fa-html5 {\n\tbackground-color: #E54D26;\n}\n\n.social-icon-colored li a:hover .fa-instagram {\n\tbackground-color: #A1755C;\n}\n\n.social-icon-colored li a:hover .fa-linkedin,\n.social-icon-colored li a:hover .fa-linkedin-in,\n.social-icon-colored li a:hover .fa-linkedin-square {\n\tbackground-color: #0085AE;\n}\n\n.social-icon-colored li a:hover .fa-linux {\n\tbackground-color: #FBC002;\n\tcolor: #333;\n}\n\n.social-icon-colored li a:hover .fa-maxcdn {\n\tbackground-color: #F6AE1C;\n}\n\n.social-icon-colored li a:hover .fa-pagelines {\n\tbackground-color: #241E20;\n\tcolor: #3984EA;\n}\n\n.social-icon-colored li a:hover .fa-pinterest,\n.social-icon-colored li a:hover .fa-pinterest-square {\n\tbackground-color: #CC2127;\n}\n\n.social-icon-colored li a:hover .fa-renren {\n\tbackground-color: #025DAC;\n}\n\n.social-icon-colored li a:hover .fa-skype {\n\tbackground-color: #01AEF2;\n}\n\n.social-icon-colored li a:hover .fa-stack-exchange {\n\tbackground-color: #245590;\n}\n\n.social-icon-colored li a:hover .fa-stack-overflow {\n\tbackground-color: #FF7300;\n}\n\n.social-icon-colored li a:hover .fa-trello {\n\tbackground-color: #265A7F;\n}\n\n.social-icon-colored li a:hover .fa-tumblr,\n.social-icon-colored li a:hover .fa-tumblr-square {\n\tbackground-color: #314E6C;\n}\n\n.social-icon-colored li a:hover .fa-twitter,\n.social-icon-colored li a:hover .fa-twitter-square {\n\tbackground-color: #32CCFE;\n}\n\n.social-icon-colored li a:hover .fa-vimeo-square {\n\tbackground-color: #229ACC;\n}\n\n.social-icon-colored li a:hover .fa-vk {\n\tbackground-color: #375474;\n}\n\n.social-icon-colored li a:hover .fa-weibo {\n\tbackground-color: #D72B2B;\n}\n\n.social-icon-colored li a:hover .fa-windows {\n\tbackground-color: #12B6F3;\n}\n\n.social-icon-colored li a:hover .fa-xing,\n.social-icon-colored li a:hover .fa-xing-square {\n\tbackground-color: #00555C;\n}\n\n.social-icon-colored li a:hover .fa-youtube,\n.social-icon-colored li a:hover .fa-youtube-play,\n.social-icon-colored li a:hover .fa-youtube-square {\n\tbackground-color: #C52F30;\n}\n\n.social-icon-colored li a:hover .fab {\n\tcolor: #ffffff;\n}\n\n/***\n\n==================================================================\n\t\tRight To Left Style\n==================================================================\n\n***/\n\n.rtl {\n\tdirection: rtl;\n\ttext-align: right;\n}\n\n.rtl .social-icon-three li,\n.rtl .social-icon-one,\n.rtl .banner-conference .time-countdown,\n.rtl .styled-pagination,\n.rtl .owl-carousel {\n\tdirection: ltr !important;\n}\n\n.rtl .banner-conference .layer-outer,\n.rtl .anim-icons {\n\ttransform: scaleX(-1);\n}\n\n.rtl .main-header .search-box-outer,\n.rtl .schedule-tabs.style-three .tab-buttons li,\n.rtl .main-header .nav-outer .main-menu,\n.rtl .main-header .logo-box {\n\tfloat: right;\n}\n\n.rtl .main-header .search-box-outer2,\n.rtl .schedule-tabs.style-three .tab-buttons li,\n.rtl .main-header .nav-outer .main-menu,\n.rtl .main-header .logo-box {\n\tfloat: right;\n}\n\n.rtl .blog-categories li a span,\n.rtl .fluid-section-one .content-column,\n.rtl .main-header .nav-outer {\n\tfloat: left;\n}\n\n.rtl .list-style-one li:before,\n.rtl .list-style-two li:before,\n.rtl .fluid-section-one .image-column,\n.rtl .schedule-block.style-two .speaker-info .thumb,\n.rtl .pricing-block-two .features li:before,\n.rtl .event-detail .speaker-info .thumb,\n.rtl .event-info-tabs .tabs-content .info-list li .icon,\n.rtl .comments-area .comment-box .author-thumb,\n.rtl .blog-single .lower-content blockquote cite:before,\n.rtl .about-section-two .about-block .icon,\n.rtl .contact-page-section .contact-info li .icon,\n.rtl .subscribe-section .content-box .sec-title .icon,\n.rtl .sidebar .popular-posts .post .post-thumb,\n.rtl .main-footer .footer-column .widget-title:before,\n.rtl .pricing-block .features li:before,\n.rtl .main-menu .navigation>li>ul {\n\tleft: auto;\n\tright: 0;\n}\n\n.rtl .main-menu .navigation>li>ul>li>ul {\n\tright: 100%;\n\tleft: auto;\n}\n\n.rtl .sidebar .search-box .form-group button,\n.rtl .subscribe-form .form-group input[type=\"submit\"],\n.rtl .subscribe-form .form-group button,\n.rtl .banner-conference .images-outer,\n.rtl .banner-conference .layer-outer {\n\tright: auto;\n\tleft: 0;\n}\n\n.rtl .main-header .outer-box {\n\tfloat: left;\n\tmargin-right: 50px;\n\tmargin-left: 0;\n}\n\n.rtl .main-header .outer-box .btn-box {\n\tfloat: right;\n\tmargin-left: 0;\n\tmargin-right: 20px;\n}\n\n.rtl .main-header .search-box-outer .dropdown-menu {\n\tright: auto !important;\n\tleft: 0 !important;\n}\n\n.rtl .main-header .search-box-outer2 .dropdown-menu {\n\tright: auto !important;\n\tleft: 0 !important;\n}\n\n.rtl .main-menu .navigation>li {\n\tfloat: right;\n\tmargin-right: 45px;\n\tmargin-left: 0;\n}\n\n.rtl .banner-carousel .content-box .info-list li .icon {\n\tfloat: right;\n\tmargin-left: 10px;\n}\n\n.rtl .coming-soon-section .time-countdown .counter-column:before {\n\tright: auto;\n\tleft: -50px;\n}\n\n.rtl .list-style-one li {\n\tpadding-left: 0;\n\tpadding-right: 35px;\n}\n\n.rtl .about-section .image-column .image-box {\n\tpadding-left: 0;\n\tpadding-right: 80px;\n}\n\n.rtl .about-section .content-column .inner-column {\n\tpadding-right: 0;\n\tpadding-left: 80px;\n}\n\n.rtl .feature-block-two .inner-box {\n\tpadding: 40px 30px;\n\tpadding-right: 100px;\n}\n\n.rtl .feature-block-two .icon-box {\n\tleft: auto;\n\tright: 30px;\n}\n\n.rtl .pricing-block .features li {\n\tpadding: 5px 0;\n\tpadding-right: 30px;\n}\n\n.rtl .register-form .form-group input[type=\"text\"],\n.rtl .register-form .form-group input[type=\"email\"],\n.rtl .register-form .form-group input[type=\"url\"],\n.rtl .register-form .form-group input[type=\"number\"],\n.rtl .register-form .form-group input[type=\"date\"],\n.rtl .register-form .form-group input[type=\"email\"],\n.rtl .register-form .form-group textarea,\n.register-form .form-group select {\n\tpadding: 10px 20px;\n\tpadding-right: 50px;\n}\n\n.rtl .register-form .form-group .icon {\n\tleft: auto;\n\tright: 20px;\n}\n\n.rtl .user-links li a {\n\tborder-left: 0;\n\tborder-right: 1px solid #f70068;\n}\n\n.rtl .main-footer .contact-list li {\n\tpadding-left: 0;\n\tpadding-right: 40px;\n}\n\n.rtl .main-footer .contact-list li .icon {\n\tleft: auto;\n\tright: 0px;\n}\n\n.rtl .speaker-block-two .info-box {\n\tborder-radius: 30px 0 0 30px;\n}\n\n.rtl .schedule-section.style-two .schedule-block .date,\n.rtl .schedule-section.style-two .schedule-block .inner-box {\n\ttext-align: right;\n}\n\n.rtl .schedule-block.style-two .speaker-info {\n\tpadding-left: 0;\n\tpadding-right: 80px;\n}\n\n.rtl .pricing-block-two .title .icon {\n\tmargin-right: 0;\n\tmargin-left: 5px;\n}\n\n.rtl .pricing-block-two .price-box {\n\tmargin-left: 0;\n\tmargin-right: -30px;\n}\n\n.rtl .pricing-block-two .price {\n\tborder-radius: 50px 0 0 50px;\n}\n\n.rtl .pricing-block-two .features li {\n\tpadding-right: 30px;\n\tpadding-left: 0;\n}\n\n.rtl .banner-meetup .address .icon,\n.rtl .event-info-tabs .tabs-content h4 .icon {\n\tmargin-right: 0;\n\tmargin-left: 10px;\n}\n\n.rtl .event-info-tabs .tabs-content .info-list li {\n\tpadding-left: 0;\n\tpadding-right: 30px;\n}\n\n.rtl .subscribe-section .content-box .sec-title {\n\ttext-align: right;\n}\n\n.rtl .subscribe-section .content-box .sec-title {\n\tpadding-right: 90px;\n\tpadding-left: 0;\n}\n\n.rtl .about-section-two .image-column .image-box {\n\tpadding-right: 0;\n\tpadding-left: 50px;\n}\n\n.rtl .about-section-two .about-block h4 {\n\tpadding-left: 0;\n\tpadding-right: 35px;\n}\n\n.rtl .feature-block-three .inner-box {\n\tpadding-right: 170px;\n\tpadding-left: 100px;\n}\n\n.rtl .feature-block-three .icon-box {\n\tleft: auto;\n\tright: 50px;\n}\n\n.rtl .feature-block-three .link-box {\n\tright: auto;\n\tleft: 30px;\n}\n\n.rtl .speaker-block-three .info-box {\n\tpadding: 10px 30px;\n\tpadding-left: 10px;\n}\n\n.rtl .speaker-block-three .info-box:before {\n\tright: 0;\n\tleft: -30px;\n\tborder-radius: 14px 0 0 14px;\n}\n\n.rtl .schedule-section.style-three .schedule-block .date,\n.rtl .schedule-section.style-three .schedule-block .inner-box {\n\ttext-align: right;\n}\n\n.rtl .accordion-box .block .acc-btn {\n\tpadding: 15px 25px 15px 25px;\n\tpadding-left: 50px;\n}\n\n.rtl .accordion-box .block .icon-outer {\n\tright: auto;\n\tleft: 25px;\n}\n\n.rtl .app-section .link-box a {\n\tmargin-right: 0;\n\tmargin-left: 25px;\n}\n\n.rtl .app-section .image-column .inner-column {\n\ttext-align: left;\n}\n\n.rtl .event-info-section .info-column .inner-column {\n\tleft: 0;\n\tpadding-right: 30px;\n}\n\n.rtl .event-info-tabs .tab-btn {\n\tfloat: right;\n\tmargin-left: 5px;\n\tmargin-right: 0;\n}\n\n.rtl .subscribe-form .form-group {\n\tpadding-right: 0;\n\tpadding-left: 70px;\n}\n\n.rtl .about-section .icon-dots {\n\tleft: auto;\n\tright: 50%;\n}\n\n.rtl .coming-soon .emailed-form .form-group input[type=\"submit\"],\n.rtl .coming-soon .emailed-form button {\n\tright: auto;\n\tleft: 35px;\n\ttransform: scaleX(-1);\n}\n\n.rtl .event-detail .speaker-info {\n\tpadding-left: 0;\n\tpadding-right: 75px;\n}\n\n.rtl .list-style-two li {\n\tpadding-left: 0;\n\tpadding-right: 25px;\n}\n\n.rtl .buy-ticket .support-box .number span {\n\tmargin-left: 5px;\n\tmargin-right: 0;\n}\n\n.rtl .buy-ticket .form-column .inner-column {\n\tpadding-right: 0;\n\tpadding-left: 30px;\n}\n\n.rtl .news-block .post-info li {\n\tmargin-left: 25px;\n\tmargin-right: 0;\n}\n\n.rtl .news-block .post-info li span {\n\tmargin-right: 0;\n\tmargin-left: 5px;\n}\n\n.rtl .sidebar-page-container .sidebar.padding-left {\n\tpadding-left: 0;\n\tpadding-right: 40px;\n}\n\n.rtl .sidebar .search-box .form-group input[type=\"text\"],\n.rtl .sidebar .search-box .form-group input[type=\"search\"] {\n\tpadding: 20px 30px 20px 50px;\n}\n\n.rtl .sidebar .popular-posts .post .post-inner {\n\tpadding-left: 0;\n\tpadding-right: 110px;\n}\n\n.rtl .sidebar .popular-tags a {\n\tfloat: right;\n\tmargin: 0 0px 10px 20px;\n}\n\n.rtl .blog-single .lower-content blockquote {\n\tpadding: 35px 40px;\n\tpadding-right: 95px;\n}\n\n.rtl .blog-single .lower-content blockquote .icon {\n\tleft: auto;\n\tright: 40px;\n}\n\n.rtl .blog-single .lower-content blockquote cite {\n\tpadding-left: 0;\n\tpadding-right: 30px;\n}\n\n.rtl .comments-area .comment {\n\tpadding-left: 0;\n\tpadding-right: 70px;\n}\n\n.rtl .comments-area .comment-box .name {\n\tmargin-right: 0;\n\tmargin-left: 10px;\n}\n\n.rtl .contact-page-section .contact-info li {\n\tpadding-left: 0;\n\tpadding-right: 55px;\n}\n\n\n.rtl .schedule-section.style-three .schedule-block .speaker-info,\n.rtl .schedule-section.style-two .schedule-block .speaker-info {\n\tpadding-left: 0;\n\tpadding-right: 80px;\n}\n\n.rtl .schedule-section.style-three .schedule-block .speaker-info .thumb,\n.rtl .schedule-section.style-two .schedule-block .speaker-info .thumb {\n\tleft: auto;\n\tright: 0;\n}\n\n.rtl .banner-conference-two .time-countdown .counter-column {\n\tmargin-right: 0px;\n\tmargin-left: 30px;\n}\n\n.rtl .banner-conference-two .time-countdown .counter-column:before {\n\tright: auto;\n\tleft: -20px;\n}\n\n.rtl .banner-conference-two .images-outer {\n\tleft: 0px;\n\tright: auto;\n}\n\n.rtl .header-top .top-left {\n\torder: 2;\n}\n\n.rtl .header-top .top-right {\n\torder: 1;\n}\n\n.rtl .header-top-two .top-left .links li a {\n\tpadding-left: 0px;\n\tpadding-right: 24px;\n}\n\n.rtl .header-top-two .top-left .links li a .icon {\n\tright: 0px;\n\tleft: auto;\n}\n\n.rtl .header-top-two .top-right .cart-box {\n\tmargin-left: 30px;\n}\n\n/***\n\n====================================================================\n\tBox Layout\n====================================================================\n\n***/\n\n.box-layout .page-wrapper {\n\tmax-width: 1280px;\n\tmargin: 0 auto;\n\tbackground-color: #ffffff;\n\toverflow: hidden;\n\tbox-shadow: 0 0 50px rgba(0, 0, 0, 0.10);\n}\n\n.box-layout .main-header {\n\tmax-width: 1280px;\n\tleft: 0;\n\tright: 0;\n\tmargin: 0 auto;\n}\n\n.box-layout {\n\tbackground-repeat: repeat;\n\tbackground-position: center;\n\tbackground-attachment: fixed;\n\t/* background-image: url(../images/icons/boxed-bg.png); */\n}\n\n.box-layout .coming-soon {\n\tposition: relative;\n}\n\n/* Header Top */\n\n.header-top {\n\tposition: relative;\n\tbackground-color: #ec167f;\n\t-webkit-transition: all 600ms ease;\n\t-ms-transition: all 600ms ease;\n\t-o-transition: all 600ms ease;\n\t-moz-transition: all 600ms ease;\n\ttransition: all 600ms ease;\n}\n\n.header-top .top-left {\n\tposition: relative;\n\tpadding: 15px 0px;\n}\n\n.header-top .text {\n\tposition: relative;\n\tcolor: #ffffff;\n\tfont-size: 16px;\n}\n\n.header-top .top-right {\n\tposition: relative;\n}\n\n.header-span.style-two {\n\theight: 145px;\n}\n\n.header-top .social-links {\n\tposition: relative;\n\tpadding: 16px 0px;\n\tfloat: left;\n}\n\n.header-top .social-links li {\n\tposition: relative;\n\tmargin-left: 18px;\n\tdisplay: inline-block;\n}\n\n.header-top .social-links li a {\n\tposition: relative;\n\tcolor: #ffffff;\n\tfont-size: 14px;\n\t-webkit-transition: all 0.3s ease;\n\t-moz-transition: all 0.3s ease;\n\t-ms-transition: all 0.3s ease;\n\t-o-transition: all 0.3s ease;\n\ttransition: all 0.3s ease;\n}\n\n.header-top .social-links li a:hover {\n\tcolor: #4c35a9;\n}\n\n.header-top .register-btn {\n\tposition: relative;\n\tcolor: #ffffff;\n\tfloat: left;\n\tfont-size: 16px;\n\tpadding: 16.5px 30px;\n\tmargin-left: 25px;\n\tbackground-color: #1c94d2;\n}\n\n.main-header.header-style-two.alternate-two {\n\tposition: absolute;\n\tleft: 0px;\n\ttop: 0px;\n\tright: 0px;\n}\n\n.main-header.header-style-two.alternate-two .outer-box .search-box-btn,\n.main-header.header-style-two.alternate-two .main-menu .navigation>li>a {\n\tcolor: #ffffff;\n}\n\n.main-header.header-style-two.alternate-two .outer-box .search-box-btn2,\n.main-header.header-style-two.alternate-two .main-menu .navigation>li>a {\n\tcolor: #ffffff;\n}\n\n.main-header.header-style-two.alternate-two .outer-box .search-box-btn3,\n.main-header.header-style-two.alternate-two .main-menu .navigation>li>a {\n\tcolor: #ffffff;\n}\n\n.main-header.header-style-two.alternate-two .outer-box .search-box-btn4,\n.main-header.header-style-two.alternate-two .main-menu .navigation>li>a {\n\tcolor: #ffffff;\n}\n\n.main-header.header-style-two.alternate-two .outer-box .search-box-btn5,\n.main-header.header-style-two.alternate-two .main-menu .navigation>li>a {\n\tcolor: #ffffff;\n}\n\n.main-header.header-style-two.alternate-two .outer-box .search-box-btn6,\n.main-header.header-style-two.alternate-two .main-menu .navigation>li>a {\n\tcolor: #ffffff;\n}\n\n.main-header.header-style-two.alternate-two.fixed-header .outer-box .search-box-btn,\n.main-header.header-style-two.alternate-two.fixed-header .main-menu .navigation>li>a {\n\tcolor: #000000;\n}\n\n.main-header.header-style-two.alternate-two.fixed-header .outer-box .search-box-btn2,\n.main-header.header-style-two.alternate-two.fixed-header .main-menu .navigation>li>a {\n\tcolor: #000000;\n}\n\n.main-header.header-style-two.alternate-two.fixed-header .outer-box .search-box-btn3,\n.main-header.header-style-two.alternate-two.fixed-header .main-menu .navigation>li>a {\n\tcolor: #000000;\n}\n\n.main-header.header-style-two.alternate-two.fixed-header .outer-box .search-box-btn4,\n.main-header.header-style-two.alternate-two.fixed-header .main-menu .navigation>li>a {\n\tcolor: #000000;\n}\n\n.main-header.header-style-two.alternate-two.fixed-header .outer-box .search-box-btn5,\n.main-header.header-style-two.alternate-two.fixed-header .main-menu .navigation>li>a {\n\tcolor: #000000;\n}\n\n.main-header.header-style-two.alternate-two.fixed-header .outer-box .search-box-btn6,\n.main-header.header-style-two.alternate-two.fixed-header .main-menu .navigation>li>a {\n\tcolor: #000000;\n}\n\n.main-header.header-style-two.alternate.fixed-header .header-top,\n.main-header.header-style-two.alternate-two.fixed-header .header-top-two {\n\tdisplay: none;\n}\n\n.main-header.header-style-two.alternate-two .main-box {\n\tposition: fixed;\n\twidth: 100%;\n}\n\n/* Banner Section Two */\n\n.banner-section-two {\n\tposition: relative;\n\tpadding: 150px 0px 350px;\n\tbackground-size: cover;\n\tbackground-repeat: no-repeat;\n\t-webkit-transition: all 600ms ease;\n\t-ms-transition: all 600ms ease;\n\t-o-transition: all 600ms ease;\n\t-moz-transition: all 600ms ease;\n\ttransition: all 600ms ease;\n}\n\n.banner-section-two .outer-container {\n\tposition: relative;\n}\n\n.banner-section-two .outer-container .content {\n\tposition: relative;\n\twidth: 100%;\n\tmax-width: 800px;\n\ttext-align: center;\n\tdisplay: inline-block;\n\tbackground-color: #ec167f;\n}\n\n.banner-section-two .outer-container .content .upper-content {\n\tposition: relative;\n\tpadding: 10px 30px;\n\tdisplay: inline-block;\n\tbackground-color: #ec167f;\n}\n\n.banner-section-two .outer-container .title {\n\tposition: relative;\n\tcolor: #ffffff;\n\tfont-size: 20px;\n}\n\n.banner-section-two .outer-container .content h1 {\n\tposition: relative;\n\tfont-weight: 800;\n\tcolor: #ffffff;\n\tfont-size: 80px;\n\tline-height: 1em;\n\tmargin-top: 12px;\n}\n\n.banner-section-two .outer-container .content h1 span {\n\tposition: relative;\n\tfont-weight: 300;\n}\n\n.banner-section-two .outer-container .content h2 {\n\tposition: relative;\n\tfont-weight: 400;\n\tcolor: #ffffff;\n\tfont-size: 35px;\n\tline-height: 1.1em;\n\tmargin-top: 18px;\n\ttext-transform: uppercase;\n}\n\n.banner-section-two .outer-container .content h2 span {\n\tfont-weight: 300;\n\tdisplay: block;\n\tfont-size: 28px;\n}\n\n.banner-section-two .outer-container .content .lower-content {\n\tposition: relative;\n\tpadding: 10px 50px;\n\tbackground-color: #363636;\n}\n\n.banner-section-two .outer-container .content .lower-content .lower-title {\n\tposition: relative;\n\tcolor: #ffffff;\n\tfont-weight: 300;\n\tfont-size: 18px;\n\tfont-style: italic;\n}\n\n.banner-section-two .outer-container .content .lower-content .date {\n\tposition: relative;\n\tcolor: #ffffff;\n\tfont-weight: 600;\n\tfont-size: 16px;\n\tfont-style: italic;\n\tmargin-top: 8px;\n}\n\n/***\n\n====================================================================\n\tComing Soon Section Two\n====================================================================\n\n***/\n\n.coming-soon-section-two {\n\tposition: relative;\n\tz-index: 2;\n}\n\n.coming-soon-section-two .outer-box:before {\n\tposition: absolute;\n\tcontent: '';\n\tleft: 0px;\n\tbottom: 0px;\n\twidth: 100%;\n\theight: 42px;\n\tbackground-color: #363941;\n}\n\n.coming-soon-section-two .outer-box {\n\tposition: relative;\n\tdisplay: block;\n\tpadding: 0px 80px 40px;\n\tbackground-color: #ec167f;\n\ttext-align: center;\n\tmargin-top: -142px;\n\t/* background: -moz-linear-gradient(to left, rgba(247,0,104,1) 0%, rgba(68,16,102,1) 100%);\n\tbackground: -webkit-linear-gradient(to left, rgba(247,0,104,1) 0%, rgba(68,16,102,1) 100%);\n\tbackground: linear-gradient(to left, rgba(247,0,104) 0%,rgba(68,16,102,1) 100%);\n\tfilter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#F70068', endColorstr='#441066',GradientType=1 ); */\n\tbox-shadow: 0 0 30px rgba(0, 0, 0, 0.30);\n}\n\n.coming-soon-section-two .timer-column {\n\tposition: relative;\n}\n\n.coming-soon-section-two .time-counter {\n\tposition: relative;\n\n}\n\n.coming-soon-section-two .time-countdown {\n\tposition: relative;\n}\n\n.coming-soon-section-two .time-countdown .counter-column {\n\tposition: relative;\n\tdisplay: inline-block;\n\tmargin: 0px 40px;\n\twidth: 100px;\n\ttext-align: center;\n\tfont-size: 14px;\n\tcolor: #ffffff;\n\ttop: 30px;\n\tfont-weight: 300;\n\tfont-style: italic;\n\ttext-transform: uppercase;\n}\n\n.coming-soon-section-two .time-countdown .counter-column:before {\n\tposition: absolute;\n\tcontent: ':';\n\ttop: 5px;\n\tright: -50px;\n\tfont-size: 80px;\n\tline-height: 1em;\n\tcolor: #ffffff;\n\tfont-style: normal;\n}\n\n.coming-soon-section-two .time-countdown .counter-column:last-child:before {\n\tdisplay: none;\n}\n\n.coming-soon-section-two .time-countdown .counter-column .count {\n\tposition: relative;\n\tdisplay: block;\n\tfont-size: 90px;\n\tline-height: 1em;\n\tcolor: #ffffff;\n\tfont-weight: 700;\n\tpadding-bottom: 30px;\n\tfont-style: normal;\n}\n\n\n\n\n\n\n.header-top-two {\n\tposition: relative;\n\tborder-bottom: 1px solid rgba(245, 245, 245, 0.50);\n}\n\n.header-top-two .top-left {\n\tposition: relative;\n\tfloat: left;\n}\n\n.header-top-two .top-left .links {\n\tposition: relative;\n}\n\n.header-top-two .top-left .links li {\n\tposition: relative;\n\tmargin-right: 18px;\n\tpadding: 13px 0px;\n\tpadding-right: 22px;\n\tdisplay: inline-block;\n\tborder-right: 1px solid rgba(245, 245, 245, 0.50);\n}\n\n.header-top-two .top-left .links li:last-child {\n\tborder-right: none;\n}\n\n.header-top-two .top-left .links li a {\n\tposition: relative;\n\tfont-size: 15px;\n\tfont-weight: 400;\n\tcolor: #ffffff;\n\tpadding-left: 24px;\n}\n\n.header-top-two .top-left .links li a .icon {\n\tposition: absolute;\n\tleft: 0px;\n\tcolor: #ec167f;\n}\n\n.header-top-two .top-right {\n\tposition: relative;\n\tfloat: right;\n}\n\n.header-top-two .top-right .social-icons {\n\tposition: relative;\n\tfloat: left;\n}\n\n.header-top-two .top-right .social-icons li {\n\tposition: relative;\n\tmargin-left: 15px;\n\tpadding: 13px 0px;\n\tdisplay: inline-block;\n}\n\n.header-top-two .top-right .social-icons li a {\n\tposition: relative;\n\tcolor: #ffffff;\n\tfont-size: 16px;\n}\n\n/***\n\n====================================================================\n\tBanner Conference Two\n====================================================================\n\n***/\n\n.banner-conference-two {\n\tposition: relative;\n\tpadding: 320px 0px 200px;\n\toverflow: hidden;\n}\n\n\n\n\n.banner-conference-two .icons {\n\tposition: absolute;\n\tleft: 0px;\n\ttop: 0px;\n\tright: 0px;\n\tbottom: 0px;\n}\n\n.banner-conference-two .icons .icon-one {\n\tposition: absolute;\n\tleft: 10% !important;\n\ttop: 17% !important;\n\twidth: 12px;\n\theight: 12px;\n\tdisplay: inline-block;\n\tbackground-repeat: no-repeat;\n}\n\n.banner-conference-two .icons .icon-two {\n\tposition: absolute;\n\tleft: 35% !important;\n\ttop: 25% !important;\n\twidth: 16px;\n\theight: 16px;\n\tdisplay: inline-block;\n\tbackground-repeat: no-repeat;\n}\n\n.banner-conference-two .icons .icon-three {\n\tposition: absolute;\n\tleft: 6% !important;\n\ttop: 58% !important;\n\twidth: 34px;\n\theight: 10px;\n\tdisplay: inline-block;\n\tbackground-repeat: no-repeat;\n}\n\n.banner-conference-two .icons .icon-four {\n\tposition: absolute;\n\tleft: 56% !important;\n\ttop: 60% !important;\n\twidth: 34px;\n\theight: 20px;\n\tdisplay: inline-block;\n\tbackground-repeat: no-repeat;\n}\n\n.banner-conference-two .icons .icon-five {\n\tposition: absolute;\n\tleft: 79% !important;\n\ttop: 25% !important;\n\twidth: 35px;\n\theight: 16px;\n\tdisplay: inline-block;\n\tbackground-repeat: no-repeat;\n}\n\n.banner-conference-two .icons .icon-six {\n\tposition: absolute;\n\tleft: 90% !important;\n\ttop: 88% !important;\n\twidth: 20px;\n\theight: 20px;\n\tdisplay: inline-block;\n\tbackground-repeat: no-repeat;\n}\n\n.banner-conference-two .icons .icon-seven {\n\tposition: absolute;\n\tleft: 80% !important;\n\ttop: 60% !important;\n\twidth: 20px;\n\theight: 20px;\n\tdisplay: inline-block;\n\tbackground-repeat: no-repeat;\n}\n\n\n\n\n.banner-conference-two .icons .icon-eight {\n\tposition: absolute;\n\tleft: 52% !important;\n\ttop: 40% !important;\n\twidth: 12px;\n\theight: 12px;\n\tdisplay: inline-block;\n\tbackground-repeat: no-repeat;\n}\n\n.banner-conference-two .icons .icon-nine {\n\tposition: absolute;\n\tleft: 52% !important;\n\ttop: 12% !important;\n\twidth: 16px;\n\theight: 16px;\n\tdisplay: inline-block;\n\tbackground-repeat: no-repeat;\n}\n\n.banner-conference-two .icons .icon-ten {\n\tposition: absolute;\n\tleft: 34% !important;\n\ttop: 68% !important;\n\twidth: 34px;\n\theight: 10px;\n\tdisplay: inline-block;\n\tbackground-repeat: no-repeat;\n}\n\n.banner-conference-two .icons .icon-eleven {\n\tposition: absolute;\n\tleft: 89% !important;\n\ttop: 80% !important;\n\twidth: 34px;\n\theight: 20px;\n\tdisplay: inline-block;\n\tbackground-repeat: no-repeat;\n}\n\n.banner-conference-two .icons .icon-twelve {\n\tposition: absolute;\n\tleft: 69% !important;\n\ttop: 70% !important;\n\twidth: 35px;\n\theight: 16px;\n\tdisplay: inline-block;\n\tbackground-repeat: no-repeat;\n}\n\n.banner-conference-two .icons .icon-thirteen {\n\tposition: absolute;\n\tleft: 200% !important;\n\ttop: 88% !important;\n\twidth: 20px;\n\theight: 20px;\n\tdisplay: inline-block;\n\tbackground-repeat: no-repeat;\n}\n\n.banner-conference-two .icons .icon-fourteen {\n\tposition: absolute;\n\tleft: 95% !important;\n\ttop: 95% !important;\n\twidth: 20px;\n\theight: 20px;\n\tdisplay: inline-block;\n\tbackground-repeat: no-repeat;\n}\n\n.banner-conference-two:before {\n\tposition: absolute;\n\tcontent: '';\n\tleft: 0px;\n\ttop: 0px;\n\tright: 0px;\n\tbottom: 0px;\n\tbackground-color: rgba(0, 0, 0, 0.85);\n}\n\n.banner-conference-two .icon-dots {\n\tleft: 40%;\n\tbottom: 180px;\n}\n\n.banner-conference-two .layer-outer {\n\tposition: absolute;\n\tright: 0;\n\ttop: 0;\n\theight: 100%;\n\twidth: 50%;\n}\n\n.banner-conference-two .images-outer {\n\tposition: absolute;\n\tright: 0;\n\ttop: 0;\n\theight: 100%;\n\twidth: 50%;\n}\n\n.banner-conference-two .images-outer .speaker-img {\n\tposition: absolute;\n\tright: 150px;\n\ttop: 52%;\n\t-webkit-transform: translateY(-50%);\n\t-moz-transform: translateY(-50%);\n\t-ms-transform: translateY(-50%);\n\t-o-transform: translateY(-50%);\n\ttransform: translateY(-50%);\n}\n\n.banner-conference-two .content-box {\n\tposition: relative;\n\tz-index: 99;\n}\n\n.banner-conference-two .content-box .title {\n\tdisplay: block;\n\tfont-size: 16px;\n\tcolor: #ffffff;\n\tfont-weight: 400;\n\tmargin-bottom: 20px;\n}\n\n.banner-conference-two .content-box h2 {\n\tdisplay: block;\n\tfont-size: 50px;\n\tline-height: 1.2em;\n\tcolor: #ffffff;\n\tfont-weight: 700;\n\tmargin-bottom: 50px;\n}\n\n.banner-conference-two .time-counter {\n\tposition: relative;\n\tmargin-bottom: 30px;\n}\n\n.banner-conference-two .time-countdown {\n\tposition: relative;\n}\n\n.banner-conference-two .time-countdown .counter-column {\n\tposition: relative;\n\tdisplay: inline-block;\n\tmargin-right: 30px;\n\twidth: 90px;\n\ttext-align: center;\n\tfont-size: 14px;\n\tcolor: #ffffff;\n\tfont-weight: 500;\n}\n\n.banner-conference-two .time-countdown .counter-column:last-child {\n\tmargin-right: 0;\n}\n\n.banner-conference-two .time-countdown .counter-column:before {\n\tposition: absolute;\n\tcontent: ':';\n\ttop: 10px;\n\tright: -20px;\n\tfont-size: 30px;\n\tline-height: 1em;\n\tcolor: #ffffff;\n}\n\n.banner-conference-two .time-countdown .counter-column:after {\n\tposition: absolute;\n\tleft: 0;\n\ttop: -20px;\n\theight: 100px;\n\twidth: 90px;\n\tz-index: -1;\n\tborder-radius: 5px 30px 5px 30px;\n\tbackground-color: #ec167f;\n\t/* border-top: 3px solid #ec167f;\n\tborder-bottom: 3px solid #ec167f; */\n\tcontent: \"\";\n}\n\n.banner-conference-two .time-countdown .counter-column:nth-child(2):after {\n\tbackground-color: #1c94d2;\n}\n\n.banner-conference-two .time-countdown .counter-column:nth-child(3):after {\n\tbackground-color: #faaC1D;\n}\n\n.banner-conference-two .time-countdown .counter-column:nth-child(4):after {\n\tbackground-color: #4c35a9;\n}\n\n.banner-conference-two .time-countdown .counter-column:last-child:before {\n\tdisplay: none;\n}\n\n.banner-conference-two .time-countdown .counter-column .count {\n\tposition: relative;\n\tdisplay: block;\n\tfont-size: 40px;\n\tline-height: 1em;\n\tcolor: #ffffff;\n\tfont-weight: 700;\n}\n\n.banner-conference-two .content-box .btn-box {\n\tposition: relative;\n\tmargin-top: 60px;\n}\n\n\n\n\n/***\n\n====================================================================\n\tSearch Popup\n====================================================================\n\n***/\n\n.search-popup {\n\tposition: fixed;\n\tleft: 0px;\n\tbottom: -100%;\n\twidth: 100%;\n\theight: 100%;\n\tz-index: 9999;\n\tvisibility: hidden;\n\topacity: 0;\n\toverflow: auto;\n\tbackground: rgba(0, 0, 0, 0.80);\n\ttransition: all 700ms ease;\n\t-moz-transition: all 700ms ease;\n\t-webkit-transition: all 700ms ease;\n\t-ms-transition: all 700ms ease;\n\t-o-transition: all 700ms ease;\n}\n\n.search-popup .overlay-layer {\n\tposition: absolute;\n\tleft: 0px;\n\ttop: 0px;\n\tright: 0px;\n\tbottom: 0px;\n\tdisplay: block;\n}\n\n.search-popup.popup-visible {\n\tbottom: 0;\n\tvisibility: visible;\n\topacity: 1;\n}\n\n.search-popup .close-search {\n\tposition: absolute;\n\tright: 25px;\n\ttop: 25px;\n\tfont-size: 22px;\n\tcolor: #ffffff;\n\tcursor: pointer;\n\tz-index: 5;\n}\n\n.search-popup .close-search:hover {\n\topacity: 0.70;\n}\n\n.search-popup .search-form {\n\tposition: relative;\n\tpadding: 0px 15px 0px;\n\tmax-width: 1024px;\n\tmargin: 0 auto;\n\tmargin-top: 200px;\n}\n\n.search-popup .search-form fieldset {\n\tposition: relative;\n\tborder: 7px solid rgba(255, 255, 255, 0.50);\n\tborder-radius: 12px;\n\t-webkit-border-radius: 12px;\n\t-ms-border-radius: 12px;\n\t-o-border-radius: 12px;\n\t-moz-border-radius: 12px;\n}\n\n.search-popup .search-form fieldset input[type=\"search\"] {\n\tposition: relative;\n\theight: 70px;\n\tpadding: 20px 220px 20px 30px;\n\tbackground: #ffffff;\n\tline-height: 30px;\n\tfont-size: 24px;\n\tcolor: #233145;\n\tborder-radius: 7px;\n\t-webkit-border-radius: 7px;\n\t-ms-border-radius: 7px;\n\t-o-border-radius: 7px;\n\t-moz-border-radius: 7px;\n}\n\n.search-popup .search-form fieldset input[type=\"submit\"] {\n\tposition: absolute;\n\tdisplay: block;\n\tright: 0px;\n\ttop: 0px;\n\ttext-align: center;\n\twidth: 220px;\n\theight: 70px;\n\tpadding: 20px 10px 20px 10px;\n\tcolor: #ffffff !important;\n\tbackground-color: #ec167f;\n\tline-height: 30px;\n\tfont-size: 20px;\n\tcolor: #233145;\n\tcursor: pointer;\n\ttext-transform: uppercase;\n\tborder-radius: 0px 7px 7px 0px;\n\t-moz-border-radius: 0px 7px 7px 0px;\n\t-ms-border-radius: 0px 7px 7px 0px;\n\t-o-border-radius: 0px 7px 7px 0px;\n\t-webkit-border-radius: 0px 7px 7px 0px;\n}\n\n.search-popup .search-form fieldset input[type=\"submit\"]:hover {\n\tbackground: #ec167f;\n}\n\n.search-popup h3 {\n\tfont-size: 24px;\n\tcolor: #ffffff;\n\tmargin-bottom: 20px;\n\ttext-align: center;\n}\n\n.search-popup .recent-searches {\n\tfont-size: 16px;\n\tcolor: #ffffff;\n\ttext-align: center;\n}\n\n.search-popup .recent-searches li {\n\tdisplay: inline-block;\n\tmargin: 0px 10px 10px 0px;\n}\n\n.search-popup .recent-searches li a {\n\tdisplay: block;\n\tline-height: 24px;\n\tborder: 1px solid #ffffff;\n\tpadding: 7px 15px;\n\tcolor: #ffffff;\n\tborder-radius: 3px;\n}\n\n.search-popup .recent-searches li a:hover {\n\tcolor: #ec167f;\n\tborder-color: #ec167f;\n}\n\n\n/***\n====================================================================\n\tSearch Popup\n====================================================================\n\n***/\n\n.search-popup1 {\n\tposition: fixed;\n\tleft: 0px;\n\tbottom: -100%;\n\twidth: 100%;\n\theight: 100%;\n\tz-index: 9999;\n\tvisibility: hidden;\n\topacity: 0;\n\toverflow: auto;\n\tbackground: rgba(0, 0, 0, 0.80);\n\ttransition: all 700ms ease;\n\t-moz-transition: all 700ms ease;\n\t-webkit-transition: all 700ms ease;\n\t-ms-transition: all 700ms ease;\n\t-o-transition: all 700ms ease;\n}\n\n.search-popup1 .overlay-layer {\n\tposition: absolute;\n\tleft: 0px;\n\ttop: 0px;\n\tright: 0px;\n\tbottom: 0px;\n\tdisplay: block;\n}\n\n.search-popup1.popup-visible {\n\tbottom: 0;\n\tvisibility: visible;\n\topacity: 1;\n}\n\n.search-popup1 .close-search {\n\tposition: absolute;\n\tright: 25px;\n\ttop: 25px;\n\tfont-size: 22px;\n\tcolor: #ffffff;\n\tcursor: pointer;\n\tz-index: 5;\n}\n\n.search-popup1 .close-search:hover {\n\topacity: 0.70;\n}\n\n.search-popup1 .search-form {\n\tposition: relative;\n\tpadding: 0px 15px 0px;\n\tmax-width: 1024px;\n\tmargin: 0 auto;\n\tmargin-top: 146px;\n}\n\n.search-popup1 .search-form fieldset {\n\tposition: relative;\n\tborder: 7px solid rgba(255, 255, 255, 0.50);\n\tborder-radius: 12px;\n\t-webkit-border-radius: 12px;\n\t-ms-border-radius: 12px;\n\t-o-border-radius: 12px;\n\t-moz-border-radius: 12px;\n}\n\n.search-popup1 .search-form fieldset input[type=\"search\"] {\n\tposition: relative;\n\theight: 70px;\n\tpadding: 20px 220px 20px 30px;\n\tbackground: #ffffff;\n\tline-height: 30px;\n\tfont-size: 24px;\n\tcolor: #233145;\n\tborder-radius: 7px;\n\t-webkit-border-radius: 7px;\n\t-ms-border-radius: 7px;\n\t-o-border-radius: 7px;\n\t-moz-border-radius: 7px;\n}\n\n.search-popup1 .search-form fieldset input[type=\"submit\"] {\n\tposition: absolute;\n\tdisplay: block;\n\tright: 0px;\n\ttop: 0px;\n\ttext-align: center;\n\twidth: 220px;\n\theight: 70px;\n\tpadding: 20px 10px 20px 10px;\n\tcolor: #ffffff !important;\n\tbackground-color: #ec167f;\n\tline-height: 30px;\n\tfont-size: 20px;\n\tcolor: #233145;\n\tcursor: pointer;\n\ttext-transform: uppercase;\n\tborder-radius: 0px 7px 7px 0px;\n\t-moz-border-radius: 0px 7px 7px 0px;\n\t-ms-border-radius: 0px 7px 7px 0px;\n\t-o-border-radius: 0px 7px 7px 0px;\n\t-webkit-border-radius: 0px 7px 7px 0px;\n}\n\n.search-popup1 .search-form fieldset input[type=\"submit\"]:hover {\n\tbackground: #ec167f;\n}\n\n.search-popup1 h3 {\n\tfont-size: 24px;\n\tcolor: #ffffff;\n\tmargin-bottom: 20px;\n\ttext-align: center;\n}\n\n.search-popup1 .recent-searches {\n\tfont-size: 16px;\n\tcolor: #ffffff;\n\ttext-align: center;\n}\n\n.search-popup1 .recent-searches li {\n\tdisplay: inline-block;\n\tmargin: 0px 10px 10px 0px;\n}\n\n.search-popup1 .recent-searches li a {\n\tdisplay: block;\n\tline-height: 24px;\n\tborder: 1px solid #ffffff;\n\tpadding: 7px 15px;\n\tcolor: #ffffff;\n\tborder-radius: 3px;\n}\n\n.search-popup1 .recent-searches li a:hover {\n\tcolor: #ec167f;\n\tborder-color: #ec167f;\n}\n\n/*search popup2*/\n\n\n\n\n\n.search-popup2 {\n\tposition: fixed;\n\tleft: 0px;\n\tbottom: -100%;\n\twidth: 100%;\n\theight: 100%;\n\tz-index: 9999;\n\tvisibility: hidden;\n\topacity: 0;\n\toverflow: auto;\n\tbackground: rgba(0, 0, 0, 0.80);\n\ttransition: all 700ms ease;\n\t-moz-transition: all 700ms ease;\n\t-webkit-transition: all 700ms ease;\n\t-ms-transition: all 700ms ease;\n\t-o-transition: all 700ms ease;\n}\n\n.search-popup2 .overlay-layer {\n\tposition: absolute;\n\tleft: 0px;\n\ttop: 0px;\n\tright: 0px;\n\tbottom: 0px;\n\tdisplay: block;\n}\n\n.search-popup2.popup-visible {\n\tbottom: 0;\n\tvisibility: visible;\n\topacity: 1;\n}\n\n.search-popup2 .close-search {\n\tposition: absolute;\n\tright: 25px;\n\ttop: 25px;\n\tfont-size: 22px;\n\tcolor: #ffffff;\n\tcursor: pointer;\n\tz-index: 5;\n}\n\n.search-popup2 .close-search:hover {\n\topacity: 0.70;\n}\n\n.search-popup2 .search-form {\n\tposition: relative;\n\tpadding: 0px 15px 0px;\n\tmax-width: 1024px;\n\tmargin: 0 auto;\n\tmargin-top: 169px;\n}\n\n.search-popup2 .search-form fieldset {\n\tposition: relative;\n\tborder: 7px solid rgba(255, 255, 255, 0.50);\n\tborder-radius: 12px;\n\t-webkit-border-radius: 12px;\n\t-ms-border-radius: 12px;\n\t-o-border-radius: 12px;\n\t-moz-border-radius: 12px;\n}\n\n.search-popup2 .search-form fieldset input[type=\"search\"] {\n\tposition: relative;\n\theight: 70px;\n\tpadding: 20px 220px 20px 30px;\n\tbackground: #ffffff;\n\tline-height: 30px;\n\tfont-size: 24px;\n\tcolor: #233145;\n\tborder-radius: 7px;\n\t-webkit-border-radius: 7px;\n\t-ms-border-radius: 7px;\n\t-o-border-radius: 7px;\n\t-moz-border-radius: 7px;\n}\n\n.search-popup2 .search-form fieldset input[type=\"submit\"] {\n\tposition: absolute;\n\tdisplay: block;\n\tright: 0px;\n\ttop: 0px;\n\ttext-align: center;\n\twidth: 220px;\n\theight: 70px;\n\tpadding: 20px 10px 20px 10px;\n\tcolor: #ffffff !important;\n\tbackground-color: #ec167f;\n\tline-height: 30px;\n\tfont-size: 20px;\n\tcolor: #233145;\n\tcursor: pointer;\n\ttext-transform: uppercase;\n\tborder-radius: 0px 7px 7px 0px;\n\t-moz-border-radius: 0px 7px 7px 0px;\n\t-ms-border-radius: 0px 7px 7px 0px;\n\t-o-border-radius: 0px 7px 7px 0px;\n\t-webkit-border-radius: 0px 7px 7px 0px;\n}\n\n.search-popup2 .search-form fieldset input[type=\"submit\"]:hover {\n\tbackground: #ec167f;\n}\n\n.search-popup2 h3 {\n\tfont-size: 24px;\n\tcolor: #ffffff;\n\tmargin-bottom: 20px;\n\ttext-align: center;\n}\n\n.search-popup2 .recent-searches {\n\tfont-size: 16px;\n\tcolor: #ffffff;\n\ttext-align: center;\n}\n\n.search-popup2 .recent-searches li {\n\tdisplay: inline-block;\n\tmargin: 0px 10px 10px 0px;\n}\n\n.search-popup2 .recent-searches li a {\n\tdisplay: block;\n\tline-height: 24px;\n\tborder: 1px solid #ffffff;\n\tpadding: 7px 15px;\n\tcolor: #ffffff;\n\tborder-radius: 3px;\n}\n\n.search-popup2 .recent-searches li a:hover {\n\tcolor: #ec167f;\n\tborder-color: #ec167f;\n}\n\n/*search popup3*/\n.search-popup3 {\n\tposition: fixed;\n\tleft: 0px;\n\tbottom: -100%;\n\twidth: 100%;\n\theight: 100%;\n\tz-index: 9999;\n\tvisibility: hidden;\n\topacity: 0;\n\toverflow: auto;\n\tbackground: rgba(0, 0, 0, 0.80);\n\ttransition: all 700ms ease;\n\t-moz-transition: all 700ms ease;\n\t-webkit-transition: all 700ms ease;\n\t-ms-transition: all 700ms ease;\n\t-o-transition: all 700ms ease;\n}\n\n.search-popup3 .overlay-layer {\n\tposition: absolute;\n\tleft: 0px;\n\ttop: 0px;\n\tright: 0px;\n\tbottom: 0px;\n\tdisplay: block;\n}\n\n.search-popup3.popup-visible {\n\tbottom: 0;\n\tvisibility: visible;\n\topacity: 1;\n}\n\n.search-popup3 .close-search {\n\tposition: absolute;\n\tright: 25px;\n\ttop: 25px;\n\tfont-size: 22px;\n\tcolor: #ffffff;\n\tcursor: pointer;\n\tz-index: 5;\n}\n\n.search-popup3 .close-search:hover {\n\topacity: 0.70;\n}\n\n.search-popup3 .search-form {\n\tposition: relative;\n\tpadding: 0px 15px 0px;\n\tmax-width: 1024px;\n\tmargin: 0 auto;\n\tmargin-top: 125px;\n}\n\n.search-popup3 .search-form fieldset {\n\tposition: relative;\n\tborder: 7px solid rgba(255, 255, 255, 0.50);\n\tborder-radius: 12px;\n\t-webkit-border-radius: 12px;\n\t-ms-border-radius: 12px;\n\t-o-border-radius: 12px;\n\t-moz-border-radius: 12px;\n}\n\n.search-popup3 .search-form fieldset input[type=\"search\"] {\n\tposition: relative;\n\theight: 70px;\n\tpadding: 20px 220px 20px 30px;\n\tbackground: #ffffff;\n\tline-height: 30px;\n\tfont-size: 24px;\n\tcolor: #233145;\n\tborder-radius: 7px;\n\t-webkit-border-radius: 7px;\n\t-ms-border-radius: 7px;\n\t-o-border-radius: 7px;\n\t-moz-border-radius: 7px;\n}\n\n.search-popup3 .search-form fieldset input[type=\"submit\"] {\n\tposition: absolute;\n\tdisplay: block;\n\tright: 0px;\n\ttop: 0px;\n\ttext-align: center;\n\twidth: 220px;\n\theight: 70px;\n\tpadding: 20px 10px 20px 10px;\n\tcolor: #ffffff !important;\n\tbackground-color: #ec167f;\n\tline-height: 30px;\n\tfont-size: 20px;\n\tcolor: #233145;\n\tcursor: pointer;\n\ttext-transform: uppercase;\n\tborder-radius: 0px 7px 7px 0px;\n\t-moz-border-radius: 0px 7px 7px 0px;\n\t-ms-border-radius: 0px 7px 7px 0px;\n\t-o-border-radius: 0px 7px 7px 0px;\n\t-webkit-border-radius: 0px 7px 7px 0px;\n}\n\n.search-popup3 .search-form fieldset input[type=\"submit\"]:hover {\n\tbackground: #ec167f;\n}\n\n.search-popup3 h3 {\n\tfont-size: 24px;\n\tcolor: #ffffff;\n\tmargin-bottom: 20px;\n\ttext-align: center;\n}\n\n.search-popup3 .recent-searches {\n\tfont-size: 16px;\n\tcolor: #ffffff;\n\ttext-align: center;\n}\n\n.search-popup3 .recent-searches li {\n\tdisplay: inline-block;\n\tmargin: 0px 10px 10px 0px;\n}\n\n.search-popup3 .recent-searches li a {\n\tdisplay: block;\n\tline-height: 24px;\n\tborder: 1px solid #ffffff;\n\tpadding: 7px 15px;\n\tcolor: #ffffff;\n\tborder-radius: 3px;\n}\n\n.search-popup3 .recent-searches li a:hover {\n\tcolor: #ec167f;\n\tborder-color: #ec167f;\n}\n\n/*search popup4*/\n.search-popup4 {\n\tposition: fixed;\n\tleft: 0px;\n\tbottom: -100%;\n\twidth: 100%;\n\theight: 100%;\n\tz-index: 9999;\n\tvisibility: hidden;\n\topacity: 0;\n\toverflow: auto;\n\tbackground: rgba(0, 0, 0, 0.80);\n\ttransition: all 700ms ease;\n\t-moz-transition: all 700ms ease;\n\t-webkit-transition: all 700ms ease;\n\t-ms-transition: all 700ms ease;\n\t-o-transition: all 700ms ease;\n}\n\n.search-popup4 .overlay-layer {\n\tposition: absolute;\n\tleft: 0px;\n\ttop: 0px;\n\tright: 0px;\n\tbottom: 0px;\n\tdisplay: block;\n}\n\n.search-popup4.popup-visible {\n\tbottom: 0;\n\tvisibility: visible;\n\topacity: 1;\n}\n\n.search-popup4 .close-search {\n\tposition: absolute;\n\tright: 25px;\n\ttop: 25px;\n\tfont-size: 22px;\n\tcolor: #ffffff;\n\tcursor: pointer;\n\tz-index: 5;\n}\n\n.search-popup4 .close-search:hover {\n\topacity: 0.70;\n}\n\n.search-popup4 .search-form {\n\tposition: relative;\n\tpadding: 0px 15px 0px;\n\tmax-width: 1024px;\n\tmargin: 0 auto;\n\tmargin-top: 84px;\n}\n\n.search-popup4 .search-form fieldset {\n\tposition: relative;\n\tborder: 7px solid rgba(255, 255, 255, 0.50);\n\tborder-radius: 12px;\n\t-webkit-border-radius: 12px;\n\t-ms-border-radius: 12px;\n\t-o-border-radius: 12px;\n\t-moz-border-radius: 12px;\n}\n\n.search-popup4 .search-form fieldset input[type=\"search\"] {\n\tposition: relative;\n\theight: 70px;\n\tpadding: 20px 220px 20px 30px;\n\tbackground: #ffffff;\n\tline-height: 30px;\n\tfont-size: 24px;\n\tcolor: #233145;\n\tborder-radius: 7px;\n\t-webkit-border-radius: 7px;\n\t-ms-border-radius: 7px;\n\t-o-border-radius: 7px;\n\t-moz-border-radius: 7px;\n}\n\n.search-popup4 .search-form fieldset input[type=\"submit\"] {\n\tposition: absolute;\n\tdisplay: block;\n\tright: 0px;\n\ttop: 0px;\n\ttext-align: center;\n\twidth: 220px;\n\theight: 70px;\n\tpadding: 20px 10px 20px 10px;\n\tcolor: #ffffff !important;\n\tbackground-color: #ec167f;\n\tline-height: 30px;\n\tfont-size: 20px;\n\tcolor: #233145;\n\tcursor: pointer;\n\ttext-transform: uppercase;\n\tborder-radius: 0px 7px 7px 0px;\n\t-moz-border-radius: 0px 7px 7px 0px;\n\t-ms-border-radius: 0px 7px 7px 0px;\n\t-o-border-radius: 0px 7px 7px 0px;\n\t-webkit-border-radius: 0px 7px 7px 0px;\n}\n\n.search-popup4.search-form fieldset input[type=\"submit\"]:hover {\n\tbackground: #ec167f;\n}\n\n.search-popup4 h3 {\n\tfont-size: 24px;\n\tcolor: #ffffff;\n\tmargin-bottom: 20px;\n\ttext-align: center;\n}\n\n.search-popup4 .recent-searches {\n\tfont-size: 16px;\n\tcolor: #ffffff;\n\ttext-align: center;\n}\n\n.search-popup4 .recent-searches li {\n\tdisplay: inline-block;\n\tmargin: 0px 10px 10px 0px;\n}\n\n.search-popup4 .recent-searches li a {\n\tdisplay: block;\n\tline-height: 24px;\n\tborder: 1px solid #ffffff;\n\tpadding: 7px 15px;\n\tcolor: #ffffff;\n\tborder-radius: 3px;\n}\n\n.search-popup4 .recent-searches li a:hover {\n\tcolor: #ec167f;\n\tborder-color: #ec167f;\n}\n\n/*search popup5*/\n.search-popup5 {\n\tposition: fixed;\n\tleft: 0px;\n\tbottom: -100%;\n\twidth: 100%;\n\theight: 100%;\n\tz-index: 9999;\n\tvisibility: hidden;\n\topacity: 0;\n\toverflow: auto;\n\tbackground: rgba(0, 0, 0, 0.80);\n\ttransition: all 700ms ease;\n\t-moz-transition: all 700ms ease;\n\t-webkit-transition: all 700ms ease;\n\t-ms-transition: all 700ms ease;\n\t-o-transition: all 700ms ease;\n}\n\n.search-popup5 .overlay-layer {\n\tposition: absolute;\n\tleft: 0px;\n\ttop: 0px;\n\tright: 0px;\n\tbottom: 0px;\n\tdisplay: block;\n}\n\n.search-popup5.popup-visible {\n\tbottom: 0;\n\tvisibility: visible;\n\topacity: 1;\n}\n\n.search-popup5 .close-search {\n\tposition: absolute;\n\tright: 25px;\n\ttop: 25px;\n\tfont-size: 22px;\n\tcolor: #ffffff;\n\tcursor: pointer;\n\tz-index: 5;\n}\n\n.search-popup5 .close-search:hover {\n\topacity: 0.70;\n}\n\n.search-popup5 .search-form {\n\tposition: relative;\n\tpadding: 0px 15px 0px;\n\tmax-width: 1024px;\n\tmargin: 0 auto;\n\tmargin-top: 117px;\n}\n\n.search-popup5 .search-form fieldset {\n\tposition: relative;\n\tborder: 7px solid rgba(255, 255, 255, 0.50);\n\tborder-radius: 12px;\n\t-webkit-border-radius: 12px;\n\t-ms-border-radius: 12px;\n\t-o-border-radius: 12px;\n\t-moz-border-radius: 12px;\n}\n\n.search-popup5 .search-form fieldset input[type=\"search\"] {\n\tposition: relative;\n\theight: 70px;\n\tpadding: 20px 220px 20px 30px;\n\tbackground: #ffffff;\n\tline-height: 30px;\n\tfont-size: 24px;\n\tcolor: #233145;\n\tborder-radius: 7px;\n\t-webkit-border-radius: 7px;\n\t-ms-border-radius: 7px;\n\t-o-border-radius: 7px;\n\t-moz-border-radius: 7px;\n}\n\n.search-popup5 .search-form fieldset input[type=\"submit\"] {\n\tposition: absolute;\n\tdisplay: block;\n\tright: 0px;\n\ttop: 0px;\n\ttext-align: center;\n\twidth: 220px;\n\theight: 70px;\n\tpadding: 20px 10px 20px 10px;\n\tcolor: #ffffff !important;\n\tbackground-color: #ec167f;\n\tline-height: 30px;\n\tfont-size: 20px;\n\tcolor: #233145;\n\tcursor: pointer;\n\ttext-transform: uppercase;\n\tborder-radius: 0px 7px 7px 0px;\n\t-moz-border-radius: 0px 7px 7px 0px;\n\t-ms-border-radius: 0px 7px 7px 0px;\n\t-o-border-radius: 0px 7px 7px 0px;\n\t-webkit-border-radius: 0px 7px 7px 0px;\n}\n\n.search-popup5.search-form fieldset input[type=\"submit\"]:hover {\n\tbackground: #ec167f;\n}\n\n.search-popup5 h3 {\n\tfont-size: 24px;\n\tcolor: #ffffff;\n\tmargin-bottom: 20px;\n\ttext-align: center;\n}\n\n.search-popup5 .recent-searches {\n\tfont-size: 16px;\n\tcolor: #ffffff;\n\ttext-align: center;\n}\n\n.search-popup5 .recent-searches li {\n\tdisplay: inline-block;\n\tmargin: 0px 10px 10px 0px;\n}\n\n.search-popup5 .recent-searches li a {\n\tdisplay: block;\n\tline-height: 24px;\n\tborder: 1px solid #ffffff;\n\tpadding: 7px 15px;\n\tcolor: #ffffff;\n\tborder-radius: 3px;\n}\n\n.search-popup5 .recent-searches li a:hover {\n\tcolor: #ec167f;\n\tborder-color: #ec167f;\n}\n\n.register-section {\n\tposition: relative;\n\tpadding: 130px 0px 130px;\n}\n\n.register-section .form-box {\n\tposition: relative;\n\tmax-width: 550px;\n\tpadding: 40px 30px;\n\tmargin: 0 auto;\n\twidth: 100%;\n\tbackground-color: #f9f9f9;\n\tborder: 3px solid #f70068;\n}\n\n.register-section .form-box h1 {\n\tposition: relative;\n\tcolor: #222222;\n\tfont-size: 30px;\n\tfont-weight: 700;\n\tline-height: 1.3em;\n\ttext-align: center;\n\tmargin-bottom: 30px;\n}\n\n/* Styled Form */\n\n.styled-form {\n\tposition: relative;\n}\n\n.styled-form .submit-text {\n\tfont-size: 15px;\n\tcolor: #9e9e9e;\n\tfont-weight: 400;\n\tmargin-top: 10px;\n}\n\n.styled-form .form-group {\n\tposition: relative;\n\tmargin-bottom: 15px;\n\tfont-size: 14px;\n\tcolor: #222222;\n}\n\n.styled-form .form-group.social-icon-one {\n\tpadding-top: 8px;\n}\n\n.checkout-section .styled-form .form-group {\n\tposition: relative;\n\tmargin-bottom: 20px;\n}\n\n.styled-form .form-group .check-box {\n\tline-height: 24px;\n\tfont-size: 15px;\n\tfont-weight: normal;\n\tpadding-top: 5px;\n\tcolor: #272727;\n}\n\n.styled-form .form-group .check-box label {\n\tposition: relative;\n\ttop: -1px;\n\tfont-weight: normal;\n\tpadding: 0px;\n\tfont-size: 15px;\n\tcursor: pointer;\n}\n\n.styled-form .pull-left label,\n.styled-form .pull-right label {\n\tcursor: pointer;\n}\n\n.styled-form .form-group .adon-icon {\n\tposition: absolute;\n\ttop: 50%;\n\tmargin-top: -10px;\n\tright: 10px;\n\twidth: 20px;\n\theight: 20px;\n\tline-height: 20px;\n\tfont-size: 15px;\n\tcolor: #999999;\n\tz-index: 2;\n}\n\n.styled-form .form-group .field-label {\n\tdisplay: block;\n\tcolor: #272727;\n\ttext-transform: capitalize;\n\tfont-size: 16px;\n\tmargin-bottom: 7px;\n\tfont-weight: 400;\n}\n\n.styled-form input[type=\"text\"],\n.styled-form input[type=\"email\"],\n.styled-form input[type=\"password\"],\n.styled-form input[type=\"tel\"],\n.styled-form input[type=\"number\"],\n.styled-form input[type=\"url\"],\n.styled-form select,\n.styled-form textarea {\n\tposition: relative;\n\tdisplay: block;\n\twidth: 100%;\n\tbackground: #ffffff;\n\tline-height: 30px;\n\tpadding: 8px 20px;\n\theight: 50px;\n\tborder: 1px solid #f4f4f4;\n\ttransition: all 300ms ease;\n\t-webkit-transition: all 300ms ease;\n\t-ms-transition: all 300ms ease;\n\t-o-transition: all 300ms ease;\n\t-moz-transition: all 300ms ease;\n}\n\n.color-palate {\n\tdisplay: none;\n}\n\nlabel {\n\tmargin-left: 5px;\n\tmargin-bottom: 2px;\n\tcolor: #890025;\n}\n\n/* new style */\n.image1 {\n\tmargin-left: -47px;\n}\n\n\n.sidebar1 .popular-tags1 a {\n\tposition: relative;\n\tcolor: #333333;\n\ttext-align: center;\n\tfont-size: 16px;\n\tline-height: 20px;\n\tbackground: none;\n\tfont-weight: 400;\n\tborder-bottom: 2px solid #dddddd;\n\tbackground-color: #ffffff;\n\t-webkit-transition: all 300ms ease;\n\t-moz-transition: all 300ms ease;\n\t-ms-transition: all 300ms ease;\n\t-o-transition: all 300ms ease;\n\ttransition: all 300ms ease;\n\tcolor: #ff9900;\n}\n\n.sidebar1 .popular-tags1 a:hover {\n\tborder-color: #e1137b;\n\tcolor: #e1137b;\n}\n\n.sidebar2 .popular-tags2 a {\n\tposition: relative;\n\tcolor: #333333;\n\ttext-align: center;\n\tfont-size: 16px;\n\tline-height: 20px;\n\tbackground: none;\n\tfont-weight: 400;\n\tborder-bottom: 2px solid #dddddd;\n\tbackground-color: #ffffff;\n\t-webkit-transition: all 300ms ease;\n\t-moz-transition: all 300ms ease;\n\t-ms-transition: all 300ms ease;\n\t-o-transition: all 300ms ease;\n\ttransition: all 300ms ease;\n\tcolor: #40cbb4;\n}\n\n.sidebar2 .popular-tags2 a:hover {\n\tborder-color: #e1137b;\n\tcolor: #e1137b;\n}\n\n.sidebar3 .popular-tags3 a {\n\tposition: relative;\n\tcolor: #333333;\n\ttext-align: center;\n\tfont-size: 16px;\n\tline-height: 20px;\n\tbackground: none;\n\tfont-weight: 400;\n\tborder-bottom: 2px solid #dddddd;\n\tbackground-color: #ffffff;\n\t-webkit-transition: all 300ms ease;\n\t-moz-transition: all 300ms ease;\n\t-ms-transition: all 300ms ease;\n\t-o-transition: all 300ms ease;\n\ttransition: all 300ms ease;\n\tcolor: #4c35a9;\n}\n\n.sidebar3 .popular-tags3 a:hover {\n\tborder-color: #e1137b;\n\tcolor: #e1137b;\n}\n\n.sidebar4 .popular-tags4 a {\n\tposition: relative;\n\tcolor: #333333;\n\ttext-align: center;\n\tfont-size: 16px;\n\tline-height: 20px;\n\tbackground: none;\n\tfont-weight: 400;\n\tborder-bottom: 2px solid #dddddd;\n\tbackground-color: #ffffff;\n\t-webkit-transition: all 300ms ease;\n\t-moz-transition: all 300ms ease;\n\t-ms-transition: all 300ms ease;\n\t-o-transition: all 300ms ease;\n\ttransition: all 300ms ease;\n\tcolor: #e6275a;\n}\n\n.sidebar4 .popular-tags4 a:hover {\n\tborder-color: #e1137b;\n\tcolor: #e1137b;\n}\n\n.sidebar5 .popular-tags5 a {\n\tposition: relative;\n\tcolor: #333333;\n\ttext-align: center;\n\tfont-size: 16px;\n\tline-height: 20px;\n\tbackground: none;\n\tfont-weight: 400;\n\tborder-bottom: 2px solid #dddddd;\n\tbackground-color: #ffffff;\n\t-webkit-transition: all 300ms ease;\n\t-moz-transition: all 300ms ease;\n\t-ms-transition: all 300ms ease;\n\t-o-transition: all 300ms ease;\n\ttransition: all 300ms ease;\n\tcolor: #05a7dc;\n}\n\n.sidebar5 .popular-tags5 a:hover {\n\tborder-color: #e1137b;\n\tcolor: #e1137b;\n}\n\n.page-title {\n\tpadding: 20px 0;\n}\n\n.speaker-detail {\n\tposition: relative;\n\tpadding: 20px 0 70px;\n}\n\n.dropdowninfinity {\n\tcolor: #888888;\n\tfont-size: 16px;\n\tline-height: 1.4em;\n\tmargin-bottom: 30px;\n}\n\n.shadow {\n\tbox-shadow: 0 0 30px rgb(0 0 0 / 10%);\n}\n\n.about-section-two-index {\n\tposition: relative;\n\tpadding: 20px 0 20px;\n}\n\n.about-section-two-index .icon-circle-1 {\n\tright: -200px;\n\ttop: -200px;\n\topacity: .05;\n}\n\n\n\n.schedule-block .speaker-info1 {\n\tposition: relative;\n\t//padding-left: 80px;\n\tpadding-top: 10px;\n\tmin-height: 60px;\n}\n\n.schedule-block .speaker-info1 .thumb {\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0;\n\twidth: 60px;\n\tborder-radius: 50%;\n\toverflow: hidden;\n}\n\n.schedule-block .speaker-info1 .name {\n\tfont-size: 16px;\n\tcolor: #212639;\n\tfont-weight: 500;\n\tline-height: 1.2em;\n\tfont-family: Poppins, sans-serif;\n}\n\n.schedule-block .speaker-info1 .designation {\n\tfont-size: 13px;\n}\n\n.about-section-two-index .icon-circle-blue {\n\tleft: -150px;\n\tbottom: -150px;\n\topacity: .70;\n\t-webkit-animation: fa-spin 30s infinite;\n\t-moz-animation: fa-spin 30s infinite;\n\t-ms-animation: fa-spin 30s infinite;\n\t-o-animation: fa-spin 30s infinite;\n\tanimation: fa-spin 30s infinite;\n}\n\n\n.fabs {\n\tfont-family: 'Font Awesome 5 Free';\n\tfont-weight: 900;\n\tfont-size: 25px;\n\tmargin-left: -100px;\n\tmargin-top: 12px;\n\tbackground-color: #fff;\n}\n\n\n\n\n@media only screen and (min-width: 1200px) and (max-width: 1367px) {\n\t.info-box-two {\n\t\tdisplay: none;\n\t\tmargin-top: 0rem !important;\n\t}\n}\n\n@media only screen and (min-width: 1200px) and (max-width: 2600px) {\n\t.info-box-two {\n\t\tdisplay: none;\n\t\tmargin-top: 0rem !important;\n\t}\n\n\t.schedule-timeline-two {\n\t\tmargin-top: 0rem;\n\t}\n\n\t.ftr-dsk-lg {\n\t\tdisplay: block !important;\n\t}\n\n\t.ftr-dsk-mn {\n\t\tdisplay: block !important;\n\t}\n\n\t.schedule-timeline-two {\n\t\tmargin-top: 0rem !important;\n\t}\n\n\t.margin-mobile {\n\t\tmargin-top: 0rem !important;\n\t}\n\n\t.schedule-tabs .tab-buttons {\n\t\tposition: relative;\n\t\ttext-align: center !important;\n\t}\n\n}\n\n.schedule-tabs .tab-buttons {\n\tposition: relative;\n\ttext-align: left;\n}\n\n.margin-mobile {\n\tmargin-top: 7rem;\n\t;\n}\n\n.ftr-dsk-lg {\n\tdisplay: none;\n}\n\n.ftr-dsk-mn {\n\tdisplay: none;\n}\n\n.schedule-timeline-two {\n\tmargin-top: 14rem;\n}\n\n.info-box-two {\n\tmargin-top: 0.6rem;\n}\n\n.info-box-two h4 {\n\tfont-size: 13px;\n\tfont-weight: 300;\n\ttext-align: center;\n}\n\n.info-box-two a {\n\tcolor: #101130 !important;\n}\n\n.banner-carousel-two .slide-item:before {\n\tbackground-color: #0000001c !important;\n}\n\n.bootstrap-select .dropdown-menu {\n\tmin-width: auto !important;\n}\n\n.buy-script {\n\tbackground: #ec167f;\n\theight: 30px;\n\tpadding-top: 2px;\n}\n\n.blinks {\n\tanimation: blinks 1s linear infinite;\n}\n\n.animate-charcter {\n\ttext-transform: uppercase;\n\tbackground-image: linear-gradient(-225deg,\n\t\t\t#231557 0%,\n\t\t\t#44107a 29%,\n\t\t\t#ff1361 67%,\n\t\t\t#fff800 100%);\n\tbackground-size: auto auto;\n\tbackground-clip: border-box;\n\tbackground-size: 200% auto;\n\tcolor: #fff;\n\tbackground-clip: text;\n\ttext-fill-color: transparent;\n\t-webkit-background-clip: text;\n\t-webkit-text-fill-color: transparent;\n\tanimation: textclip 4s linear infinite;\n\tdisplay: inline-block;\n\tfont-size: 190px;\n}\n\n@keyframes textclip {\n\tto {\n\t\tbackground-position: 200% center;\n\t}\n}\n\n.btn-style-letsbegin {\n\tcolor: #000;\n\tfont-weight: 400;\n\ttext-align: center;\n\tbackground-color: #ffffff;\n}\n\n@media screen and (max-width:768px) {\n\t.sec-title .text {\n\t\tmargin-top: 30px;\n\t}\n}\n\n.styled-pagination li a {\n\tline-height: 32px;\n\tfont-size: 18px;\n\theight: 32px;\n\twidth: 32px;\n\tfont-weight: 500;\n}\n\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n\t-webkit-appearance: none;\n\tmargin: 0;\n}\n\n/* Firefox */\ninput[type=number] {\n\t-moz-appearance: textfield;\n}\n\n.react-loading {\n\tposition: absolute;\n\tleft: 50%;\n\ttop: 50%;\n\ttransform: translate(-50%, -50%);\n}\n\n.input_eyes_icon {\n\tposition: absolute;\n\tright: 30px;\n\ttop: 23px;\n\ttransform: translateY(-50%);\n\tcursor: pointer;\n}\n\n.bg-main {\n    background-color: #fff;\n    box-shadow: 2px 3px 6px 2px #cdcdcd;\n    border-radius: 5px;\n    padding: 30px;\n}\nsection.about-section .inner-column {\n    width: auto;\n}\n.inner-column.contact-width {\n    width: auto;\n}\nbutton.sub-btn{\n\tbackground-color: #890025;\n\tborder: none;\n\tborder-radius: 50px;\n\tfont-size: 15px;\n\tfont-weight: 400;\n\tpadding: 6px 18px;\n\tcolor:#ffff;\n}\n.contact-form {\n    margin: auto;\n    box-shadow: 2px 4px 12px 5px #d5d3d3;\n    padding: 20px;\n    border-radius: 28px;\n    border: 0.3px solid #cc003726;\n}\n.cards-one {\n    margin: auto;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\tmargin-top: 0;\n}\np.desh {\n\ttext-align: start;\n    word-break: break-all;\n}\n\ntextarea.about-me {\n    width: 100%;\n    border: 1px solid  #00000042;\n    padding: 0px 7px;\n\tmin-height: 215px;\n    overflow-y: auto;\n}\ndiv.document-verified{\n\tpadding: 13px;\n}\n.d-verify-tick{\n\tcolor: green;\n}\n.date-time label {\n    align-items: center;\n    display: flex;\n}\n.date-time {\n    font-size: 14px;\n    border: 1px solid #a1a7a1;\n    border-radius: 5px;\n    height: 50px;\n    display: flex;\n    justify-content: space-between;\n\tmax-width: 367px;\n    margin-left: 15px\n}\n.profile-modal li {\n\tborder-radius: 50px;\n\tborder: 1px solid #890025;\n\tborder-radius: 50px;\n\tmargin-right: 20px;\n\tpadding: 5px 10px;\n}\n.profile-modal ul {\n\tdisplay: flex;\n}\n\n/* 05/04/0/2024 */\n\n.btn-custom {\n    background: linear-gradient(to left, #A28089, #C63800);\n    color: #fff;\n    padding: 10px 40px;\n    border-radius: 8px;\n\tborder: none !important;\n\ttransition: 0.4s ease-in-out;\n}\n.btn-custom:hover {\n    background: linear-gradient(90deg, #A28089, #C63800);\n\tcolor: #fff;\n}\n.marriageRegister .card img {\n    height: 400px;\n    width: 100%;\n    object-fit: cover;\n    border-radius: 10px;\n    margin-bottom: 20px;\n}\n.marriageRegister .card {\n    padding: 0;\n    border: none;\n    box-shadow: none;\n    text-align: center;\n\tbackground: transparent;\n}\n.marriageRegister .card h2 {\n    line-height: 38px;\n    margin-bottom: 10px;\n    font-size: 24px;\n}\n.customSideToggler {\n    flex-wrap: wrap;\n}\n.customSideToggler li a {\n    width: 100%;\n    text-align: left;\n    border: none;\n    box-shadow: none !important;\n    border-right: 4px solid #a28089;\n    border-radius: 0;\n    margin: 20px 0;\n    opacity: 0.7;\n}\n.customSideToggler li a p {\n    width: 100%;\n    text-wrap: wrap;\n\tfont-size: 12px;\n    line-height: normal;\n    margin-top: 6px;\n}\n.customSideToggler li a b {\n    font-size: 24px;\n    text-wrap: pretty;\n    font-weight: normal;\n}\n.customSideToggler li.active a {\n    border-color: #c63800;\n    opacity: 1;\n}\n.tab-content>.active {\n    opacity: 1;\n}\np.services-para {\n    max-width: 800px;\n    margin: 0 auto;\n}\n\np.services-para {\n    max-width: 800px;\n    margin: 0 auto;\n}\n\n.servicesList ul {\n    display: grid;\n    grid-template-columns: repeat(5, 1fr);\n    gap: 16px;\n}\na.card-Custom {\n\tdisplay: inline-block;\n    padding: 20px;\n    background: #000;\n    color: #fff;\n    border-radius: 12px;\n    background-size: cover !important;\n    background-position: center !important;\n\tposition: relative;\n\twidth: 100%;\n}\n\na.card-Custom img {\n    border: 2px solid rgb(0, 0, 0);\n    padding: 20px;\n    border-radius: 12px;\n    filter: invert(1);\n    transition: all 0.5s ease-in-out 0s;\n    opacity: 1;\n    max-width: 150px;\n    margin: 0 auto 10px;\n    min-height: auto;\n\twidth: 100%;\n}\n\na.card-Custom h3 {\n    margin: 0;\n    font-size: 18px;\n}\na.card-Custom:before {\n    content: \"\";\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    inset: 0px;\n    border-radius: 8px;\n    transition: all 0.4s ease 0s;\n    background: linear-gradient(to top, rgb(37, 24, 8), rgba(215, 154, 78, 0));\n}\n\na.card-Custom:after {\n    content: '';\n    position: absolute;\n    width: 100%;\n    height: 200px;\n    right: 0px;\n    bottom: 0px;\n    left: 0px;\n    border-radius: 50px 50px 0px 0px;\n    transition: all 0.4s ease-in-out 0s;\n    background: rgb(229, 2, 107);\n    transform: scale(0);\n    transform-origin: right bottom;\n    z-index: 0;\n}\n\nbody {\n\tbackground-image: url(../images/sideflowers.png);\n\tbackground-position: center right;\n    background-size: 200px;\n    background-repeat: no-repeat;\n    background-attachment: fixed;\n\tbackground-color: #f3ffef;\n}\n\n.customHeading {\n\tposition: relative;\n    margin-bottom: 50px;\n    padding-bottom: 10px;\n}\n\n.customHeading span {\n    position: absolute;\n    left: 50%;\n    bottom: 10px;\n    transform: translateX(-50%);\n    width: 200px;\n    height: auto;\n}\n\n.customHeading span:before {\n    content: '';\n    position: absolute;\n    width: 100px;\n    height: 40px;\n    top: 0px;\n    transition: all 0.4s ease-in-out 0s;\n\tbackground-image: url(../images/headingPattern.png);\n\tbackground-size: contain;\n    background-repeat: no-repeat;\n\ttransform: scalex(-1);\n\tleft: 0;\n}\n\n.customHeading span:after {\n\tcontent: '';\n    position: absolute;\n    width: 100px;\n    height: 40px;\n    top: 0px;\n    background-image: url(../images/headingPattern.png);\n    transition: all 0.4s ease-in-out 0s;\n    background-size: contain;\n    background-repeat: no-repeat;\n\tright: 0;\n}\n\n.frameImg {\n    width: 100%;\n    height: auto;\n    background: transparent;\n    border-radius: 24px;\n    overflow: hidden;\n    border: 1px solid #dbdbdb;\n    padding: 10px;\n}\n\n.frameImg img {border-radius: 10px;}\n\n.customFooter {\n    padding: 70px 0  10px;\n    background: #101130;\n    position: relative;\n    z-index: 1;\n}\n\n.servicesList:after {\n    position: absolute;\n    content: '';\n    height: 34px;\n    width: 100%;\n    background-image: url(../images/grass.png);\n    /* background-position: bottom center; */\n    background-repeat: no-repeat;\n    background-size: contain;\n    transform: scaleY(-1);\n    bottom: 0px;\n\tleft: 0;\n}\n\n.servicesList {\n    position: relative;\n    padding: 60px 0;\n}\n\n.customFooter h5 {\n    font-size: 18px;\n    color: #fff;\n    margin-bottom: 20px;\n}\n\n.customFooter  li {\n    margin-bottom: 10px;\n}\n\n.customFooter li a {\n    color: #898989;\n    transition: 0.4s ease-in-out;\n    position: relative;\n    border-left: 1px solid transparent;\n\tword-break: break-all;\n}\n\n.customFooter li a:hover {\n    color: #fff;\n    padding-left: 15px;\n    border-color: #fff;\n}\n\nul.socialLinks a i {\n    width: 30px;\n    text-align: center;\n}\n\n.copyright {\n    border-top: 1px dashed #525252;\n}\n\n.coming-soon-section .outer-box {\n    max-width: 1400px;\n    margin: -72px auto 0;\n}\n\n.bannerTitle {\n\tbackground-image: url(../images/weddingPartner.jpg);\n    background-size: cover;\n    background-position: center;\n    min-height: 300px;\n    position: relative;\n}\n\n.bannerTitle:after {\n    content: '';\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    background: #00000078;\n}\n\n.bannerTitle .container {\n    z-index: 1;\n    position: relative;\n}\n\n.customModal {\n    max-width: 800px;\n}\n\n.customModal .modal-body {\n    background: linear-gradient(to left, #A28089, #C63800);\n    border: none;\n\tpadding: 0;\n\tposition: relative;\n    border-radius: 18px;\n\toverflow: hidden;\n}\n\n.customModal .modal-content {\n    border: none;\n\tpadding: 0;\n\tbackground: transparent;\n}\n\n.photoprimary {\n    background-size: cover;\n    background-position: center;\n\tmin-height: 500px;\n}\n\n.photoprimary {\n    background-size: cover;\n    background-position: center;\n    min-height: 500px;\n}\n\n.customModal .modal-body h2 {\n    font-size: 28px;\n    margin-bottom: 10px;\n    font-weight: 700;\n}\n\nul.modalSocial {\n    gap: 15px;\n    font-size: 22px;\n    color: #fff;\n}\n\n.customModal button.close {\n    color: #fff;\n    position: absolute;\n    right: 10px;\n    top: 10px;\n\ttransition: 0.4s ease-in-out;\n}\n\n.customModal button.close:hover {\n\tcolor: #fff;\n}\n\n/* Media Query */\n\n@media screen and (max-width: 1200px) {\n\tbody {background-size: 100px;}\n\t.servicesList ul {grid-template-columns: repeat(3, 1fr);align-items: center;justify-content: center;}\n\t.customSideToggler {flex-wrap: nowrap;flex-direction: row !important;overflow:auto; margin-bottom: 30px;}\n\t.customSideToggler li a {border-right: 0;border-bottom: 4px solid #a28089;min-width: 300px;margin-bottom: 0;}\n\t.customSideToggler li a b {font-size: 18px;}\n}\n\n@media screen and (max-width: 767px) {\n\t.marriageRegister .card {margin-bottom: 30px;}\n}\n\n@media screen and (max-width: 567px) {\n\t.servicesList ul {grid-template-columns: repeat(2, 1fr);}\n\t.servicesList ul {grid-template-columns: repeat(2, 1fr);}\n\t.coming-soon-section .outer-box {padding: 30px;margin-top: 30px !important;}\n\t.banner-carousel .content-box h2 {font-size: 30px;}\n\t.matching-ai .tab-content.px-5 {padding:  0 !important;}\n\t.matching-ai {z-index: 1;position: relative;background: #f3ffef;}\n\t.matching-ai .tab-content.px-5 {padding:  0 !important;}\n\t.servicesList:after {background-size: cover;background-position: center;}\n\tbody {background-size: 50px;}\n\t.banner-carousel .slide-item {padding: 100px 0 100px;}\n\t.banner-carousel .slide-item:before {border-top: 190px solid #800925;border-right: 70px solid transparent;border-left: 216px solid #800925;border-bottom: 322px solid #800925;}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
